/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://staticpg.paytm.in/checkout/442/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "1Vik");
/******/ })
/************************************************************************/
/******/ ({

/***/ "+mM3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/tqE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return processLocalStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDataFromLocalStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return savingUsedPaymodeInLocalStorage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_constants__ = __webpack_require__("hafV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__("lq6S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_common__ = __webpack_require__("ocZ9");




var msgHandler = function msgHandler(cache, resolve, event) {
  switch (Object(__WEBPACK_IMPORTED_MODULE_2__utils_common__["q" /* getKey */])(event, 'data.type')) {
    case 'fetchedData':
      cache.setData(__WEBPACK_IMPORTED_MODULE_0__utils_constants__["g" /* default */].SAVED_PAYMODES, Object(__WEBPACK_IMPORTED_MODULE_2__utils_common__["q" /* getKey */])(event, 'data.resp'));
      window.removeEventListener('message', msgHandler);
      resolve(Object(__WEBPACK_IMPORTED_MODULE_2__utils_common__["q" /* getKey */])(event, 'data.resp'));
      break;
    default:
      break;
  }
};

var processLocalStorage = function processLocalStorage(cache) {
  try {
    var savedPaymodesArray = cache.getData(__WEBPACK_IMPORTED_MODULE_0__utils_constants__["g" /* default */].SAVED_PAYMODES);
    if (savedPaymodesArray && savedPaymodesArray.length > 0 && window && window.localStorage && cache.getData(__WEBPACK_IMPORTED_MODULE_0__utils_constants__["g" /* default */].IS_LOCAL_STORAGE_ALLOWED) && cache.getData(__WEBPACK_IMPORTED_MODULE_0__utils_constants__["g" /* default */].IS_LOGGED_IN)) {
      var mobileNo = cache.getData(__WEBPACK_IMPORTED_MODULE_0__utils_constants__["g" /* default */].MOBILE_NO) && cache.getData(__WEBPACK_IMPORTED_MODULE_0__utils_constants__["g" /* default */].MOBILE_NO).slice(0, 4);

      var result = {};
      savedPaymodesArray.forEach(function (item) {
        if (item.userId === mobileNo) {
          if (item.uniqueCardData) {
            result[item.paymodeUsed + '_' + item.isWalletCheck] = savedPaymodesArray.filter(function (e) {
              return e.paymodeUsed === item.paymodeUsed && e.uniqueCardData === item.uniqueCardData && e.isWalletCheck === item.isWalletCheck && e.userId === mobileNo;
            }).length > 1 ? result[item.paymodeUsed + '_' + item.isWalletCheck] = 1 || 0 : 0;
          } else {
            result[item.paymodeUsed + '_' + item.isWalletCheck] = savedPaymodesArray.filter(function (e) {
              return e.paymodeUsed === item.paymodeUsed && e.isWalletCheck === item.isWalletCheck && e.userId === mobileNo;
            }).length > 1 ? result[item.paymodeUsed + '_' + item.isWalletCheck] = 1 || 0 : 0;
          }
        }
      });

      if (Object.keys(result).length) {
        var duplicateArray = savedPaymodesArray.filter(function (mode) {
          return result[mode.paymodeUsed + '_' + mode.isWalletCheck];
        });
        if (duplicateArray && duplicateArray.length > 0) {
          cache.setData(__WEBPACK_IMPORTED_MODULE_0__utils_constants__["g" /* default */].CURRENT_PAYMODE, duplicateArray[0]);
          return;
        }
        cache.setData(__WEBPACK_IMPORTED_MODULE_0__utils_constants__["g" /* default */].CURRENT_PAYMODE, savedPaymodesArray[0]);
      }
    }
  } catch (e) {
    Object(__WEBPACK_IMPORTED_MODULE_1__logger__["log"])({
      eventType: __WEBPACK_IMPORTED_MODULE_1__logger__["EVENT"].EXCEPTION,
      message: e.message,
      name: e.name
    });
  }
};

var getDataFromLocalStorage = function getDataFromLocalStorage(cache) {
  return new Promise(function (resolve) {
    var dummyFrame = document.getElementById('dummy-iframe');
    dummyFrame.contentWindow.postMessage({ type: 'FETCHDATA', key: 'savedPaymodes' }, '*');
    window.addEventListener('message', msgHandler.bind(null, cache, resolve));
    setTimeout(function () {
      resolve();
    }, 3000);
  });
};

var savingUsedPaymodeInLocalStorage = function savingUsedPaymodeInLocalStorage(cache) {
  try {
    var dummyFrame = document.getElementById('dummy-iframe');
    window.addEventListener('message', msgHandler.bind(null, cache));
    var selectedPaymode = cache.getData(__WEBPACK_IMPORTED_MODULE_0__utils_constants__["g" /* default */].CURRENT_PAYMODE);
    var usedPaymode = Object(__WEBPACK_IMPORTED_MODULE_2__utils_common__["q" /* getKey */])(selectedPaymode, 'paymentMode');
    // check whether localStorage api exists on window object
    if (selectedPaymode !== __WEBPACK_IMPORTED_MODULE_0__utils_constants__["g" /* default */].WALLET && window && window.localStorage && cache.getData(__WEBPACK_IMPORTED_MODULE_0__utils_constants__["g" /* default */].IS_LOCAL_STORAGE_ALLOWED) && cache.getData(__WEBPACK_IMPORTED_MODULE_0__utils_constants__["g" /* default */].IS_LOGGED_IN)) {
      var savedPaymodesArray = cache.getData(__WEBPACK_IMPORTED_MODULE_0__utils_constants__["g" /* default */].SAVED_PAYMODES) || [];
      var mobileNo = cache.getData(__WEBPACK_IMPORTED_MODULE_0__utils_constants__["g" /* default */].MOBILE_NO) && cache.getData(__WEBPACK_IMPORTED_MODULE_0__utils_constants__["g" /* default */].MOBILE_NO).slice(0, 4);
      var paymodeObj = {
        isWalletCheck: Object(__WEBPACK_IMPORTED_MODULE_2__utils_common__["q" /* getKey */])(cache.getData(__WEBPACK_IMPORTED_MODULE_0__utils_constants__["a" /* CACHE */].PAYMENT_OPTIONS), 'wallet.isUsed', undefined),
        paymodeUsed: Object(__WEBPACK_IMPORTED_MODULE_2__utils_common__["q" /* getKey */])(selectedPaymode, 'savedName') || Object(__WEBPACK_IMPORTED_MODULE_2__utils_common__["q" /* getKey */])(selectedPaymode, 'displayName'),
        userId: mobileNo
      };

      if (usedPaymode && (usedPaymode === __WEBPACK_IMPORTED_MODULE_0__utils_constants__["g" /* default */].DC || usedPaymode === __WEBPACK_IMPORTED_MODULE_0__utils_constants__["g" /* default */].CC)) {
        paymodeObj.paymodeUsed = 'card';
        paymodeObj.subType = cache.getData(__WEBPACK_IMPORTED_MODULE_0__utils_constants__["g" /* default */].CARD_TYPE) || '';
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_common__["q" /* getKey */])(selectedPaymode, 'paymentMode') === 'GIFT_VOUCHER') {
        paymodeObj.isMGV = true;
      }
      if (typeof Object(__WEBPACK_IMPORTED_MODULE_2__utils_common__["q" /* getKey */])(selectedPaymode, 'id', undefined) === 'string' && Object(__WEBPACK_IMPORTED_MODULE_2__utils_common__["q" /* getKey */])(selectedPaymode, 'id').indexOf('emi') > -1) {
        paymodeObj.paymodeUsed = 'EMI';
      }
      /* eslint valid-typeof: ["error", { "requireStringLiterals": false }] */
      // this is required to differentiate b/w different saved(DC/CC) cards of same bank
      if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_common__["q" /* getKey */])(selectedPaymode, 'type') === 'sc' && typeof Object(__WEBPACK_IMPORTED_MODULE_2__utils_common__["q" /* getKey */])(selectedPaymode, 'id', undefined) === 'number') {
        paymodeObj.uniqueCardData = selectedPaymode.lastFour;
      }
      var currentUserPaymodes = savedPaymodesArray.length > 0 && savedPaymodesArray.filter(function (paymode) {
        return paymode.userId === mobileNo;
      });
      if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_common__["x" /* isArray */])(currentUserPaymodes) && currentUserPaymodes.length === 3) {
        savedPaymodesArray.splice(savedPaymodesArray.lastIndexOf(currentUserPaymodes[2]), 1);
      }

      Object(__WEBPACK_IMPORTED_MODULE_1__logger__["log"])({
        eventType: __WEBPACK_IMPORTED_MODULE_1__logger__["EVENT"].SAVING_CURRENT_PAYMODE,
        paymodeUsed: paymodeObj
      });
      savedPaymodesArray.unshift(paymodeObj);
      Object(__WEBPACK_IMPORTED_MODULE_1__logger__["log"])({
        eventType: __WEBPACK_IMPORTED_MODULE_1__logger__["EVENT"].PERSISTED_ARRAY,
        persistedLocalStorageArray: savedPaymodesArray
      });

      dummyFrame.contentWindow.postMessage({ type: 'SETDATA', key: 'savedPaymodes', data: savedPaymodesArray }, '*');
    }
  } catch (e) {
    Object(__WEBPACK_IMPORTED_MODULE_1__logger__["log"])({
      eventType: __WEBPACK_IMPORTED_MODULE_1__logger__["EVENT"].EXCEPTION,
      message: e.message,
      name: e.name
    });
  }
};

/***/ }),

/***/ "0gEq":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e(e, t) {
    var n,
        o,
        r,
        i,
        l = W;for (i = arguments.length; i-- > 2;) {
      P.push(arguments[i]);
    }t && null != t.children && (P.length || P.push(t.children), delete t.children);while (P.length) {
      if ((o = P.pop()) && void 0 !== o.pop) for (i = o.length; i--;) {
        P.push(o[i]);
      } else "boolean" == typeof o && (o = null), (r = "function" != typeof e) && (null == o ? o = "" : "number" == typeof o ? o += "" : "string" != typeof o && (r = !1)), r && n ? l[l.length - 1] += o : l === W ? l = [o] : l.push(o), n = r;
    }var a = new T();return a.nodeName = e, a.children = l, a.attributes = null == t ? void 0 : t, a.key = null == t ? void 0 : t.key, void 0 !== M.vnode && M.vnode(a), a;
  }function t(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function n(e, t) {
    e && ("function" == typeof e ? e(t) : e.current = t);
  }function o(n, o) {
    return e(n.nodeName, t(t({}, n.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : n.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == V.push(e) && (M.debounceRendering || D)(i);
  }function i() {
    var e;while (e = V.pop()) {
      e.__d && x(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var n = t({}, e.attributes);n.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === n[r] && (n[r] = o[r]);
    }return n;
  }function c(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function s(e, t, o, r, i) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n(o, null), n(r, e);else if ("class" !== t || i) {
      if ("style" === t) {
        if (r && "string" != typeof r && "string" != typeof o || (e.style.cssText = r || ""), r && "object" == typeof r) {
          if ("string" != typeof o) for (var l in o) {
            l in r || (e.style[l] = "");
          }for (var l in r) {
            e.style[l] = "number" == typeof r[l] && !1 === E.test(l) ? r[l] + "px" : r[l];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) r && (e.innerHTML = r.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var a = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), r ? o || e.addEventListener(t, _, a) : e.removeEventListener(t, _, a), (e.__l || (e.__l = {}))[t] = r;
      } else if ("list" !== t && "type" !== t && !i && t in e) {
        try {
          e[t] = null == r ? "" : r;
        } catch (e) {}null != r && !1 !== r || "spellcheck" == t || e.removeAttribute(t);
      } else {
        var u = i && t !== (t = t.replace(/^xlink:?/, ""));null == r || !1 === r ? u ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof r && (u ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), r) : e.setAttribute(t, r));
      }
    } else e.className = r || "";
  }function _(e) {
    return this.__l[e.type](M.event && M.event(e) || e);
  }function f() {
    var e;while (e = A.shift()) {
      M.afterMount && M.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function d(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, B = null != e && !("__preactattr_" in e));var l = h(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (B = !1, i || f()), l;
  }function h(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return N(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = c(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0);
    }var p = i.firstChild,
        s = i.__preactattr_,
        _ = t.children;if (null == s) {
      s = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        s[f[d].name] = f[d].value;
      }
    }return !B && _ && 1 === _.length && "string" == typeof _[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != _[0] && (p.nodeValue = _[0]) : (_ && _.length || null != p) && m(i, _, n, o, B || null != s.dangerouslySetInnerHTML), y(i, t.attributes, s), R = l, i;
  }function m(e, t, n, o, r) {
    var i,
        a,
        u,
        c,
        s,
        _ = e.childNodes,
        f = [],
        d = {},
        m = 0,
        b = 0,
        y = _.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = _[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (m++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      c = t[C], s = null;var k = c.key;if (null != k) m && void 0 !== d[k] && (s = d[k], d[k] = void 0, m--);else if (b < g) for (i = b; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], c, r)) {
          s = a, f[i] = void 0, i === g - 1 && g--, i === b && b++;break;
        }
      }s = h(s, c, n, o), u = _[C], s && s !== e && s !== u && (null == u ? e.appendChild(s) : s === u.nextSibling ? p(u) : e.insertBefore(s, u));
    }if (m) for (var C in d) {
      void 0 !== d[C] && v(d[C], !1);
    }while (b <= g) {
      void 0 !== (s = f[g--]) && v(s, !1);
    }
  }function v(e, t) {
    var o = e._component;o ? k(o) : (null != e.__preactattr_ && n(e.__preactattr_.ref, null), !1 !== t && null != e.__preactattr_ || p(e), b(e));
  }function b(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;v(e, !0), e = t;
    }
  }function y(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || s(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || s(e, o, n[o], n[o] = t[o], R);
    }
  }function g(e, t, n) {
    var o,
        r = F.length;e.prototype && e.prototype.render ? (o = new e(t, n), U.call(o, t, n)) : (o = new U(t, n), o.constructor = e, o.render = w);while (r--) {
      if (F[r].constructor === e) return o.__b = F[r].__b, F.splice(r, 1), o;
    }return o;
  }function w(e, t, n) {
    return this.constructor(e, n);
  }function C(e, t, o, i, l) {
    e.__x || (e.__x = !0, e.__r = t.ref, e.__k = t.key, delete t.ref, delete t.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || l ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, i)), i && i !== e.context && (e.__c || (e.__c = e.context), e.context = i), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== o && (1 !== o && !1 === M.syncComponentUpdates && e.base ? r(e) : x(e, 1, l)), n(e.__r, e));
  }function x(e, n, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          c = e.props,
          p = e.state,
          s = e.context,
          _ = e.__p || c,
          h = e.__s || p,
          m = e.__c || s,
          b = e.base,
          y = e.__b,
          w = b || y,
          N = e._component,
          U = !1,
          S = m;if (e.constructor.getDerivedStateFromProps && (p = t(t({}, p), e.constructor.getDerivedStateFromProps(c, p)), e.state = p), b && (e.props = _, e.state = h, e.context = m, 2 !== n && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(c, p, s) ? U = !0 : e.componentWillUpdate && e.componentWillUpdate(c, p, s), e.props = c, e.state = p, e.context = s), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !U) {
        i = e.render(c, p, s), e.getChildContext && (s = t(t({}, s), e.getChildContext())), b && e.getSnapshotBeforeUpdate && (S = e.getSnapshotBeforeUpdate(_, h));var L,
            T,
            P = i && i.nodeName;if ("function" == typeof P) {
          var W = u(i);l = N, l && l.constructor === P && W.key == l.__k ? C(l, W, 1, s, !1) : (L = l, e._component = l = g(P, W, s), l.__b = l.__b || y, l.__u = e, C(l, W, 0, s, !1), x(l, 1, o, !0)), T = l.base;
        } else a = w, L = N, L && (a = e._component = null), (w || 1 === n) && (a && (a._component = null), T = d(a, i, s, o || !b, w && w.parentNode, !0));if (w && T !== w && l !== N) {
          var D = w.parentNode;D && T !== D && (D.replaceChild(T, w), L || (w._component = null, v(w, !1)));
        }if (L && k(L), e.base = T, T && !r) {
          var E = e,
              V = e;while (V = V.__u) {
            (E = V).base = T;
          }T._component = E, T._componentConstructor = E.constructor;
        }
      }!b || o ? A.push(e) : U || (e.componentDidUpdate && e.componentDidUpdate(_, h, S), M.afterUpdate && M.afterUpdate(e));while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || f();
    }
  }function N(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        c = a,
        p = u(t);while (r && !c && (r = r.__u)) {
      c = r.constructor === t.nodeName;
    }return r && c && (!o || r._component) ? (C(r, p, 3, n, o), e = r.base) : (i && !a && (k(i), e = l = null), r = g(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), C(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, v(l, !1))), e;
  }function k(e) {
    M.beforeUnmount && M.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var o = e._component;o ? k(o) : t && (null != t.__preactattr_ && n(t.__preactattr_.ref, null), e.__b = t, p(t), F.push(e), b(t)), n(e.__r, null);
  }function U(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {}, this.__h = [];
  }function S(e, t, n) {
    return d(n, e, {}, !1, t, !1);
  }function L() {
    return {};
  }var T = function T() {},
      M = {},
      P = [],
      W = [],
      D = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      E = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      V = [],
      A = [],
      H = 0,
      R = !1,
      B = !1,
      F = [];t(U.prototype, { setState: function setState(e, n) {
      this.__s || (this.__s = this.state), this.state = t(t({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), n && this.__h.push(n), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && this.__h.push(e), x(this, 2);
    }, render: function render() {} });var j = { h: e, createElement: e, cloneElement: o, createRef: L, Component: U, render: S, rerender: i, options: M }; true ? module.exports = j : self.preact = j;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "1Lr7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return queryStr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Interceptor; });
/* harmony export (immutable) */ __webpack_exports__["e"] = runMiddleware;
/* unused harmony export urlEncodeData */
/* harmony export (immutable) */ __webpack_exports__["c"] = post;
/* harmony export (immutable) */ __webpack_exports__["b"] = get;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger__ = __webpack_require__("2HRo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__("y11t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__("TwIz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__checkout_src_utils_common__ = __webpack_require__("ocZ9");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






/* Error object to return in case of status 0 or try catch error */
var errorObj = {
  head: {},
  body: {
    objectType: 'genericError',
    resultInfo: {
      resultStatus: 'F',
      resultCode: '0000',
      resultMsg: __WEBPACK_IMPORTED_MODULE_2__constant__["j" /* MESSAGE */].GENERIC_ERROR
    }
  }
};

/**
 * parse query parameter object and return & separated key value pair
 * @param {Object} query - key value pair of query parameter
 * @return {String} - & separated key value pair
 * adding export so that this can be used to generate query string for content type other than
 * application/json where we arent sending the data in head body but need to send query params
 * */
var queryStr = function queryStr(query) {
  var output = '';
  Object.keys(query).forEach(function (key) {
    output += key + '=' + query[key] + '&';
  });
  return output;
};

var Interceptor = function Interceptor() {
  var _this = this;

  _classCallCheck(this, Interceptor);

  this.interceptors = {};

  this.add = function (interceptor) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__common__["f" /* isFunction */])(interceptor)) {
      // eslint-disable-next-line no-console
      console.error('interceptor should be of function type!');
      return null;
    }

    var key = Object(__WEBPACK_IMPORTED_MODULE_3__checkout_src_utils_common__["n" /* generateUUID */])();
    _this.interceptors[key] = interceptor;
    return _this._remove.bind(_this, key);
  };

  this.getAsArray = function () {
    return Object(__WEBPACK_IMPORTED_MODULE_1__common__["j" /* objectValues */])(_this.interceptors);
  };

  this._remove = function (key) {
    _this.interceptors[key] && delete _this.interceptors[key];
  };
}

/**
 * Private method to remove middleware
 * @param {string} key : Unique/UUID key for interceptor
 */
;

/**
 * Loop over all the middleware attached to this instance and modify the request object as per their preferences
 *
 * @param {Object} payload - default request payload
 * @return {Object} - modified request payload
 * */
function runMiddleware(payload) {
  var options = payload;
  options.query = {};
  var getInterceptors = Object(__WEBPACK_IMPORTED_MODULE_1__common__["b" /* getKey */])(this, 'middleware.getAsArray');

  if (Object(__WEBPACK_IMPORTED_MODULE_1__common__["f" /* isFunction */])(getInterceptors)) {
    getInterceptors().forEach(function (interceptor) {
      options = interceptor(options);
    });
  }
  if (options.url.search('/v2/') > -1) {
    options.data.head.version = 'v2';
  }

  return options;
}

/**
 * Convert a form data to url encoded form
 * @param {Object} obj - object
 */
function urlEncodeData(obj) {
  var s = '';
  function encode(s) {
    return encodeURIComponent(s).replace(/%20/g, '+');
  }
  Object.keys(obj).forEach(function (key) {
    s += (s ? '&' : '') + encode(key) + '=' + encode(obj[key]);
  });
  return s;
}

/**
 * Send ajax request to native api server.
 *
 * @param {object} payload - option object contains required data - url,method,data
 * @returns {Promise<any>} - ajax promise object
 * @private
 */
function _ajax(payload) {
  var options = {};
  var callerContext = this;

  if (payload.method === 'GET') {
    options = payload;
    options.query = {};
  } else {
    // skip middleware in case of merchant server url
    options = payload.skipMiddleware ? payload : Object(__WEBPACK_IMPORTED_MODULE_1__common__["f" /* isFunction */])(Object(__WEBPACK_IMPORTED_MODULE_1__common__["b" /* getKey */])(this, 'runMiddleware')) && this.runMiddleware(payload);
  }

  return new Promise(function (resolve, reject) {
    var xhr = new window.XMLHttpRequest();
    var url = options.url + (!Object(__WEBPACK_IMPORTED_MODULE_1__common__["b" /* getKey */])(payload, 'noQueryParam', false) && options.query ? '?' + queryStr(options.query) : '');
    xhr.open(options.method, url);
    /* if content type is being passed through options then set that content type */
    if (options['Content-type']) {
      xhr.setRequestHeader('Content-Type', options['Content-type']);
    } else {
      xhr.setRequestHeader('Content-type', __WEBPACK_IMPORTED_MODULE_2__constant__["b" /* CONTENT_TYPE */].JSON);
    }

    var payModeDetails = {};
    if (url.indexOf(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* API */].PT) !== -1) {
      payModeDetails = {
        paymentMode: Object(__WEBPACK_IMPORTED_MODULE_1__common__["b" /* getKey */])(options, 'data.body.paymentMode'),
        channelCode: Object(__WEBPACK_IMPORTED_MODULE_1__common__["b" /* getKey */])(options, 'data.body.channelCode'),
        bankCode: Object(__WEBPACK_IMPORTED_MODULE_1__common__["b" /* getKey */])(options, 'data.body.issuingBankCode')
      };
    }

    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* pubsubLogger */].info(_extends({ eventType: __WEBPACK_IMPORTED_MODULE_2__constant__["g" /* EVENT */].API_INIT, url: url }, payModeDetails));
    /* istanbul ignore next */
    xhr.onreadystatechange = function onReadyStateChange() {
      if (this.readyState === 4) {
        var data = {};

        try {
          data = JSON.parse(this.responseText);
          __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* pubsubLogger */].info(_extends({
            eventType: __WEBPACK_IMPORTED_MODULE_2__constant__["g" /* EVENT */].API_STATUS,
            url: url,
            data: data,
            statusCode: this.status
          }, payModeDetails));
        } catch (e) {
          data = {};
          if (this.status >= 400 && this.status <= 599) {
            __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* pubsubLogger */].info(_extends({
              eventType: __WEBPACK_IMPORTED_MODULE_2__constant__["g" /* EVENT */].API_STATUS,
              url: url,
              data: errorObj,
              statusCode: this.status
            }, payModeDetails));
            return reject(errorObj); // reject with generic error object
          }
        }

        // if no net status is 0
        if (this.status === 0) {
          __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* pubsubLogger */].info(_extends({
            eventType: __WEBPACK_IMPORTED_MODULE_2__constant__["g" /* EVENT */].API_STATUS,
            url: url,
            data: errorObj,
            statusCode: this.status
          }, payModeDetails));
          return reject(errorObj);
        }

        if (this.status >= 200 && this.status < 400) {
          var getInterceptors = Object(__WEBPACK_IMPORTED_MODULE_1__common__["b" /* getKey */])(callerContext, 'postFetch.getAsArray');
          if (Object(__WEBPACK_IMPORTED_MODULE_1__common__["f" /* isFunction */])(getInterceptors)) {
            getInterceptors().forEach(function (interceptor) {
              interceptor({ response: data, request: options });
            });
          }

          if (data && data.body) {
            return resolve(data);
          }
          return resolve(data);
        }

        if (this.status >= 400 && this.status <= 599) {
          if (data && data.body) {
            return reject(data);
          }
          return reject(data);
        }
      }
      return null;
    };
    if (options.data && options['Content-type'] === __WEBPACK_IMPORTED_MODULE_2__constant__["b" /* CONTENT_TYPE */].FORM_URLENCODED) {
      xhr.send(urlEncodeData(options.data));
    } else if (options.data) {
      // POST,PUT request with data payload
      xhr.send(JSON.stringify(options.data));
    } else {
      // GET , DELETE request
      xhr.send();
    }
  });
}

/**
 * ajax POST request
 *
 * @param {string} url - ajax request url
 * @param {object} data - json data send over post request
 * @param {Boolean/object} skipMiddleware - boolean flag to skip running the middleware over request object
 * @returns {Promise<any>} - promise object contains response from server
 * @throws {Error} - throw if url is empty or not of string type
 */
function post(url, data, skipMiddleware) {
  var options = {};
  options.method = __WEBPACK_IMPORTED_MODULE_2__constant__["k" /* METHOD */].POST;
  __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* pubsubLogger */].debug({ eventType: __WEBPACK_IMPORTED_MODULE_2__constant__["k" /* METHOD */].POST, url: url, data: data, skipMiddleware: skipMiddleware });
  if (!url) {
    throw new Error('url cannot be empty or null');
  }
  options.url = url;
  if (data) {
    options.data = data;
  }
  options.skipMiddleware = skipMiddleware || false;
  if (skipMiddleware && typeof skipMiddleware === 'object') {
    /* if the skipMiddleware is being passed as object it wil contain skipMiddleware key and
    content tye */
    options.skipMiddleware = skipMiddleware.skipMiddleware;
    options['Content-type'] = skipMiddleware['Content-type'];
  }
  return _ajax.call(this, options);
}

function get(url, option) {
  var options = {};
  options.method = __WEBPACK_IMPORTED_MODULE_2__constant__["k" /* METHOD */].GET;
  __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* pubsubLogger */].debug({ eventType: __WEBPACK_IMPORTED_MODULE_2__constant__["k" /* METHOD */].GET, url: url, option: option });
  if (!url) {
    throw new Error('url cannot be empty or null');
  }
  options.url = url;
  options.skipMiddleware = option && option.skipMiddleware || false;
  options.noQueryParam = Object(__WEBPACK_IMPORTED_MODULE_1__common__["b" /* getKey */])(option, 'noQueryParam', false);
  return _ajax.call(this, options);
}

/***/ }),

/***/ "1Vik":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_utils_common__ = __webpack_require__("ocZ9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_src_utils_common__ = __webpack_require__("y11t");
var _this = this;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* -------------------------------- POLYFILLS ------------------------------ */

var promiseLoadHandler = function _promiseLoadHandler() {
  var _promiseLoadSubscribers = [];

  function onPromiseResolved() {
    _promiseLoadSubscribers.forEach(function (cb) {
      return cb();
    });
    _promiseLoadSubscribers = [];
  }

  function addPromiseLoadSubscriber(cb) {
    Object(__WEBPACK_IMPORTED_MODULE_0__src_utils_common__["y" /* isFunction */])(cb) && _promiseLoadSubscribers.push(cb);
  }

  return {
    onPromiseResolved: onPromiseResolved,
    addPromiseLoadSubscriber: addPromiseLoadSubscriber
  };
}();

(function polyfillHandler() {
  function _loadPolyfill(path, next) {
    var s = document.createElement('script');
    s.type = 'application/javascript';
    s.async = true;
    s.src = path;
    s.onload = function onScriptLoad() {
      next && next();
    };
    document.body.appendChild(s);
  }

  // Promise polyfill
  window.Promise || _loadPolyfill('https://staticpg.paytm.in/common/lib/promise/promise-polyfill.min.js', promiseLoadHandler.onPromiseResolved);

  // String.fromCodePoint polyfill
  // Source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/fromCodePoint
  // eslint-disable-next-line
  String.fromCodePoint || function (d) {
    var f = function f(g) {
      for (var b = [], a, e = "", c = 0, h = arguments.length; c !== h; ++c) {
        a = +arguments[c];if (!(1114111 > a && a >>> 0 === a)) throw RangeError("Invalid code point: " + a);65535 >= a ? a = b.push(a) : (a -= 65536, a = b.push((a >> 10) + 55296, a % 1024 + 56320));16383 <= a && (e += d.apply(null, b), b.length = 0);
      }return e + d.apply(null, b);
    };try {
      Object.defineProperty(String, "fromCodePoint", { value: f, configurable: !0, writable: !0 });
    } catch (g) {
      String.fromCodePoint = f;
    }
  }(String.fromCharCode);
  // Number.isNaN poyfill
  // Source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isNaN
  // eslint-disable-next-line
  Number.isNaN = Number.isNaN || function (a) {
    return "number" === typeof a && a !== a;
  };
})();

/* -------------------------------------------------------------------------- */

var _preact = __webpack_require__("0gEq");

var interopDefault = function interopDefault(m) {
  return m && m.default ? m.default : m;
};

// eslint-disable-next-line import/no-unresolved
var app = interopDefault(__webpack_require__("JkW7"));

var checkout = __webpack_require__("KD7D");
var logger = __webpack_require__("lq6S");

if (typeof app === 'function') {
  var _config = {};
  var _renderedAppDataId = '';

  (function loadLogScript() {
    var ele = document.createElement('script');
    if (ele) {
      ele.type = 'application/javascript';
      ele.src = 'https://staticpg.paytm.in/common/lib/logger/ui-logger.min.js';
      ele.async = true;
      ele.crossOrigin = 'anonymous';
      ele.onload = function () {
        logger.init({
          debug: "prod" !== 'prod',
          env: 'checkoutjs_' + "prod"
        });
      };
      document.body.appendChild(ele);
    }
  })();

  var removeElementById = function removeElementById(id) {
    var element = document.getElementById(id);

    if (element) {
      element.remove();
    }
  };

  var element = function element(selector) {
    var ele = void 0;
    if (!selector) {
      var elementId = 'paytm-checkoutjs';
      removeElementById(elementId);
      // when merchant doesn't pass the selector
      ele = document.createElement('div');
      ele.id = elementId; // parent element
      ele.setAttribute('class', 'ptm-own-element');
      document.body.appendChild(ele);
    } else if (selector.constructor === String) {
      // merchant has pass the selector
      ele = document.querySelector(selector);
      if (!ele) {
        throw new Error('selector id ' + selector + ' not exists in the dom');
      }
    } else if (selector instanceof HTMLElement) {
      ele = selector;
    } else {
      // selector is not a string value
      throw new Error('selector should be of string or HTMLElement');
    }
    ele.appendChild(document.createElement('div')); // element in which app is render
    return ele;
  };

  var removeElementByAttribute = function removeElementByAttribute(attribute, value) {
    var element = document.querySelector('[' + attribute + '=\'' + value + '\']');

    if (element) {
      element.remove();
    }
  };

  var _init = function _init(instanceKey, selector) {
    var dataIdAttrName = 'data-id';

    if (!selector && _renderedAppDataId) {
      removeElementByAttribute(dataIdAttrName, _renderedAppDataId);
    }
    // eslint-disable-next-line global-require,import/no-unresolved
    app = interopDefault(__webpack_require__("JkW7"));
    var ele = element(selector || _config.root);

    if (ele) {
      var props = { instanceKey: instanceKey };
      var renderedEl = (0, _preact.render)((0, _preact.h)(app, props), ele, ele.firstElementChild);

      if (renderedEl) {
        _renderedAppDataId = 'paytm-checkout-app-' + new Date().getTime();
        renderedEl.setAttribute(dataIdAttrName, _renderedAppDataId);
      }
    } else {
      throw new Error('checkout not initialize. Please check root field of merchant configuration');
    }
  };

  if (false) module.hot.accept('preact-cli-entrypoint', _init);
  var _isInitResolved = false;
  var _isInvokeQueued = false;

  var _createElement = function _createElement(baseConfig, payMode, elementConfig) {
    var mergedElementConfig = _extends({}, baseConfig);

    if (typeof checkout.helpers.getKey(elementConfig, 'root') !== 'string') {
      return console.error('Please provide root value in config');
    }

    mergedElementConfig.root = elementConfig.root;

    if (checkout.helpers.isObject(elementConfig.style)) {
      mergedElementConfig.style = elementConfig.style;
    }

    var isValidPayMode = Object.keys(checkout.ELEMENT_PAYMODE).some(function (mode) {
      return checkout.ELEMENT_PAYMODE[mode].toLowerCase() === (payMode || '').toLowerCase();
    });
    if (!isValidPayMode) {
      return console.error('Invalid paymode');
    }

    var isInvokeQueued = null;
    var isInitialized = false;

    var _checkout$createInsta = checkout.createInstance(payMode),
        init = _checkout$createInsta.init,
        close = _checkout$createInsta.close,
        instanceKey = _checkout$createInsta.instanceKey;

    var invokeFn = _init.bind(_this, instanceKey);

    init(mergedElementConfig).then(function () {
      isInvokeQueued && invokeFn(mergedElementConfig.root);
      isInitialized = true;
      isInvokeQueued = false;
    }).catch(function (error) {
      console.error(error.message);
    });

    return {
      invoke: function invoke() {
        if (isInitialized) {
          invokeFn(mergedElementConfig.root);
        } else {
          console.info('Invoke has been queued. It will be automatically called once element initialization is completed!');
          isInvokeQueued = true;
        }
      },
      close: close
    };
  };

  window.CheckoutJS = {
    init: function init() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var mid = checkout.helpers.getMid();
      var orderId = Object(__WEBPACK_IMPORTED_MODULE_0__src_utils_common__["q" /* getKey */])(config, 'data.orderId', '');
      var txnToken = Object(__WEBPACK_IMPORTED_MODULE_0__src_utils_common__["q" /* getKey */])(config, 'data.token', '');

      // When multipleWindowWebview key is false & webview is there then redirection flow initiated
      if (Object(__WEBPACK_IMPORTED_MODULE_1__common_src_utils_common__["h" /* isWebViewFlow */])(config)) {
        if (orderId && mid && txnToken) {
          window.location.href = Object(__WEBPACK_IMPORTED_MODULE_0__src_utils_common__["T" /* showPaymentPageUrl */])() + '?mid=' + mid + '&orderId=' + orderId + '&txnToken=' + txnToken + '&flow=checkout&mode=webview';
          return Promise.resolve();
        }
      }
      _config = config;
      _isInitResolved = false;

      return checkout.init(config).then(function (response) {
        _isInitResolved = true;

        if (_isInvokeQueued) {
          _this.invoke();
        }

        return response;
      });
    },
    invoke: function invoke() {
      if (!_isInitResolved) {
        _isInvokeQueued = true;
        /* eslint no-console: "off" */
        console.info('Invoke has been queued. It will be automatically called once init is completed! Please do make sure to call init.');
        return;
      }

      _isInvokeQueued = false;
      _init(checkout.BASE_INSTANCE_KEY);
    },
    elements: function elements(config) {
      if (!config) {
        return console.error('Please provide config!');
      }

      try {
        checkout.helpers.setMerchantConfig(config, true);
      } catch (error) {
        return console.error(error.message);
      }

      config.merchant = config.merchant || {};
      config.merchant.hidePaytmBranding = true;

      checkout.helpers.fetchPaymentOptions({
        token: config.data.token,
        orderId: config.data.orderId,
        tokenType: config.data.tokenType
      }).catch(function (error) {
        console.error(error);
      });

      return {
        createElement: _createElement.bind(null, config)
      };
    },

    close: function close() {
      checkout.close();
    },
    initLib: function initLib(mid) {
      var catchCallback = void 0;
      return window.Promise ? checkout.initLib(mid) : {
        then: function then(resolve, reject) {
          promiseLoadHandler.addPromiseLoadSubscriber(function () {
            checkout.initLib(mid).then(resolve, reject).catch(function (error) {
              catchCallback && catchCallback(error);
            });
          });
        },
        catch: function _catch(cb) {
          catchCallback = cb;
        }
      };
    },
    PAYMODE: JSON.parse(JSON.stringify(checkout.PAYMODE)),
    ELEMENT_PAYMODE: JSON.parse(JSON.stringify(checkout.ELEMENT_PAYMODE)),
    FLOW: JSON.parse(JSON.stringify(checkout.FLOW)),
    TOKEN: JSON.parse(JSON.stringify(checkout.TOKEN)),
    DEFERRED_EVENTS: JSON.parse(JSON.stringify(checkout.DEFERRED_EVENTS)),
    NOTIFY_MERCHANT_EVENTS: JSON.parse(JSON.stringify(checkout.NOTIFY_MERCHANT_EVENTS))
  };
}

/***/ }),

/***/ "2FAC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function n(n, t) {
  for (var r in t) {
    n[r] = t[r];
  }return n;
}/* harmony default export */ __webpack_exports__["a"] = (function (t) {
  var r = [];function u(n) {
    for (var t = [], u = 0; u < r.length; u++) {
      r[u] === n ? n = null : t.push(r[u]);
    }r = t;
  }function e(u, e, f) {
    t = e ? u : n(n({}, t), u);for (var i = r, o = 0; o < i.length; o++) {
      i[o](t, f);
    }
  }return t = t || {}, { action: function action(n) {
      function r(t) {
        e(t, !1, n);
      }return function () {
        for (var u = arguments, e = [t], f = 0; f < arguments.length; f++) {
          e.push(u[f]);
        }var i = n.apply(this, e);if (null != i) return i.then ? i.then(r) : r(i);
      };
    }, setState: e, subscribe: function subscribe(n) {
      return r.push(n), function () {
        u(n);
      };
    }, unsubscribe: u, getState: function getState() {
      return t;
    } };
});
//# sourceMappingURL=unistore.es.js.map

/***/ }),

/***/ "2HRo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pubsubLogger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__("y11t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__("TwIz");
var _logPriorityMap;




var subscribers = [];
var logPriorityMap = (_logPriorityMap = {}, _logPriorityMap[__WEBPACK_IMPORTED_MODULE_1__constant__["i" /* LOGGER */].INFO] = 20, _logPriorityMap[__WEBPACK_IMPORTED_MODULE_1__constant__["i" /* LOGGER */].DEBUG] = 30, _logPriorityMap);

function getEventCallback(argsArr) {
  var obj = { event: __WEBPACK_IMPORTED_MODULE_1__constant__["i" /* LOGGER */].INFO, callback: null };
  if (argsArr.length === 1) {
    obj.callback = argsArr[0];
  } else if (argsArr.length === 2) {
    obj.callback = argsArr[1];
    obj.event = argsArr[0];
  }
  return obj;
}

var pubsubLogger = {
  publish: function publish(event, data) {
    if (subscribers.length === 0) return;
    subscribers.forEach(function (subsObj) {
      if (logPriorityMap[event] <= logPriorityMap[subsObj.logLavel]) {
        subsObj.callback(data);
      }
    });
  },
  info: function info(data) {
    this.publish(__WEBPACK_IMPORTED_MODULE_1__constant__["i" /* LOGGER */].INFO, data);
  },
  debug: function debug(data) {
    this.publish(__WEBPACK_IMPORTED_MODULE_1__constant__["i" /* LOGGER */].DEBUG, data);
  },
  subscribe: function subscribe() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _getEventCallback = getEventCallback(Array.prototype.slice.call(args)),
        event = _getEventCallback.event,
        callback = _getEventCallback.callback;

    if (!Object(__WEBPACK_IMPORTED_MODULE_0__common__["f" /* isFunction */])(callback)) {
      throw new Error('Callback must be a function');
    }

    if (typeof event !== 'string') {
      throw new Error('event name must be a string');
    }

    var logLavel = event.toUpperCase();
    if (!Object.prototype.hasOwnProperty.call(__WEBPACK_IMPORTED_MODULE_1__constant__["i" /* LOGGER */], logLavel)) {
      throw new Error('event name must be a valid string : ', __WEBPACK_IMPORTED_MODULE_1__constant__["i" /* LOGGER */]);
    }

    var uniqueId = new Date().getTime();
    subscribers.push({ id: uniqueId, logLavel: logLavel, callback: callback });

    return {
      unsubscribe: function unsubscribe() {
        subscribers = subscribers.filter(function (subsObj) {
          return uniqueId !== subsObj.id;
        });
      }
    };
  }
};

/***/ }),

/***/ "6SrU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getErrorMessage */
/* unused harmony export ifSuccessOrThrowError */
/* harmony export (immutable) */ __webpack_exports__["a"] = getDeferredCallbackResponseForEvent;
/* harmony export (immutable) */ __webpack_exports__["b"] = initiateCheckout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("hafV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__("ocZ9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_src_utils_common__ = __webpack_require__("y11t");




var _STATUS = {
  SUCCESS: [__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* RESPONSE_STATUS */].SUCCESS, __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* RESPONSE_STATUS */].S]
};

function getErrorMessage(response) {
  var statusCode = Object(__WEBPACK_IMPORTED_MODULE_1__common__["q" /* getKey */])(response, 'status.code', null);
  var status = Object(__WEBPACK_IMPORTED_MODULE_1__common__["q" /* getKey */])(response, 'status', null);
  var cartError = Object(__WEBPACK_IMPORTED_MODULE_1__common__["q" /* getKey */])(response, 'cart.error', null);

  if (status && Object(__WEBPACK_IMPORTED_MODULE_1__common__["H" /* isString */])(status) && !_STATUS.SUCCESS.includes(status)) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__common__["q" /* getKey */])(response, 'message', __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* default */].GENERIC_ERROR);
  }

  if (statusCode && statusCode !== __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* RESPONSE_STATUS_CODE */].SUCCESS) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__common__["q" /* getKey */])(response, 'status.message.message', __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* default */].GENERIC_ERROR);
  }

  if (cartError) {
    return cartError;
  }

  return null;
}

function ifSuccessOrThrowError(response, successCallback) {
  var error = getErrorMessage(response);
  if (Object(__WEBPACK_IMPORTED_MODULE_2__common_src_utils_common__["g" /* isNull */])(error)) {
    return successCallback(response);
  }

  throw new Error(error);
}

function getDeferredCallbackResponseForEvent(cache, deferredEvent) {
  for (var _len = arguments.length, payload = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    payload[_key - 2] = arguments[_key];
  }

  var config = cache.getData(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CACHE */].MERCHANT_CONFIG);

  return new Promise(function (resolve, reject) {
    var _config$handler;

    (_config$handler = config.handler).deferred.apply(_config$handler, [deferredEvent].concat(payload)).then(function (response) {
      ifSuccessOrThrowError(response, function (callbackResponse) {
        resolve(callbackResponse);
      });
    }).catch(function (error) {
      reject(error);
    });
  });
}

function initiateCheckout(payload) {
  return getDeferredCallbackResponseForEvent(__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* default */].DEFERRED_EVENTS.INITIATE_TXN, payload);
}

/***/ }),

/***/ "AWfl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _getFormHtmlNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return paymentConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return openPopUpWindow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handlePostData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return postInWindow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return openWindowPopup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("hafV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__("ocZ9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_src_utils_common__ = __webpack_require__("y11t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_logger__ = __webpack_require__("lq6S");
var _this = this;

/* eslint-disable no-undef,no-restricted-syntax,no-prototype-builtins */





var popupLoaded = false;

var _submitForm = function _submitForm(res, cache) {
  var w = cache.getData(__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* default */].POPUP_WINDOW);
  if (w) {
    if (res && res.body && res.body.resultInfo && res.body.resultInfo.resultStatus === 'S') {
      w.postMessage(res.body, '*');
    } else {
      // pay api failed and set the IS_SELF_CLOSE to true
      cache.setData(__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* default */].IS_SELF_CLOSE, true);
      /* if retry is set true dont hide overlay  to show the retry msg */
      var retryValue = Object(__WEBPACK_IMPORTED_MODULE_1__common__["q" /* getKey */])(res, 'body.resultInfo.retry', false);
      if (!retryValue) {
        cache.getData(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CACHE */].STORE).setState({ overlayValue: '' });
      }
      w.close();
      popupLoaded = false;
    }
  }
};

var bankPopupMessageHandler = function bankPopupMessageHandler(cache, e) {
  if (e.data.type === 'BANK_HTML_LOADED') {
    popupLoaded = true;
    if (cache.getData(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CACHE */].DEFERRED_POPUP_DATA)) {
      var _cache$getData = cache.getData(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CACHE */].DEFERRED_POPUP_DATA),
          res = _cache$getData.res;

      _submitForm(res, cache);
    }
  }
};

var shouldWindowOpen = function shouldWindowOpen(selected) {
  if (selected && (selected.type === 'nb' || selected.type === 'sc' || selected.type === 'card' || selected.type === 'upi' || selected.type === 'ppbl' || selected.type === 'emi' || selected.type === 'upipush' || selected.type === __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* default */].BM || selected.type === __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* default */].SAVED_BANK_MANDATE_PAY_TYPE)) {
    return true; // open window popup if paymode is nb,saved card , card ( credit , debit ) , upi collect , payment bank ( ppb ) , postpaid ( pdc )
  }
  return false;
};

var notifyPaymentStatusFromPopup = function notifyPaymentStatusFromPopup(popup, cache) {
  function notifyFromPopup(event) {
    if (event.source === popup) {
      if (event.data.type === 'BANK_HTML_LOADED') {
        bankPopupMessageHandler(cache, event);
      } else {
        popup.close();
        window.removeEventListener('message', notifyFromPopup, false);
      }
    }
  }
  return notifyFromPopup;
};

var _getFormHtmlNode = function _getFormHtmlNode(data) {
  var node = document.createElement('form');
  node.action = data.callbackUrl || data.callBackUrl || '';
  node.method = 'post';
  for (var key in data.content) {
    if (data.content.hasOwnProperty(key)) {
      var inputNode = document.createElement('input');
      var value = data.content[key];
      inputNode.type = 'hidden';
      inputNode.value = value;
      inputNode.name = key;
      node.appendChild(inputNode);
    }
  }
  return node;
};

var _handleTxnStatusData = function _handleTxnStatusData(cache, data) {
  var config = cache.getData(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CACHE */].MERCHANT_CONFIG);
  cache.getData(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CACHE */].STORE).setState({ overlayValue: '' });
  Object(__WEBPACK_IMPORTED_MODULE_3__common_logger__["log"])({ eventType: __WEBPACK_IMPORTED_MODULE_3__common_logger__["EVENT"].TXN_STATUS_HANDLED });
  /* setting popup data to be null so that every time there is a new txn, new data is picked */
  cache.setData(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CACHE */].DEFERRED_POPUP_DATA, null);

  if (Object(__WEBPACK_IMPORTED_MODULE_1__common__["q" /* getKey */])(data, 'body.resultStatus') === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* RESPONSE_STATUS */].F && Object(__WEBPACK_IMPORTED_MODULE_1__common__["q" /* getKey */])(data, 'body.retry')) {
    cache.getData(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CACHE */].STORE).setState({
      overlayValue: __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* default */].RETRY,
      retryMessage: Object(__WEBPACK_IMPORTED_MODULE_1__common__["q" /* getKey */])(data, 'body.resultMsg'),
      isPollingRequired: false
    });
  } else if (Object(__WEBPACK_IMPORTED_MODULE_1__common__["q" /* getKey */])(config, 'merchant.redirect')) {
    var form = _getFormHtmlNode(data.body);
    document.body.appendChild(form);
    form.submit();
  } else {
    var merchantHandler = config.handler && config.handler.transactionStatus;
    if (typeof merchantHandler === 'function') {
      merchantHandler(data.body.content);
    }
  }
};

var paymentConfirmation = function paymentConfirmation(cache, retryCallback) {
  var config = cache.getData(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CACHE */].MERCHANT_CONFIG);
  var isPaymentConfirmationRequestInProgress = cache.getData(__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* default */].IS_PAYMENT_REQUEST_CONFIRMATION_PROGRESS);
  if (isPaymentConfirmationRequestInProgress === true) {
    return;
  }
  cache.setData(__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* default */].IS_PAYMENT_REQUEST_CONFIRMATION_PROGRESS, true);
  cache.getData(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CACHE */].API).status(Object(__WEBPACK_IMPORTED_MODULE_1__common__["q" /* getKey */])(config, 'merchant.mid', undefined), Object(__WEBPACK_IMPORTED_MODULE_1__common__["q" /* getKey */])(config, 'data.orderId', undefined)).then(function (res) {
    cache.setData(__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* default */].IS_PAYMENT_REQUEST_CONFIRMATION_PROGRESS, false);
    _handleTxnStatusData(cache, {
      body: {
        callbackUrl: Object(__WEBPACK_IMPORTED_MODULE_1__common__["q" /* getKey */])(res, 'body.callbackUrl', undefined),
        content: Object(__WEBPACK_IMPORTED_MODULE_1__common__["q" /* getKey */])(res, 'body.txnInfo', undefined),
        resultMsg: Object(__WEBPACK_IMPORTED_MODULE_1__common__["q" /* getKey */])(res, 'body.resultInfo.resultMsg', undefined),
        resultStatus: Object(__WEBPACK_IMPORTED_MODULE_1__common__["q" /* getKey */])(res, 'body.resultInfo.resultStatus', undefined),
        retry: Object(__WEBPACK_IMPORTED_MODULE_1__common__["q" /* getKey */])(res, 'body.resultInfo.retry', false)
      }
    }, config);
  }).catch(function (err) {
    cache.setData(__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* default */].IS_PAYMENT_REQUEST_CONFIRMATION_PROGRESS, false);
    cache.getData(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CACHE */].STORE).setState({ overlayValue: '' });
    var resultInfo = Object(__WEBPACK_IMPORTED_MODULE_1__common__["q" /* getKey */])(err, 'body.resultInfo', undefined);
    if (retryCallback) {
      retryCallback(resultInfo || {});
    }
  });
};

var _onCloseWatcher = function _onCloseWatcher(win, retryCallback, cache) {
  var timer = setInterval(function () {
    if (win.closed) {
      clearInterval(timer);
      popupLoaded = false;
      if (cache.getData(__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* default */].IS_SELF_CLOSE) !== true && !cache.getData(__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* default */].IS_DIRECT_BANK, false)) {
        paymentConfirmation(cache, retryCallback);
      }
    }
  }, 1000);
  window.addEventListener('message', notifyPaymentStatusFromPopup(win, cache), false);
};

var _getOptimalDimension = function _getOptimalDimension(evaluated, minBestFit, maxBestFit) {
  return Math.min(Math.max(Math.floor(evaluated), minBestFit), maxBestFit);
};

var _openCenteredWindowPopup = function _openCenteredWindowPopup(url, name) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__common__["E" /* isMobileDevice */])()) {
    return window.open(url, name);
  }

  var width = _getOptimalDimension(0.7 * window.innerWidth, 895, 1440);
  var height = _getOptimalDimension(0.8 * window.innerHeight, 520, 1060);
  var top = parseInt(window.outerHeight / 2 - (height - (window.screenY || window.screenTop)) / 2, 10);
  var left = parseInt(window.outerWidth / 2 - (width - (window.screenX || window.screenLeft)) / 2, 10);

  return window.open(url, name, 'toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=' + width + ', height=' + height + ', top=' + top + ', left=' + left);
};

var openPopUpWindow = function openPopUpWindow(cache) {
  /* setting popup data to be null so that every time there is a new txn, new data is picked */
  cache.setData(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CACHE */].DEFERRED_POPUP_DATA, null);
  var selected = Object(__WEBPACK_IMPORTED_MODULE_1__common__["q" /* getKey */])(cache.getData(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CACHE */].STORE).getState(), 'selected', {});
  var isBankPageBlocked = cache.getData(__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* default */].IS_BANKPAGE_REQUIRED_BLOCKED, false);
  var mConfig = cache.getData(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CACHE */].MERCHANT_CONFIG);
  var webViewFlow = Object(__WEBPACK_IMPORTED_MODULE_2__common_src_utils_common__["h" /* isWebViewFlow */])(mConfig);
  cache.setData(__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* default */].WEB_VIEW_FLOW, webViewFlow);
  if (!webViewFlow && !isBankPageBlocked && shouldWindowOpen(selected)) {
    var w = _openCenteredWindowPopup(Object(__WEBPACK_IMPORTED_MODULE_2__common_src_utils_common__["c" /* getStaticPath */])() + '/assets/iframes/bank.html', '_blank');
    if (w) {
      try {
        w.addEventListener('message', bankPopupMessageHandler.bind(_this, cache), false);
      } catch (e) {}
      cache.setData(__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* default */].POPUP_WINDOW, w);
      cache.setData(__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* default */].IS_SELF_CLOSE, false);
      _onCloseWatcher(w, function () {}, cache);
    }
  }
};

var handlePostData = function handlePostData(data, cache) {
  _handleTxnStatusData(cache, data);
};

/* setting force close because in case of deferred flow api is returniing error before the bank page can be loaded */
var postInWindow = function postInWindow(res, cache, forceClose) {
  if (popupLoaded) {
    _submitForm(res, cache);
  } else if (cache.getData(__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* default */].WEB_VIEW_FLOW)) {
    var form = _getFormHtmlNode(res.body);
    document.body.appendChild(form);
    form.submit();
  } else if (res && Object.keys(res).length) {
    cache.setData(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CACHE */].DEFERRED_POPUP_DATA, { res: res, forceClose: forceClose });
  } else if (forceClose === true) {
    _submitForm(res, cache);
  }
};

var openWindowPopup = function openWindowPopup(cache) {
  var selected = Object(__WEBPACK_IMPORTED_MODULE_1__common__["q" /* getKey */])(cache.getData(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CACHE */].STORE).getState(), 'selected', {});
  shouldWindowOpen(selected) && openPopUpWindow(cache);
};

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./style/style.module.scss
var style_module = __webpack_require__("+mM3");
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);

// EXTERNAL MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("0gEq");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/node_modules/unistore/preact.js
var preact = __webpack_require__("LeMX");
var preact_default = /*#__PURE__*/__webpack_require__.n(preact);

// EXTERNAL MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/node_modules/unistore/dist/unistore.es.js
var unistore_es = __webpack_require__("2FAC");

// EXTERNAL MODULE: ./common/cache.js
var common_cache = __webpack_require__("WsRd");

// CONCATENATED MODULE: ./common/actions.js
var onChange = function onChange() {
  return {
    onPayChange: function onPayChange(state, val) {
      return { payEnabled: val };
    },
    onSelectChange: function onSelectChange(state, selected) {
      return { selected: selected };
    },
    onSubSelectChange: function onSubSelectChange(state, subSelected) {
      return { subSelected: subSelected };
    },
    onLoginDataChange: function onLoginDataChange(state, payOption) {
      return {
        payData: payOption.payData,
        wallet: payOption.wallet,
        mgv: payOption.mgv,
        loginInfo: payOption.loginInfo
      };
    },
    onSessionExpire: function onSessionExpire(state, sessionExpired) {
      return {
        sessionExpired: sessionExpired
      };
    },
    onOtpSentChange: function onOtpSentChange(state, show) {
      return {
        showOtpSent: show
      };
    },
    onPayDataChange: function onPayDataChange(state, paymentOptions) {
      return { payData: paymentOptions.payData };
    },
    onWalletToggle: function onWalletToggle(state, wallet) {
      return { wallet: wallet };
    },
    onOverlayValueChange: function onOverlayValueChange(state, overlayValue) {
      return { overlayValue: overlayValue };
    },
    onRetryMessageChange: function onRetryMessageChange(state, message) {
      return {
        retryMessage: message
      };
    },
    onBtnTextChange: function onBtnTextChange(state, text, btnSubText) {
      return { btnText: text, btnSubText: btnSubText };
    },
    onSelectedPlan: function onSelectedPlan(state, selectedEmiPlan) {
      return { selectedEmiPlan: selectedEmiPlan };
    },
    onStopScroll: function onStopScroll(state, stopScroll) {
      return { stopScroll: stopScroll };
    },
    onHelperOverlayToggle: function onHelperOverlayToggle(state, showHelperOverlay) {
      return { showHelperOverlay: showHelperOverlay };
    },
    onNotificationTextChange: function onNotificationTextChange(state, notificationMsg) {
      return { notificationMsg: notificationMsg };
    },
    onHighlightOfferError: function onHighlightOfferError(state, shouldHighlightOfferError) {
      return { shouldHighlightOfferError: shouldHighlightOfferError };
    },
    toggleDirectBank: function toggleDirectBank(state, directBankData) {
      return { directBankData: directBankData };
    }
  };
};
// EXTERNAL MODULE: ./utils/common.js
var common = __webpack_require__("ocZ9");

// EXTERNAL MODULE: ./common/logger.js
var logger = __webpack_require__("lq6S");

// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__("hafV");

// CONCATENATED MODULE: ./components/iframe/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var iframe_Iframe = function (_Component) {
  _inherits(Iframe, _Component);

  function Iframe() {
    var _temp, _this, _ret;

    _classCallCheck(this, Iframe);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.postDataToIframe = function (data) {
      _this.iframe.contentWindow.postMessage(data, '*');
    }, _this.initialize = function () {
      _this.postDataToIframe(_this.props.initializeObject);
    }, _this.postMessageHandler = function (event) {
      switch (Object(common["q" /* getKey */])(event, 'data.type')) {
        case constants["g" /* default */].PAY_SUCCES:
        case constants["g" /* default */].PAY_FAIL:
          {
            var response = void 0;
            try {
              response = JSON.parse(Object(common["q" /* getKey */])(event, 'data.response'));
            } catch (e) {
              response = {};
            }

            Object(logger["log"])({
              eventType: logger["EVENT"].API_STATUS,
              url: Object(common["q" /* getKey */])(event, 'data.payloadLogData.url'),
              data: response,
              paymentMode: Object(common["q" /* getKey */])(event, 'data.payloadLogData.paymentMode'),
              channelCode: Object(common["q" /* getKey */])(event, 'data.payloadLogData.channelCode'),
              bankCode: Object(common["q" /* getKey */])(event, 'data.payloadLogData.bankCode')
            });

            break;
          }
        case logger["EVENT"].PRE_PTC_API_CALL_LOG:
          {
            Object(logger["log"])({
              eventType: logger["EVENT"].API_INIT,
              url: Object(common["q" /* getKey */])(event, 'data.payloadLogData.url'),
              paymentMode: Object(common["q" /* getKey */])(event, 'data.payloadLogData.paymentMode'),
              channelCode: Object(common["q" /* getKey */])(event, 'data.payloadLogData.channelCode'),
              bankCode: Object(common["q" /* getKey */])(event, 'data.payloadLogData.bankCode')
            });
            break;
          }
        default:
          break;
      }

      Object(common["y" /* isFunction */])(_this.props.postMessageHandler) && _this.props.postMessageHandler(event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Iframe.prototype.componentDidMount = function componentDidMount() {
    this.iframe.onload = this.initialize.bind(this);
    window.addEventListener('message', this.postMessageHandler);
  };

  Iframe.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('message', this.postMessageHandler);
    this.props.unload && this.props.unload();
  };

  Iframe.prototype.render = function render(_ref) {
    var _this2 = this;

    var classname = _ref.classname,
        src = _ref.src;

    return Object(preact_min["h"])(
      'div',
      { id: 'ptm-checkout-iframe' },
      Object(preact_min["h"])('iframe', { className: classname, src: src, ref: function ref(frame) {
          return _this2.iframe = frame;
        } })
    );
  };

  return Iframe;
}(preact_min["Component"]);


// EXTERNAL MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/constant.js
var constant = __webpack_require__("TwIz");

// EXTERNAL MODULE: ./utils/formPost.js
var formPost = __webpack_require__("AWfl");

// CONCATENATED MODULE: ./components/subscription/renewal/index.js


function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function renewal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function renewal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function renewal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var renewal_Renewal = function (_Component) {
  renewal__inherits(Renewal, _Component);

  function Renewal() {
    renewal__classCallCheck(this, Renewal);

    return renewal__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Renewal.prototype.mapClientMessage = function mapClientMessage() {
    var msg = this.props.subscription.renewMessage;
    var clientSubsMsg = Object(common["e" /* clientMessage */])(constants["g" /* default */].SUBSCRIPTION.toLowerCase(), this.props.cache);
    Object(common["q" /* getKey */])(clientSubsMsg, 'label.renewMessage') && (msg = Object(common["q" /* getKey */])(clientSubsMsg, 'label.renewMessage'));
    return msg;
  };

  Renewal.prototype.showRenewMessage = function showRenewMessage(subscription) {
    var paymentOptions = this.props.cache.getData('paymentOptions');
    return Object(common["q" /* getKey */])(subscription, 'isEnabled') && Object(common["q" /* getKey */])(subscription, 'renewMessage') && Object(common["w" /* isAddNPay */])(paymentOptions, this.props.cache);
  };

  Renewal.prototype.render = function render(_ref, _ref2) {
    var subscription = _ref.subscription;

    _objectDestructuringEmpty(_ref2);

    if (this.showRenewMessage(subscription)) {
      return Object(preact_min["h"])(
        'div',
        { 'class': 'ptm-msg-info' },
        ' ',
        this.mapClientMessage() || subscription.renewMessage
      );
    }
    return '';
  };

  return Renewal;
}(preact_min["Component"]);

/* harmony default export */ var renewal = (Object(preact["connect"])('subscription, cache', onChange)(renewal_Renewal));
// EXTERNAL MODULE: ./utils/i18n.js
var i18n = __webpack_require__("LnyB");

// CONCATENATED MODULE: ./components/offers/paymodeOffer/index.js


function paymodeOffer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function paymodeOffer__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function paymodeOffer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var paymodeOffer_PaymodeOffer = function (_Component) {
  paymodeOffer__inherits(PaymodeOffer, _Component);

  function PaymodeOffer(props) {
    paymodeOffer__classCallCheck(this, PaymodeOffer);

    var _this = paymodeOffer__possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      errorMessage: null,
      offerMessage: null
    };
    return _this;
  }

  PaymodeOffer.prototype.componentDidMount = function componentDidMount() {
    this.updateState(this.props);
  };

  PaymodeOffer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.updateState(nextProps);
  };

  PaymodeOffer.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    return Object(common["b" /* areObjectValuesShallowNotEqual */])(this.props, nextProps, ['offer', 'applied', 'shouldHighlightOfferError']) || Object(common["b" /* areObjectValuesShallowNotEqual */])(this.state, nextState, Object.keys(this.state));
  };

  PaymodeOffer.prototype.updateState = function updateState(_ref) {
    var offer = _ref.offer;

    var errorMessage = Object(common["q" /* getKey */])(offer, 'validationErrorMessage');
    var offerMessage = '';

    if (!errorMessage) {
      var instantDiscount = Object(common["q" /* getKey */])(offer, 'instantDiscount');
      var cashbackAmount = Object(common["q" /* getKey */])(offer, 'cashbackAmount');
      var isOfferAvailable = Boolean(instantDiscount || cashbackAmount);

      if (isOfferAvailable) {
        offerMessage = instantDiscount ? Object(i18n["a" /* locale */])('offers.instantDiscount').replace('amount', Object(common["L" /* money */])(instantDiscount)) : Object(i18n["a" /* locale */])('offers.cashback').replace('amount', Object(common["L" /* money */])(cashbackAmount));
        offerMessage = Object(common["h" /* convertRupeeCharToUnicode */])(offerMessage);
      }
    }
    this.setState({
      errorMessage: errorMessage,
      offerMessage: offerMessage
    });
  };

  PaymodeOffer.prototype.render = function render(_ref2, _ref3) {
    var shouldHighlightOfferError = _ref2.shouldHighlightOfferError,
        _ref2$applied = _ref2.applied,
        applied = _ref2$applied === undefined ? true : _ref2$applied,
        _ref2$noLeftPadding = _ref2.noLeftPadding,
        noLeftPadding = _ref2$noLeftPadding === undefined ? false : _ref2$noLeftPadding;
    var offerMessage = _ref3.offerMessage,
        errorMessage = _ref3.errorMessage;

    return Object(preact_min["h"])(
      'div',
      { className: 'ptm-cash-app ptm-body-color ' + (noLeftPadding ? 'ptm-mg-lt-0' : '') },
      offerMessage && Object(preact_min["h"])(
        'span',
        { 'class': 'ptm-message' },
        applied && Object(preact_min["h"])('img', {
          'class': 'ptm-offer-applied-img',
          src: Object(common["U" /* staticPath */])() + '/assets/images/ic-selection.svg',
          alt: 'offer-applied-img'
        }),
        offerMessage
      ),
      applied && errorMessage && Object(preact_min["h"])(
        'div',
        { className: (shouldHighlightOfferError ? 'ptm-highlight' : '') + ' ptm-error' },
        errorMessage
      )
    );
  };

  return PaymodeOffer;
}(preact_min["Component"]);

/* harmony default export */ var offers_paymodeOffer = (Object(preact["connect"])('shouldHighlightOfferError')(paymodeOffer_PaymodeOffer));
// CONCATENATED MODULE: ./utils/api-response-utils.js



function getApi(cache) {
  return cache.getData(constants["a" /* CACHE */].API);
}

function _isSuccess(response) {
  return constants["d" /* RESPONSE_STATUS */].S === Object(common["q" /* getKey */])(response, 'body.resultInfo.resultStatus');
}

function _getResponseBody(response) {
  return response && response.body;
}

function _getResultInfo(response) {
  return Object(common["q" /* getKey */])(response, 'body.resultInfo', {});
}

function ifSuccessOrThrowError(response, successCallback) {
  if (_isSuccess(response)) {
    var responseBody = _getResponseBody(response);
    return successCallback(responseBody);
  }

  var _getResultInfo2 = _getResultInfo(response),
      _getResultInfo2$resul = _getResultInfo2.resultMsg,
      resultMsg = _getResultInfo2$resul === undefined ? constants["g" /* default */].GENERIC_ERROR : _getResultInfo2$resul;
  /* session expired handling is being done here so that apart from session expired handling,
  other errors continue as it is not to disturb the current flow */


  if (Object(common["q" /* getKey */])(response, 'body.resultInfo.resultCode', '') === '1006') {
    var mConfig = this.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
    this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ sessionExpired: true });
    var notifyMerchant = Object(common["q" /* getKey */])(mConfig, 'handler.notifyMerchant', undefined);
    if (notifyMerchant && notifyMerchant.constructor === Function) {
      notifyMerchant(constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.SESSION_EXPIRED, response);
    }
    return resultMsg;
  }

  throw new Error(resultMsg);
}
// CONCATENATED MODULE: ./controllers/offers.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function getSimplifiedPaymentOffers(cache) {
  var paymentOptions = cache.getData(constants["a" /* CACHE */].PAYMENT_OPTIONS, {});
  var isEmiSubventionFlow = cache.getData(constants["g" /* default */].IS_EMISUBVENTION_ACCESS_TOKEN_FLOW);
  /* picking from cache since in case of login/logout the payment offers is not available in payment
   * options object */
  var paymentOffers = Object(common["q" /* getKey */])(paymentOptions, 'paymentOffers', cache.getData(constants["a" /* CACHE */].PAYMENT_OFFERS));
  var toExecuteBankOffersOnSubvention = Boolean(isEmiSubventionFlow && paymentOffers.length);
  /* checking for bankoffers on execution here since in home this function is called directly first
   to check for offers */
  return Object(common["q" /* getKey */])(paymentOptions, 'simplifiedPaymentOffers', toExecuteBankOffersOnSubvention);
}

function offers_isPromoAvailable(cache) {
  var _ref = cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG) || {},
      flow = _ref.flow;

  var paymentOptions = cache.getData(constants["a" /* CACHE */].PAYMENT_OPTIONS, {});
  var isPwpFlow = Object(common["q" /* getKey */])(paymentOptions, 'pwpEnabled');
  return !(Object(common["j" /* equalsIgnoreCase */])(flow, constant["h" /* FLOW */].DEFERRED) || Object(common["z" /* isHybridOrAddNPay */])(paymentOptions, cache) || isPwpFlow && Object(common["q" /* getKey */])(paymentOptions, 'loginInfo.userLoggedIn', false)) && Boolean(getSimplifiedPaymentOffers(cache));
}

function shouldValidateBankOffer(cache) {
  return Object(common["q" /* getKey */])(getSimplifiedPaymentOffers(cache), 'validatePromo', false);
}

function getFetchPaymentOptionsPromoCode(cache) {
  return Object(common["q" /* getKey */])(getSimplifiedPaymentOffers(cache), 'promoCode');
}

function getValidationErrorMessage(cache, offer) {
  return shouldValidateBankOffer(cache) && !Object(common["q" /* getKey */])(offer, 'cashbackAmount') && !Object(common["q" /* getKey */])(offer, 'instantDiscount') ? Object(i18n["a" /* locale */])('offers.validatePromoError') : null;
}
function _createOfferObject(cache, paymentOfferDetails, payMode, bankCode, validationErrorMessage) {
  var _offerBreakup;

  validationErrorMessage = validationErrorMessage || getValidationErrorMessage(cache, paymentOfferDetails);

  return {
    totalInstantDiscount: Object(common["q" /* getKey */])(paymentOfferDetails, 'instantDiscount', 0),
    totalCashbackAmount: Object(common["q" /* getKey */])(paymentOfferDetails, 'cashbackAmount', 0),
    hasValidationError: Boolean(validationErrorMessage),
    offerBreakup: (_offerBreakup = {}, _offerBreakup[payMode] = _extends({}, paymentOfferDetails, {
      bankCode: bankCode,
      validationErrorMessage: validationErrorMessage
    }), _offerBreakup)
  };
}

function _getPreAppliedPromo(cache, payModeObj, isWalletUsed) {
  if ((Object.prototype.hasOwnProperty.call(payModeObj, 'isWalletOnly') || !isWalletUsed) && payModeObj.paymentOfferDetails) {
    var payMode = (payModeObj.paymentMode || payModeObj.type).toUpperCase();
    var paymentOfferDetails = _extends({}, Object(common["q" /* getKey */])(payModeObj, 'paymentOfferDetails'));
    var validationErrorMessage = getValidationErrorMessage(cache, paymentOfferDetails);
    return _createOfferObject(cache, paymentOfferDetails, payMode, Object(common["q" /* getKey */])(payModeObj, 'issuingBank'), validationErrorMessage);
  }

  return null;
}

function _getPaymentOptionsObj(payModeObj, amount, bankCode, cardNumber, vpa, savedCardId, custId) {
  var paymentOptions = {};

  if (Object(common["j" /* equalsIgnoreCase */])(payModeObj.type, constants["g" /* default */].SC)) {
    paymentOptions.payMethod = Object(common["q" /* getKey */])(payModeObj, 'cardDetails.cardType', '').toUpperCase();
    paymentOptions.savedCardId = Object(common["q" /* getKey */])(payModeObj, 'cardDetails.cardId');
    paymentOptions.bankCode = Object(common["q" /* getKey */])(payModeObj, 'issuingBank');
  } else {
    paymentOptions.payMethod = payModeObj.paymentMode.toUpperCase();

    if (bankCode) {
      paymentOptions.bankCode = bankCode;
    }

    if (savedCardId) {
      paymentOptions.savedCardId = savedCardId;
    }
  }

  if (amount) {
    paymentOptions.transactionAmount = Object(common["L" /* money */])(amount);
  }

  if (cardNumber) {
    paymentOptions.cardNo = cardNumber;
  }

  if (payModeObj.vpaId) {
    paymentOptions.vpa = payModeObj.vpaId;
  }

  if (vpa) {
    paymentOptions.vpa = vpa;
  }
  if (custId) {
    paymentOptions.custId = custId;
  }

  return paymentOptions;
}

function _isDetailsNotSufficient(payModeObj, bankCode, cardNumber, vpa, savedCardId) {
  var paymentMode = payModeObj.paymentMode;
  var paymentType = payModeObj.type;

  return Object(common["j" /* equalsIgnoreCase */])(paymentMode, constant["m" /* PAYMODE */].UPI) && !(vpa || payModeObj.vpaId) || (Object(common["j" /* equalsIgnoreCase */])(paymentMode, constant["m" /* PAYMODE */].CARD) || Object(common["j" /* equalsIgnoreCase */])(paymentMode, constants["g" /* default */].CC) || Object(common["j" /* equalsIgnoreCase */])(paymentMode, constants["g" /* default */].DC)) && !cardNumber || Object(common["j" /* equalsIgnoreCase */])(paymentMode, constants["g" /* default */].NB) && !bankCode || Object(common["j" /* equalsIgnoreCase */])(paymentMode, constant["m" /* PAYMODE */].EMI) && !(bankCode || savedCardId) || Object(common["j" /* equalsIgnoreCase */])(paymentType, constants["g" /* default */].MGV);
}

function _isCachableOfferPaymode(payModeObj) {
  var payMode = Object(common["q" /* getKey */])(payModeObj, 'type');
  return [constant["m" /* PAYMODE */].NB, constants["g" /* default */].SC].some(function (allowedpayMode) {
    return Object(common["j" /* equalsIgnoreCase */])(allowedpayMode, payMode);
  });
}

function _getOfferCachekey(payModeObj, isWalletUsed, bankCode) {
  var key = isWalletUsed ? 'hybrid_' : '';
  key += Object(common["q" /* getKey */])(payModeObj, 'type') + '_' + bankCode + '_' + Object(common["q" /* getKey */])(payModeObj, 'cardDetails.cardId');
  return key;
}

function _getCachedOffer(cache, payModeObj, isWalletUsed, bankCode) {
  if (!_isCachableOfferPaymode(payModeObj)) {
    return null;
  }

  var cacheKey = _getOfferCachekey(payModeObj, isWalletUsed, bankCode);
  return cache.getData(constants["a" /* CACHE */].BANK_OFFERS, {})[cacheKey];
}

function _setOfferCache(cache, payModeObj, isWalletUsed, bankCode, value) {
  var _extends2;

  if (!_isCachableOfferPaymode(payModeObj)) {
    return;
  }
  var cacheKey = _getOfferCachekey(payModeObj, isWalletUsed, bankCode);
  var cached = cache.getData(constants["a" /* CACHE */].BANK_OFFERS, {});

  cache.setData(constants["a" /* CACHE */].BANK_OFFERS, _extends({}, cached, (_extends2 = {}, _extends2[cacheKey] = _extends({}, value), _extends2)));
}
function _isCardPayMode(payMethod) {
  return Object(common["j" /* equalsIgnoreCase */])(payMethod, constants["g" /* default */].CC) || Object(common["j" /* equalsIgnoreCase */])(payMethod, constants["g" /* default */].DC);
}

function handleApplyPromoError(cache, error, payMethod, bankCode) {
  var isSC = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  if (shouldValidateBankOffer(cache)) {
    var errorMessage = getValidationErrorMessage(cache);
    payMethod = _isCardPayMode(payMethod) ? isSC ? constants["g" /* default */].SC : constant["m" /* PAYMODE */].CARD : payMethod;

    return _createOfferObject(cache, {}, payMethod, bankCode, errorMessage);
  }

  return null;
}

function parseApplyPromoResponse(cache, isSC, bankCode, response) {
  if ((Object(common["q" /* getKey */])(response, 'paymentOffer.offerBreakup') || []).length) {
    var paymentOffer = _extends({}, response.paymentOffer);
    var hasValidationError = false;

    paymentOffer.offerBreakup = paymentOffer.offerBreakup.reduce(function (acc, cur) {
      // card paymethod name renaming
      var payMethod = _isCardPayMode(cur.payMethod) ? isSC ? constants["g" /* default */].SC : constant["m" /* PAYMODE */].CARD : cur.payMethod.toUpperCase();
      var validationErrorMessage = getValidationErrorMessage(cache, cur);

      if (validationErrorMessage) {
        hasValidationError = true;
      }

      acc[payMethod] = _extends({}, cur, {
        bankCode: Object(common["j" /* equalsIgnoreCase */])(cur.payMethod, constant["m" /* PAYMODE */].WALLET) ? '' : bankCode,
        validationErrorMessage: validationErrorMessage
      });
      return acc;
    }, {});

    paymentOffer.hasValidationError = hasValidationError;

    return paymentOffer;
  }

  return null;
}

function getApplyPromoBaseRequestObj(cache) {
  var custId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var wallet = Object(common["q" /* getKey */])(cache.getData(constants["a" /* CACHE */].PAYMENT_OPTIONS), 'wallet');
  var isWalletUsed = Object(common["q" /* getKey */])(wallet, 'isUsed', false);
  var txnAmount = Number(cache.getData(constants["g" /* default */].UNMODIFIED_TXN_AMOUNT, 0));

  var requestObj = {
    custId: custId,
    totalTransactionAmount: Object(common["L" /* money */])(txnAmount),
    paymentOptions: []
  };

  var promocode = getFetchPaymentOptionsPromoCode(cache);
  if (promocode) {
    requestObj.promocode = promocode;
  }

  if (isWalletUsed) {
    var walletBallence = Number(Object(common["q" /* getKey */])(wallet, 'walletBalance', 0));
    var amount = walletBallence >= txnAmount ? txnAmount : walletBallence;

    requestObj.paymentOptions.push(_getPaymentOptionsObj({ paymentMode: constants["g" /* default */].WALLET }, amount));
  }

  return requestObj;
}

function applyPromo(cache, payModeObj, bankCode, cardNumber, vpa, savedCardId, custId) {
  if (!payModeObj || Object(common["j" /* equalsIgnoreCase */])(payModeObj.paymentMode, constant["m" /* PAYMODE */].LOGIN)) {
    return Promise.reject(new Error());
  }
  var isWalletPayMode = false;
  if (payModeObj && Object.prototype.hasOwnProperty.call(payModeObj, 'isWalletOnly') && !payModeObj.used) {
    isWalletPayMode = true;
    return Promise.reject(new Error());
  }

  var isWalletUsed = Object(common["q" /* getKey */])(cache.getData(constants["a" /* CACHE */].PAYMENT_OPTIONS), 'wallet.isUsed', false);
  var preAppliedPromo = _getPreAppliedPromo(cache, payModeObj, isWalletUsed);
  if (preAppliedPromo) {
    return Promise.resolve(preAppliedPromo);
  }

  if (_isDetailsNotSufficient(payModeObj, bankCode, cardNumber, vpa, savedCardId)) {
    return Promise.reject();
  }

  var cachedOffer = _getCachedOffer(cache, payModeObj, isWalletUsed, bankCode);
  if (cachedOffer) {
    return Promise.resolve(cachedOffer);
  }

  var requestObj = getApplyPromoBaseRequestObj(cache, custId);
  if (!isWalletPayMode) {
    var nonWalletPaymodeAmount = requestObj.paymentOptions.length ? Number(requestObj.totalTransactionAmount) - Number(requestObj.paymentOptions[0].transactionAmount) : Number(requestObj.totalTransactionAmount);

    requestObj.paymentOptions.push(_getPaymentOptionsObj(payModeObj, nonWalletPaymodeAmount, bankCode, cardNumber, vpa, savedCardId));
  }

  return getApi(cache).applyPromo(requestObj).then(function (response) {
    return ifSuccessOrThrowError(response, function (callBackResponse) {
      var parsedResponse = parseApplyPromoResponse(cache, Object(common["j" /* equalsIgnoreCase */])(payModeObj.type, constants["g" /* default */].SC), bankCode, callBackResponse);
      _setOfferCache(cache, payModeObj, isWalletUsed, bankCode, parsedResponse);
      return parsedResponse;
    });
  }).catch(function (error) {
    var payMethod = isWalletPayMode ? constant["m" /* PAYMODE */].WALLET : (payModeObj.paymentMode || payModeObj.type).toUpperCase();
    return handleApplyPromoError(cache, error, payMethod, bankCode, Object(common["j" /* equalsIgnoreCase */])(payModeObj.type, constants["g" /* default */].SC));
  });
}
// CONCATENATED MODULE: ./components/card/index.js
var card__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, card__temp, card__initialiseProps;



function card__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function card__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function card__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var card__ref3 = Object(preact_min["h"])('span', { 'class': 'ptm-checkmark' });

var _ref4 = Object(preact_min["h"])(renewal, null);

var card_Card = (card__temp = _class = function (_Component) {
  card__inherits(Card, _Component);

  function Card(props) {
    card__classCallCheck(this, Card);

    var _this = card__possibleConstructorReturn(this, _Component.call(this, props));

    card__initialiseProps.call(_this);

    var newStyle = '.ptm-card-input:focus{\n      border-color:' + _this.props.AppStyle.themeBackgroundColor + ';\n      caret-color:' + _this.props.AppStyle.themeBackgroundColor + ';\n    }\n    .ptm-card-input:focus ~ .hidden-border{\n      background:' + _this.props.AppStyle.themeBackgroundColor + ';\n    }\n    .ptm-card-input,.card-expiry,.card-content{\n      border-color:' + _this.props.AppStyle.borderColor + ';\n      color:' + _this.props.AppStyle.bodyColor + '\n    }\n    .ptm-check,.ptm-container:hover input ~ .ptm-check{\n      border-color:' + _this.props.AppStyle.bodyColor + ';\n    }\n    .ptm-card-input::placeholder,.slash,.ptm-container{\n      color:' + _this.props.AppStyle.bodyColor + ';\n    }\n    #mm:focus+span+input+p.hidden-border,#yy:focus+p.hidden-border{\n      background:' + _this.props.AppStyle.themeBackgroundColor + ';\n      border-color:transparent;\n    }\n    .ptm-msg-red {\n      color:' + _this.props.AppStyle.errorColor + '\n    }\n    .ptm-container input:checked ~ .ptm-check{\n      background-color: ' + _this.props.AppStyle.themeBackgroundColor + ';\n      border-color:' + _this.props.AppStyle.themeBackgroundColor + ';\n    }';
    var locale = Object(common["e" /* clientMessage */])(constant["m" /* PAYMODE */].CARD.toLowerCase(), _this.props.cache);
    var config = card__extends({}, _this.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG));
    _this.state = {
      initializeObject: {
        type: 'INITIALIZE',
        paymode: {
          type: _this.props.option.type,
          id: _this.props.option.id
        },
        requestPayload: Object(common["p" /* getIframeRequestPayload */])(_this.props.cache, constant["a" /* API */].BIN),
        // IF FLOW IS DEFERRED PASS THE CARD DETAIL OBJECT
        requestCardDetailsPayload: config.flow === constant["h" /* FLOW */].DEFERRED ? Object(common["p" /* getIframeRequestPayload */])(_this.props.cache, constant["a" /* API */].CARD_DETAILS) : {},
        style: newStyle,
        error: locale.error,
        instanceKey: _this.props.instanceKey
      }
    };
    _this.frame = undefined;
    return _this;
  }

  Card.prototype.getApplyPromoBaseRequestPayload = function getApplyPromoBaseRequestPayload() {
    if (!offers_isPromoAvailable(this.props.cache)) {
      return null;
    }

    var mConfig = this.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
    var customerId = Object(common["q" /* getKey */])(mConfig, 'emiSubvention.customerId', null);
    var payload = Object(common["p" /* getIframeRequestPayload */])(this.props.cache, constant["a" /* API */].APPLY_PROMO);
    payload.requestData.body = card__extends({}, payload.requestData.body, getApplyPromoBaseRequestObj(this.props.cache, customerId));

    return payload;
  };

  Card.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    if (nextProps.isActive) {
      this.setState(function (prevState) {
        return {
          initializeObject: card__extends({}, prevState.initializeObject, {
            applyPromoRequestPayload: _this2.getApplyPromoBaseRequestPayload()
          })
        };
      });
    }
  };

  Card.prototype.render = function render(_ref, _ref2) {
    var _this3 = this;

    var option = _ref.option,
        isActive = _ref.isActive,
        offers = _ref.offers,
        subscription = _ref.subscription,
        instanceKey = _ref.instanceKey,
        cache = _ref.cache;
    var initializeObject = _ref2.initializeObject;

    var cardOptions = Object(common["t" /* handleSaveCardOnSubscription */])(subscription, cache.getData(constants["a" /* CACHE */].PAYMENT_OPTIONS), cache);
    var frameData = card__extends({}, initializeObject, { cardOptions: cardOptions });
    var cardOffer = Object(common["q" /* getKey */])(offers, constant["m" /* PAYMODE */].CARD);

    return Object(preact_min["h"])(
      'div',
      {
        className: 'ptm-pay-method ptm-w100-ib ptm-noborder',
        id: 'checkout-card',
        ref: function ref(componentRef) {
          _this3.componentRef = componentRef;
        }
      },
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-radio-wrap ptm-pt11' },
        Object(preact_min["h"])(
          'label',
          { className: 'ptm-lbl' },
          Object(preact_min["h"])('input', {
            type: 'radio',
            name: 'verify' + instanceKey,
            className: 'ptm-margin0',
            checked: isActive,
            onClick: function onClick() {
              _this3.onOptionSelect(option);
            }
          }),
          card__ref3,
          Object(preact_min["h"])(
            'div',
            { 'class': 'ptm-pay-method-cont' },
            Object(preact_min["h"])(
              'p',
              { 'class': 'ptm-paymode-name' },
              option && option.showDisplayName ? option.displayName : 'Debit / Credit Cards'
            )
          )
        )
      ),
      option && isActive && Object(preact_min["h"])(
        'div',
        { className: 'ptm-card-main' },
        Object(preact_min["h"])(iframe_Iframe, {
          ref: function ref(r) {
            return _this3.frame = r;
          },
          classname: 'ptm-card-iframe',
          name: 'ptm-card-iframe',
          unload: this.updateIframeHeight,
          postMessageHandler: this.messageHandler,
          src: Object(common["U" /* staticPath */])() + '/assets/iframes/card.html',
          initializeObject: frameData
        }),
        cardOffer && Object(preact_min["h"])(offers_paymodeOffer, { offer: cardOffer }),
        _ref4
      ),
      Object(preact_min["h"])('p', { className: 'ptm-global-bottom-border' })
    );
  };

  return Card;
}(preact_min["Component"]), card__initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.hasValidationError = true;

  this.submit = function () {
    var tokenData = _this4.props.cache.getData(constants["a" /* CACHE */].TOKEN_DATA);
    var payload = _this4.props.cache.getData(constants["a" /* CACHE */].API).requestPayload(constant["a" /* API */].PT);
    var config = _this4.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
    var orderId = _this4.props.cache.getData(constants["a" /* CACHE */].ORDER_ID);
    if (config && config.flow === constant["h" /* FLOW */].DEFERRED) {
      payload.data.body.orderId = orderId;
      payload.query.orderId = orderId;
    }
    payload.data.body = card__extends({}, payload.data.body, payload.query);
    var reqData = {
      type: constants["g" /* default */].SUBMIT,
      targetURL: payload.url + '?' + Object(common["o" /* getEncodedQs */])(payload.query),
      queryParams: payload.query,
      method: payload.method,
      requestData: card__extends({}, payload.data),
      paymode: { id: _this4.props.option.id, type: _this4.props.option.type },
      guestFlow: tokenData.tokenType !== constant["n" /* TOKEN */].TXN || false,
      shouldPostOpenWindowEvent: _this4.hasValidationError
    };

    !_this4.hasValidationError && Object(formPost["c" /* openPopUpWindow */])(_this4.props.cache);
    _this4.frame && _this4.frame.postDataToIframe(reqData);
    Object(logger["log"])({ eventType: logger["EVENT"].CARD_IFRAME_SUBMIT });
  };

  this.messageHandler = function (event) {
    if (!_this4.props.cache.getData(constants["a" /* CACHE */].STORE) || Object(common["q" /* getKey */])(event, 'data.calledFrom') !== 'card' || Object(common["q" /* getKey */])(event, 'data.instanceKey') !== _this4.props.instanceKey) {
      return;
    }
    var mConfig = _this4.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
    var notifyMerchant = Object(common["q" /* getKey */])(mConfig, 'handler.notifyMerchant', undefined);
    if (typeof Object(common["q" /* getKey */])(event, 'data.type') === 'string') {
      switch (event.data.type) {
        case constants["g" /* default */].PAY_SUCCESS:
          {
            Object(logger["log"])({ eventType: logger["EVENT"].CARD_EVENT_PAY_SUCCESS });
            _this4.props.onOverlayValueChange(constants["g" /* default */].PROCESSING);
            var response = Object(common["q" /* getKey */])(event, 'data.response', undefined);
            /** Direct Bank Changes */
            // const isDirect = getKey(response, 'body.bankForm.pageType', undefined);
            // if (isDirect === 'direct') {
            //   postInWindow(null, this.props.cache, true);
            //   this.props.onOverlayValueChange('');
            //   const bankForm = getKey(response, 'body.bankForm', undefined);
            //   bankForm && this.props.toggleDirectBank(bankForm);
            //   return;
            // }

            var _getKey = Object(common["q" /* getKey */])(response, 'body.bankForm.redirectForm', {}),
                actionUrl = _getKey.actionUrl,
                content = _getKey.content;

            response.body.content = content;
            response.body.callbackUrl = actionUrl;
            Object(formPost["f" /* postInWindow */])(response, _this4.props.cache);
            break;
          }
        case constants["g" /* default */].PAY_FAIL:
          {
            Object(logger["log"])({ eventType: logger["EVENT"].CARD_EVENT_PAY_FAIL });
            var data = event.data.response;
            if (Object(common["q" /* getKey */])(data, 'body.resultInfo.resultStatus') === 'F' && Object(common["q" /* getKey */])(data, 'body.resultInfo.retry') === false) {
              if (Object(common["q" /* getKey */])(data, 'body.txnInfo.RESPCODE', '') === '1006' || Object(common["q" /* getKey */])(data, 'body.resultInfo.resultCode', '') === '1006') {
                _this4.props.onOverlayValueChange('');
                var _mConfig = _this4.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
                _this4.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ sessionExpired: true });
                var _notifyMerchant = Object(common["q" /* getKey */])(_mConfig, 'handler.notifyMerchant', undefined);
                if (Object.prototype.toString.call(_notifyMerchant) === '[object Function]') {
                  _notifyMerchant(constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.SESSION_EXPIRED, data);
                }
              } else {
                if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
                  notifyMerchant(constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.PAYMENT_ERROR, data);
                }
                data.body.content = data.body.txnInfo;
              }
            } else if (Object(common["q" /* getKey */])(data, 'body.resultInfo.resultStatus') === 'F' && Object(common["q" /* getKey */])(data, 'body.resultInfo.retry') === true) {
              _this4.props.cache.getData(constants["a" /* CACHE */].STORE).setState({
                overlayValue: constants["g" /* default */].RETRY,
                retryMessage: Object(common["q" /* getKey */])(data, 'body.resultInfo.resultMsg')
              });
              //  in case of reyr get fallback token from cache and set current access token
              //  and remove txn token to fetch new txn token
              if (_this4.props.cache.getData(constants["g" /* default */].IS_EMISUBVENTION_ACCESS_TOKEN_FLOW)) {
                var _mConfig2 = _this4.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
                var tokenData = _this4.props.cache.getData(constants["a" /* CACHE */].FALLBACK_TOKEN_DATA, {
                  token: Object(common["q" /* getKey */])(_mConfig2, 'data.token', ''),
                  tokenType: constant["n" /* TOKEN */].ACCESS
                });
                _this4.props.cache.setData(constants["a" /* CACHE */].TOKEN_DATA, {
                  token: tokenData.token,
                  tokenType: tokenData.tokenType
                });
              }
            }
            Object(formPost["f" /* postInWindow */])(data, _this4.props.cache);
            break;
          }
        case constants["g" /* default */].SESSION_EXPIRED:
          {
            Object(logger["log"])({ eventType: logger["EVENT"].CARD_EVENT_SESSION_EXPIRED });
            if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
              notifyMerchant(constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.SESSION_EXPIRED, {
                message: 'Session Expired'
              });
            }
            _this4.props.onOverlayValueChange('');
            _this4.updateGuestToken();
            Object(formPost["f" /* postInWindow */])(Object(common["q" /* getKey */])(event, 'data.response', {}), _this4.props.cache);
            break;
          }
        case constants["g" /* default */].TXN_TOKEN_EXPIRED:
          {
            Object(logger["log"])({ eventType: logger["EVENT"].CARD_EVENT_TXN_TOKEN_EXPIRED });
            _this4.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ sessionExpired: true });
            if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
              notifyMerchant(constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.SESSION_EXPIRED, {
                message: 'Session Expired'
              });
            }
            _this4.props.onOverlayValueChange('');
            Object(formPost["f" /* postInWindow */])(Object(common["q" /* getKey */])(event, 'data.response', {}), _this4.props.cache);
            break;
          }
        case constants["g" /* default */].CARD_NOT_SUPPORTED:
          {
            Object(logger["log"])({ eventType: logger["EVENT"].CARD_EVENT_CARD_NOT_SUPPORTED });
            break;
          }
        case constants["g" /* default */].CARD_DETAILS_RESOLVED:
          {
            Object(logger["log"])({ eventType: logger["EVENT"].CARD_DETAILS_RESOLVED });
            var pcf = Object(common["q" /* getKey */])(event.data, 'response.pcf');
            if (pcf) {
              _this4.props.updatePcfAmount(pcf);
            }
            _this4.props.cache.setData(constants["g" /* default */].CARD_TYPE, Object(common["q" /* getKey */])(event.data, 'response.binDetail.paymentMode'));
            break;
          }
        case constants["g" /* default */].HELPER_TYPE.CVV_HELPER:
          {
            Object(logger["log"])({ eventType: logger["EVENT"].CARD_EVENT_CVV_HELPER });
            _this4.props.onHelperOverlayToggle(constants["g" /* default */].HELPER_TYPE.CVV_HELPER);
            break;
          }
        case 'cardDetails':
          {
            var obj = {
              details: event.data.cardDetails.details,
              cardHash: event.data.cardDetails.cardHash
            };
            _this4.props.cache.setData(constants["a" /* CACHE */].CARD_DETAILS, obj);
            break;
          }
        case constants["g" /* default */].SET_VALIDATION_STATUS:
          {
            _this4.hasValidationError = Object(common["q" /* getKey */])(event, 'data.hasError');
            break;
          }
        case constants["g" /* default */].OPEN_POPUP_WINDOW:
          {
            var paymodeId = Object(common["q" /* getKey */])(event, 'data.paymode.id', null);
            var optionId = Object(common["q" /* getKey */])(_this4.props, 'option.id', null);
            /* if the paymode id recieved from iframe is same as that of option id then only open the popup */
            if (paymodeId === optionId) {
              Object(formPost["c" /* openPopUpWindow */])(_this4.props.cache);
              Object(logger["log"])({ eventType: logger["EVENT"].POPUP_WINDOW });
            }
            break;
          }
        case constants["g" /* default */].SHOW_PROCESSING:
          {
            Object(logger["log"])({ eventType: logger["EVENT"].CARD_EVENT_SHOW_PROCESSING });
            _this4.props.onOverlayValueChange(constants["g" /* default */].PROCESSING);
            break;
          }
        case constants["g" /* default */].HIDE_PROCESSING:
          {
            Object(logger["log"])({ eventType: logger["EVENT"].CARD_EVENT_HIDE_PROCESSING });
            _this4.props.onOverlayValueChange('');
            break;
          }
        case constants["g" /* default */].CLIENT_VALIDATION:
          {
            Object(logger["log"])({ eventType: logger["EVENT"].CARD_EVENT_CLIENT_VALIDATION });
            Object(formPost["f" /* postInWindow */])({}, _this4.props.cache); // close popup window as client side validation failed
            break;
          }
        case constants["g" /* default */].GET_TXN_TOKEN_PAYLOAD:
          {
            var _paymodeId = Object(common["q" /* getKey */])(event, 'data.paymode.id', null);
            var _optionId = Object(common["q" /* getKey */])(_this4.props, 'option.id', null);
            if (_paymodeId === _optionId) {
              _this4.props.cache.getData(constants["a" /* CACHE */].API).getAsyncPayload(constant["a" /* API */].PT, _this4.hasValidationError).then(function (payload) {
                var tokenData = _this4.props.cache.getData(constants["a" /* CACHE */].TOKEN_DATA);
                var config = _this4.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
                var orderId = _this4.props.cache.getData(constants["a" /* CACHE */].ORDER_ID);
                if (config && config.flow === constant["h" /* FLOW */].DEFERRED) {
                  payload.data.body.orderId = orderId;
                  payload.query.orderId = orderId;
                }
                payload.data.body = card__extends({}, payload.data.body, payload.query);
                var reqData = {
                  type: constants["g" /* default */].SUBMIT_WITH_TOKEN,
                  targetURL: payload.url + '?' + Object(common["o" /* getEncodedQs */])(payload.query),
                  queryParams: payload.query,
                  method: payload.method,
                  requestData: card__extends({}, payload.data),
                  paymode: { id: _this4.props.option.id, type: _this4.props.option.type },
                  guestFlow: tokenData.tokenType !== constant["n" /* TOKEN */].TXN || false
                };
                _this4.frame && _this4.frame.postDataToIframe(reqData);
              }).catch(function () {
                _this4.props.onOverlayValueChange('');
              });
            }
            break;
          }
        case constants["g" /* default */].UPDATE_HEIGHT:
          {
            _this4.updateIframeHeight(event.data.height);
            break;
          }
        case constants["g" /* default */].LOG_CARD_DETAILS:
          {
            Object(logger["log"])(card__extends({ eventType: logger["EVENT"].CARD_EVENT_CARD_DETAILS }, event.data.detail));
            break;
          }
        case constants["g" /* default */].HANDLE_PROMO_RESPONSE:
          {
            if (event.data.error) {
              _this4.props.handlePromoErrorFromCard(event.data.error, event.data.payMethod, event.data.bankCode);
            } else {
              _this4.props.handlePromoResponseFromCard(event.data.response, event.data.bankCode);
            }
            break;
          }
        case constants["g" /* default */].CVV_EXPIRY_FOCUS:
          {
            // const defaultSelectedPaymodeOffSetTop = getKey(
            //   this.props.selected,
            //   'reference._component.componentRef.offsetTop',
            //   0
            // );
            // scrollWithTimeout(defaultSelectedPaymodeOffSetTop + 80);

            break;
          }
        case 'CARD_NUMBER_FOCUS':
          {
            // const defaultSelectedPaymodeOffSetTop = getKey(
            //   this.props.selected,
            //   'reference._component.componentRef.offsetTop',
            //   0
            // );
            // scrollWithTimeout(defaultSelectedPaymodeOffSetTop);
            break;
          }
        default:
          {
            break;
          }
      }
    } else if (Object(common["q" /* getKey */])(event, 'data.hasError')) {
      Object(logger["log"])({ eventType: logger["EVENT"].CARD_ERROR, data: event.data });
      Object(formPost["f" /* postInWindow */])({}, _this4.props.cache);
    }
  };

  this.updateGuestToken = function () {
    _this4.props.cache.getData(constants["a" /* CACHE */].API).payModes().then(function (res) {
      if (Object(common["q" /* getKey */])(res, 'body.resultInfo.resultStatus', undefined) === 'S') {
        _this4.props.cache.setData(constants["a" /* CACHE */].TOKEN_DATA, {
          tokenType: constant["n" /* TOKEN */].GUEST,
          token: Object(common["q" /* getKey */])(res, 'body.guestToken', '')
        });

        var _props$cache$getData$ = _this4.props.cache.getData(constants["a" /* CACHE */].API).requestPayload(constant["a" /* API */].BIN),
            url = _props$cache$getData$.url,
            query = _props$cache$getData$.query,
            method = _props$cache$getData$.method,
            data = _props$cache$getData$.data;

        data.body = card__extends({}, query);
        var eventData = {
          type: constants["g" /* default */].UPDATE_PAYLOAD,
          paymode: {
            type: _this4.props.option.type,
            id: _this4.props.option.id
          },
          requestPayload: {
            targetURL: url + '?' + Object(common["o" /* getEncodedQs */])(query),
            queryParams: query,
            requestData: data,
            method: method
          }
        };
        _this4.frame && _this4.frame.postDataToIframe(eventData);
      }
    });
  };

  this.updateIframeHeight = function (height) {
    var iframe = Object(common["q" /* getKey */])(_this4.frame, 'iframe');
    if (iframe) {
      if (height) {
        iframe.style.minHeight = height;
      } else {
        iframe.style.removeProperty('min-height');
      }
    }
  };

  this.onOptionSelect = function (option) {
    _this4.props.onOptionSelect(option);
    _this4.props.onPayChange(true);
  };
}, card__temp);

/* harmony default export */ var components_card = (Object(preact["connect"])('selected, AppStyle, cache, instanceKey, subscription', onChange)(card_Card));
// CONCATENATED MODULE: ./components/wallet/WalletLogin.js


function WalletLogin__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function WalletLogin__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function WalletLogin__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var WalletLogin_WalletLogin = function (_Component) {
  WalletLogin__inherits(WalletLogin, _Component);

  function WalletLogin() {
    WalletLogin__classCallCheck(this, WalletLogin);

    return WalletLogin__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  WalletLogin.prototype.render = function render(_ref) {
    var wallet = _ref.wallet,
        insufficientBalance = _ref.insufficientBalance;

    var paymentOptions = this.props.cache.getData('paymentOptions');
    var locale = Object(common["e" /* clientMessage */])(constant["m" /* PAYMODE */].WALLET.toLowerCase(), this.props.cache);
    this.label = locale.label;
    return Object(preact_min["h"])(
      'div',
      { className: 'ptm-pay-method-cont', id: 'checkout-wallet-login' },
      Object(preact_min["h"])(
        'p',
        { className: 'ptm-paymode-name' },
        wallet.displayName
      ),
      Object(preact_min["h"])(
        'p',
        { className: 'ptm-small-txt' },
        'Available Balance Rs ',
        wallet.walletBalance ? wallet.walletBalance : 0
      ),
      insufficientBalance && (paymentOptions.paymentFlow === constant["l" /* PAYMENT_FLOW */].ADDANDPAY || paymentOptions.paymentFlow === constant["l" /* PAYMENT_FLOW */].NONE) && Object(preact_min["h"])(
        'p',
        { className: 'ptm-small-txt ptm-msg-red ptm-insufficient-balance' },
        this.label.insufficientBalance
      ),
      !wallet.isEnabled && Object(preact_min["h"])(
        'p',
        { className: 'ptm-small-txt ptm-msg-red ptm-disabled-msg' },
        wallet.disableMsg
      )
    );
  };

  return WalletLogin;
}(preact_min["Component"]);

/* harmony default export */ var wallet_WalletLogin = (Object(preact["connect"])('cache')(WalletLogin_WalletLogin));
// CONCATENATED MODULE: ./components/walletToggleWarning/index.js

var walletToggleWarning_WalletToggleWarning = function WalletToggleWarning(props) {
  return Object(preact_min["h"])(
    'div',
    { className: 'ptm-cancel-box paytm-txt-center ptm-pos-a ptm-centralized ptm-body-bg' },
    Object(preact_min["h"])(
      'h3',
      { className: 'ptm-body-color paytm-txt-center' },
      'Are you sure?'
    ),
    Object(preact_min["h"])(
      'p',
      { className: 'ptm-body-color paytm-txt-center' },
      'if you ',
      props.wallet.isUsed ? 'uncheck' : 'check',
      ' Paytm Balance, you will have to re-select the EMI tenure to proceed with payment'
    ),
    Object(preact_min["h"])(
      'div',
      null,
      Object(preact_min["h"])(
        'button',
        { className: 'ptm-custom-btn', onClick: props.toggleWallet },
        'OK'
      ),
      Object(preact_min["h"])(
        'button',
        { className: 'ptm-custom-btn', onClick: props.closeWalletWarning },
        'Cancel'
      )
    )
  );
};

/* harmony default export */ var components_walletToggleWarning = (walletToggleWarning_WalletToggleWarning);
// EXTERNAL MODULE: ./locale/en.js
var en = __webpack_require__("RH0W");

// CONCATENATED MODULE: ./components/wallet/index.js
var wallet__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function wallet__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function wallet__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function wallet__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var wallet__ref3 = Object(preact_min["h"])('span', { className: 'ptm-check' });

var wallet_Wallet = function (_Component) {
  wallet__inherits(Wallet, _Component);

  function Wallet() {
    var _temp, _this, _ret;

    wallet__classCallCheck(this, Wallet);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = wallet__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.walletToggle = function (e) {
      if (_this.props.selectedEmiPlan) {
        // e.stopPropagation();
        _this.setState({ walletToggleWarning: true });
        return;
      }

      var paymentOptions = wallet__extends({}, _this.props.cache.getData('paymentOptions'));
      /* if paymode has hybrid disabled  disable wallet check */
      if (_this.props.selected && _this.props.selected.isHybridDisabled && !_this.props.selected.type === 'mgv') {
        var _wallet = wallet__extends({}, paymentOptions.wallet, { isUsed: false });
        paymentOptions.wallet = _wallet;
        _this.props.cache.setData(constants["a" /* CACHE */].PAYMENT_OPTIONS, paymentOptions);
        _this.props.onWalletToggle(_wallet);
        _this.props.onPayDataChange(paymentOptions);
        return;
      }

      _this.props.isPromoAvailable && _this.props.cache.setData(constants["g" /* default */].TXN_AMOUNT, _this.props.cache.getData(constants["g" /* default */].UNMODIFIED_TXN_AMOUNT));
      var wallet = wallet__extends({}, paymentOptions.wallet, { isUsed: e.checked ? e.checked : e.target.checked });

      if (paymentOptions && Object(common["q" /* getKey */])(paymentOptions, 'wallet')) {
        if (paymentOptions.paymentFlow !== constant["l" /* PAYMENT_FLOW */].ADDANDPAY && !(Object(common["L" /* money */])(paymentOptions.wallet.walletBalance) > 0)) {
          e.preventDefault();
          return;
        }
        var insufficientBalance = Object(common["B" /* isInsufficientBalance */])(paymentOptions, _this.props.cache);
        var selected = void 0;
        if (!insufficientBalance) {
          if (e.checked || e.target && e.target.checked) {
            selected = wallet;
            // setting selected bank on option change to be included in defered flow
            _this.props.cache.setData(constants["a" /* CACHE */].SELECTEDBANK, null);
            _this.props.cache.setData(constants["a" /* CACHE */].CARD_DETAILS, null);
          }
        } else if (paymentOptions.paymentFlow === constant["l" /* PAYMENT_FLOW */].ADDANDPAY) {
          if (e.checked || e.target && e.target.checked) {
            paymentOptions.payData = paymentOptions.addMoneyPayOption;
          } else {
            paymentOptions.payData = paymentOptions.merchantPayOption;
          }
          selected = Object(common["i" /* defaultSelected */])(paymentOptions, _this.props.cache);
        } else if (paymentOptions.paymentFlow === constant["l" /* PAYMENT_FLOW */].HYBRID) {
          paymentOptions.payData = paymentOptions.merchantPayOption;
          if (e.checked || e.target && e.target.checked) {
            if (insufficientBalance) {
              selected = _this.props.selected;
            } else {
              selected = null;
            }
          } else {
            selected = _this.props.selected;
          }
        } else {
          paymentOptions.payData = paymentOptions.merchantPayOption;
          _this.props.selected && !_this.props.selected.type === 'mgv' ? selected = _this.props.selected : selected = _this.props.wallet;
        }

        _this.props.cache.setData(constants["g" /* default */].CURRENT_PAYMODE, selected);
        paymentOptions.wallet = wallet;
        _this.props.cache.setData(constants["a" /* CACHE */].PAYMENT_OPTIONS, paymentOptions);
        _this.props.onSelectChange(selected);
        _this.updatePaytext(paymentOptions, selected);
        var nextSelectable = selected && !Object.prototype.hasOwnProperty.call(selected, 'isWalletOnly') ? selected : wallet;
        _this.props.updatePromoEnableStatus(selected, nextSelectable);
        _this.props.fetchPcf(nextSelectable);
        _this.props.onWalletToggle(wallet);
        _this.props.onPayDataChange(paymentOptions);
      }
    }, _this.updatePaytext = function (paymentOptions, selected) {
      var txnAmount = _this.props.cache.getData(constants["g" /* default */].TXN_AMOUNT);
      var amountPayable = Object(common["c" /* calculateAmountPayable */])(txnAmount, Object(common["q" /* getKey */])(paymentOptions, 'wallet'), true, _this.props.subscription);

      var payAmountText = en["a" /* default */].payButton.text + amountPayable;
      if (Object(common["w" /* isAddNPay */])(paymentOptions, _this.props.cache) && selected && selected.type !== 'mgv') {
        payAmountText = en["a" /* default */].payButton.addNPayText.replace('amount', amountPayable);
      }
      _this.props.onPayChange(true);
      _this.props.onBtnTextChange(payAmountText);
    }, _this.handleAfterPay = function (response) {
      var _getKey = Object(common["q" /* getKey */])(response, 'body', undefined),
          callBackUrl = _getKey.callBackUrl,
          txnInfo = _getKey.txnInfo;

      response.body.content = txnInfo;
      response.body.callbackUrl = callBackUrl;
      Object(formPost["b" /* handlePostData */])(response, _this.props.cache);
    }, _this.submit = function () {
      var payload = _this.props.cache.getData(constants["a" /* CACHE */].API).requestPayload(constant["a" /* API */].PT);
      var paymentOptions = _this.props.cache.getData('paymentOptions');
      var reqData = {
        body: {
          paymentMode: constants["g" /* default */].WALLET,
          authMode: constants["g" /* default */]['3D'],
          paymentFlow: paymentOptions.paymentFlow
        }
      };
      reqData = wallet__extends({}, reqData.body, payload.query);
      _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: constants["g" /* default */].PROCESSING });
      _this.props.cache.getData(constants["a" /* CACHE */].API).pay(reqData).then(function (response) {
        _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: '' });
        if (response && Object(common["q" /* getKey */])(response, 'body.resultInfo.resultStatus') === 'S') {
          _this.handleAfterPay(response);
        }
      }).catch(function () {
        _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: '' });
      });
    }, _this.closeWalletWarning = function () {
      // when the user selects okay on wallet warning message hide the popup
      _this.setState({ walletToggleWarning: false });
    }, _this.toggleWallet = function () {
      // when the user selects okay on wallet warning message change the wallet state
      var paymentOptions = wallet__extends({}, _this.props.cache.getData('paymentOptions'));
      var wallet = wallet__extends({}, paymentOptions.wallet, { isUsed: true });
      if (wallet.isUsed) {
        _this.props.onSelectedPlan(null);
      }
      // const Selected = this.props.wallet;
      paymentOptions.wallet = wallet;
      _this.props.cache.setData(constants["a" /* CACHE */].PAYMENT_OPTIONS, paymentOptions);
      _this.props.onWalletToggle(wallet);
      var txnAmount = _this.props.cache.getData(constants["g" /* default */].TXN_AMOUNT);
      var amountPayable = Object(common["c" /* calculateAmountPayable */])(txnAmount, paymentOptions.wallet, true, _this.props.subscription);
      _this.props.onBtnTextChange(en["a" /* default */].payButton.text + amountPayable);
      _this.props.onSelectChange(wallet);
      _this.props.onPayDataChange(paymentOptions);
      _this.setState({ walletToggleWarning: false });
    }, _temp), wallet__possibleConstructorReturn(_this, _ret);
  }

  Wallet.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (this.props.wallet && this.props.wallet.isEnabled && this.props.wallet.isUsed) {
      this.props.fetchPcf(this.props.wallet);
      this.props.applyPromoForPayMode(this.props.wallet);
      if (!this.props.insufficientBalance) {
        setTimeout(function () {
          _this2.props.onSelectChange(_this2.props.wallet);
        }, 0);
      } else {
        Object(logger["log"])({ eventType: logger["EVENT"].WALLET_BALANCE_INSUFFICIENT });
      }
    }
  };

  Wallet.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return Boolean(nextProps.wallet);
  };

  Wallet.prototype.render = function render(_ref, _ref2) {
    var _this3 = this;

    var wallet = _ref.wallet,
        insufficientBalance = _ref.insufficientBalance,
        offers = _ref.offers,
        isPromoAvailable = _ref.isPromoAvailable,
        instanceKey = _ref.instanceKey;
    var walletToggleWarning = _ref2.walletToggleWarning;

    var isWalletUsed = Object(common["q" /* getKey */])(wallet, 'isUsed', false);
    var walletOffer = isPromoAvailable ? isWalletUsed ? Object(common["q" /* getKey */])(offers, constant["m" /* PAYMODE */].WALLET) : Object(common["q" /* getKey */])(wallet, 'paymentOfferDetails') : null;

    var isWalletDisabled = false;
    if (wallet.isWalletOnly || !wallet.isEnabled) {
      isWalletDisabled = true;
    }
    return Object(preact_min["h"])(
      'div',
      {
        'class': 'ptm-pay-method ptm-w100-ib ' + (isWalletDisabled ? 'ptm-walletDisabled' : ''),
        id: 'checkout-wallet'
      },
      Object(preact_min["h"])(
        'div',
        { id: 'wallet_check', 'class': 'ptm-radio-wrap' },
        Object(preact_min["h"])(
          'label',
          { 'class': 'ptm-container' },
          Object(preact_min["h"])('input', {
            type: 'checkbox',
            name: 'verify' + instanceKey,
            className: 'ptm-margin0',
            id: 'wallet_checkbox',
            checked: wallet.isUsed,
            disabled: isWalletDisabled,
            onClick: function onClick(e) {
              _this3.walletToggle(e);
            }
          }),
          wallet__ref3,
          Object(preact_min["h"])(wallet_WalletLogin, { wallet: wallet, insufficientBalance: insufficientBalance })
        )
      ),
      walletToggleWarning && Object(preact_min["h"])(
        'div',
        { className: 'ptm-overlay-black' },
        Object(preact_min["h"])(components_walletToggleWarning, wallet__extends({ wallet: wallet }, {
          closeWalletWarning: this.closeWalletWarning,
          toggleWallet: this.toggleWallet
        }))
      ),
      walletOffer && Object(preact_min["h"])(offers_paymodeOffer, { offer: walletOffer, applied: isWalletUsed })
    );
  };

  return Wallet;
}(preact_min["Component"]);

/* harmony default export */ var components_wallet = (Object(preact["connect"])('selected,wallet,selectedEmiPlan, cache, subscription', onChange)(wallet_Wallet));
// CONCATENATED MODULE: ./components/mgv/index.js
var mgv__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function mgv__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function mgv__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function mgv__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var mgv__ref2 = Object(preact_min["h"])('span', { 'class': 'ptm-checkmark' });

var mgv_MGV = function (_Component) {
  mgv__inherits(MGV, _Component);

  function MGV() {
    var _temp, _this, _ret;

    mgv__classCallCheck(this, MGV);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = mgv__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleAfterPay = function (response) {
      var _getKey = Object(common["q" /* getKey */])(response, 'body', undefined),
          callBackUrl = _getKey.callBackUrl,
          txnInfo = _getKey.txnInfo;

      response.body.content = txnInfo;
      response.body.callbackUrl = callBackUrl;
      Object(formPost["b" /* handlePostData */])(response, _this.props.cache);
    }, _this.submit = function () {
      var payload = _this.props.cache.getData(constants["a" /* CACHE */].API).requestPayload(constant["a" /* API */].PT);
      var paymentOptions = _this.props.cache.getData('paymentOptions');
      var reqData = {
        body: {
          paymentMode: constants["g" /* default */].GIFT_VOUCHER,
          authMode: constants["g" /* default */]['3D'],
          paymentFlow: paymentOptions.paymentFlow,
          templateId: _this.props.mgv.templateId
        }
      };
      reqData = mgv__extends({}, reqData.body, payload.query);
      _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: constants["g" /* default */].PROCESSING });
      _this.props.cache.getData(constants["a" /* CACHE */].API).pay(reqData).then(function (response) {
        _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: '' });
        if (response && Object(common["q" /* getKey */])(response, 'body.resultInfo.resultStatus') === 'S') {
          _this.props.cache.setData(constants["g" /* default */].CURRENT_PAYMODE, _this.props.mgv);
          _this.handleAfterPay(response);
        }
      }).catch(function () {
        _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: '' });
      });
    }, _this.onOptionSelect = function (option) {
      var paymentOptions = mgv__extends({}, _this.props.cache.getData(constants["a" /* CACHE */].PAYMENT_OPTIONS));
      var wallet = mgv__extends({}, paymentOptions.wallet, { isUsed: false });
      paymentOptions.wallet = wallet;
      paymentOptions.paymentFlow === constant["l" /* PAYMENT_FLOW */].ADDANDPAY && (paymentOptions.payData = paymentOptions.merchantPayOption);
      _this.props.cache.setData(constants["a" /* CACHE */].PAYMENT_OPTIONS, paymentOptions);
      _this.props.onWalletToggle(wallet);
      _this.props.onPayDataChange(paymentOptions);
      _this.props.onOptionSelect(option);
      _this.props.onPayChange(true);
    }, _temp), mgv__possibleConstructorReturn(_this, _ret);
  }

  MGV.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (this.props.mgv) {
      if (this.props.mgv.isEnabled) {
        if (this.props.isMgvBalSufficient) {
          setTimeout(function () {
            Object(logger["log"])({ eventType: logger["EVENT"].SELECTED_PAYMODE, payMode: _this2.props.mgv.paymentMode });
            if (Object(common["q" /* getKey */])(_this2.props.cache.getData(constants["g" /* default */].CURRENT_PAYMODE), 'type') === 'mgv') {
              _this2.props.onSelectChange(_this2.props.mgv);
            }
          }, 0);
        } else {
          Object(logger["log"])({ eventType: logger["EVENT"].MGV_BALANCE_INSUFFICIENT });
        }
      }
    }
  };

  MGV.prototype.render = function render(_ref) {
    var _this3 = this;

    var instanceKey = _ref.instanceKey,
        isMgvActive = _ref.isMgvActive,
        mgv = _ref.mgv,
        isMgvBalSufficient = _ref.isMgvBalSufficient,
        cache = _ref.cache;

    if (!mgv) return null;
    var isMgvDisabled = !(mgv.isEnabled && isMgvBalSufficient);
    var locale = Object(common["e" /* clientMessage */])(constant["m" /* PAYMODE */].GIFT_VOUCHER.toLowerCase(), cache);
    this.label = locale.label;
    return Object(preact_min["h"])(
      'div',
      {
        'class': 'ptm-pay-method ptm-w100-ib ' + (isMgvDisabled ? 'ptm-disabled-mgv' : ''),
        id: 'checkout-mgv',
        ref: function ref(componentRef) {
          _this3.componentRef = componentRef;
        }
      },
      Object(preact_min["h"])(
        'div',
        { 'class': 'ptm-radio-wrap ptm-pt11' },
        Object(preact_min["h"])(
          'label',
          { 'class': 'ptm-lbl' },
          Object(preact_min["h"])('input', {
            type: 'radio',
            name: 'verify' + instanceKey,
            checked: isMgvActive,
            disabled: isMgvDisabled,
            onClick: function onClick() {
              _this3.onOptionSelect(mgv);
            }
          }),
          mgv__ref2,
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-pay-method-cont' },
            Object(preact_min["h"])(
              'p',
              { className: 'ptm-paymode-name' },
              mgv.displayName
            ),
            Object(preact_min["h"])(
              'p',
              { className: 'ptm-small-txt' },
              'Available Balance Rs ',
              mgv.availableBalance ? mgv.availableBalance : 0
            ),
            !isMgvBalSufficient && mgv.isEnabled && Object(preact_min["h"])(
              'p',
              { className: 'ptm-small-txt ptm-msg-red' },
              this.label.insufficientBalance
            ),
            !mgv.isEnabled && Object(preact_min["h"])(
              'p',
              { className: 'ptm-small-txt ptm-msg-red' },
              mgv.disableMsg
            )
          )
        )
      )
    );
  };

  return MGV;
}(preact_min["Component"]);

/* harmony default export */ var components_mgv = (Object(preact["connect"])('selected,mgv, cache, instanceKey', onChange)(mgv_MGV));
// CONCATENATED MODULE: ./components/OverlayWrap/index.js

var OverlayWrap_OverlayWrap = function OverlayWrap(props) {
  return Object(preact_min["h"])(
    "div",
    { className: "ptm-overlay-wrapper" },
    Object(preact_min["h"])(
      "div",
      { className: "ptm-overlay-container ptm-body-bg ptm-body-color" },
      props.children
    )
  );
};

/* harmony default export */ var components_OverlayWrap = (OverlayWrap_OverlayWrap);
// CONCATENATED MODULE: ./components/btn/index.js


function btn__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function btn__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function btn__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var btn_Btn = function (_Component) {
  btn__inherits(Btn, _Component);

  function Btn(props) {
    btn__classCallCheck(this, Btn);

    var _this = btn__possibleConstructorReturn(this, _Component.call(this, props));

    _this.buttonText = 'Submit';
    var merchantConfig = _this.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
    if (merchantConfig && merchantConfig.labels && merchantConfig.labels.pay) {
      _this.buttonText = merchantConfig.labels.pay;
    }
    return _this;
  }

  Btn.prototype.render = function render(_ref) {
    var payEnabled = _ref.payEnabled,
        onBtnClick = _ref.onBtnClick,
        btnText = _ref.btnText,
        btnSubText = _ref.btnSubText,
        subscription = _ref.subscription;

    var buttonText = this.buttonText;
    var subscriptionText = void 0;
    if (btnText) {
      buttonText = btnText;
    }
    /* using string fromcodepoint to convert the entity to javascript object */
    buttonText = Object(common["h" /* convertRupeeCharToUnicode */])(buttonText);

    if (Object(common["q" /* getKey */])(subscription, 'isEnabled', false) && buttonText.includes('PAY')) {
      subscriptionText = Object(common["s" /* getZeroSubscriptionText */])(this.props.cache);
    }

    return Object(preact_min["h"])(
      'div',
      {
        className: 'ptm-body-bg ptm-pos-a ptm-btn-wrapper ' + (!payEnabled ? 'ptm-btn-disabled' : ''),
        id: 'checkout-button'
      },
      Object(preact_min["h"])(
        'button',
        {
          className: 'ptm-custom-btn ptm-hvr-pop ' + (btnSubText || subscriptionText ? 'ptm-has-sub-text' : '') + ' ' + (!payEnabled ? 'ptm-disabled-btn' : ''),
          disabled: !payEnabled,
          onClick: onBtnClick
        },
        buttonText,
        btnSubText && Object(preact_min["h"])(
          'span',
          { 'class': 'ptm-d-block ptm-small-txt ptm-sub-text' },
          btnSubText
        ),
        subscriptionText && Object(preact_min["h"])(
          'span',
          { className: 'ptm-d-block ptm-small-txt ptm-subs-info-text' },
          subscriptionText
        )
      )
    );
  };

  return Btn;
}(preact_min["Component"]);

/* harmony default export */ var btn = (Object(preact["connect"])('payEnabled, btnText, cache, btnSubText, subscription')(btn_Btn));
var CustomButtom = Object(preact["connect"])('cache')(btn_Btn);
// CONCATENATED MODULE: ./components/help/index.js


function help__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function help__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function help__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var help_Help = function (_Component) {
  help__inherits(Help, _Component);

  function Help(props) {
    help__classCallCheck(this, Help);

    var _this = help__possibleConstructorReturn(this, _Component.call(this, props));

    _this.swipeDist = 0;
    _this.threshold = 10; // required min distance traveled to be considered swipe
    _this.startX = 0;
    _this.startY = 0;
    _this.state = {
      currentSlide: 0,
      activeInd: 0,
      okBtn: false
    };
    return _this;
  }

  Help.prototype.detectTouchStart = function detectTouchStart(e) {
    var coord = Object(common["W" /* touchStart */])(e);
    this.startX = coord.startX;
    this.startY = coord.startY;
  };

  Help.prototype.detectTouchEnd = function detectTouchEnd(e, index) {
    var isrightswipe = Object(common["V" /* touchEnd */])(e, this.startX, this.threshold);
    this.handleswipe(isrightswipe, index);
    e.preventDefault();
  };

  Help.prototype.detectTouchMove = function detectTouchMove(e) {
    e.preventDefault();
  };

  Help.prototype.handleswipe = function handleswipe(isrightswipe, index) {
    var res = Object(common["u" /* handleSwipeCtrl */])(isrightswipe, index, this.props.helpText);
    this.setState({
      activeInd: res.actvInd,
      okBtn: res.okBtnVal,
      initialAnimation: true
    });
  };

  Help.prototype.updateSlide = function updateSlide(index) {
    var _this2 = this;

    this.setState({
      activeInd: index,
      initialAnimation: true
    }, function () {
      _this2.setState({
        okBtn: Object(common["_0" /* updateSlideIndex */])(_this2.state.activeInd, _this2.props.helpText.length)
      });
    });
  };

  Help.prototype.render = function render(_ref, _ref2) {
    var _this3 = this;

    var title = _ref.title,
        closeHelp = _ref.closeHelp,
        helpImgTitle = _ref.helpImgTitle,
        helpText = _ref.helpText,
        headTitleLogo = _ref.headTitleLogo;
    var activeInd = _ref2.activeInd,
        initialAnimation = _ref2.initialAnimation,
        okBtn = _ref2.okBtn;

    var dot = 'ptm-help-dot';
    var dotAct = 'ptm-help-dot\' ptm-btn-active';
    var slideAct = 'slide ptm-hidden';
    var slide = 'slide';
    return Object(preact_min["h"])(
      components_OverlayWrap,
      null,
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-content-section' },
        Object(preact_min["h"])(
          'div',
          { className: 'ptm-content-top' },
          Object(preact_min["h"])(
            'p',
            { className: 'ptm-app-heading ptm-body-color' },
            title,
            headTitleLogo && Object(preact_min["h"])('img', {
              className: 'paytm-logo',
              src: Object(common["U" /* staticPath */])() + '/assets/images/logo-paytm.svg',
              alt: 'paytm'
            }),
            helpImgTitle
          ),
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-close-wrap ptm-pos-a ptm-closeIcon', onClick: function onClick(e) {
                return closeHelp(e);
              } },
            Object(preact_min["h"])('span', { className: 'ptm-cross ptm-pos-r' })
          ),
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-sliderWrap paytm-txt-center' },
            Object(preact_min["h"])(
              'ul',
              { className: 'ptm-appWorkSlides' },
              helpText && helpText.length > 0 && helpText.map(function (data, index) {
                return Object(preact_min["h"])(
                  'li',
                  {
                    onTouchStart: function onTouchStart(e) {
                      return _this3.detectTouchStart(e);
                    },
                    onTouchMove: function onTouchMove(e) {
                      _this3.detectTouchMove(e);
                    },
                    onTouchEnd: function onTouchEnd(e) {
                      return _this3.detectTouchEnd(e, index);
                    },
                    className: (index === activeInd ? slide : slideAct) + ' ' + (index ? 'ptm-animated ptmslideInRight faster' : initialAnimation ? 'ptm-animated ptmslideInLeft faster' : '')
                  },
                  Object(preact_min["h"])(
                    'p',
                    { className: 'ptm-app-para ptm-body-color' },
                    data.textSrc
                  ),
                  Object(preact_min["h"])('img', { src: data.imgSrc, alt: '', className: 'ptm-margin0 ptm-image' })
                );
              })
            )
          ),
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-btn-slider ptm-pos-a' },
            helpText && helpText.length > 0 && activeInd !== helpText.length - 1 && helpText.map(function (data, index) {
              return Object(preact_min["h"])('span', {
                className: index === activeInd ? dotAct : dot,
                onclick: function onclick() {
                  return _this3.updateSlide(index);
                }
              });
            }),
            okBtn && Object(preact_min["h"])(CustomButtom, {
              btnText: Object(i18n["a" /* locale */])('static.got.it'),
              payEnabled: true,
              onBtnClick: function onBtnClick(e) {
                return closeHelp(e);
              },
              isAppInvoke: true,
              className: 'ptm-sliderBtn'
            })
          )
        )
      )
    );
  };

  return Help;
}(preact_min["Component"]);

/* harmony default export */ var help = (Object(preact["connect"])('', onChange)(help_Help));
// CONCATENATED MODULE: ./controllers/upi.js








var upi_clearTimer = function clearTimer(cache) {
  var setTimeoutId = cache.getData(constants["g" /* default */].TIMEOUT_ID);
  var setIntervalId = cache.getData(constants["g" /* default */].INTERVAL_ID);
  clearInterval(setIntervalId);
  clearTimeout(setTimeoutId);
  cache.setData(constants["g" /* default */].IS_IN_POLLING_STATUS, false);
};

var upi_callUpiPollStatus = function callUpiPollStatus(cache) {
  var config = cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
  cache.getData(constants["a" /* CACHE */].API).status(Object(common["q" /* getKey */])(config, 'merchant.mid', undefined), Object(common["q" /* getKey */])(config, 'data.orderId', undefined)).then(function (res) {
    if (Object(common["q" /* getKey */])(res, 'body.txnInfo.RESPCODE', undefined) === '1006' || Object(common["q" /* getKey */])(res, 'body.resultInfo.resultCode', undefined) === '1006') {
      upi_clearTimer(cache);
    } else if (Object(common["q" /* getKey */])(res, 'body.isPollingRequired') === false || Object(common["q" /* getKey */])(res, 'body.txnInfo.STATUS') === constants["d" /* RESPONSE_STATUS */].SUCCESS || Object(common["q" /* getKey */])(res, 'body.txnInfo.STATUS') === constants["d" /* RESPONSE_STATUS */].TXN_SUCCESS) {
      upi_clearTimer(cache);
      Object(formPost["e" /* paymentConfirmation */])(cache);
    }
  }).catch(function (err) {
    Object(logger["log"])({ eventType: logger["EVENT"].POLLING_ERROR, err: err });
  });
};

/**
 *
 * @param {string} vpa
 */
var upi_verifyVPA = function verifyVPA(vpa, cache) {
  return new Promise(function (resolve, reject) {
    getApi(cache).verifyVPA(vpa).then(function (response) {
      var status = Object(common["q" /* getKey */])(response, 'body.resultInfo.resultStatus', 'F');
      if (status === 'S') {
        if (Object(common["q" /* getKey */])(response, 'body.recurringDetails.pspSupportedRecurring', null) === false || Object(common["q" /* getKey */])(response, 'body.recurringDetails.bankSupportedRecurring', null) === false) {
          var err = Object(common["e" /* clientMessage */])(constant["m" /* PAYMODE */].UPI.toLowerCase(), cache).error.subscriptionError;
          Object(logger["log"])({ eventType: logger["EVENT"].INVALID_VPA_ERROR, err: err });
          return reject(err);
        }
        return resolve({ valid: response.body.valid });
      }
      var errorMsg = Object(common["q" /* getKey */])(response, 'body.resultInfo.resultMsg', constants["g" /* default */].GENERIC_ERROR);
      return reject(errorMsg);
    }).catch(function (err) {
      var errorMsg = Object(common["q" /* getKey */])(err, 'body.resultInfo.resultMsg', constants["g" /* default */].GENERIC_ERROR);
      return reject(errorMsg);
    });
  });
};

var upi_proceedToCollectFlow = function proceedToCollectFlow(payload, cache, vpa) {
  return new Promise(function (resolve, reject) {
    getApi(cache).pay(payload, false).then(function (res) {
      cache.setData(constants["g" /* default */].IS_BANKPAGE_REQUIRED_BLOCKED, false);
      cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: '' });
      if (Object(common["q" /* getKey */])(res, 'body.resultInfo.resultStatus', 'F') === 'S') {
        setTimeout(function () {
          cache.getData(constants["a" /* CACHE */].STORE).setState({ isPollingRequired: true });
        }, 50);
        resolve({
          pollingData: {
            STATUS_TIMEOUT: Object(common["q" /* getKey */])(res, 'body.bankForm.displayField.statusTimeout', 480000),
            STATUS_INTERVAL: Object(common["q" /* getKey */])(res, 'body.bankForm.displayField.statusInterval', 5000),
            vpaID: vpa,
            content: Object(common["q" /* getKey */])(res, 'body.bankForm.redirectForm.content')
          },
          isUpiPollingRequired: true
        });
      } else {
        var err = {
          showError: true,
          errorText: Object(common["q" /* getKey */])(res, 'body.resultInfo.resultMsg', constants["g" /* default */].GENERIC_ERROR)
        };
        reject(err);
      }
    }).catch(function () {
      cache.setData(constants["g" /* default */].IS_BANKPAGE_REQUIRED_BLOCKED, false);
      cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: '' });
      var err = { showError: true, errorText: constants["g" /* default */].GENERIC_ERROR };
      reject(err);
    });
  });
};

var vpaValid = function vpaValid(vpa) {
  // console.log(api().requestPayload('/api/v'));
  var upiPattern = /^[a-zA-Z0-9.-]*$/;
  var pspPattern = /^[a-zA-Z]*$/;
  var isValid = false;

  if (vpa.length > 0 && vpa.length <= 255) {
    if (vpa.indexOf('@') >= 0) {
      var vpaSplit = vpa.split('@');
      if (vpaSplit.length === 2) {
        var handle = vpaSplit[0];
        var psp = vpaSplit[1];
        if (psp.length > 0 && handle.length) {
          isValid = pspPattern.test(psp) && upiPattern.test(handle);
        }
      }
    }
  }
  return isValid;
};

var upi_callPolling = function callPolling(timeOut, timeInterval, cache) {
  var pollingVariable = setInterval(function () {
    upi_callUpiPollStatus(cache);
  }, timeInterval);

  var timeoutVariable = setTimeout(function () {
    clearInterval(pollingVariable);
    cache.setData(constants["g" /* default */].IS_IN_POLLING_STATUS, false);
    Object(formPost["e" /* paymentConfirmation */])(cache);
  }, timeOut);

  cache.setData(constants["g" /* default */].TIMEOUT_ID, timeoutVariable);
  cache.setData(constants["g" /* default */].INTERVAL_ID, pollingVariable);
};

/**
 * UPI crossponding app name and image name for polling screen `[PGP-15198]`
 * @param {String} upiName - entered upi name
 * @returns {Object} - return the Object of UPI crossponding app name and image name
 */
var upi_upiAppImgName = function upiAppImgName() {
  var upiName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var upiExt = upiName.split('@');
  var upiMap = { appName: Object(i18n["a" /* locale */])('upi.polling.default.goto'), imageName: 'upi_default.png' };

  if (upiExt && upiExt[1]) {
    var upiExtName = upiExt[1];
    if (upiExtName === 'paytm') {
      upiMap.appName = 'Paytm mobile app';
      upiMap.imageName = 'upi_paytm.png';
    } else if (upiExtName === 'upi') {
      upiMap.appName = 'BHIM mobile app';
      upiMap.imageName = 'upi_bhim.svg';
    } else if (upiExtName === 'ybl') {
      upiMap.appName = 'PhonePe mobile app';
      upiMap.imageName = 'upi_phonepe.svg';
    } else if (upiExtName.indexOf('ok') >= 0) {
      upiMap.appName = 'Google Pay mobile app';
      upiMap.imageName = 'upi_google.svg';
    }
  }
  return upiMap;
};
// CONCATENATED MODULE: ./components/upi-intent/index.js


function upi_intent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function upi_intent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function upi_intent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var upi_intent_UpiIntent = function (_Component) {
  upi_intent__inherits(UpiIntent, _Component);

  function UpiIntent(props) {
    upi_intent__classCallCheck(this, UpiIntent);

    var _this = upi_intent__possibleConstructorReturn(this, _Component.call(this, props));

    _this.transactionStatusCall = function () {
      var setTimeoutId = _this.props.cache.getData(constants["g" /* default */].TIMEOUT_ID);
      var setIntervalId = _this.props.cache.getData(constants["g" /* default */].INTERVAL_ID);
      var config = _this.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
      var retryCounts = _this.props.cache.getData(constants["g" /* default */].ALLOWED_MERCHANT_RETRY_COUNTS);
      clearInterval(setIntervalId);
      clearTimeout(setTimeoutId);
      if (Object(common["F" /* isNullOrUndefined */])(retryCounts) || retryCounts <= 0) {
        Object(formPost["e" /* paymentConfirmation */])(_this.props.cache);
      } else {
        _this.setState({
          genericError: '',
          isProceedToPayClicked: false,
          isTxtStatusInProgress: false
        });
        _this.props.cache.getData(constants["a" /* CACHE */].API).status(Object(common["q" /* getKey */])(config, 'merchant.mid', undefined), Object(common["q" /* getKey */])(config, 'data.orderId', undefined)).then(function (res) {
          if (Object(common["q" /* getKey */])(res, 'body.txnInfo.STATUS') === constants["d" /* RESPONSE_STATUS */].SUCCESS || Object(common["q" /* getKey */])(res, 'body.txnInfo.STATUS') === constants["d" /* RESPONSE_STATUS */].TXN_SUCCESS) {
            Object(formPost["e" /* paymentConfirmation */])(_this.props.cache);
          } else {
            _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: null, customOverlayData: null });
          }
        }).catch(function (err) {
          Object(logger["log"])({ eventType: logger["EVENT"].API_FAILED, err: err });
          Object(formPost["e" /* paymentConfirmation */])(_this.props.cache);
        });
      }
    };

    _this.attachListener = function () {
      document.addEventListener(_this.state.hiddenVisibilityObj.visibilityChange, _this.focusListener);
      Object(logger["log"])({ eventType: logger["EVENT"].UPI_INTENT_ACTIVE, value: true });
    };

    _this.clearTimer = function () {
      var _this$state = _this.state,
          setIntervalId = _this$state.setIntervalId,
          setTimeoutId = _this$state.setTimeoutId,
          hiddenVisibilityObj = _this$state.hiddenVisibilityObj,
          isWindowFocusedInterval = _this$state.isWindowFocusedInterval,
          isWindowFocusedTimeout = _this$state.isWindowFocusedTimeout;

      clearInterval(setIntervalId);
      clearTimeout(setTimeoutId);
      clearInterval(isWindowFocusedInterval);
      clearTimeout(isWindowFocusedTimeout);
      _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: null, customOverlayData: null });
      document.removeEventListener(hiddenVisibilityObj.visibilityChange, _this.focusListener);
      Object(logger["log"])({ eventType: logger["EVENT"].UPI_INTENT_ACTIVE, value: false });
    };

    _this.onSubmit = function () {
      Object(logger["log"])({
        eventType: logger["EVENT"].INTENT_PAY_SUBMIT,
        payMode: constants["f" /* UPI_INTENT_MWEB */].UPI_INTENT,
        message: 'onsubmit called'
      });
      _this.setState({ genericError: '', isTxtStatusInProgress: false });

      var payload = {
        authMode: constants["g" /* default */]['3D'],
        payerAccount: _this.state.upi,
        paymentMode: constants["f" /* UPI_INTENT_MWEB */].UPI_INTENT,
        selectedPaymentModeId: Object(common["q" /* getKey */])(_this.props, 'option.id')
      };

      _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({
        overlayValue: constants["g" /* default */].CUSTOM_PROCESSING,
        customOverlayData: {
          heading: Object(i18n["a" /* locale */])('upi_intent.loader.heading'),
          desc: Object(i18n["a" /* locale */])('upi_intent.loader.desc')
        }
      });
      _this.props.cache.setData(constants["g" /* default */].IS_BANKPAGE_REQUIRED_BLOCKED, true);

      _this.props.cache.getData(constants["a" /* CACHE */].API).pay(payload).then(function (res) {
        _this.props.cache.setData(constants["g" /* default */].IS_BANKPAGE_REQUIRED_BLOCKED, false);
        Object(logger["log"])({
          eventType: logger["EVENT"].INTENT_PAY_SUBMIT,
          payMode: constants["f" /* UPI_INTENT_MWEB */].UPI_INTENT,
          message: 'API_SUCCESS',
          response: res
        });

        var deepLink = Object(common["q" /* getKey */])(res, 'body.deepLinkInfo.deepLink');
        if (deepLink) {
          _this.setState({ isProceedToPayClicked: true });
          Object(logger["log"])({
            eventType: logger["EVENT"].INTENT_DEEPLINK_INVOKED,
            value: true,
            message: 'Invoked deepLink ' + deepLink
          });

          var isPSPTrayOpened = false;
          var isWindowFocusedInterval = setInterval(function () {
            if (!document.hasFocus()) {
              clearInterval(isWindowFocusedInterval);
              isPSPTrayOpened = true;
            }
          }, 300);

          var isWindowFocusedTimeout = setTimeout(function () {
            clearInterval(isWindowFocusedInterval);
            _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: '' });
            var genericError = isPSPTrayOpened ? '' : Object(i18n["a" /* locale */])('upi_intent.psp.not.found');
            _this.setState({ genericError: genericError });
            Object(logger["log"])({
              eventType: logger["EVENT"].INTENT_DEEPLINK_INVOKED,
              value: false,
              message: 'Unable fo open PSP URL ' + deepLink
            });
          }, 10000);
          _this.setState({ isWindowFocusedInterval: isWindowFocusedInterval, isWindowFocusedTimeout: isWindowFocusedTimeout });

          document.location.href = deepLink;
          return true;
        }
        throw new Error('Deep Link is not present in PTC response');
      }).catch(function (err) {
        _this.props.cache.setData(constants["g" /* default */].IS_BANKPAGE_REQUIRED_BLOCKED, false);
        _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: '' });
        Object(logger["log"])({
          eventType: logger["EVENT"].INTENT_PAY_SUBMIT,
          payMode: constants["f" /* UPI_INTENT_MWEB */].UPI_INTENT,
          message: 'api response error',
          error: err
        });
        _this.setState({ isProceedToPayClicked: false });
        if (Object(common["q" /* getKey */])(err, 'body.resultInfo.resultStatus') === 'F' && Object(common["q" /* getKey */])(err, 'body.resultInfo.resultMsg')) {
          _this.setState({ genericError: Object(common["q" /* getKey */])(err, 'body.resultInfo.resultMsg') });
        } else {
          _this.setState({ genericError: constants["g" /* default */].GENERIC_ERROR });
        }
      });
    };

    _this.state = {
      genericError: '',
      hiddenVisibilityObj: _this.props.cache.getData(constants["f" /* UPI_INTENT_MWEB */].VISIBILITY_HIDDEN_VALUE),
      setIntervalId: '',
      setTimeoutId: '',
      defaultSetTimeoutMS: 480000,
      defaultSetIntervalMS: 5000,
      showSliderSec: false,
      helpText: [{
        textSrc: Object(i18n["a" /* locale */])('upi_intent.help.step1'),
        imgSrc: Object(common["U" /* staticPath */])() + '/assets/images/upi_intent_open_list.png'
      }, {
        textSrc: Object(i18n["a" /* locale */])('upi_intent.help.step2'),
        imgSrc: Object(common["U" /* staticPath */])() + '/assets/images/upi_intent_select.png'
      }, {
        textSrc: Object(i18n["a" /* locale */])('upi_intent.help.step3'),
        imgSrc: Object(common["U" /* staticPath */])() + '/assets/images/upi_intent_txn_complete.png'
      }],
      paymode: props.paymode,
      isProceedToPayClicked: false,
      isTxtStatusInProgress: false,
      isWindowFocusedInterval: '',
      isWindowFocusedTimeout: ''
    };
    _this.focusListener = _this.focusListener.bind(_this);
    _this.pollingTxnStatus = _this.pollingTxnStatus.bind(_this);
    return _this;
  }

  UpiIntent.prototype.toggleShowSlider = function toggleShowSlider() {
    Object(logger["log"])({ eventType: logger["EVENT"].UPI_INTENT_HELPER, value: !this.state.showSliderSec });
    this.setState(function (prevState) {
      return { showSliderSec: !prevState.showSliderSec };
    });
  };

  UpiIntent.prototype.onRetryClick = function onRetryClick() {
    Object(logger["log"])({
      eventType: logger["EVENT"].UPI_INTENT_RETRY,
      RetryCounts: this.props.cache.getData(constants["g" /* default */].ALLOWED_MERCHANT_RETRY_COUNTS)
    });
    this.transactionStatusCall();
    this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({
      overlayValue: constants["g" /* default */].CUSTOM_PROCESSING,
      customOverlayData: {
        heading: Object(i18n["a" /* locale */])('upi_intent.loader.retry.validation.heading'),
        desc: Object(i18n["a" /* locale */])('upi_intent.loader.retry.validation.desc'),
        handlerText: ''
      }
    });
  };

  UpiIntent.prototype.pollingTxnStatus = function pollingTxnStatus() {
    var _this2 = this;

    var _state = this.state,
        defaultSetTimeoutMS = _state.defaultSetTimeoutMS,
        defaultSetIntervalMS = _state.defaultSetIntervalMS;


    Object(logger["log"])({ eventType: logger["EVENT"].POLLING_STATUS_CALL });
    this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: constants["g" /* default */].PROCESSING });

    var setIntervalId = setInterval(function () {
      upi_callUpiPollStatus(_this2.props.cache);
    }, defaultSetIntervalMS);

    var retryCounts = this.props.cache.getData(constants["g" /* default */].ALLOWED_MERCHANT_RETRY_COUNTS);
    if (!Object(common["F" /* isNullOrUndefined */])(retryCounts) && retryCounts > 0) {
      setTimeout(function () {
        _this2.props.cache.getData(constants["a" /* CACHE */].STORE).setState({
          overlayValue: constants["g" /* default */].CUSTOM_PROCESSING,
          customOverlayData: {
            heading: Object(i18n["a" /* locale */])('upi_intent.loader.retry.heading'),
            desc: Object(i18n["a" /* locale */])('upi_intent.loader.retry.desc'),
            handlerText: 'Try Again',
            handler: _this2.onRetryClick.bind(_this2)
          }
        });
      }, 5000);
    }

    var setTimeoutId = setTimeout(function () {
      clearInterval(setIntervalId);
      Object(logger["log"])({ eventType: logger["EVENT"].INTENT_SET_TIMEOUT, message: 'submitForm called from setTimeout' });
      _this2.transactionStatusCall();
    }, defaultSetTimeoutMS);

    this.props.cache.setData(constants["g" /* default */].TIMEOUT_ID, setTimeoutId);
    this.props.cache.setData(constants["g" /* default */].INTERVAL_ID, setIntervalId);

    this.setState({ setTimeoutId: setTimeoutId, setIntervalId: setIntervalId, isTxtStatusInProgress: true, genericError: '' });
  };

  UpiIntent.prototype.focusListener = function focusListener() {
    var _state2 = this.state,
        hiddenVisibilityObj = _state2.hiddenVisibilityObj,
        isProceedToPayClicked = _state2.isProceedToPayClicked,
        isTxtStatusInProgress = _state2.isTxtStatusInProgress,
        isWindowFocusedTimeout = _state2.isWindowFocusedTimeout,
        isWindowFocusedInterval = _state2.isWindowFocusedInterval;

    if (isProceedToPayClicked) {
      if (!document[hiddenVisibilityObj.hidden] && !isTxtStatusInProgress) {
        this.pollingTxnStatus();
      } else if (document[hiddenVisibilityObj.hidden]) {
        clearTimeout(isWindowFocusedTimeout);
        clearInterval(isWindowFocusedInterval);
        this.setState({ genericError: '' });
      }
    }
    Object(logger["log"])({
      eventType: logger["EVENT"].APP_SWITCH,
      value: document[hiddenVisibilityObj.hidden],
      message: 'isProceedToPayClicked => ' + isProceedToPayClicked
    });
  };

  UpiIntent.prototype.componentDidMount = function componentDidMount() {
    this.attachListener();
  };

  UpiIntent.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearTimer();
  };

  UpiIntent.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (props) {
      if (props.paymode !== constants["f" /* UPI_INTENT_MWEB */].UPI_INTENT_MWEB) {
        this.clearTimer();
      } else if (this.state && this.state.paymode !== props.paymode && props.paymode === constants["f" /* UPI_INTENT_MWEB */].UPI_INTENT_MWEB) {
        this.setState({ isProceedToPayClicked: false, isTxtStatusInProgress: false });
        this.attachListener();
      }
      this.setState({ paymode: props.paymode, genericError: '' });
    }
  };

  UpiIntent.prototype.render = function render(_ref, _ref2) {
    var _this3 = this;

    var onIntentClick = _ref.onIntentClick,
        paymode = _ref.paymode;
    var genericError = _ref2.genericError,
        showSliderSec = _ref2.showSliderSec,
        helpText = _ref2.helpText;

    return Object(preact_min["h"])(
      'div',
      null,
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-upi-main-box ptm-pos-r', onClick: onIntentClick },
        Object(preact_min["h"])(
          'div',
          null,
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-upi-icon ptm-pos-a' },
            Object(preact_min["h"])('img', {
              className: 'ptm-upi-icon-pic ptm-centralized',
              src: Object(common["U" /* staticPath */])() + '/assets/images/bhim-upi-app.png',
              alt: 'logos'
            }),
            paymode === constants["f" /* UPI_INTENT_MWEB */].UPI_INTENT_MWEB && Object(preact_min["h"])(
              'div',
              { className: 'ptm-tick ptm-pos-a' },
              Object(preact_min["h"])('span', { className: 'ptm-sign1' }),
              Object(preact_min["h"])('span', { className: 'ptm-sign2' })
            )
          ),
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-upi-heading-txt' },
            Object(i18n["a" /* locale */])('upi_intent.label'),
            ' '
          ),
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-upi-sbtxt ptm-body-color' },
            Object(i18n["a" /* locale */])('upi_intent.desc')
          )
        ),
        Object(preact_min["h"])(
          'a',
          {
            'class': 'ptm-know-more ptm-primary ib fs12 body-bg-global',
            onClick: function onClick(e) {
              return _this3.toggleShowSlider(e);
            }
          },
          Object(i18n["a" /* locale */])('upi_intent.help')
        )
      ),
      genericError && Object(preact_min["h"])(
        'div',
        { className: 'ptm-msg-red ptm-upierror' },
        genericError
      ),
      showSliderSec && Object(preact_min["h"])(help, {
        title: Object(i18n["a" /* locale */])('upi_intent.help.title'),
        helpText: helpText,
        closeHelp: function closeHelp(e) {
          return _this3.toggleShowSlider(e);
        }
      })
    );
  };

  return UpiIntent;
}(preact_min["Component"]);

/* harmony default export */ var upi_intent = (Object(preact["connect"])('cache')(upi_intent_UpiIntent));
// CONCATENATED MODULE: ./components/upipolling/index.js
var upipolling__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function upipolling__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function upipolling__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function upipolling__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var upipolling__ref3 = Object(preact_min["h"])(
  'h2',
  { className: 'ptm-bold ptm-body-color' },
  'Complete your Payment'
);

var upipolling__ref4 = Object(preact_min["h"])(
  'h5',
  { className: 'ptm-fs11 paytm-txt-center ptm-body-color' },
  'REQUEST EXPIRES IN'
);

var _ref5 = Object(preact_min["h"])(
  'p',
  { className: 'ptm-fs11 paytm-txt-center' },
  'MIN'
);

var _ref6 = Object(preact_min["h"])(
  'p',
  { className: 'ptm-fs11 paytm-txt-center' },
  'SEC'
);

var upipolling_UpiPolling = function (_Component) {
  upipolling__inherits(UpiPolling, _Component);

  function UpiPolling(props) {
    upipolling__classCallCheck(this, UpiPolling);

    var _this = upipolling__possibleConstructorReturn(this, _Component.call(this, props));

    var merchantConfig = _this.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
    var merchantDetails = {};
    if (typeof _this.props.cache.getData(constants["a" /* CACHE */].PAYMENT_OPTIONS) === 'object') {
      var paymentOptions = _this.props.cache.getData(constants["a" /* CACHE */].PAYMENT_OPTIONS);
      merchantDetails = paymentOptions.merchantDetails || {};
      // setting name and logo from merchant config  if it exists instead from api
      var merchantName = Object(common["q" /* getKey */])(merchantConfig, 'merchant.name', null);
      var merchantLogo = Object(common["q" /* getKey */])(merchantConfig, 'merchant.logo', null);
      merchantDetails.name = merchantName || merchantDetails.merchantDisplayName || merchantDetails.merchantName;
      merchantDetails.logo = merchantLogo || merchantDetails.merchantLogo;
    }
    _this.setTimeoutIntervalId = '';
    _this.timeExp = parseInt(_this.props.pollingData.STATUS_TIMEOUT, 10);
    _this.timeInMin = _this.timeExp / 60000;
    _this.state = upipolling__extends({
      minLeft: _this.timeInMin < 10 ? '0' + _this.timeInMin : _this.timeInMin,
      secLeft: '00',
      showInfo: false,
      upiMessage: Object(i18n["a" /* locale */])('upi.polling.click'),
      paymodeTxnAmount: _this.props.cache.getData(constants["g" /* default */].TXN_AMOUNT),
      merchantDetails: merchantDetails
    }, upi_upiAppImgName(_this.props.pollingData.vpaID));
    return _this;
  }

  UpiPolling.prototype.componentDidMount = function componentDidMount() {
    var timeOut = parseInt(this.props.pollingData.STATUS_TIMEOUT, 10);
    var timeInterval = parseInt(this.props.pollingData.STATUS_INTERVAL, 10);

    this.setState(upi_upiAppImgName(Object(common["q" /* getKey */])(this.props, 'pollingData.vpaID', '')));

    this.props.cache.setData(constants["g" /* default */].IS_IN_POLLING_STATUS, true);

    // start timer for polling
    this.updateTimeCount();

    // call polling
    upi_callPolling(timeOut, timeInterval, this.props.cache);
  };

  UpiPolling.prototype.updateTimeCount = function updateTimeCount() {
    var _this2 = this;

    var totalTime = this.timeExp / 1000; // convert ms to sec
    this.setTimeoutIntervalId = setInterval(function () {
      var calcMins = parseInt(totalTime / 60, 10);
      var calcSecs = parseInt(totalTime % 60, 10);

      _this2.setState({
        minLeft: calcMins < 10 ? '0' + calcMins : calcMins,
        secLeft: calcSecs < 10 ? '0' + calcSecs : calcSecs
      });
      totalTime -= 1;
      if (totalTime < 0) {
        clearInterval(_this2.setTimeoutIntervalId);
      }
    }, 1000);
  };

  UpiPolling.prototype.toggleInfo = function toggleInfo() {
    this.setState({ showInfo: !this.state.showInfo });
  };

  UpiPolling.prototype.componentWillUnmount = function componentWillUnmount() {
    clearInterval(this.setTimeoutIntervalId);
  };

  UpiPolling.prototype.render = function render(_ref, _ref2) {
    var _this3 = this;

    var pollingData = _ref.pollingData;
    var showInfo = _ref2.showInfo,
        minLeft = _ref2.minLeft,
        secLeft = _ref2.secLeft,
        appName = _ref2.appName,
        imageName = _ref2.imageName,
        paymodeTxnAmount = _ref2.paymodeTxnAmount,
        merchantDetails = _ref2.merchantDetails;

    return Object(preact_min["h"])(
      'section',
      { className: 'ptm-search-module  ptm-upi-visible' },
      Object(preact_min["h"])(
        'div',
        { 'class': 'ptm-s-inner ptm-h100 ptm-body-bg' },
        Object(preact_min["h"])(
          'div',
          { className: 'ptm-h100' },
          Object(preact_min["h"])(
            'div',
            {
              className: 'ptm-main-wrapper ptm-upipolling-global ptm-w100 ptm-h100 ptm-auto-overflow'
            },
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-payment-wrapper ptm-w100 ptm-pos-r' },
              Object(preact_min["h"])(
                'div',
                { className: 'ptm-payment-top ptm-upipolling-top-global ptm-w100 ptm-pos-r' },
                merchantDetails && merchantDetails.logo && Object(preact_min["h"])(
                  'div',
                  { className: 'ptm-upi-merc ptm-pos-r' },
                  Object(preact_min["h"])('img', {
                    className: 'ptm-upi-merc-img ptm-pos-a',
                    src: merchantDetails.logo,
                    alt: ''
                  })
                ),
                merchantDetails && merchantDetails.name && Object(preact_min["h"])(
                  'span',
                  {
                    className: 'ptm-provider ptm-sub-txt-header-global ptm-semibold ptm-ellipsis'
                  },
                  merchantDetails.name
                ),
                Object(preact_min["h"])(
                  'span',
                  { className: 'ptm-polling-amount ptm-sub-txt-header-global ptm-semibold' },
                  '\u20B9 ',
                  paymodeTxnAmount
                )
              ),
              Object(preact_min["h"])(
                'div',
                { className: 'ptm-payment-bottom ptm-poll-bottom ptm-w100' },
                upipolling__ref3,
                Object(preact_min["h"])(
                  'div',
                  { 'class': 'ptm-upi-para ptm-pos-r ptm-fs15' },
                  Object(preact_min["h"])(
                    'span',
                    { 'class': 'ptm-elip-control ptm-sub-txt-global ptm-ellipsis ptm-body-color' },
                    'Entered UPI Address: ',
                    pollingData.vpaID
                  ),
                  Object(preact_min["h"])(
                    'span',
                    {
                      onclick: function onclick(e) {
                        return _this3.toggleInfo(e);
                      },
                      className: (showInfo ? 'ptm-info-wrapper' : '') + ' ptm-info-wraper-after'
                    },
                    Object(preact_min["h"])('img', {
                      className: 'ptm-info-wrap ptm-pos-r',
                      src: Object(common["U" /* staticPath */])() + '/assets/images/info.png'
                    })
                  ),
                  showInfo && Object(preact_min["h"])(
                    'div',
                    {
                      className: 'ptm-info-tab\n                        ptm-sub-txt-global ptm-fs12 ptm-pos-a'
                    },
                    Object(i18n["a" /* locale */])('upi.polling.click')
                  )
                ),
                Object(preact_min["h"])(
                  'div',
                  { 'class': 'ptm-steps-wrap' },
                  Object(preact_min["h"])(
                    'div',
                    {
                      'class': 'ptm-upi-steps ptm-upi-steps-global ptm-pos-r ptm-steps-min-height'
                    },
                    Object(preact_min["h"])(
                      'p',
                      { 'class': 'ptm-upi-dscr ptm-semibold ptm-sub-txt-global ptm-body-color' },
                      'Go to the ',
                      appName
                    ),
                    Object(preact_min["h"])('img', {
                      'class': 'ptm-upipolling-img ptm-pos-a',
                      src: Object(common["U" /* staticPath */])() + '/assets/images/' + imageName,
                      alt: 'bank app'
                    })
                  ),
                  Object(preact_min["h"])(
                    'div',
                    {
                      'class': 'ptm-upi-steps ptm-upi-steps-global ptm-pos-r ptm-steps-min-height'
                    },
                    Object(preact_min["h"])(
                      'p',
                      { 'class': 'ptm-upi-dscr ptm-semibold ptm-sub-txt-global ptm-body-color' },
                      Object(i18n["a" /* locale */])('upi.polling.approve')
                    ),
                    Object(preact_min["h"])('img', {
                      'class': 'ptm-upipolling-img ptm-pos-a',
                      src: Object(common["U" /* staticPath */])() + '/assets/images/step-2.png',
                      alt: 'bank app'
                    })
                  )
                )
              ),
              Object(preact_min["h"])(
                'div',
                { className: 'ptm-timer-wrap ptm-sub-txt-global ptm-w100 paytm-txt-center' },
                upipolling__ref4,
                Object(preact_min["h"])(
                  'div',
                  { className: 'ptm-timer ptm-timer-global' },
                  Object(preact_min["h"])(
                    'div',
                    {
                      className: 'ptm-block ptm-timer-block-global ptm-fs-15 ptm-bold ptm-pos-r paytm-txt-center'
                    },
                    minLeft,
                    _ref5
                  ),
                  Object(preact_min["h"])(
                    'div',
                    { className: 'ptm-block ptm-timer-block-global paytm-txt-center' },
                    secLeft,
                    _ref6
                  )
                )
              )
            )
          ),
          Object(preact_min["h"])(
            'p',
            {
              className: 'ptm-instruction ptm-black-global ptm-w100 ptm-fs12 paytm-txt-center ptm-pos-a'
            },
            Object(i18n["a" /* locale */])('upi.polling.noback')
          )
        )
      )
    );
  };

  return UpiPolling;
}(preact_min["Component"]);

/* harmony default export */ var upipolling = (Object(preact["connect"])('cache')(upipolling_UpiPolling));
// CONCATENATED MODULE: ./components/upi/index.js
var upi__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function upi__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function upi__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function upi__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var _INVALID_UPI_CHAR_REGEX = /[^0-9a-z@A-Z.-]/g;
var _NEXT_AT_SYMBOL_REGEX = /(.*@.*)@/;

var upi__ref = Object(preact_min["h"])(
  'div',
  { className: 'ptm-tick ptm-pos-a' },
  Object(preact_min["h"])('span', { className: 'ptm-sign1' }),
  Object(preact_min["h"])('span', { className: 'ptm-sign2' })
);

var upi__ref4 = Object(preact_min["h"])('span', { 'class': 'ptm-checkmark' });

var upi__ref5 = Object(preact_min["h"])(renewal, null);

var upi_Upi = function (_Component) {
  upi__inherits(Upi, _Component);

  function Upi(props) {
    upi__classCallCheck(this, Upi);

    /* the handlers and relevant images related to JIRA - PGPUI-1001 */
    var _this = upi__possibleConstructorReturn(this, _Component.call(this, props));

    _this.submit = function () {
      if (_this.state.paymode === constants["g" /* default */].UPI) {
        _this.collectFlow();
      } else if (_this.state.paymode === constants["g" /* default */].UPI_INTENT) {
        _this.intentFlow();
      } else if (_this.state.paymode === constants["f" /* UPI_INTENT_MWEB */].UPI_INTENT_MWEB && _this.upiIntentRef && _this.upiIntentRef._component) {
        _this.upiIntentRef._component.onSubmit();
      }
    };

    _this.intentFlow = function () {};

    _this.collectFlow = function () {
      // remove the handlers dropdown
      _this.setState({ showHandlers: false });

      if (!_this.state.upi) {
        _this.setState(function (prevState) {
          return {
            errorText: prevState.errorObjMsg.requiredErrorMsg,
            showError: true
          };
        });
        return;
      }

      if (!vpaValid(_this.state.upi)) {
        _this.setState(function (prevState) {
          return {
            errorText: prevState.errorObjMsg.validErrorMsg,
            showError: true
          };
        });
        return;
      }

      Object(logger["log"])({ eventType: logger["EVENT"].COLLECT_FLOW_USED });
      _this.props.cache.setData(constants["g" /* default */].IS_BANKPAGE_REQUIRED_BLOCKED, true);
      _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: constants["g" /* default */].PROCESSING });
      Object(formPost["c" /* openPopUpWindow */])(_this.props.cache);
      var payload = {
        authMode: constants["g" /* default */]['3D'],
        payerAccount: _this.state.upi,
        paymentMode: constants["g" /* default */].UPI,
        selectedPaymentModeId: _this.props.option.id
      };
      if (Object(common["q" /* getKey */])(_this.props.subscription, 'isEnabled', false)) {
        upi_verifyVPA(_this.state.upi, _this.props.cache).then(function (res) {
          if (res.valid) {
            upi_proceedToCollectFlow(payload, _this.props.cache, _this.state.upi).then(function (res) {
              // postInWindow(res, this.props.cache)
              _this.setState(res);
            }).catch(function (err) {
              _this.setState(err);
            });
          }
        }).catch(function (error) {
          _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: '' });
          _this.setState({ showError: true, errorText: error });
          // postInWindow({}, this.props.cache);
        });
      } else {
        upi_proceedToCollectFlow(payload, _this.props.cache, _this.state.upi).then(function (res) {
          return _this.setState(res);
        }).catch(function (err) {
          _this.setState(err);
        });
      }
    };

    _this.selectIntentApp = function (app) {
      _this.setState({
        selectedUpiIntentApp: app,
        paymode: constants["g" /* default */].UPI_INTENT,
        genericErrorIntent: '',
        upi: '',
        showHandlers: false
      });

      _this.props.onPayChange(true);
    };

    _this.renderIntentApps = function (startIndex, endIndex) {
      var apps = [];

      var _loop = function _loop(i) {
        apps.push(Object(preact_min["h"])(
          'div',
          {
            className: 'ptm-upi-list-item',
            onClick: function onClick() {
              return _this.selectIntentApp(_this.state.upiIntentApps[i]);
            }
          },
          Object(preact_min["h"])(
            'div',
            {
              className: 'ptm-upi-img ' + (_this.state.selectedUpiIntentApp.name === _this.state.upiIntentApps[i].name ? 'ptm-activebank' : '')
            },
            Object(preact_min["h"])('img', { src: Object(common["U" /* staticPath */])() + '/assets/images/ic-upi.svg', alt: '', className: 'ptm-margin0' }),
            _this.state.selectedUpiIntentApp.name === _this.state.upiIntentApps[i].name ? upi__ref : null
          ),
          Object(preact_min["h"])(
            'p',
            { className: 'ptm-bank-name' },
            _this.state.upiIntentApps[i].displayName
          )
        ));
      };

      for (var i = startIndex; i <= endIndex; i += 1) {
        _loop(i);
      }
      if (_this.state.upiIntentApps.length > 5 && !_this.state.showRemainingApps) {
        apps.push(Object(preact_min["h"])(
          'div',
          { className: 'ptm-upi-list-item', onClick: function onClick() {
              return _this.toggleShowRemainingApps(true);
            } },
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-upi-img' },
            Object(preact_min["h"])('img', {
              src: Object(common["U" /* staticPath */])() + '/assets/images/ic-upi.svg',
              alt: '',
              className: 'ptm-margin0'
            })
          ),
          Object(preact_min["h"])(
            'p',
            { className: 'ptm-bank-name' },
            'More'
          )
        ));
      }

      return apps;
    };

    _this.handleInputClick = function (paymode) {
      _this.setState({ paymode: paymode, selectedUpiIntentApp: '' });
    };

    _this.handlePastedInput = function () {
      var upiFld = _this.upi;
      setTimeout(function () {
        _this.applyPromoOnVPAValidate(upiFld.value);
        _this.setState({ upi: upiFld.value, paymode: constants["g" /* default */].UPI, selectedUpiIntentApp: '' }); // setting state values same as input focus
      }, 100);
    };

    _this.toggleShowRemainingApps = function (value) {
      _this.setState({ showRemainingApps: value, showError: true });
    };

    _this.updateUpiWithHandler = function (handler) {
      Object(logger["log"])({ eventType: logger["EVENT"].UPI_HANDLER_SELECTED, handler: handler });
      var upi = _this.state.upi.split('@')[0] + handler;
      _this.setState(upi__extends({}, _this.state, {
        upi: upi,
        showHandlers: false
      }));
      _this.props.onPayChange(true);
      _this.applyPromoOnVPAValidate(upi);
    };

    _this.renderHandlerSuggestions = function () {
      var handlerName = _this.state.upi ? _this.state.upi.split('@')[1] : '';
      Object(logger["log"])({ eventType: logger["EVENT"].DISPLAY_UPI_HANDLER_SUGGESTION });
      var suggestions = [];
      _this.state.handlers.forEach(function (handler) {
        /* if the upi handle is found in suggestion then only show relevant handles and not all handlers */
        if (handler.name.indexOf(handlerName.toLowerCase()) > -1) {
          suggestions.push(Object(preact_min["h"])(
            'div',
            {
              className: 'ptm-suggest-card ptm-global-border',
              onClick: function onClick() {
                return _this.updateUpiWithHandler(handler.name);
              }
            },
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-suggest-card-box ptm-pos-r ptm-body-color' },
              Object(preact_min["h"])('img', { src: handler.imageUrl, alt: 'bank', className: 'ptm-margin0' }),
              handler.name
            )
          ));
        }
      });
      return suggestions;
    };

    _this.onOptionSelect = function (option) {
      _this.props.onOptionSelect(option);
      try {
        if (!_this.state.isUpiIntentMwebEnabled) {
          // setTimeout(() => {
          //   this.focusOnUPI();
          // }, 100);

          Object(logger["log"])({ eventType: logger["EVENT"].UPI_FOCUS });
        }
      } catch (error) {
        Object(logger["log"])({ eventType: logger["EVENT"].UPI_FOCUS_ERROR, error: error });
      }
    };

    _this.onUpiPaymodeChannelClick = function (value) {
      _this.setState({ paymode: value });
      /* if value is upi ie collect box then focus on it and open keyboard */
      // if (value === CONSTANTS.UPI) {
      //   setTimeout(() => {
      //     this.focusOnUPI();
      //     const element = document.querySelector('.ptm-upi-select');
      //     const defaultSelectedPaymodeOffSetTop = getKey(element, 'offsetTop', 0);
      //     scrollWithTimeout(defaultSelectedPaymodeOffSetTop - 60);
      //   }, 100);
      // }

      Object(logger["log"])({ eventType: logger["EVENT"].BUTTON_CLICK, value: value });
    };

    _this.hanlders = [{ imageUrl: Object(common["U" /* staticPath */])() + '/assets/images/ic-paytm.svg', name: '@paytm' }, { imageUrl: Object(common["U" /* staticPath */])() + '/assets/images/ic-upi.svg', name: '@upi' }, { imageUrl: Object(common["U" /* staticPath */])() + '/assets/images/ic-phonepe.svg', name: '@ybl' }, { imageUrl: Object(common["U" /* staticPath */])() + '/assets/images/ic-gpay.svg', name: '@okicici' }, { imageUrl: Object(common["U" /* staticPath */])() + '/assets/images/ic-gpay.svg', name: '@okhdfcbank' }, { imageUrl: Object(common["U" /* staticPath */])() + '/assets/images/ic-gpay.svg', name: '@oksbi' }];
    var locale = Object(common["e" /* clientMessage */])(constant["m" /* PAYMODE */].UPI.toLowerCase(), _this.props.cache);
    _this.label = locale.label;
    _this.error = locale.error;
    var isUpiIntentMwebEnabled = props.upiIntentApps.length === 0 && Object(common["q" /* getKey */])(_this.props, 'channels.intentEnabled') && _this.props.cache.getData(constants["f" /* UPI_INTENT_MWEB */].IS_UPI_INTENT_MWEB_ENABLED);
    _this.state = {
      upiIntentApps: _this.props.upiIntentApps,
      selectedUpiIntentApp: {},
      showRemainingApps: false,
      showError: false,
      errorText: '',
      paymode: isUpiIntentMwebEnabled ? constants["f" /* UPI_INTENT_MWEB */].UPI_INTENT_MWEB : constants["g" /* default */].UPI,
      handlers: _this.hanlders,
      errorObjMsg: {
        validErrorMsg: _this.error.inValidId,
        requiredErrorMsg: _this.error.required
      },
      isUpiIntentMwebEnabled: isUpiIntentMwebEnabled,
      isUpiPollingRequired: false,
      pollingData: {}
    };
    _this.upiIntentRef = null;
    _this.onUpiPaymodeChannelClickUPI = _this.onUpiPaymodeChannelClick.bind(_this, constants["g" /* default */].UPI);
    _this.onUpiPaymodeChannelClickMWEB = _this.onUpiPaymodeChannelClick.bind(_this, constants["f" /* UPI_INTENT_MWEB */].UPI_INTENT_MWEB);
    return _this;
  }

  Upi.prototype.componentDidMount = function componentDidMount() {
    // this.props.onPayChange(false);
    if (this.props.upiIntentApps.length > 0) {
      this.selectIntentApp(this.props.upiIntentApps[0]);
    }
  };

  Upi.prototype.componentDidUpdate = function componentDidUpdate(previousProps, prevState) {
    var selectedType = Object(common["q" /* getKey */])(this.props, 'selected.type', null);

    if (selectedType && Object(common["j" /* equalsIgnoreCase */])(selectedType, constant["m" /* PAYMODE */].UPI) && this.props.selected !== previousProps.selected) {
      this.setState({
        upi: '',
        paymode: this.state.isUpiIntentMwebEnabled ? constants["f" /* UPI_INTENT_MWEB */].UPI_INTENT_MWEB : constants["g" /* default */].UPI
      });
      if (this.state.paymode === constants["g" /* default */].UPI) {
        // setTimeout(() => {
        //   this.focusOnUPI();
        // }, 100);
      }
    }
    if (Object(common["q" /* getKey */])(prevState, 'isUpiPollingRequired', false) === true && Object(common["q" /* getKey */])(previousProps, 'isPollingRequired', false) === true && Object(common["q" /* getKey */])(this.props, 'isPollingRequired', true) === false) {
      this.setState({ pollingData: {}, isUpiPollingRequired: false });
    }
  };

  // isVpaValid(ev) {
  //   if (this.state.upi !== this.upi.value) {
  //     this.setState({ upi: this.upi.value });
  //   }
  //   const isValid = this.vpaValid(this.state.upi);
  //   if (isValid) {
  //     this.verifyVPA();
  //   } else {
  //     this.setState({ showError: true, errorText: 'Enter Valid UPI Id' });
  //   }
  // }

  Upi.prototype.updateUpiId = function updateUpiId(_ev) {
    var ev = _ev;
    ev.target.value = ev.target.value.replace(_INVALID_UPI_CHAR_REGEX, '').replace(_NEXT_AT_SYMBOL_REGEX, '$1');
    var upi = ev.target.value;

    var showHandlers = false;

    if (upi.split('@').length > 1) {
      showHandlers = true;
      this.applyPromoOnVPAValidate(upi);
    }
    this.setState({
      upi: upi,
      showError: false,
      errorText: '',
      vpaVerified: false,
      btnDisabled: false,
      showHandlers: showHandlers
    });
  };

  Upi.prototype.applyPromoOnVPAValidate = function applyPromoOnVPAValidate(vpa) {
    var _this2 = this;

    if (!this.props.isPromoAvailable) {
      return;
    }

    if (!vpaValid(vpa)) {
      this.props.applyPromoForPayMode(this.props.option);
      return;
    }

    this.props.onPayChange(false);

    upi_verifyVPA(vpa, this.props.cache).then(function (response) {
      if (response.valid) {
        _this2.props.applyPromoForPayMode(_this2.props.option, null, null, vpa);
      } else {
        _this2.props.applyPromoForPayMode(_this2.props.option);
      }
    }).catch(function () {
      _this2.props.applyPromoForPayMode(_this2.props.option);
      _this2.props.onPayChange(true);
    });
  };

  // focusOnUPI = () => {
  //   !isIphoneDevice() && isMobileDevice() && this.upi && this.upi.focus();
  // };

  Upi.prototype.render = function render(_ref2, _ref3) {
    var _this3 = this;

    var option = _ref2.option,
        instanceKey = _ref2.instanceKey,
        channels = _ref2.channels,
        isActive = _ref2.isActive,
        offers = _ref2.offers;
    var upiIntentApps = _ref3.upiIntentApps,
        upi = _ref3.upi,
        paymode = _ref3.paymode,
        showError = _ref3.showError,
        errorText = _ref3.errorText,
        showHandlers = _ref3.showHandlers,
        isUpiIntentMwebEnabled = _ref3.isUpiIntentMwebEnabled,
        isUpiPollingRequired = _ref3.isUpiPollingRequired,
        pollingData = _ref3.pollingData;
    var collectEnabled = channels.collectEnabled,
        intentEnabled = channels.intentEnabled;


    if (!collectEnabled && !isUpiIntentMwebEnabled) {
      return '';
    }
    var upiOffer = Object(common["q" /* getKey */])(offers, constant["m" /* PAYMODE */].UPI);

    return Object(preact_min["h"])(
      'div',
      {
        className: 'ptm-bhipupi-main ' + (isUpiPollingRequired ? 'ptm-upipolling-stretched' : ''),
        ref: function ref(componentRef) {
          _this3.componentRef = componentRef;
        }
      },
      Object(preact_min["h"])(
        'div',
        { 'class': 'ptm-pay-method ptm-w100-ib ptm-noborder', id: 'checkout-upi' },
        Object(preact_min["h"])(
          'div',
          {
            'class': 'ptm-radio-wrap ptm-pt11',
            onClick: function onClick() {
              _this3.onOptionSelect(option);
            }
          },
          Object(preact_min["h"])(
            'label',
            { 'class': 'ptm-lbl' },
            Object(preact_min["h"])('input', {
              type: 'radio',
              name: 'verify' + instanceKey,
              checked: isActive,
              className: 'ptm-margin0'
            }),
            upi__ref4,
            Object(preact_min["h"])(
              'div',
              { 'class': 'ptm-pay-method-cont' },
              Object(preact_min["h"])(
                'p',
                { 'class': 'ptm-paymode-name' },
                !collectEnabled && isUpiIntentMwebEnabled ? Object(i18n["a" /* locale */])('upi_intent.paymode.label') : option.displayName
              )
            )
          )
        ),
        option && isActive && Object(preact_min["h"])(
          'div',
          { className: 'ptm-upi-inner' },
          isUpiIntentMwebEnabled && Object(preact_min["h"])(upi_intent, {
            ref: function ref(r) {
              _this3.upiIntentRef = r;
            },
            onIntentClick: this.onUpiPaymodeChannelClickMWEB,
            paymode: paymode,
            option: option
          }),
          collectEnabled && isUpiIntentMwebEnabled && Object(preact_min["h"])(
            'div',
            { className: 'ptm-ortxt-box ptm-pos-r ' },
            Object(preact_min["h"])('div', { className: 'ptm-or-line ptm-global-border' }),
            Object(preact_min["h"])(
              'span',
              { className: 'ptm-ortxt ptm-body-bg ptm-body-color ptm-pos-a' },
              'OR'
            )
          ),
          collectEnabled && Object(preact_min["h"])(
            'div',
            {
              className: 'ptm-upi-main-box ptm-pos-r',
              onClick: this.onUpiPaymodeChannelClickUPI
            },
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-upi-icon ptm-pos-a' },
              Object(preact_min["h"])('img', {
                className: 'ptm-upi-icon-pic ptm-centralized',
                src: Object(common["U" /* staticPath */])() + '/assets/images/paybyupi.png',
                alt: 'logos'
              }),
              paymode === constants["g" /* default */].UPI && Object(preact_min["h"])(
                'div',
                { className: 'ptm-tick ptm-pos-a' },
                Object(preact_min["h"])('span', { className: 'ptm-sign1' }),
                Object(preact_min["h"])('span', { className: 'ptm-sign2' })
              )
            ),
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-upi-heading-txt ptm-body-color' },
              Object(i18n["a" /* locale */])('upi.title')
            ),
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-upi-sbtxt ptm-body-color' },
              Object(i18n["a" /* locale */])('upi.title.desc')
            )
          ),
          collectEnabled && Object(preact_min["h"])(
            'div',
            { className: 'ptm-upi-select', onClick: this.onUpiPaymodeChannelClickUPI },
            intentEnabled && upiIntentApps && upiIntentApps.length > 0 && Object(preact_min["h"])(
              'h4',
              { className: 'ptm-upi-select ptm-uppercase' },
              this.label.UpiEnterSuggest
            ),
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-pos-r ptm-bhim-upi-wrap' },
              Object(preact_min["h"])(
                'div',
                null,
                Object(preact_min["h"])('input', {
                  type: 'text',
                  placeholder: 'username@bank',
                  className: 'ptm-margin0 ptm-upi-input',
                  value: paymode === constants["g" /* default */].UPI ? upi : '',
                  ref: function ref(p) {
                    _this3.upi = p;
                  }
                  // autoFocus={!isIphoneDevice()}
                  , id: 'ptm-upi-input',
                  onKeyUp: function onKeyUp(e) {
                    return _this3.updateUpiId(e);
                  },
                  onClick: function onClick() {
                    return _this3.handleInputClick(constants["g" /* default */].UPI);
                  },
                  onPaste: function onPaste(e) {
                    _this3.handlePastedInput(e);
                  }
                }),
                showError ? Object(preact_min["h"])(
                  'p',
                  { className: 'ptm-msg-red' },
                  errorText
                ) : null,
                upiOffer && Object(preact_min["h"])(offers_paymodeOffer, { offer: upiOffer, noLeftPadding: true })
              ),
              Object(preact_min["h"])(
                'div',
                { className: 'paytm-txt-center ptm-sugg-wrap ptm-handlers-wrap' },
                showHandlers && this.renderHandlerSuggestions()
              )
            )
          ),
          upi__ref5
        ),
        Object(preact_min["h"])('p', { className: 'ptm-global-bottom-border' }),
        isUpiPollingRequired && pollingData && pollingData.vpaID && Object(preact_min["h"])(upipolling, { pollingData: pollingData })
      )
    );
  };

  return Upi;
}(preact_min["Component"]);

/* harmony default export */ var components_upi = (Object(preact["connect"])('selected, style, cache, instanceKey, subscription, isPollingRequired', onChange)(upi_Upi));
// CONCATENATED MODULE: ./components/nb/notFound.js




var notFound_NotFound = function NotFound() {
  return Object(preact_min["h"])(
    'div',
    { className: 'ptm-no-bank ptm-pos-a' },
    Object(preact_min["h"])('img', {
      className: 'ptm-margin0 ptm-icon-bank_results_not_found',
      src: Object(common["U" /* staticPath */])() + '/assets/images/not_found.png'
    }),
    Object(preact_min["h"])(
      'p',
      { className: 'ptm-no-result ptm-body-color' },
      Object(i18n["a" /* locale */])('nb.no.result.found')
    )
  );
};

/* harmony default export */ var notFound = (notFound_NotFound);
// CONCATENATED MODULE: ./components/nb/BankLists.js


function BankLists__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function BankLists__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function BankLists__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function BankLists__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var BankLists__ref3 = Object(preact_min["h"])(notFound, null);

var BankLists_BankLists = function (_Component) {
  BankLists__inherits(BankLists, _Component);

  function BankLists(props) {
    BankLists__classCallCheck(this, BankLists);

    var _this = BankLists__possibleConstructorReturn(this, _Component.call(this, props));

    _this.filterBankListByAlphabates = function (bankListsData) {
      var bankAlphabates = [];
      var bankAlphabatesMap = {};
      bankListsData.forEach(function (bankData) {
        if (bankData.channelName) {
          var firstChar = bankData.channelName.toUpperCase().charAt(0);
          if (!Object.prototype.hasOwnProperty.call(bankAlphabatesMap, firstChar)) {
            bankAlphabatesMap[firstChar] = 1;
            bankAlphabates.push(firstChar);
          }
        }
      });
      return bankAlphabates.sort();
    };

    _this.state = {};
    _this.alpahbetStringData = _this.filterBankListByAlphabates(props.bankListsData);
    return _this;
  }

  BankLists.prototype.render = function render(_ref, _ref2) {
    var bankListsData = _ref.bankListsData,
        BankOptionClick = _ref.BankOptionClick,
        filterBankData = _ref.filterBankData,
        showFilteredData = _ref.showFilteredData,
        alphabetFilter = _ref.alphabetFilter;

    BankLists__objectDestructuringEmpty(_ref2);

    var banks = bankListsData;
    if (filterBankData.length || showFilteredData) {
      banks = filterBankData;
    }
    var isfilteredData = !!banks.length;
    var iconBaseUrl = this.props.cache.getData(constants["g" /* default */].ICON_BASE_URL);
    return Object(preact_min["h"])(
      'div',
      { className: 'ptm-nb-list-wrapper ptm-pos-r' },
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-nb-bankcard-wrapper ptm-pos-r', id: 'checkout-nb-banks-list' },
        !isfilteredData && BankLists__ref3,
        isfilteredData && banks.map(function (bankData) {
          return Object(preact_min["h"])(
            'div',
            {
              className: 'ptm-nb-bankcard ptm-pos-r nb-border',
              onClick: function onClick() {
                return BankOptionClick(bankData);
              }
            },
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-nb-cardimg ptm-pos-a ptm-global-border' },
              Object(preact_min["h"])('img', {
                className: 'ptm-centralized ptm-pos-a ptm-margin0',
                src: Object(common["I" /* isUrlAbsolute */])(bankData.iconUrl) ? bankData.iconUrl : iconBaseUrl + bankData.iconUrl,
                alt: ''
              })
            ),
            Object(preact_min["h"])(
              'span',
              { className: 'ptm-body-color' },
              bankData.channelName
            ),
            bankData.hasLowSuccess && Object(common["q" /* getKey */])(bankData.hasLowSuccess, 'status') && Object(common["q" /* getKey */])(bankData.hasLowSuccess, 'msg') && Object(preact_min["h"])(
              'p',
              { className: 'ptm-low-success' },
              bankData.hasLowSuccess.msg
            )
          );
        })
      ),
      isfilteredData && Object(preact_min["h"])(
        'div',
        { className: 'ptm-filter-wrap ptm-pos-a ptm-body-bg' },
        this.alpahbetStringData.map(function (value) {
          return Object(preact_min["h"])(
            'span',
            { className: 'ptm-body-color', onClick: function onClick() {
                return alphabetFilter(value);
              } },
            value
          );
        })
      )
    );
  };

  return BankLists;
}(preact_min["Component"]);

/* harmony default export */ var nb_BankLists = (Object(preact["connect"])('cache', null)(BankLists_BankLists));
// CONCATENATED MODULE: ./components/nb/BankListsWrapper.js


function BankListsWrapper__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function BankListsWrapper__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function BankListsWrapper__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var BankListsWrapper_BankListsWrapper = function (_Component) {
  BankListsWrapper__inherits(BankListsWrapper, _Component);

  function BankListsWrapper(props) {
    BankListsWrapper__classCallCheck(this, BankListsWrapper);

    var _this = BankListsWrapper__possibleConstructorReturn(this, _Component.call(this, props));

    _this.searchBank = function (e) {
      Object(logger["log"])({ eventType: logger["EVENT"].NB_SEARCH_BAR_USED });
      if (e && e.target) {
        _this.setState({ searchValue: e.target.value });
      }
      _this.props.filterBanks(e);
    };

    _this.clearSearchValue = function () {
      _this.setState({ searchValue: '' });
      _this.props.clearSeacrh();
    };

    _this.state = { searchValue: '' };
    return _this;
  }

  BankListsWrapper.prototype.render = function render(_ref, _ref2) {
    var bankListsData = _ref.bankListsData,
        cancel = _ref.cancel,
        BankOptionClick = _ref.BankOptionClick,
        filterBankData = _ref.filterBankData,
        showFilteredData = _ref.showFilteredData,
        alphabetFilter = _ref.alphabetFilter,
        isSearchFocused = _ref.isSearchFocused,
        focusIn = _ref.focusIn;
    var searchValue = _ref2.searchValue;

    return Object(preact_min["h"])(
      'div',
      { className: 'ptm-nb-bank-wrap ptm-pos-a', id: 'checkout-nb-banks' },
      Object(preact_min["h"])(
        components_OverlayWrap,
        null,
        Object(preact_min["h"])(
          'div',
          { className: 'ptm-nb-dropdown-wrap' },
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-nb-dropdown-header ' + (isSearchFocused ? 'ptm-focused-state' : '') },
            Object(preact_min["h"])(
              'div',
              { className: 'nb-inputarea' },
              Object(preact_min["h"])('span', { className: 'ptm-cross ptm-pos-r ptm-black', onClick: function onClick() {
                  return cancel();
                } }),
              Object(preact_min["h"])(
                'span',
                { className: 'ptm-select-bank ptm-body-color' },
                'Select Bank'
              ),
              Object(preact_min["h"])(
                'div',
                { className: 'ptm-nb-boxinput ptm-pos-r' },
                Object(preact_min["h"])('input', {
                  type: 'text',
                  id: 'searchBar',
                  className: ' ptm-margin0 ptm-dropdown-input ptm-input-common',
                  onFocusIn: function onFocusIn() {
                    return focusIn();
                  },
                  placeholder: 'Search',
                  onKeyUp: this.searchBank,
                  value: searchValue
                }),
                Object(preact_min["h"])('img', {
                  className: 'ptm-search-img ptm-pos-a',
                  src: Object(common["U" /* staticPath */])() + '/assets/images/search-icon.svg',
                  alt: ''
                })
              ),
              Object(preact_min["h"])(
                'button',
                {
                  className: 'ptm-nb-cancel ptm-primary ptm-pos-a ptm-nb-cancel-btn ptm-hidden',
                  onClick: this.clearSearchValue
                },
                'Cancel'
              )
            )
          ),
          Object(preact_min["h"])(nb_BankLists, {
            bankListsData: bankListsData,
            filterBankData: filterBankData,
            cancel: this.cancel,
            BankOptionClick: BankOptionClick,
            showFilteredData: showFilteredData,
            alphabetFilter: alphabetFilter
          })
        )
      )
    );
  };

  return BankListsWrapper;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/nb/index.js


function nb__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function nb__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function nb__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var nb__ref3 = Object(preact_min["h"])('span', { 'class': 'ptm-checkmark' });

var nb__ref4 = Object(preact_min["h"])(renewal, null);

var nb_Nb = function (_Component) {
  nb__inherits(Nb, _Component);

  function Nb(props) {
    nb__classCallCheck(this, Nb);

    var _this = nb__possibleConstructorReturn(this, _Component.call(this, props));

    _this.componentDidMount = function () {
      var banks = Object(common["q" /* getKey */])(_this.props, 'option.data.banks', []);
      var selectedType = Object(common["q" /* getKey */])(_this.props, 'selected.type', null);

      if (selectedType && Object(common["j" /* equalsIgnoreCase */])(selectedType, constant["m" /* PAYMODE */].NB) && banks.length) {
        _this.bankOptionClick(banks[0]);
      }
    };

    _this.bankOptionClick = function (bank) {
      _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ stopScroll: false });
      if (Object(common["q" /* getKey */])(bank, 'hasLowSuccess.status', false)) {
        Object(logger["log"])({ eventType: logger["EVENT"].NB_BANK_SELECTED, hasLowSuccess: true, bankName: bank.channelName });
      } else {
        Object(logger["log"])({ eventType: logger["EVENT"].NB_BANK_SELECTED, hasLowSuccess: false, bankName: bank.channelName });
      }
      _this.setState({ selectedBank: bank, showOtherBanks: false });
      if (bank.channelCode !== _this.prevOPtionsSelected) {
        _this.bankOptionsSelected += bank.channelCode + '|';
        _this.prevOPtionsSelected = bank.channelCode;
      }
      _this.props.cache.setData(constants["a" /* CACHE */].SELECTEDBANK, bank);
      _this.props.onPayChange(true);
      _this.props.updateSelectedPayModePcfWithInstId(bank.channelCode);
      _this.props.applyPromoForPayMode(_this.props.option, bank.channelCode);
      // clearing the search since on reopening the bank list  after selecting a bank only filtered bank list was shown
      _this.clearSeacrh();
    };

    _this.submit = function () {
      if (_this.state.selectedBank) {
        var payload = {
          paymentMode: constants["g" /* default */].NB,
          channelCode: _this.state.selectedBank.channelCode,
          authMode: constants["g" /* default */]['3D'],
          selectedPaymentModeId: _this.props.option.id
        };
        _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: constants["g" /* default */].PROCESSING });
        _this.props.cache.getData(constants["a" /* CACHE */].API).pay(payload).then(function (response) {
          var notifyMerchant = Object(common["q" /* getKey */])(_this.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG), 'handler.notifyMerchant', undefined);
          if (Object(common["q" /* getKey */])(response, 'body.resultInfo.resultStatus', undefined) === 'S') {
            var _getKey = Object(common["q" /* getKey */])(response, 'body.bankForm.redirectForm', {}),
                actionUrl = _getKey.actionUrl,
                content = _getKey.content;

            response.body.content = content;
            response.body.callbackUrl = actionUrl;
          } else {
            var errorMsg = Object(common["q" /* getKey */])(response, 'body.resultInfo.resultMsg', constants["g" /* default */].GENERIC_ERROR);
            if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
              notifyMerchant(constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.PAYMENT_ERROR, response);
            }
            _this.setState({ showError: true, errorText: errorMsg });
          }
          Object(formPost["f" /* postInWindow */])(response, _this.props.cache);
        }).catch(function (err) {
          var notifyMerchant = Object(common["q" /* getKey */])(_this.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG), 'handler.notifyMerchant', undefined);
          _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: '' });
          _this.setState(function (prevState) {
            return { showError: true, errorText: prevState.genericErrorMsg };
          });
          if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
            notifyMerchant(constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.PAYMENT_ERROR, err);
          }
          Object(formPost["f" /* postInWindow */])({}, _this.props.cache); // close window in case of network error
        });
      }
    };

    _this.showMoreBankLists = function () {
      if (!_this.state.bankListsData.length) {
        var paymentOptions = _this.props.cache.getData('paymentOptions');
        _this.props.cache.getData(constants["a" /* CACHE */].API).nbChannels(Object(common["w" /* isAddNPay */])(paymentOptions, _this.props.cache)).then(function (res) {
          if (res && Object(common["q" /* getKey */])(res, 'body.nbPayOption.payChannelOptions')) {
            _this.setState({
              bankListsData: res.body.nbPayOption.payChannelOptions,
              showOtherBanks: true
            });
            _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ stopScroll: true });
          }
        });
      } else {
        _this.setState({ showOtherBanks: true });
        _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ stopScroll: true });
      }
    };

    _this.cancel = function () {
      if (document.getElementById('searchBar')) {
        document.getElementById('searchBar').value = '';
        document.getElementById('searchBar').blur();
      }
      _this.setState(function (prevState) {
        return {
          showOtherBanks: !prevState.showOtherBanks,
          filterBankData: {},
          showFilteredData: false,
          isSearchFocused: false
        };
      });
      _this.props.onStopScroll(false);
    };

    _this._filterBanks = function (value, data) {
      var result = data.filter(function (record) {
        var bankName = record.displayName ? 'displayName' : 'channelName';
        return record[bankName].toLowerCase().indexOf(value.toLowerCase()) !== -1;
      });
      return result;
    };

    _this.filterBanks = function (e) {
      if (e.currentTarget.value) {
        // const filterBankData = this._filterBanks(e.currentTarget.value, this.state.bankListsData);
        // this.setState({ filterBankData, showFilteredData: true });
        _this.setState(function (prevState) {
          return {
            filterBankData: _this._filterBanks(e.currentTarget.value, prevState.bankListsData),
            showFilteredData: true
          };
        });
      } else {
        _this.setState(function (prevState) {
          return {
            filterBankData: {},
            bankListsData: prevState.bankListsData,
            showFilteredData: false
          };
        });
      }
    };

    _this._filterByAlphabet = function (alphabet, data) {
      return data.filter(function (record) {
        var bankName = record[record.displayName ? 'displayName' : 'channelName'].toLowerCase();
        return !!(bankName && bankName.charAt(0) === alphabet.toLowerCase());
      });
    };

    _this.clearSeacrh = function () {
      _this.setState({ filterBankData: [], showFilteredData: false, isSearchFocused: false });
    };

    _this.alphabetFilter = function (alphabet) {
      // const filterBankData = this._filterByAlphabet(alphabet, this.state.bankListsData);
      // this.setState({ filterBankData, showFilteredData: true });
      _this.setState(function (prevState) {
        return {
          filterBankData: _this._filterByAlphabet(alphabet, prevState.bankListsData),
          showFilteredData: true
        };
      });
    };

    _this.focusIn = function () {
      if (!_this.isSearchFocusedLogged) {
        _this.isSearchFocusedLogged = true;
      }
      _this.setState({ isSearchFocused: true });
    };

    _this.onOptionSelect = function (option) {
      _this.props.onOptionSelect(option);
      _this.props.onPayChange(true);
    };

    _this.state = {
      showOtherBanks: false,
      selectedBank: null,
      bankListsData: {},
      filterBankData: {},
      showFilteredData: false,
      isSearchFocused: false,
      showError: false,
      errorText: ''
    };
    _this.defaultState = JSON.parse(JSON.stringify(_this.state));
    _this.prevOPtionsSelected = '';
    _this.bankOptionsSelected = '';
    _this.isSearchFocusedLogged = false;
    var locale = Object(common["e" /* clientMessage */])(constant["m" /* PAYMODE */].NB.toLowerCase(), _this.props.cache);
    _this.label = locale.label;
    _this.error = locale.error;
    return _this;
  }

  Nb.prototype.componentDidUpdate = function componentDidUpdate(previousProps) {
    var _this2 = this;

    var selected = Object(common["q" /* getKey */])(this.props, 'selected', null);
    var option = Object(common["q" /* getKey */])(this.props, 'option', null);
    if (!this.props.cache.getData(constants["a" /* CACHE */].SELECTEDBANK) && selected && option && selected.id === option.id) {
      // set selected bank in cache if not there on render
      this.props.cache.setData(constants["a" /* CACHE */].SELECTEDBANK, this.state.selectedBank);
    }
    if (selected && Object(common["j" /* equalsIgnoreCase */])(selected.type, constant["m" /* PAYMODE */].NB) && previousProps.selected !== this.props.selected) {
      this.setState(this.defaultState, function () {
        if (_this2.props.option.data.banks && _this2.props.option.data.banks.length > 0) {
          _this2.bankOptionClick(_this2.props.option.data.banks[0]);
        }
      });
    }
  };

  Nb.prototype.render = function render(_ref, _ref2) {
    var _this3 = this;

    var option = _ref.option,
        instanceKey = _ref.instanceKey,
        isActive = _ref.isActive,
        offers = _ref.offers,
        cache = _ref.cache;
    var selectedBank = _ref2.selectedBank,
        bankListsData = _ref2.bankListsData,
        showOtherBanks = _ref2.showOtherBanks,
        filterBankData = _ref2.filterBankData,
        showFilteredData = _ref2.showFilteredData,
        isSearchFocused = _ref2.isSearchFocused,
        showError = _ref2.showError,
        errorText = _ref2.errorText;

    var isBankInList = false;
    var nbOffer = Object(common["q" /* getKey */])(offers, constants["g" /* default */].NB);
    var iconBaseUrl = cache.getData(constants["g" /* default */].ICON_BASE_URL);

    return Object(preact_min["h"])(
      'div',
      {
        className: (showOtherBanks ? 'ptm-nb-banks-opened' : '') + ' ',
        ref: function ref(componentRef) {
          _this3.componentRef = componentRef;
        }
      },
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-pay-method ptm-w100-ib', id: 'checkout-nb' },
        Object(preact_min["h"])(
          'div',
          { className: 'ptm-radio-wrap ptm-pt11' },
          Object(preact_min["h"])(
            'label',
            { className: 'ptm-lbl' },
            Object(preact_min["h"])('input', {
              type: 'radio',
              name: 'verify' + instanceKey,
              className: 'ptm-margin0',
              checked: isActive,
              onClick: function onClick() {
                _this3.onOptionSelect(option);
              }
            }),
            nb__ref3,
            Object(preact_min["h"])(
              'div',
              { 'class': 'ptm-pay-method-cont' },
              Object(preact_min["h"])(
                'p',
                { 'class': 'ptm-paymode-name ' },
                option.displayName
              )
            )
          )
        ),
        option && isActive && Object(preact_min["h"])(
          'div',
          { className: 'ptm-nb-inner ptm-pl-35', id: 'ptm-nb-inner' },
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-nb-list ptm-w100-ib' },
            option.data && Object(common["q" /* getKey */])(option.data, 'banks') && option.data.banks.map(function (bank) {
              return Object(preact_min["h"])(
                'div',
                {
                  className: 'ptm-nb-list-item paytm-txt-center',
                  onClick: function onClick() {
                    return _this3.bankOptionClick(bank);
                  }
                },
                Object(preact_min["h"])(
                  'div',
                  {
                    className: 'ptm-pos-r ptm-nb-img ' + (selectedBank && bank.channelName === selectedBank.channelName ? (isBankInList = true) && 'ptm-activeBank' : '')
                  },
                  Object(preact_min["h"])('img', { className: 'ptm-pos-a', src: iconBaseUrl + bank.iconUrl, alt: '' }),
                  selectedBank && bank.channelName === selectedBank.channelName && Object(preact_min["h"])(
                    'div',
                    { className: 'ptm-tick ptm-pos-a' },
                    Object(preact_min["h"])('span', { className: 'ptm-sign1' }),
                    Object(preact_min["h"])('span', { className: 'ptm-sign2' })
                  )
                ),
                Object(preact_min["h"])(
                  'p',
                  { className: 'ptm-bank-name ptm-body-color' },
                  bank.channelCode
                )
              );
            })
          ),
          nbOffer && selectedBank && isBankInList && Object(preact_min["h"])(offers_paymodeOffer, { offer: nbOffer, noLeftPadding: true }),
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-nb-select ptm-global-border', onClick: this.showMoreBankLists },
            Object(preact_min["h"])(
              'h3',
              { className: 'ptm-nb-select-heading ptm-body-color' },
              selectedBank && !isBankInList && Object(preact_min["h"])(
                'span',
                { className: 'ptm-pos-r ptm-global-border' },
                selectedBank && Object(preact_min["h"])('img', {
                  className: 'ptm-centralized ptm-pos-a ptm-margin0',
                  src: iconBaseUrl + selectedBank.iconUrl
                })
              ),
              selectedBank && !isBankInList ? selectedBank.channelName : 'Select From Other Banks',
              Object(preact_min["h"])('img', {
                className: 'ptm-right ptm-margin0',
                src: Object(common["U" /* staticPath */])() + '/assets/images/ic-dropdown-light.svg',
                alt: ''
              })
            )
          ),
          nbOffer && selectedBank && !isBankInList && Object(preact_min["h"])(offers_paymodeOffer, { offer: nbOffer, noLeftPadding: true }),
          Object(preact_min["h"])(
            'p',
            { className: 'ptm-nb-select-para ptm-body-color' },
            this.label.secureRedirectionMessage
          ),
          option && isActive && nb__ref4,
          showError ? Object(preact_min["h"])(
            'p',
            { className: 'ptm-msg-red' },
            errorText
          ) : null
        )
      ),
      showOtherBanks && Object(preact_min["h"])(BankListsWrapper_BankListsWrapper, {
        bankListsData: bankListsData,
        filterBankData: filterBankData,
        cancel: this.cancel,
        filterBanks: this.filterBanks,
        BankOptionClick: this.bankOptionClick,
        showFilteredData: showFilteredData,
        alphabetFilter: this.alphabetFilter,
        isSearchFocused: isSearchFocused,
        focusIn: this.focusIn,
        clearSeacrh: this.clearSeacrh
      })
    );
  };

  return Nb;
}(preact_min["Component"]);

/* harmony default export */ var nb = (Object(preact["connect"])('selected, cache, instanceKey', onChange)(nb_Nb));
// CONCATENATED MODULE: ./components/rupeeSymbol/index.js


var rupeeSymbol__ref = Object(preact_min["h"])(
  "div",
  { className: "rupee-symbol" },
  "\u20B9"
);

var RupeeSymbol = function RupeeSymbol() {
  // using div as of now aditya will look forward to a solution using inline tag here
  return rupeeSymbol__ref;
};
// CONCATENATED MODULE: ./components/emiPlans/index.js


function emiPlans__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function emiPlans__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function emiPlans__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var emiPlans__ref3 = Object(preact_min["h"])(RupeeSymbol, null);

var emiPlans__ref4 = Object(preact_min["h"])('span', { className: 'ptm-checkmark' });

var emiPlans__ref5 = Object(preact_min["h"])(RupeeSymbol, null);

var emiPlans__ref6 = Object(preact_min["h"])(RupeeSymbol, null);

var _ref7 = Object(preact_min["h"])(RupeeSymbol, null);

var emiPlans_EmiPlansList = function (_Component) {
  emiPlans__inherits(EmiPlansList, _Component);

  function EmiPlansList(props) {
    emiPlans__classCallCheck(this, EmiPlansList);

    var _this = emiPlans__possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      selectedPlan: null
    };
    return _this;
  }

  EmiPlansList.prototype.componentDidMount = function componentDidMount() {
    var _props$planDetails = this.props.planDetails,
        emiPlans = _props$planDetails.emiPlans,
        payableAmount = _props$planDetails.payableAmount;


    this.setState({
      emiPlans: emiPlans,
      txnAmount: payableAmount,
      selectedPlan: emiPlans && emiPlans.details && emiPlans.details.length ? emiPlans.details[0] : null
    });
  };

  EmiPlansList.prototype.setActivePlan = function setActivePlan(plan) {
    this.setState({ selectedPlan: plan });
    this.props.setEmiPlan(plan);
  };

  EmiPlansList.prototype.render = function render(_ref, _ref2) {
    var _this2 = this;

    var cache = _ref.cache,
        instanceKey = _ref.instanceKey,
        miniCart = _ref.miniCart;
    var emiPlans = _ref2.emiPlans,
        selectedPlan = _ref2.selectedPlan,
        txnAmount = _ref2.txnAmount;

    var locale = Object(common["e" /* clientMessage */])(constant["m" /* PAYMODE */].EMI.toLowerCase(), cache);

    return Object(preact_min["h"])(
      'div',
      { className: 'ptm-emi-plan-wrap' },
      Object(preact_min["h"])(
        'div',
        {
          className: 'ptm-close-wrap ptm-pos-a ptm-closeIcon',
          onClick: function onClick() {
            _this2.props.hideEmiPlans();
          }
        },
        Object(preact_min["h"])('span', { className: 'ptm-cross ptm-pos-r' })
      ),
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-emi-heading  ptm-w100-ib' },
        Object(preact_min["h"])(
          'span',
          { className: 'ptm-left ptm-body-color' },
          'Select EMI Plan'
        ),
        Object(preact_min["h"])(
          'span',
          { className: 'ptm-right' },
          emiPlans__ref3,
          ' ',
          txnAmount
        )
      ),
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-emi-innerbox' },
        Object(preact_min["h"])(
          'div',
          { className: 'ptm-emi-head-strip ptm-body-bg ptm-body-color' },
          Object(preact_min["h"])(
            'span',
            { className: 'ptm-body-color' },
            'Duration'
          ),
          Object(preact_min["h"])(
            'span',
            { className: 'ptm-body-color' },
            'EMI per month'
          ),
          Object(preact_min["h"])(
            'span',
            { className: 'ptm-body-color' },
            'Total Cost'
          )
        ),
        Object(preact_min["h"])(
          'div',
          { className: 'ptm-emi-plancard-wrap' },
          emiPlans && emiPlans.details.length && emiPlans.details.map(function (plan) {
            return Object(preact_min["h"])(
              'div',
              {
                className: 'ptm-emi-plancard ptm-pos-r ptm-global-border',
                onClick: function onClick() {
                  _this2.setActivePlan(plan);
                }
              },
              Object(preact_min["h"])(
                'label',
                { className: 'ptm-lbl' },
                Object(preact_min["h"])('input', {
                  type: 'radio',
                  className: 'ptm-margin0',
                  name: 'plan' + instanceKey,
                  checked: plan.planId === selectedPlan.planId
                }),
                emiPlans__ref4,
                Object(preact_min["h"])(
                  'div',
                  { className: 'ptm-emi-plan-dscr' },
                  Object(preact_min["h"])(
                    'span',
                    { className: 'ptm-body-color' },
                    plan.interval,
                    ' Months'
                  ),
                  Object(preact_min["h"])(
                    'span',
                    { className: 'ptm-body-color' },
                    emiPlans__ref5,
                    ' ',
                    plan.emi,
                    ' (',
                    plan.rate,
                    '% p.a.)'
                  ),
                  Object(preact_min["h"])(
                    'span',
                    { className: 'ptm-body-color' },
                    emiPlans__ref6,
                    ' ',
                    plan.effectivePrice
                  )
                ),
                plan.gratifications && plan.gratifications.length ? Object(preact_min["h"])(
                  'p',
                  {
                    className: 'ptm-cashback-txt',
                    onClick: function onClick() {
                      _this2.props.showMiniCart(plan);
                    }
                  },
                  _ref7,
                  ' ',
                  plan.gratifications[0].value,
                  ' ',
                  plan.gratifications[0].label,
                  miniCart && Object(preact_min["h"])('span', { className: 'ptm-dropdown-green' })
                ) : ''
              )
            );
          }),
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-emi-note ptm-body-bg ptm-body-color' },
            Object(preact_min["h"])(
              'h5',
              { className: 'ptm-body-color' },
              'Things to note:'
            ),
            Object(preact_min["h"])(
              'ul',
              { className: 'ptm-note-list ptm-body-color ptm-note-listing ' },
              Object(preact_min["h"])(
                'li',
                { className: 'ptm-body-color' },
                locale.label.emiConvert
              ),
              Object(preact_min["h"])(
                'li',
                { className: 'ptm-body-color' },
                locale.label.cashback
              ),
              Object(preact_min["h"])(
                'li',
                { className: 'ptm-body-color' },
                locale.label.kycText
              )
            )
          )
        )
      ),
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-btn-wrapper ptm-body-bg' },
        Object(preact_min["h"])(
          'button',
          {
            className: 'ptm-custom-btn',
            onClick: function onClick() {
              _this2.props.selectEmiPlan(selectedPlan);
            }
          },
          'Proceed'
        )
      )
    );
  };

  return EmiPlansList;
}(preact_min["Component"]);

/* harmony default export */ var components_emiPlans = (Object(preact["connect"])('cache, instanceKey')(emiPlans_EmiPlansList));
// CONCATENATED MODULE: ./components/miniCart/index.js
var miniCart__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var miniCart__ref = Object(preact_min["h"])(RupeeSymbol, null);

var miniCart__ref2 = Object(preact_min["h"])(RupeeSymbol, null);

var miniCart__ref3 = Object(preact_min["h"])(RupeeSymbol, null);

var miniCart__ref4 = Object(preact_min["h"])(RupeeSymbol, null);

var miniCart_MiniCart = function MiniCart(props) {
  var isEmiSubventionFlow = props.isEmiSubventionFlow;
  var locale = Object(common["e" /* clientMessage */])(constant["m" /* PAYMODE */].EMI.toLowerCase(), props.cache);
  var selectedPlan = props.selectedPlan,
      cart = props.cart,
      miniCart = props.miniCart;

  var cartItems = Object(common["q" /* getKey */])(cart, 'cart_items', null);
  if (isEmiSubventionFlow && miniCart) {
    var itemBreakUp = Object(common["q" /* getKey */])(selectedPlan, 'itemBreakUp', []);
    cartItems = miniCart.map(function (item) {
      itemBreakUp.forEach(function (i) {
        if (item.id === i.id) {
          var gratifications = i.gratifications,
              offerId = i.offerId;
          var effectivePrice = selectedPlan.effectivePrice,
              interval = selectedPlan.interval,
              interest = selectedPlan.interest,
              emi = selectedPlan.emi,
              finalTransactionAmount = selectedPlan.finalTransactionAmount;

          item = miniCart__extends({}, item, {
            gratifications: gratifications,
            offerId: offerId,
            effectivePrice: effectivePrice,
            interval: interval,
            emi: emi,
            finalTransactionAmount: finalTransactionAmount,
            interest: interest
          });
        }
      });
      return item;
    });
  }
  return Object(preact_min["h"])(
    'div',
    { className: 'ptm-plan-detail' },
    Object(preact_min["h"])(
      'div',
      { className: 'ptm-close-wrap ptm-pos-a ptm-closeIcon' },
      Object(preact_min["h"])('span', { className: 'ptm-cross ptm-pos-r', onClick: function onClick() {
          return props.closeMiniCart();
        } })
    ),
    selectedPlan && Object(preact_min["h"])(
      'div',
      { className: 'ptm-emi-heading  ptm-w100-ib' },
      Object(preact_min["h"])(
        'span',
        { className: 'ptm-left' },
        ' ',
        selectedPlan.interval,
        ' Months EMI plan'
      )
    ),
    Object(preact_min["h"])(
      'p',
      { className: 'ptm-light-txt' },
      locale.label.interest
    ),
    cartItems && cartItems.map(function (item) {
      var planId = selectedPlan.planId;
      var itemEmiOffer = Object(common["q" /* getKey */])(item, 'emi_offers.' + planId, null);
      var gratification = void 0;
      if (isEmiSubventionFlow) {
        itemEmiOffer = item;
      }
      if (itemEmiOffer) {
        gratification = Object(common["q" /* getKey */])(itemEmiOffer, 'gratifications', null);
      }
      if (gratification) {
        var _gratification = gratification;
        gratification = _gratification[0];
      }
      return Object(preact_min["h"])(
        'div',
        { className: 'ptm-product-box prduct-box-global' },
        Object(preact_min["h"])(
          'div',
          { className: 'ptm-product-inner ptm-pos-r ptm-global-border' },
          Object(preact_min["h"])('img', {
            src: item.image_url || item.image,
            className: 'ptm-product-img ptm-centralized ptm-pos-a',
            alt: 'product_img'
          }),
          Object(preact_min["h"])(
            'p',
            { className: 'ptm-product-detail' },
            item.name
          ),
          Object(preact_min["h"])(
            'p',
            { className: 'ptm-quantity' },
            'Qty: ',
            Object(preact_min["h"])(
              'span',
              null,
              item.quantity
            )
          )
        ),
        Object(preact_min["h"])(
          'p',
          { className: 'ptm-dscrpt-row ptm-w100-ib' },
          Object(preact_min["h"])(
            'span',
            { className: 'ptmleft' },
            'Item Value'
          ),
          Object(preact_min["h"])(
            'span',
            { className: 'ptm-right' },
            miniCart__ref,
            ' ',
            item.total_price || item.finalTransactionAmount
          )
        ),
        Object(preact_min["h"])(
          'p',
          { className: 'ptm-dscrpt-row ptm-w100-ib' },
          Object(preact_min["h"])(
            'span',
            { className: 'ptm-left' },
            'Total Interest ',
            Object(preact_min["h"])(
              'span',
              { className: 'ptm-charge-txt' },
              '(Charged by bank)'
            )
          ),
          Object(preact_min["h"])(
            'span',
            { className: 'ptm-right' },
            '+ ',
            miniCart__ref2,
            ' ',
            itemEmiOffer.interest
          )
        ),
        itemEmiOffer && itemEmiOffer.gratifications && gratification && Object(preact_min["h"])(
          'div',
          { className: 'ptm-cashback-strip' },
          'EMI ',
          gratification.type.toLowerCase(),
          Object(preact_min["h"])(
            'span',
            { className: 'ptm-right' },
            ' ',
            '- ',
            miniCart__ref3,
            ' ',
            gratification.value
          )
        ),
        gratification && gratification.type === 'CASHBACK' && Object(preact_min["h"])(
          'p',
          { className: 'ptm-light-txt' },
          'Cashback will be credited in your Paytm wallet'
        ),
        Object(preact_min["h"])(
          'p',
          { className: 'ptm-effective-price ptm-w100-ib' },
          Object(preact_min["h"])(
            'span',
            { className: 'ptm-left' },
            'Effective Price'
          ),
          Object(preact_min["h"])(
            'span',
            { className: 'ptm-right' },
            miniCart__ref4,
            ' ',
            itemEmiOffer && itemEmiOffer.effectivePrice
          )
        )
      );
    })
  );
};

/* harmony default export */ var components_miniCart = (Object(preact["connect"])('cache')(miniCart_MiniCart));
// CONCATENATED MODULE: ./components/loader/index.js


var loader__ref = Object(preact_min["h"])(
  'div',
  { className: 'ptm-lds-ring' },
  Object(preact_min["h"])('div', null),
  Object(preact_min["h"])('div', null),
  Object(preact_min["h"])('div', null),
  Object(preact_min["h"])('div', null)
);

var Loader = function Loader() {
  return loader__ref;
};

/* harmony default export */ var components_loader = (Loader);
// EXTERNAL MODULE: ./utils/deferred-utils.js
var deferred_utils = __webpack_require__("6SrU");

// CONCATENATED MODULE: ./controllers/emi.js
var emi__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _CARD_LABELS2, _EMI_TYPES_DISPLAY_NA;







var _ERROR_MESSAGES = {
  NO_EMI_BANKS: 'No banks available for EMI',
  NO_EMI_PLANS: 'EMI option is not available on this bank',
  NO_INITIATE_CHECKOUT_FOR_DEFAULT: 'Initiate checkout is not supported for default flow',
  EMI_AND_CARD_BANK_MISMATCH: 'The card does not belong to the selected bank.',
  NO_EMI_PLANS_FOR_MODE: 'EMI option is not available for provided card type.'
};

var _CARD_LABELS = (_CARD_LABELS2 = {}, _CARD_LABELS2[constants["g" /* default */].CC] = 'Credit Card', _CARD_LABELS2[constants["g" /* default */].DC] = 'Debit Card', _CARD_LABELS2);

var _EMI_TYPES_DISPLAY_NAMES = (_EMI_TYPES_DISPLAY_NA = {}, _EMI_TYPES_DISPLAY_NA[constants["g" /* default */].EMI_SUBVENTION] = 'Zero/Low Cost EMI', _EMI_TYPES_DISPLAY_NA[constants["g" /* default */].EMI_STANDARD] = 'Standard  EMI', _EMI_TYPES_DISPLAY_NA);

/* -------------------------------------------------------------------------- */
/*                            Common / helper methods                         */
/* -------------------------------------------------------------------------- */

function _sortByBankName(banks) {
  return banks.sort(function (a, b) {
    if (a.bankName < b.bankName) {
      return -1;
    }
    if (a.bankName > b.bankName) {
      return 1;
    }
    return 0;
  });
}

function _validateCardWithEmi() {
  var bankDetails = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var cardDetails = Object(common["l" /* find */])(bankDetails.payment_intent || [], function (data) {
    return Object.prototype.hasOwnProperty.call(data, 'banks');
  });

  if (cardDetails) {
    var cardBank = Object(common["q" /* getKey */])(cardDetails, 'banks', [])[0] || '';
    var cardType = Object(common["q" /* getKey */])(cardDetails, 'mode_type');

    if (!(Object(common["j" /* equalsIgnoreCase */])(bankDetails.bankCode, cardBank) || Object(common["j" /* equalsIgnoreCase */])(bankDetails.bankName, cardBank))) {
      return _ERROR_MESSAGES.EMI_AND_CARD_BANK_MISMATCH;
    }
    if (!Object(common["j" /* equalsIgnoreCase */])(bankDetails.cardType, cardType)) {
      return _ERROR_MESSAGES.NO_EMI_PLANS_FOR_MODE;
    }
  }

  return null;
}

function _getTxnAmountFromCache(cache) {
  return cache.getData(constants["g" /* default */].TXN_AMOUNT);
}

function _formatBankList(bankList) {
  var mappedBankList = (bankList || []).map(function (bank) {
    var emiType = bank.type;
    var cardTypes = [];

    var _loop = function _loop(card) {
      var cardLabel = card.cardLabel,
          cardType = card.cardType;

      var bankDetails = (card.bankDetails || []).map(function (bankDetail) {
        return emi__extends({}, bankDetail, {
          cardLabel: cardLabel,
          cardType: cardType,
          emiType: emiType
        });
      });

      if (bankDetails.length) {
        cardTypes = cardTypes.concat(bankDetails);
      }
    };

    for (var _iterator = bank.cardTypes || [], _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var card = _ref;

      _loop(card);
    }

    return emi__extends({}, bank, {
      displayLabel: _EMI_TYPES_DISPLAY_NAMES[emiType] || emiType,
      cardTypes: _sortByBankName(cardTypes)
    });
  });

  // append subvention bank at first
  var subventionBanksIndex = Object(common["m" /* findIndex */])(mappedBankList, function (bank) {
    return constants["g" /* default */].EMI_SUBVENTION === bank.type;
  });
  if (subventionBanksIndex !== -1) {
    mappedBankList.unshift(mappedBankList.splice(subventionBanksIndex, 1)[0]);
  }

  return mappedBankList;
}

function _getDisplayName(channel) {
  return channel.channelName + ' ' + _CARD_LABELS[channel.emiType];
}
/* -------------------------------------------------------------------------- */
/*                              Deferred Flow EMI                             */
/* -------------------------------------------------------------------------- */

var _deferredFlowEmiApi = function deferredFlowEMIAPIS() {
  function createApi(cache) {
    this.getDeferredCallbackResponseForEvent = deferred_utils["a" /* getDeferredCallbackResponseForEvent */].bind(this, cache);
    this.cache = cache;
  }

  /* -------------------------------- Bank list ------------------------------- */

  createApi.prototype.getBankList = function getBankList() {
    return this.getDeferredCallbackResponseForEvent(constants["g" /* default */].DEFERRED_EVENTS.FETCH_EMI_BANK_DETAILS).then(function (response) {
      var bankList = Object(common["q" /* getKey */])(response, 'emi_bank_details');
      return _formatBankList(bankList);
    });
  };

  /* -------------------------------- EMI Plans ------------------------------- */

  function _isHybridPayModeDisabled(emiPlansResponse, bankCode) {
    var paymentModes = Object(common["q" /* getKey */])(emiPlansResponse, 'payment_instruments.body.merchantPayOption.paymentModes', []);
    var emiPayMode = Object(common["l" /* find */])(paymentModes, function (mode) {
      return mode.paymentMode === constants["g" /* default */].EMI;
    });
    var selectedEmiBank = emiPayMode && Object(common["l" /* find */])(emiPayMode.payChannelOptions || [], function (channel) {
      return channel.channelCode === bankCode;
    });

    return Boolean(selectedEmiBank && selectedEmiBank.isHybridDisabled);
  }

  function _parseEmiPlan(bankCode, response) {
    var emiPlans = Object(common["q" /* getKey */])(response, 'emi_plans', null);

    if (!emiPlans) {
      throw new Error(_ERROR_MESSAGES.NO_EMI_PLANS);
    }

    var formattedEmiPlan = Object(common["P" /* pick */])(emiPlans, ['bankName', 'bankCode', 'cardType', 'bankLogoUrl', 'details']);

    formattedEmiPlan.details = (formattedEmiPlan.details || []).map(function (detail) {
      return Object(common["P" /* pick */])(detail, ['planId', 'interval', 'emi', 'effectivePrice', 'gratifications', 'rate', 'pgPlanId']);
    });

    return {
      bankCode: bankCode,
      cart: Object(common["q" /* getKey */])(response, 'cart', null),
      emiPlans: formattedEmiPlan,
      isHybridDisabled: _isHybridPayModeDisabled(response, bankCode),
      payableAmount: Object(common["q" /* getKey */])(response, 'paymentInfo.payableAmount.value', 0)
    };
  }

  createApi.prototype.getEmiPlans = function getEmiPlans(payload) {
    var cardError = _validateCardWithEmi(payload);

    if (cardError) {
      return Promise.reject(new Error(cardError));
    }

    return this.getDeferredCallbackResponseForEvent(constants["g" /* default */].DEFERRED_EVENTS.FETCH_EMI_PLANS, payload).then(function (response) {
      return _parseEmiPlan(payload.bankCode, response);
    });
  };

  /* -------------------------------- Apply EMI ------------------------------- */

  createApi.prototype.applyEmi = function applyEmi(payload) {
    var _this = this;

    return this.getDeferredCallbackResponseForEvent(constants["g" /* default */].DEFERRED_EVENTS.APPLY_EMI, payload).then(function (response) {
      var fallBackAmount = _getTxnAmountFromCache(_this.cache);
      var hasEmiPlans = Boolean(Object(common["q" /* getKey */])(response, 'emi_plan', null));
      response.emi_plans = response.emi_plan;

      return {
        apiResponse: _parseEmiPlan(payload.bankCode, response),
        hasEmiPlans: hasEmiPlans,
        fallBackAmount: fallBackAmount,
        txnAmount: Object(common["q" /* getKey */])(response, 'paymentInfo.payableAmount.value', fallBackAmount)
      };
    });
  };

  /* ---------------------------- Initiate Checkout --------------------------- */

  createApi.prototype.initiateCheckout = function initiateCheckout(payload) {
    return this.getDeferredCallbackResponseForEvent(constants["g" /* default */].DEFERRED_EVENTS.INITIATE_TXN, payload);
  };

  /* ------------------------------ Deferred APIs ----------------------------- */

  return createApi;
}();

/* -------------------------------------------------------------------------- */
/*                              Default Flow EMI                              */
/* -------------------------------------------------------------------------- */

var _defaultFlowEmiApi = function defaultFlowEmiApi() {
  function createApi(cache) {
    this.getApi = getApi.bind(this, cache);
    this.cache = cache;
  }

  /* -------------------------------- Bank list ------------------------------- */

  createApi.prototype.getBankList = function getBankList() {
    var paymentOptions = this.cache.getData(constants["a" /* CACHE */].PAYMENT_OPTIONS, {});
    var paymentModes = Object(common["q" /* getKey */])(paymentOptions, 'merchantPayOption.paymentModes', []);
    var emiPayMode = Object(common["l" /* find */])(paymentModes, function (mode) {
      return mode.paymentMode === constants["g" /* default */].EMI;
    });
    var emiPayChannels = Object(common["q" /* getKey */])(emiPayMode || {}, 'data.banks', []);
    var iconBaseUrl = this.cache.getData(constants["g" /* default */].ICON_BASE_URL);

    if (!emiPayChannels.length) {
      return Promise.reject(new Error(_ERROR_MESSAGES.NO_EMI_BANKS));
    }
    var cardTypes = emiPayChannels.map(function (channel) {
      return {
        bankCode: channel.channelCode,
        bankName: channel.channelName,
        cardType: channel.emiType,
        emiType: constants["g" /* default */].EMI_STANDARD,
        cardLabel: _CARD_LABELS[channel.emiType],
        bankLogoUrl: iconBaseUrl + channel.iconUrl,
        isHybridDisabled: channel.isHybridDisabled,
        displayName: _getDisplayName(channel)
      };
    });
    var bankList = [{
      cardTypes: _sortByBankName(cardTypes),
      info: [],
      label: _EMI_TYPES_DISPLAY_NAMES[constants["g" /* default */].EMI_STANDARD],
      type: constants["g" /* default */].EMI_STANDARD,
      displayLabel: _EMI_TYPES_DISPLAY_NAMES[constants["g" /* default */].EMI_STANDARD]
    }];
    return Promise.resolve(bankList);
  };

  /* -------------------------------- EMI plans ------------------------------- */

  function _parseEmiPlan(bankDetails, apiResponse, cache) {
    var emiDetail = Object(common["q" /* getKey */])(apiResponse, 'emiDetail');

    if (!emiDetail) {
      throw new Error(_ERROR_MESSAGES.NO_EMI_PLANS);
    }
    var emiChannelInfos = Object(common["q" /* getKey */])(emiDetail, 'emiChannelInfos', []);

    var formattedEmiDetails = emiChannelInfos.map(function (detail) {
      var planId = detail.planId,
          ofMonths = detail.ofMonths,
          _detail$emiAmount = detail.emiAmount,
          emiAmount = _detail$emiAmount === undefined ? {} : _detail$emiAmount,
          _detail$totalAmount = detail.totalAmount,
          totalAmount = _detail$totalAmount === undefined ? {} : _detail$totalAmount,
          interestRate = detail.interestRate;


      return {
        planId: planId,
        interval: ofMonths,
        emi: emiAmount.value,
        effectivePrice: totalAmount.value,
        rate: interestRate,
        pgPlanId: planId,
        gratifications: []
      };
    });

    var emiPlans = emi__extends({}, Object(common["P" /* pick */])(bankDetails, ['bankName', 'bankCode', 'cardType', 'bankLogoUrl']), {
      details: formattedEmiDetails
    });

    return {
      bankCode: bankDetails.bankCode,
      cart: null,
      emiPlans: emiPlans,
      isHybridDisabled: emiDetail.isHybridDisabled,
      payableAmount: _getTxnAmountFromCache(cache)
    };
  }

  createApi.prototype.getEmiPlans = function getEmiPlans(payload) {
    var _this2 = this;

    var cardError = _validateCardWithEmi(payload);

    if (cardError) {
      return Promise.reject(new Error(cardError));
    }

    return this.getApi().emiDetails(payload.bankCode, _getTxnAmountFromCache(this.cache), payload.cardType).then(function (response) {
      return ifSuccessOrThrowError(response, function (callBackResponse) {
        return _parseEmiPlan(payload, callBackResponse, _this2.cache);
      });
    });
  };

  /* ------------------------------ Apply EMI ------------------------------ */

  createApi.prototype.applyEmi = function applyEmi() {
    var txnAmount = _getTxnAmountFromCache(this.cache);

    return Promise.resolve({
      apiResponse: null,
      hasEmiPlans: true,
      fallBackAmount: txnAmount,
      txnAmount: txnAmount
    });
  };

  /* ------------------------------ Default APIs ------------------------------ */

  return createApi;
}();

/* -------------------------------------------------------------------------- */
/*                              Default Flow EMI SUBVENTION                   */
/* -------------------------------------------------------------------------- */

var _defaultFlowEmiSubventionApi = function defaultFlowEmiSubventionApi() {
  function createApi(cache) {
    this.getApi = getApi.bind(this, cache);
    this.cache = cache;
  }

  /* -------------------------------- Bank list EMI SUBVENTION  ------------------------------- */

  createApi.prototype.getBankList = function getBankList(payload) {
    var _this3 = this;

    return this.getApi().emiSubventionBanks(payload).then(function (response) {
      var status = Object(common["q" /* getKey */])(response, 'body.resultInfo.resultStatus', 'F');
      var resultCode = Object(common["q" /* getKey */])(response, 'body.resultInfo.resultCode', '');
      if (status === 'S') {
        var bankList = Object(common["q" /* getKey */])(response, 'body.emiTypes');
        return _formatBankList(bankList);
      }
      /* session expired handling */
      if (resultCode === '1006') {
        var mConfig = _this3.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
        _this3.cache.getData(constants["a" /* CACHE */].STORE).setState({ sessionExpired: true });
        var notifyMerchant = Object(common["q" /* getKey */])(mConfig, 'handler.notifyMerchant', undefined);
        if (notifyMerchant && notifyMerchant.constructor === Function) {
          notifyMerchant(constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.SESSION_EXPIRED, response);
        }
      }
      throw new Error(Object(common["q" /* getKey */])(response, 'body.resultInfo.resultMsg', ''));
    });
  };

  /* -------------------------------- EMI plans  EMI SUBVENTION  ------------------------------- */

  function _parseEmiPlan(bankCode, response, cache) {
    var planDetails = Object(common["q" /* getKey */])(response, 'planDetails', null);

    if (!planDetails) {
      throw new Error(_ERROR_MESSAGES.NO_EMI_PLANS);
    }

    var formattedEmiPlan = Object(common["P" /* pick */])(response, ['bankName', 'bankCode', 'cardType', 'bankLogoUrl', 'planDetails']);

    formattedEmiPlan.details = (formattedEmiPlan.planDetails || []).map(function (detail) {
      return Object(common["P" /* pick */])(detail, ['planId', 'interval', 'emi', 'effectivePrice', 'gratifications', 'rate', 'pgPlanId', 'finalTransactionAmount', 'itemBreakUp', 'interest']);
    });

    delete formattedEmiPlan.planDetails;
    return {
      bankCode: bankCode,
      emiPlans: formattedEmiPlan,
      payableAmount: _getTxnAmountFromCache(cache)
    };
  }

  createApi.prototype.getEmiPlans = function getEmiPlans(payload) {
    var _this4 = this;

    var cardError = _validateCardWithEmi(payload);
    if (cardError) {
      return Promise.reject(new Error(cardError));
    }

    var obj = Object(common["X" /* updatePayloadBasedOnStrategy */])(this.cache, {}, payload.subventionObject);
    return this.getApi().emiSubventionPlans(payload.bankCode, payload.cardType, obj).then(function (response) {
      return ifSuccessOrThrowError(response, function (callBackResponse) {
        return _parseEmiPlan(payload, callBackResponse, _this4.cache);
      });
    });
  };

  /* ------------------------------ Apply EMI  EMI SUBVENTION  ------------------------------ */

  createApi.prototype.applyEmi = function applyEmi(payload) {
    var _this5 = this;

    var fallBackAmount = this.cache.getData(constants["g" /* default */].FALLBACK_TXN_AMOUNT);
    var obj = Object(common["X" /* updatePayloadBasedOnStrategy */])(this.cache, {}, payload);
    return this.getApi().emiSubventionValidatePlan(payload, obj).then(function (response) {
      if (Object(common["q" /* getKey */])(response, 'body.resultInfo.resultStatus', 'F') === 'S') {
        return {
          apiResponse: response.body,
          hasEmiPlans: true,
          fallBackAmount: fallBackAmount,
          txnAmount: Object(common["q" /* getKey */])(response, 'body.finalTransactionAmount', fallBackAmount)
        };
      }

      /* session expired handling */
      if (Object(common["q" /* getKey */])(response, 'body.resultInfo.resultCode', '') === '1006') {
        var mConfig = _this5.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
        _this5.cache.getData(constants["a" /* CACHE */].STORE).setState({ sessionExpired: true });
        var notifyMerchant = Object(common["q" /* getKey */])(mConfig, 'handler.notifyMerchant', undefined);
        if (notifyMerchant && notifyMerchant.constructor === Function) {
          notifyMerchant(constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.SESSION_EXPIRED, response);
        }
      }
      throw new Error(Object(common["q" /* getKey */])(response, 'body.resultInfo.resultMsg', 'Selected Plan is not offered by bank'));
    });
  };

  /* ------------------------------ Default APIs ------------------------------ */

  return createApi;
}();

/* -------------------------------------------------------------------------- */
/*                              EMI API Evaluation                              */
/* -------------------------------------------------------------------------- */

/* setting a value to call default flow validate emi in case of access token flow because for
standard emi plans in access token flow there is no support at backend and on validate it throws
error */
function emiApi(cache) {
  var callDefaultFlowInAccessToken = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var _cache$getData = cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG),
      flow = _cache$getData.flow;

  var isEmiSubventionFlow = cache.getData(constants["g" /* default */].IS_EMISUBVENTION_ACCESS_TOKEN_FLOW);

  /* if flow is deferred execute deferred emi api
   * if flow is default and emi subvention key is true then execute the
   * _defaultFlowEmiSubventionApi functions */

  var Api = Object(common["j" /* equalsIgnoreCase */])(flow, constant["h" /* FLOW */].DEFERRED) ? _deferredFlowEmiApi : isEmiSubventionFlow ? callDefaultFlowInAccessToken ? _defaultFlowEmiApi : _defaultFlowEmiSubventionApi : _defaultFlowEmiApi;

  return new Api(cache);
}
// CONCATENATED MODULE: ./components/sc/index.js
var sc__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var sc__class, sc__temp, sc__initialiseProps;



function sc__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function sc__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function sc__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var sc__ref3 = Object(preact_min["h"])('span', { 'class': 'ptm-checkmark' });

var sc__ref4 = Object(preact_min["h"])(components_loader, null);

var sc__ref5 = Object(preact_min["h"])(
  'p',
  { 'class': 'ptm-small-txt ptm-msg-red ptm-selectplan-error' },
  'Please select EMI Plan'
);

var sc__ref6 = Object(preact_min["h"])(components_loader, null);

var sc__ref7 = Object(preact_min["h"])(
  'p',
  { 'class': 'ptm-small-txt ptm-msg-red' },
  'Please select EMI Plan'
);

var sc__ref8 = Object(preact_min["h"])(RupeeSymbol, null);

var _ref9 = Object(preact_min["h"])(RupeeSymbol, null);

var _ref10 = Object(preact_min["h"])(RupeeSymbol, null);

var _ref11 = Object(preact_min["h"])(renewal, null);

var _ref12 = Object(preact_min["h"])(components_loader, null);

var _ref13 = Object(preact_min["h"])('p', { className: 'ptm-global-bottom-border' });

var sc_SC = (sc__temp = sc__class = function (_Component) {
  sc__inherits(SC, _Component);

  function SC(props) {
    sc__classCallCheck(this, SC);

    var _this = sc__possibleConstructorReturn(this, _Component.call(this, props));

    sc__initialiseProps.call(_this);

    _this.frame = undefined;
    var option = Object(common["q" /* getKey */])(_this, 'props.option', {});
    /* setting cvv Required as default true unless saved card response has it false */
    var cvvRequired = Object(common["q" /* getKey */])(option, 'cardDetails.cvvRequired', true);
    var locale = Object(common["e" /* clientMessage */])(constant["m" /* PAYMODE */].CARD.toLowerCase(), _this.props.cache);

    var _this$props$cache$get = _this.props.cache.getData(constants["a" /* CACHE */].API).requestPayload(constant["a" /* API */].PT),
        url = _this$props$cache$get.url,
        query = _this$props$cache$get.query,
        method = _this$props$cache$get.method,
        data = _this$props$cache$get.data;

    data.body = sc__extends({}, query);
    var newStyle = '\n    .ptm-card-input:focus{\n      border-color:' + _this.props.AppStyle.themeBackgroundColor + ';\n      caret-color:' + _this.props.AppStyle.themeBackgroundColor + ';\n    }\n     .ptm-card-input:focus ~ .hidden-border{\n      background:' + _this.props.AppStyle.themeBackgroundColor + ';\n    }\n    .ptm-card-input,.card-expiry,.card-content{\n      border-color:' + _this.props.AppStyle.borderColor + ';\n      color:' + _this.props.AppStyle.bodyColor + '\n    }\n    .ptm-check,.ptm-container:hover input ~ .ptm-check{\n      border-color:' + _this.props.AppStyle.bodyColor + ';\n    }\n    .ptm-card-input::placeholder,.slash,.ptm-container{\n       color:' + _this.props.AppStyle.bodyColor + ';\n    }\n    #mm:focus+span+input+p.hidden-border,#yy:focus+p.hidden-border{\n      background:' + _this.props.AppStyle.themeBackgroundColor + ';\n      border-color:transparent;\n    }\n    .ptm-change-plan{\n      border-color:' + _this.props.AppStyle.borderColor + ';\n    }\n    .ptm-card-input{\n      border-color:' + _this.props.AppStyle.borderColor + ';\n      color:' + _this.props.AppStyle.bodyColor + ';\n    }\n    .ptm-card-input::placeholder{\n      color:' + _this.props.AppStyle.bodyColor + ';\n    }\n    .ptm-msg-red {\n      color: #ff585d;\n    }\n    .ptm-container input:checked ~ .ptm-check{\n      background-color: ' + _this.props.AppStyle.themeBackgroundColor + ';\n      border: 2px solid ' + _this.props.AppStyle.themeBackgroundColor + ';\n    }';
    _this.state = {
      initializeObject: {
        type: 'INITIALIZE',
        paymode: {
          type: _this.props.option.type,
          id: _this.props.option.id
        },
        inputLength: Object(common["q" /* getKey */])(_this.props, 'option.cardDetails.cvvLength') || 4,
        requestPayload: {
          targetURL: url + '?' + Object(common["o" /* getEncodedQs */])(query),
          queryParams: query,
          requestData: data,
          method: method
        },
        style: newStyle,
        isSavedCard: true,
        messageObj: {
          label: locale.label,
          error: locale.error
        },
        // to pass cvv length to passcode html
        cvvLength: Object(common["q" /* getKey */])(_this.props, 'option.cardDetails.cvvLength', 4),
        cvvRequired: cvvRequired,
        instanceKey: _this.props.instanceKey
      },
      showEmiPlanDetails: false,
      loader: false,
      isValidPlan: true,
      iframeError: false,
      showCVV: cvvRequired
    };
    // this.label = locale.label;
    // this.error = locale.error;
    return _this;
  }

  SC.prototype.componentDidUpdate = function componentDidUpdate(previousProps) {
    var option = Object(common["q" /* getKey */])(this.props, 'option', null);
    var selected = Object(common["q" /* getKey */])(this.props, 'selected', null);
    var subOption = Object(common["q" /* getKey */])(this.props, 'selected.subOption', null);
    var previousPropsWallet = Object(common["q" /* getKey */])(previousProps, 'wallet', null);
    var currentPropsWallet = Object(common["q" /* getKey */])(this.props, 'wallet', null);
    var cvvRequired = Object(common["q" /* getKey */])(this.props.selected, 'cardDetails.cvvRequired', true);
    if (option && selected && option.id === selected.id && previousPropsWallet && currentPropsWallet && this.state.showCVV !== cvvRequired) {
      this.setState({ showCVV: cvvRequired });
    }
    if (option && selected && option.id === selected.id && previousPropsWallet && currentPropsWallet && currentPropsWallet.isUsed !== previousPropsWallet.isUsed) {
      this.setState({ selectedPlan: null, showEmiPlanDetails: false });
    }
    if (selected && selected.name !== constant["m" /* PAYMODE */].EMI) {
      if (option && selected && option.id !== selected.id) {
        if (this.state.selectedPlan || this.state.showEmiPlanDetails) {
          this.setState({ selectedPlan: null, showEmiPlanDetails: false });
        }
      }
    } else if (subOption && option && subOption.id !== option.id) {
      if (this.state.selectedPlan || this.state.showEmiPlanDetails) {
        this.setState({ selectedPlan: null, showEmiPlanDetails: false });
      }
      /* if option has changed then remove the local selected plan from payment */
      if (!this.props.selectedEmiPlan && this.state.selectedPlan) {
        this.setState({ selectedPlan: null });
      }
    }
    /* if another card is selected from emi then hide the error in sc component in emi */
    if (this.props.useAnotherCard && (!this.state.isValidPlan || this.state.error)) {
      this.setState({ isValidPlan: true, error: '' });
    }
    /* if anther card is selected the mei plan set on sc is removed and set plan selected in local
      state as null */
    var emiPlans = this.props.cache.getData(constants["a" /* CACHE */].EMI_PLANS);
    if (this.state.selectedPlan && !emiPlans && !this.props.selectedEmiPlan) {
      this.setState({ selectedPlan: null });
    }
  };

  SC.prototype.areNoScEmiPlanSelected = function areNoScEmiPlanSelected() {
    return !this.state.selectedPlan && Object(common["j" /* equalsIgnoreCase */])(Object(common["q" /* getKey */])(this.props, 'selected.type'), constants["g" /* default */].SC);
  };

  SC.prototype.fetchEmiPlansFromApi = function fetchEmiPlansFromApi(payload) {
    var _this2 = this;

    payload = Object(common["Y" /* updatePayloadForTenureEMI */])(this.props.cache, payload);
    emiApi(this.props.cache).getEmiPlans(payload).then(function (data) {
      _this2.props.cache.setData(constants["a" /* CACHE */].PLAN_DETAILS, data);
      _this2.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ stopScroll: true });
      _this2.setState({ showEmiPlans: true, loader: false });
    }).catch(function (err) {
      _this2.setState({ loader: false, error: err.message });
      Object(logger["log"])({
        eventType: constants["b" /* EVENTS */].SC_EMI_FETCH_PLANS_ERROR,
        error: err
      });
    });
  };

  SC.prototype.render = function render(_ref, _ref2) {
    var _this3 = this;

    var option = _ref.option,
        instanceKey = _ref.instanceKey,
        cache = _ref.cache,
        selected = _ref.selected,
        isDisplay = _ref.isDisplay,
        isActive = _ref.isActive,
        _ref$isEmi = _ref.isEmi,
        isEmi = _ref$isEmi === undefined ? false : _ref$isEmi,
        offers = _ref.offers,
        isPromoAvailable = _ref.isPromoAvailable;
    var showEmiPlans = _ref2.showEmiPlans,
        showMiniCart = _ref2.showMiniCart,
        selectedPlan = _ref2.selectedPlan,
        showEmiPlanDetails = _ref2.showEmiPlanDetails,
        initializeObject = _ref2.initializeObject,
        loader = _ref2.loader,
        isValidPlan = _ref2.isValidPlan,
        iframeError = _ref2.iframeError,
        showCVV = _ref2.showCVV,
        error = _ref2.error,
        bankError = _ref2.bankError,
        errorSubText = _ref2.errorSubText,
        errorHeading = _ref2.errorHeading;

    var emiType = {
      LOW_COST: 'Low Cost EMI Available',
      ZERO_COST: 'Zero Cost EMI Available'
    };
    var planDetails = cache.getData(constants["a" /* CACHE */].PLAN_DETAILS);
    var gratification = Object(common["q" /* getKey */])(selectedPlan, 'gratifications', null);
    var scOffer = isPromoAvailable ? option && Object(common["j" /* equalsIgnoreCase */])(Object(common["q" /* getKey */])(selected, 'type'), constants["g" /* default */].SC) && isActive ? Object(common["q" /* getKey */])(offers, selectedPlan ? constants["g" /* default */].EMI : constants["g" /* default */].SC) : Object(common["q" /* getKey */])(option, 'paymentOfferDetails') : null;
    if (gratification) {
      gratification = gratification[0];
    }

    var isEmiSubventionFlow = cache.getData(constants["g" /* default */].IS_EMISUBVENTION_ACCESS_TOKEN_FLOW);
    var miniCart = cache.getData(constants["g" /* default */].SUBVENTION_MINI_CART_OBJ);

    var locale = Object(common["e" /* clientMessage */])(constant["m" /* PAYMODE */].EMI.toLowerCase(), cache);
    return isDisplay ? Object(preact_min["h"])(
      'div',
      {
        className: 'ptm-sc-main ' + (isEmi ? 'ptm-emi-sc' : '') + ' ptm-test-checkout-sc-' + option.id,
        ref: function ref(componentRef) {
          _this3.componentRef = componentRef;
        }
      },
      Object(preact_min["h"])(
        'div',
        { 'class': 'ptm-pay-method ptm-w100-ib ptm-checkout-sc-' + option.id, id: 'ptm-checkout-sc' },
        Object(preact_min["h"])(
          'div',
          { 'class': 'ptm-sc sc-wrap-test' },
          Object(preact_min["h"])(
            'div',
            {
              'class': 'ptm-radio-wrap',
              onClick: function onClick() {
                _this3.onOptionSelect(option);
              }
            },
            Object(preact_min["h"])(
              'label',
              { 'class': 'ptm-lbl', 'for': 'sc-radio-' + option.id },
              Object(preact_min["h"])('input', {
                type: 'radio',
                name: 'verify-sc' + instanceKey,
                className: 'ptm-margin0',
                id: 'sc-radio-' + option.id,
                checked: isActive
              }),
              sc__ref3,
              Object(preact_min["h"])(
                'div',
                { 'class': 'ptm-pay-method-cont' },
                Object(preact_min["h"])(
                  'p',
                  { 'class': 'ptm-paymode-name ' },
                  option.displayName,
                  Object(preact_min["h"])('span', { className: 'ptm-card-type-img ' + option.cardScheme })
                ),
                Object(preact_min["h"])(
                  'p',
                  { 'class': 'ptm-small-txt' },
                  option.scType,
                  ' XXXX ',
                  option.lastFour
                )
              )
            )
          )
        ),
        option && isActive && Object(preact_min["h"])(
          'div',
          null,
          Object(preact_min["h"])(iframe_Iframe, sc__extends({
            ref: function ref(r) {
              return _this3.frame = r;
            },
            classname: 'ptm-sc-iframe ' + (iframeError ? 'error' : '') + '\n                 ' + (showCVV ? 'show-cvv-iframe' : 'hide-cvv-iframe'),
            option: option,
            postMessageHandler: this.messageHandler,
            src: Object(common["U" /* staticPath */])() + '/assets/iframes/passcode.html'
          }, { initializeObject: initializeObject })),
          option.isEmiAvailable && !option.subventionType && Object(preact_min["h"])(
            'div',
            {
              className: 'ptm-emi-avl ptm-small-txt-link ptm-pos-r',
              onClick: function onClick() {
                _this3.getEMIPlans(option);
              }
            },
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-txt ptm-primary' },
              'EMI Available'
            ),
            loader && Object(preact_min["h"])(
              'div',
              { className: 'ptm-loader-wrap' },
              sc__ref4
            ),
            !isValidPlan && sc__ref5
          ),
          option.subventionType && Object(preact_min["h"])(
            'div',
            { className: 'ptm-emi-avl ptm-small-txt-link ptm-pos-r' },
            Object(preact_min["h"])(
              'div',
              {
                className: 'ptm-txt',
                onClick: function onClick() {
                  _this3.getEMIPlans(option);
                }
              },
              emiType[option.subventionType]
            ),
            loader && Object(preact_min["h"])(
              'div',
              { className: 'ptm-loader-wrap' },
              sc__ref6
            ),
            !isValidPlan && sc__ref7
          ),
          showEmiPlanDetails && selectedPlan && Object(preact_min["h"])(
            'div',
            { className: 'ptm-change-plan ptm-body-bg', id: 'planDetails' },
            Object(preact_min["h"])(
              'p',
              { className: 'ptm-emi-cal', id: 'emiPlans' },
              'EMI of',
              ' ',
              sc__ref8,
              ' ',
              selectedPlan.emi + ' for ' + selectedPlan.interval + ' months @ ' + selectedPlan.rate + '% p.a.'
            ),
            Object(preact_min["h"])(
              'h6',
              { className: 'ptm-total-amount', id: 'price' },
              'Total',
              ' ',
              _ref9,
              ' ',
              '' + selectedPlan.effectivePrice
            ),
            Object(preact_min["h"])(
              'p',
              {
                className: 'ptm-small-txt-link',
                id: 'changePlan',
                onClick: function onClick() {
                  _this3.getEMIPlans(option);
                }
              },
              'Change Plan'
            ),
            gratification && Object(preact_min["h"])(
              'div',
              { className: 'ptm-applied-offer' },
              Object(preact_min["h"])(
                'p',
                { className: 'ptm-applied-para' },
                'EMI offer of ',
                _ref10,
                ' ',
                gratification.value,
                ' ',
                gratification.label,
                ' ',
                'successfully applied'
              )
            )
          )
        ),
        scOffer && Object(preact_min["h"])(offers_paymodeOffer, { offer: scOffer, applied: isActive }),
        error && Object(preact_min["h"])(
          'p',
          { className: 'ptm-small-txt ptm-msg-red ptm-sc-error' },
          ' ',
          error,
          ' '
        ),
        option && isActive && _ref11,
        showEmiPlans && Object(preact_min["h"])(
          'div',
          { className: 'ptm-emi-overlay' },
          Object(preact_min["h"])(
            components_OverlayWrap,
            null,
            Object(preact_min["h"])(components_emiPlans, {
              planDetails: planDetails,
              hideEmiPlans: this.hideEmiPlans,
              setEmiPlan: this.setEmiPlan,
              showMiniCart: this.showMiniCart,
              selectEmiPlan: this.selectEmiPlan,
              miniCart: miniCart
            })
          ),
          loader && Object(preact_min["h"])(
            'div',
            { className: 'ptm-bank-loader-wrap' },
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-inn-load-wrap ptm-centralized ptm-pos-a' },
              _ref12
            )
          )
        ),
        showMiniCart && (planDetails.cart || isEmiSubventionFlow && miniCart) && selectedPlan && Object(preact_min["h"])(
          'div',
          { className: 'ptm-emi-overlay' },
          Object(preact_min["h"])(
            components_OverlayWrap,
            null,
            Object(preact_min["h"])(components_miniCart, {
              cart: planDetails.cart,
              selectedPlan: selectedPlan,
              isEmiSubventionFlow: isEmiSubventionFlow,
              closeMiniCart: this.closeMiniCart,
              miniCart: miniCart
            })
          )
        ),
        bankError && Object(preact_min["h"])(
          'div',
          { className: 'ptm-emi-overlay-bank-error' },
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-modal-wrapper ptm-body-bg' },
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-excl-box ptm-pos-r' },
              Object(preact_min["h"])(
                'span',
                { className: 'ptm-centralized ptm-pos-a' },
                '!'
              )
            ),
            Object(preact_min["h"])(
              'h2',
              { className: 'ptm-body-color' },
              errorHeading
            ),
            Object(preact_min["h"])(
              'p',
              { className: 'ptm-body-color' },
              errorSubText
            ),
            Object(preact_min["h"])(
              'button',
              { onClick: this.hideShowError },
              locale.error.errorBtn
            )
          )
        )
      ),
      _ref13
    ) : null;
  };

  return SC;
}(preact_min["Component"]), sc__initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.hasValidationError = true;
  this.cvvRegex = /[^0-9]/g;

  this.handleAfterPay = function (response) {
    var _getKey = Object(common["q" /* getKey */])(response, 'body.bankForm.redirectForm', {}),
        actionUrl = _getKey.actionUrl,
        content = _getKey.content;

    response.body.content = content;
    response.body.callbackUrl = actionUrl;
    return response;
  };

  this.messageHandler = function (event) {
    if (!_this4.props.cache.getData(constants["a" /* CACHE */].STORE) || Object(common["q" /* getKey */])(event, 'data.calledFrom') !== 'passcode' || Object(common["q" /* getKey */])(event, 'data.instanceKey') !== _this4.props.instanceKey) {
      return;
    }

    switch (event.data && event.data.type) {
      case constants["g" /* default */].PAY_SUCCESS:
        {
          var payload = Object(common["q" /* getKey */])(event, 'data.response', {});
          Object(formPost["f" /* postInWindow */])(_this4.handleAfterPay(payload), _this4.props.cache);
          Object(logger["log"])({ eventType: logger["EVENT"].BOC_EVENT_PAY_SUCCESS });
          break;
        }
      // in case of payment fail show error
      case constants["g" /* default */].PAY_FAIL:
        {
          var data = event.data.response;
          Object(logger["log"])({ eventType: logger["EVENT"].BOC_EVENT_PAY_FAIL });
          Object(formPost["f" /* postInWindow */])(data, _this4.props.cache);
          _this4.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: '' });
          if (Object(common["q" /* getKey */])(data, 'body.resultInfo.resultStatus', '') === 'F' && Object(common["q" /* getKey */])(data, 'body.resultInfo.retry', '') === false) {
            if (Object(common["q" /* getKey */])(data, 'body.txnInfo.RESPCODE', '') === '1006' || Object(common["q" /* getKey */])(data, 'body.resultInfo.resultCode', '') === '1006') {
              _this4.props.onOverlayValueChange('');
              var mConfig = _this4.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
              _this4.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ sessionExpired: true });
              var notifyMerchant = Object(common["q" /* getKey */])(mConfig, 'handler.notifyMerchant', undefined);
              if (notifyMerchant && notifyMerchant.constructor === Function) {
                notifyMerchant(constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.SESSION_EXPIRED, data);
              }
            } else {
              data.body.content = data.body.txnInfo;
              Object(formPost["b" /* handlePostData */])(data, _this4.props.cache);
            }
          } else if (Object(common["q" /* getKey */])(data, 'body.resultInfo.resultStatus') === 'F' && Object(common["q" /* getKey */])(data, 'body.resultInfo.retry') === true) {
            _this4.props.cache.getData(constants["a" /* CACHE */].STORE).setState({
              overlayValue: constants["g" /* default */].RETRY,
              retryMessage: Object(common["q" /* getKey */])(data, 'body.resultInfo.resultMsg')
            });

            //  in case of reyr get fallback token from cache and set current access token
            //  and remove txn token to fetch new txn token
            if (_this4.props.cache.getData(constants["g" /* default */].IS_EMISUBVENTION_ACCESS_TOKEN_FLOW)) {
              var _mConfig = _this4.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
              var tokenData = _this4.props.cache.getData(constants["a" /* CACHE */].FALLBACK_TOKEN_DATA, {
                token: Object(common["q" /* getKey */])(_mConfig, 'data.token', ''),
                tokenType: constant["n" /* TOKEN */].ACCESS
              });
              _this4.props.cache.setData(constants["a" /* CACHE */].TOKEN_DATA, {
                token: tokenData.token,
                tokenType: tokenData.tokenType
              });
            }
          }
          break;
        }
      case 'payerror':
        {
          Object(logger["log"])({ eventType: logger["EVENT"].BOC_EVENT_PAY_ERROR });
          if (_this4.state.payError) {
            _this4.setState({ showError: false, errorText: '', payError: false });
          }
          Object(formPost["f" /* postInWindow */])({}, _this4.props.cache);
          break;
        }
      case constants["g" /* default */].CLIENT_VALIDATION:
        {
          Object(logger["log"])({ eventType: logger["EVENT"].BOC_EVENT_CLIENT_VALIDATION });
          _this4.setState({ iframeError: true });
          Object(formPost["f" /* postInWindow */])({}, _this4.props.cache);
          break;
        }
      case constants["g" /* default */].SHOW_PROCESSING:
        {
          Object(logger["log"])({ eventType: logger["EVENT"].BOC_EVENT_SHOW_PROCESSING });
          _this4.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: constants["g" /* default */].PROCESSING });
          break;
        }

      case constants["g" /* default */].GET_TXN_TOKEN_PAYLOAD:
        {
          Object(logger["log"])({ eventType: logger["EVENT"].BOC_GET_TXN_TOKEN_PAYLOAD });
          var paymodeId = Object(common["q" /* getKey */])(event, 'data.paymode.id', null);
          var optionId = Object(common["q" /* getKey */])(_this4.props, 'option.id', null);
          /*
          if the paymode id recieved from iframe is same as that of option id then only call the submit
          */
          if (paymodeId === optionId) {
            _this4.props.cache.getData(constants["a" /* CACHE */].API).getAsyncPayload(constant["a" /* API */].PT, _this4.hasValidationError).then(function (payload) {
              var tokenData = _this4.props.cache.getData(constants["a" /* CACHE */].TOKEN_DATA);
              var config = _this4.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
              var orderId = _this4.props.cache.getData(constants["a" /* CACHE */].ORDER_ID);
              if (config && config.flow === constant["h" /* FLOW */].DEFERRED) {
                payload.data.body.orderId = orderId;
                payload.query.orderId = orderId;
              }
              var emiPlans = _this4.props.cache.getData(constants["a" /* CACHE */].EMI_PLANS);
              if (_this4.props.isEmi && !_this4.state.selectedPlan && !emiPlans) {
                _this4.setState({ isValidPlan: false });
                return;
              }

              var reqData = {
                body: {
                  type: constants["g" /* default */].SUBMIT_WITH_TOKEN,
                  targetURL: payload.url + '?' + Object(common["o" /* getEncodedQs */])(payload.query),
                  queryParams: payload.query,
                  method: payload.method,
                  requestData: sc__extends({}, payload.data),
                  paymode: { id: _this4.props.option.id, type: _this4.props.option.type },
                  paymentMode: _this4.state.selectedPlan || _this4.props.isEmi ? constant["m" /* PAYMODE */].EMI : _this4.props.option.cardDetails.cardType,
                  authMode: constants["g" /* default */].OTP,
                  selectedPaymentModeId: _this4.props.option.id,
                  cardInfo: Object(common["q" /* getKey */])(_this4.props.option, 'cardDetails.cardId', '') + '||',
                  isSavedCard: true,
                  guestFlow: tokenData.tokenType !== constant["n" /* TOKEN */].TXN || false // because of use of sso token guest flow will be set to true
                }
              };

              reqData = sc__extends({}, payload.data.body, reqData.body);

              /* if paymode is emi add emitype to request body */
              if (_this4.state.selectedPlan || _this4.props.isEmi) {
                reqData.emiType = _this4.props.option.cardDetails.cardType;
                reqData.isEmi = true;
                reqData.planId = emiPlans && emiPlans.pgPlanId;
              }
              reqData.inputLength = _this4.props.option.cardDetails.cvvLength || 4;
              _this4.frame && _this4.frame.postDataToIframe(reqData);
            }).catch(function () {
              // close processing screen
              _this4.props.onOverlayValueChange('');
            });
          }
          break;
        }
      case constants["g" /* default */].SET_VALIDATION_STATUS:
        {
          _this4.hasValidationError = Object(common["q" /* getKey */])(event, 'data.hasError');
          break;
        }
      case constants["g" /* default */].OPEN_POPUP_WINDOW:
        {
          var _paymodeId = Object(common["q" /* getKey */])(event, 'data.paymode.id', null);
          var _optionId = Object(common["q" /* getKey */])(_this4.props, 'option.id', null);
          /* if the paymode id recieved from iframe is same as that of option id then only open the popup */
          if (_paymodeId === _optionId) {
            Object(formPost["c" /* openPopUpWindow */])(_this4.props.cache);
            Object(logger["log"])({ eventType: logger["EVENT"].POPUP_WINDOW });
          }
          break;
        }
      case constants["g" /* default */].HELPER_TYPE.CVV_HELPER:
        {
          Object(logger["log"])({ eventType: logger["EVENT"].CARD_EVENT_CVV_HELPER });
          _this4.props.onHelperOverlayToggle(constants["g" /* default */].HELPER_TYPE.CVV_HELPER);
          break;
        }
      case 'INPUT_FOCUS':
        {
          // const defaultSelectedPaymodeOffSetTop = getKey(
          //   this.props.selected,
          //   'reference._component.componentRef.offsetTop',
          //   0
          // );
          // this.hiddenInputRef && this.hiddenInputRef.focus();
          // scrollInContentWrap(defaultSelectedPaymodeOffSetTop);
          break;
        }
      default:
        break;
    }
  };

  this.submit = function () {
    var payload = _this4.props.cache.getData(constants["a" /* CACHE */].API).requestPayload(constant["a" /* API */].PT);
    var tokenData = _this4.props.cache.getData(constants["a" /* CACHE */].TOKEN_DATA);

    var emiPlans = _this4.props.cache.getData(constants["a" /* CACHE */].EMI_PLANS);
    if (_this4.props.isEmi && !_this4.state.selectedPlan && !emiPlans) {
      _this4.setState({ isValidPlan: false });
      return;
    }
    // payload.data.body = { ...payload.query };
    var reqData = {
      body: {
        type: constants["g" /* default */].SUBMIT,
        targetURL: payload.url + '?' + Object(common["o" /* getEncodedQs */])(payload.query),
        queryParams: payload.query,
        method: payload.method,
        requestData: sc__extends({}, payload.data),
        paymode: { id: _this4.props.option.id, type: _this4.props.option.type },
        paymentMode: _this4.state.selectedPlan || _this4.props.isEmi ? constant["m" /* PAYMODE */].EMI : _this4.props.option.cardDetails.cardType,
        authMode: constants["g" /* default */].OTP,
        selectedPaymentModeId: _this4.props.option.id,
        cardInfo: Object(common["q" /* getKey */])(_this4.props.option, 'cardDetails.cardId', '') + '||',
        isSavedCard: true,
        guestFlow: tokenData.tokenType !== constant["n" /* TOKEN */].TXN || false // because of use of sso token guest flow will be set to true
      }
    };
    reqData = sc__extends({}, payload.data.body, reqData.body);
    reqData.shouldPostOpenWindowEvent = _this4.hasValidationError;

    if (_this4.state.selectedPlan || _this4.props.isEmi) {
      reqData.emiType = _this4.props.option.cardDetails.cardType;
      reqData.isEmi = true;
      reqData.planId = emiPlans && emiPlans.pgPlanId;
    }

    reqData.inputLength = _this4.props.option.cardDetails.cvvLength || 4;
    Object(logger["log"])({
      eventType: logger["EVENT"].BOC_IFRAME_SUBMIT,
      paymentMode: reqData.paymentMode,
      payMode: _this4.props && _this4.props.option && _this4.props.option.type
    });
    // return 1;
    !_this4.hasValidationError && Object(formPost["c" /* openPopUpWindow */])(_this4.props.cache);
    _this4.frame && _this4.frame.postDataToIframe(reqData);
  };

  this.handleCVVInput = function (e) {
    var cursorPosition = e.target.selectionStart;
    e.target.value = e.target.value.replace(_this4.cvvRegex, '');
    if (cursorPosition) {
      if (e.target.setSelectionRange) {
        e.target.setSelectionRange(cursorPosition, cursorPosition);
      }
    }
    _this4.state.cvv = e.currentTarget.value;
  };

  this.restrictInput = function (ev) {
    var digit = String.fromCharCode(ev.which);
    if (ev.key !== undefined) {
      digit = ev.key;
    }
    // any other character than digit
    if (!/^\d+$/.test(digit)) {
      if (ev.which !== 8 && ev.which !== 9 && ev.which !== 37 && ev.which !== 39) {
        ev.preventDefault();
      }
    }
  };

  this.onOptionSelect = function (option) {
    _this4.props.onOptionSelect(option);
  };

  this.hideEmiPlans = function () {
    _this4.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ stopScroll: false });
    _this4.setState({ showEmiPlans: false });
    if (_this4.areNoScEmiPlanSelected()) {
      _this4.props.fetchPcf(_this4.props.option);
      _this4.props.applyPromoForPayMode(_this4.props.option);
    }
  };

  this.showMiniCart = function (plan) {
    _this4.props.onSelectedPlan(plan);
    _this4.setState({ showMiniCart: true, selectedPlan: plan });
    return null;
  };

  this.closeMiniCart = function () {
    _this4.setState({ showMiniCart: false });
  };

  this.getEMIPlans = function (option) {
    var paymentOptions = sc__extends({}, _this4.props.cache.getData('paymentOptions'));
    /* if emi hybrid disabled set  wallet isUsed false */
    if (option.isEmiHybridDisabled && Object(common["q" /* getKey */])(_this4.props, 'wallet.isUsed', false)) {
      var emiLocale = Object(common["e" /* clientMessage */])(constant["m" /* PAYMODE */].EMI.toLowerCase(), _this4.props.cache);
      var wallet = sc__extends({}, paymentOptions.wallet, { isUsed: false });
      paymentOptions.wallet = wallet;
      var _txnAmount = _this4.props.cache.getData(constants["g" /* default */].TXN_AMOUNT);
      var amountPayable = Object(common["c" /* calculateAmountPayable */])(_txnAmount, paymentOptions.wallet);
      _this4.props.cache.setData(constants["a" /* CACHE */].PAYMENT_OPTIONS, paymentOptions);
      _this4.props.onWalletToggle(wallet);
      var text = Object(common["q" /* getKey */])(emiLocale, 'label.emiHybridDisabledCardText', 'Paytm Balance and EMI cannot be used together for this payment. Please select your Emi Again');
      _this4.props.onNotificationTextChange(text);
      _this4.props.onBtnTextChange(en["a" /* default */].payButton.text + amountPayable);
      return 1;
    }
    _this4.setState({ loader: true, error: null });
    var paymentIntent = [];
    if (_this4.props.wallet && _this4.props.wallet.isUsed) {
      paymentIntent.push({
        mode: constant["m" /* PAYMODE */].WALLET,
        txnAmount: _this4.props.wallet.walletBalance
      });
    }

    var txnAmount = Number(_this4.props.cache.getData(constants["g" /* default */].TXN_AMOUNT)) || 0;
    paymentIntent.push({
      banks: [option.issuingBank],
      cardHash: option.cardDetails.cardHash,
      channels: [option.channelCode],
      mode: constant["m" /* PAYMODE */].EMI,
      mode_type: option.cardDetails.cardType,
      txnAmount: _this4.props.wallet && _this4.props.wallet.isUsed ? txnAmount - _this4.props.wallet.walletBalance : txnAmount
    });
    var payload = {
      bankCode: option.issuingBank,
      cardType: option.cardDetails.cardType,
      paymentIntent: paymentIntent
    };
    _this4.props.cache.setData(constants["a" /* CACHE */].PAYMENT_INTENT, paymentIntent);
    // this.setState({ paymentIntent });
    Object(logger["log"])({
      eventType: constants["b" /* EVENTS */].SC_EMI_FETCH_PLANS,
      bankCode: option.issuingBank,
      cardType: option.cardDetails.cardType
    });

    if (_this4.areNoScEmiPlanSelected()) {
      var emiPayMode = Object(common["l" /* find */])(Object(common["q" /* getKey */])(paymentOptions, 'payData.paymentModes', []), function (paymode) {
        return Object(common["j" /* equalsIgnoreCase */])(paymode.paymentMode, constant["m" /* PAYMODE */].EMI);
      });

      /* if it is emi subvention flow call plans api after promo has been called so that
       updated amount can be set for cart items */
      if (_this4.props.cache.getData(constants["g" /* default */].IS_EMISUBVENTION_ACCESS_TOKEN_FLOW)) {
        _this4.props.applyPromoForPayMode(emiPayMode, Object(common["q" /* getKey */])(option, 'issuingBank'), null, null, Object(common["q" /* getKey */])(option, 'cardDetails.cardId')).then(function () {
          _this4.fetchEmiPlansFromApi(payload);
        });
      } else {
        _this4.props.applyPromoForPayMode(emiPayMode, Object(common["q" /* getKey */])(option, 'issuingBank'), null, null, Object(common["q" /* getKey */])(option, 'cardDetails.cardId'));
        _this4.props.fetchPcf(emiPayMode, option.issuingBank).then(function () {
          _this4.fetchEmiPlansFromApi(payload);
        });
      }
    } else {
      _this4.fetchEmiPlansFromApi(payload);
    }
    return null;
  };

  this.selectEmiPlan = function (plan) {
    _this4.setState({ loader: true });
    var itemHash = {};
    _this4.props.onSelectedPlan(plan);
    var planDetails = _this4.props.cache.getData(constants["a" /* CACHE */].PLAN_DETAILS);
    var paymentIntent = _this4.props.cache.getData(constants["a" /* CACHE */].PAYMENT_INTENT);

    Object(common["q" /* getKey */])(planDetails, 'cart.cart_items', []).map(function (item) {
      var offerId = Object(common["q" /* getKey */])(item, 'emi_offers.' + plan.planId + '.offerId');
      itemHash[item.item_id] = offerId ? { offer_id: offerId } : {};
      return item;
    });

    var requestPayload = {
      plan_id: plan.planId,
      pgPlanId: plan.pgPlanId,
      item_map: itemHash,
      paymentIntent: paymentIntent,
      bankCode: planDetails.bankCode,
      planId: plan.planId // adding a duplicate since in another place this needs to be used and camel case is not being allowed by eslint
    };

    Object(logger["log"])({
      eventType: constants["b" /* EVENTS */].SC_EMI_APPLY_PLAN,
      plan_id: plan.planId,
      item_map: itemHash
    });

    var isEmiSubventionFlow = _this4.props.cache.getData(constants["g" /* default */].IS_EMISUBVENTION_ACCESS_TOKEN_FLOW);
    if (isEmiSubventionFlow) {
      _this4.getCacheCardTokenForSavedCard().then(function (resp) {
        _this4.applyEMIFunction(requestPayload, plan, resp);
      }).catch(function (err) {
        var errorMsg = Object(common["q" /* getKey */])(err, 'ErrorMsg', constants["g" /* default */].GENERIC_ERROR);
        _this4.setState({ loader: false, error: errorMsg });
      });
    } else {
      _this4.applyEMIFunction(requestPayload, plan);
    }

    return null;
  };

  this.applyEMIFunction = function (requestPayload, plan) {
    var cacheCardToken = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    requestPayload = Object(common["Z" /* updatePayloadForValidateEMI */])(_this4.props.cache, plan, requestPayload, cacheCardToken);
    var gratifications = Object(common["q" /* getKey */])(plan, 'gratifications', []);
    var isStandardEmi = !gratifications.length;
    requestPayload = Object(common["Z" /* updatePayloadForValidateEMI */])(_this4.props.cache, plan, requestPayload, _this4.props.cache.getData(constants["g" /* default */].CACHE_CARD_TOKEN));
    /* if plan selected is not subvented emi call default flow function in case of validate emi that
     is  not to make validate emi api call */
    emiApi(_this4.props.cache, isStandardEmi).applyEmi(requestPayload).then(function (data) {
      var apiResponse = data.apiResponse,
          fallBackAmount = data.fallBackAmount,
          txnAmount = data.txnAmount;

      if (apiResponse) {
        var emiSubventionToken = apiResponse.emiSubventionToken;

        _this4.props.cache.setData(constants["g" /* default */].EMISUBVENTION_TOKEN, emiSubventionToken);
      }
      _this4.setState({ loader: false });
      if (apiResponse) {
        _this4.props.cache.setData(constants["a" /* CACHE */].PLAN_DETAILS, apiResponse);
      }
      /* set existing amount in fallback amount so that on payment mode change amount is restored */
      var paymentOptions = _this4.props.cache.getData('paymentOptions');
      var walletObj = sc__extends({}, paymentOptions.wallet);
      _this4.props.cache.setData(constants["g" /* default */].FALLBACK_TXN_AMOUNT, fallBackAmount);
      _this4.props.cache.setData(constants["g" /* default */].TXN_AMOUNT, txnAmount);
      _this4.amountPayable = Object(common["c" /* calculateAmountPayable */])(txnAmount, walletObj);
      var payAmountText = en["a" /* default */].payButton.text + _this4.amountPayable;
      _this4.props.onBtnTextChange(payAmountText);
      _this4.props.onSelectedPlan(plan);
      _this4.setState({
        showEmiPlans: false,
        showEmiPlanDetails: true,
        selectedPlan: plan,
        isValidPlan: true
      });
      _this4.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ stopScroll: false });
      _this4.props.cache.setData(constants["a" /* CACHE */].EMI_PLANS, requestPayload);
    }).catch(function (err) {
      _this4.setState({ loader: false });
      Object(logger["log"])({
        eventType: constants["b" /* EVENTS */].SC_EMI_APPLY_PLAN_ERROR,
        error: err
      });
      _this4.props.onSelectedPlan(null);
      var locale = Object(common["e" /* clientMessage */])(constant["m" /* PAYMODE */].EMI.toLowerCase(), _this4.props.cache);
      _this4.setState({
        loader: false,
        bankError: true,
        errorHeading: locale.error.emiPlanError,
        errorSubText: err.message || locale.error.emiPlanSubtext
      });
    });
  };

  this.setEmiPlan = function (plan) {
    _this4.props.onSelectedPlan(plan);
    _this4.setState({ selectedPlan: plan });
  };

  this.getCacheCardTokenForSavedCard = function () {
    var mid = _this4.props.cache.getData(constants["a" /* CACHE */].MID);
    var savedCardId = Object(common["q" /* getKey */])(_this4, 'props.option.cardDetails.cardId', '');
    var tokenData = _this4.props.cache.getData(constants["a" /* CACHE */].TOKEN_DATA);
    var token = Object(common["q" /* getKey */])(tokenData, 'token', '');
    var mConfig = _this4.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
    var referenceId = Object(common["q" /* getKey */])(mConfig, 'emiSubvention.referenceId', '');
    var payload = {
      SAVED_CARD_ID: savedCardId,
      MID: mid,
      ACCESS_TOKEN: token,
      CUST_ID: Object(common["q" /* getKey */])(mConfig, 'emiSubvention.customerId', null)
    };
    /* since the content type is application form encoded middleware wont run on it hence the url
    wont have query params mid and reference id so sending it as another object */
    var urlQueryParams = {
      mid: mid,
      referenceId: referenceId
    };
    return new Promise(function (resolve, reject) {
      _this4.props.cache.getData(constants["a" /* CACHE */].API).getCacheCardToken(payload, urlQueryParams).then(function (resp) {
        var status = Object(common["q" /* getKey */])(resp, 'STATUS', 'FAILURE');
        if (status === 'SUCCESS') {
          return resolve(Object(common["q" /* getKey */])(resp, 'TOKEN', null));
        }
        var errorMsg = Object(common["q" /* getKey */])(resp, 'ErrorMsg', '');
        _this4.setState({ loader: false, error: errorMsg });
        return resolve(Object(common["q" /* getKey */])(resp, 'TOKEN', null));
      }).catch(function (err) {
        return reject(err);
      });
    });
  };

  this.hideShowError = function () {
    _this4.setState({ bankError: false, errorHeading: '', errorSubText: '' });
  };
}, sc__temp);


/* harmony default export */ var sc = (Object(preact["connect"])('selected, wallet, selectedEmiPlan, AppStyle, cache, instanceKey', onChange)(sc_SC));
// CONCATENATED MODULE: ./components/bankOrCredit/index.js
var bankOrCredit__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function bankOrCredit__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function bankOrCredit__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function bankOrCredit__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var bankOrCredit__ref3 = Object(preact_min["h"])('span', { className: 'ptm-checkmark' });

var bankOrCredit__ref4 = Object(preact_min["h"])(renewal, null);

var bankOrCredit_BOC = function (_Component) {
  bankOrCredit__inherits(BOC, _Component);

  function BOC(props) {
    bankOrCredit__classCallCheck(this, BOC);

    var _this = bankOrCredit__possibleConstructorReturn(this, _Component.call(this, props));

    _this.hasValidationError = true;
    _this.inputLength = 4;

    _this.submit = function () {
      if (_this.state.passcodeRequired) {
        var payload = _this.props.cache.getData(constants["a" /* CACHE */].API).requestPayload(constant["a" /* API */].PT);
        var tokenData = _this.props.cache.getData(constants["a" /* CACHE */].TOKEN_DATA);
        // payload.data.body = { ...payload.query };
        var reqData = {
          body: {
            type: constants["g" /* default */].SUBMIT,
            targetURL: payload.url + '?' + Object(common["o" /* getEncodedQs */])(payload.query),
            queryParams: payload.query,
            method: payload.method,
            requestData: bankOrCredit__extends({}, payload.data),
            paymode: { id: _this.props.option.id, type: _this.props.option.type },
            paymentMode: _this.props.paymentMode,
            guestFlow: tokenData.tokenType !== constant["n" /* TOKEN */].TXN || false // because of use of sso token guest flow will be set to true
          }
        };
        reqData = bankOrCredit__extends({}, reqData.body, payload.data.body);
        reqData.inputLength = 4;
        reqData.shouldPostOpenWindowEvent = _this.hasValidationError;
        Object(logger["log"])({
          eventType: logger["EVENT"].BOC_IFRAME_SUBMIT,
          paymentMode: reqData.paymentMode,
          payMode: _this.props && _this.props.option && _this.props.option.type
        });
        !_this.hasValidationError && Object(formPost["c" /* openPopUpWindow */])(_this.props.cache);
        _this.frame && _this.frame.postDataToIframe(reqData);
      } else {
        var _payload = {
          paymentMode: _this.props.paymentMode,
          authMode: constants["g" /* default */]['3D'],
          selectedPaymentModeId: _this.props.option.id
        };
        _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: constants["g" /* default */].PROCESSING });
        Object(logger["log"])({
          eventType: logger["EVENT"].BOC_SUBMIT,
          paymentMode: _payload.paymentMode,
          payMode: _this.props && _this.props.option && _this.props.option.type
        });
        _this.props.cache.getData(constants["a" /* CACHE */].API).pay(_payload).then(function (res) {
          var notifyMerchant = Object(common["q" /* getKey */])(_this.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG), 'handler.notifyMerchant', undefined);
          if (Object(common["q" /* getKey */])(res, 'body.resultInfo.resultStatus', undefined) === 'S') {} else {
            var errorMsg = Object(common["q" /* getKey */])(res, 'body.resultInfo.resultMsg', constants["g" /* default */].GENERIC_ERROR);
            if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
              notifyMerchant(constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.PAYMENT_ERROR, res);
            }
            _this.setState({ showError: true, errorText: errorMsg });
          }
          /* if postpaid is called just call handle after pay as it is as a normal function */
          if (_this.props.paymentMode === constants["g" /* default */].POSTPAID) {
            _this.handleAfterPay(res);
          } else {
            Object(formPost["f" /* postInWindow */])(_this.handleAfterPay(res), _this.props.cache);
          }
        }).catch(function (err) {
          var notifyMerchant = Object(common["q" /* getKey */])(_this.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG), 'handler.notifyMerchant', undefined);
          if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
            notifyMerchant(constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.PAYMENT_ERROR, err);
          }
          Object(formPost["f" /* postInWindow */])({}, _this.props.cache);
        });
      }
    };

    _this.fetchBalance = function () {
      _this.props.cache.getData(constants["a" /* CACHE */].API).balance(_this.props.paymentMode).then(function (res) {
        var balanceInfo = Object(common["q" /* getKey */])(res, 'body.balanceInfo', undefined);
        if (balanceInfo) {
          var insufficientBalance = void 0;
          if (balanceInfo.value > 0) {
            _this.setState({
              insufficientBalance: false,
              balanceFetched: true,
              balanceData: balanceInfo
            });
            insufficientBalance = false;
          } else {
            _this.setState({
              balanceFetched: true,
              insufficientBalance: true
            });
            insufficientBalance = true;
          }
          Object(logger["log"])({
            eventType: logger["EVENT"].BALANCE_CHECKED,
            paymode: _this.props.paymentMode,
            insufficientBalance: insufficientBalance
          });
          _this.props.onPayChange(true);
        } else if (Object(common["q" /* getKey */])(res, 'body.resultInfo.resultStatus') === 'F') {
          var errorMsg = Object(common["q" /* getKey */])(res, 'body.resultInfo.resultMsg', constants["g" /* default */].GENERIC_ERROR);
          _this.setState({ showError: true, errorText: errorMsg });
        }
      }).catch(function (err) {
        var errorMsg = Object(common["q" /* getKey */])(err, 'body.resultInfo.resultMsg', undefined);
        _this.setState({ showError: true, errorText: errorMsg });
      });
    };

    _this.checkForSufficientBalance = function () {
      var paymentOptions = bankOrCredit__extends({}, _this.props.cache.getData('paymentOptions'));
      var amountPayable = Object(common["c" /* calculateAmountPayable */])(_this.props.cache.getData(constants["g" /* default */].TXN_AMOUNT), paymentOptions.wallet, false, _this.props.subscription);
      var balanceInfo = _this.state.balanceData;
      if (parseFloat(amountPayable) > parseFloat(balanceInfo.value)) {
        var errorMsg = Object(common["q" /* getKey */])(_this.props, 'initializeObject.messageObj.label.insufficientBalance', 'You do not have enough balance for this payment');
        _this.setState({
          showError: true,
          errorText: errorMsg,
          sufficientBalanceForPaymentChecked: true
        });
        _this.props.onPayChange(false);
      } else {
        _this.setState({ showError: false, errorText: '', sufficientBalanceForPaymentChecked: true });
        _this.state.balanceFetched ? _this.props.onPayChange(true) : _this.props.onPayChange(false);
      }
    };

    _this.messageHandler = function (event) {
      if (!_this.props.cache.getData(constants["a" /* CACHE */].STORE) || Object(common["q" /* getKey */])(event, 'data.calledFrom') !== 'passcode' || Object(common["q" /* getKey */])(event, 'data.instanceKey') !== _this.props.instanceKey) {
        return;
      }

      if (Object(common["q" /* getKey */])(event, 'data.paymode.id', undefined) === _this.props.option.id) {
        switch (event.data && event.data.type) {
          case constants["g" /* default */].PAY_SUCCESS:
            {
              var payload = Object(common["q" /* getKey */])(event, 'data.response', {});
              Object(formPost["f" /* postInWindow */])(_this.handleAfterPay(payload), _this.props.cache);
              Object(logger["log"])({ eventType: logger["EVENT"].BOC_EVENT_PAY_SUCCESS });
              break;
            }
          // in case of payment fail show error
          case constants["g" /* default */].PAY_FAIL:
            {
              var data = event.data.response;
              Object(logger["log"])({ eventType: logger["EVENT"].BOC_EVENT_PAY_FAIL });
              _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: '' });
              if (Object(common["q" /* getKey */])(data, 'body.resultInfo.resultStatus', '') === 'F' && Object(common["q" /* getKey */])(data, 'body.resultInfo.retry', '') === false) {
                if (Object(common["q" /* getKey */])(data, 'body.txnInfo.RESPCODE', '') === '1006' || Object(common["q" /* getKey */])(data, 'body.resultInfo.resultCode', '') === '1006') {
                  _this.props.onOverlayValueChange('');
                  var mConfig = _this.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
                  var notifyMerchant = Object(common["q" /* getKey */])(mConfig, 'handler.notifyMerchant', undefined);
                  if (notifyMerchant && notifyMerchant.constructor === Function) {
                    notifyMerchant(constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.SESSION_EXPIRED, data);
                  }
                  _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ sessionExpired: true });
                } else {
                  data.body.content = data.body.txnInfo;
                  Object(formPost["b" /* handlePostData */])(data, _this.props.cache);
                }
              } else if (Object(common["q" /* getKey */])(data, 'body.resultInfo.resultStatus') === 'F' && Object(common["q" /* getKey */])(data, 'body.resultInfo.retry') === true) {
                _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({
                  overlayValue: constants["g" /* default */].RETRY,
                  retryMessage: Object(common["q" /* getKey */])(data, 'body.resultInfo.resultMsg')
                });

                //  in case of reyr get fallback token from cache and set current access token
                //  and remove txn token to fetch new txn token
                if (_this.props.cache.getData(constants["g" /* default */].IS_EMISUBVENTION_ACCESS_TOKEN_FLOW)) {
                  var _mConfig = _this.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
                  var tokenData = _this.props.cache.getData(constants["a" /* CACHE */].FALLBACK_TOKEN_DATA, {
                    token: Object(common["q" /* getKey */])(_mConfig, 'data.token', ''),
                    tokenType: constant["n" /* TOKEN */].ACCESS
                  });
                  _this.props.cache.setData(constants["a" /* CACHE */].TOKEN_DATA, {
                    token: tokenData.token,
                    tokenType: tokenData.tokenType
                  });
                }
              }
              Object(formPost["f" /* postInWindow */])(data, _this.props.cache, _this.props.cache);
              break;
            }
          case 'payerror':
            {
              Object(logger["log"])({ eventType: logger["EVENT"].BOC_EVENT_PAY_ERROR });
              if (_this.state.payError) {
                _this.setState({ showError: false, errorText: '', payError: false });
              }
              Object(formPost["f" /* postInWindow */])({}, _this.props.cache);
              break;
            }
          case constants["g" /* default */].CLIENT_VALIDATION:
            {
              Object(logger["log"])({ eventType: logger["EVENT"].BOC_EVENT_CLIENT_VALIDATION });
              Object(formPost["f" /* postInWindow */])({}, _this.props.cache);
              break;
            }
          case constants["g" /* default */].SHOW_PROCESSING:
            {
              Object(logger["log"])({ eventType: logger["EVENT"].BOC_EVENT_SHOW_PROCESSING });
              _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: constants["g" /* default */].PROCESSING });
              break;
            }
          case constants["g" /* default */].SET_VALIDATION_STATUS:
            {
              _this.hasValidationError = Object(common["q" /* getKey */])(event, 'data.hasError');
              break;
            }
          case constants["g" /* default */].OPEN_POPUP_WINDOW:
            {
              var paymodeId = Object(common["q" /* getKey */])(event, 'data.paymode.id', null);
              var optionId = Object(common["q" /* getKey */])(_this.props, 'option.id', null);
              /* if the paymode id recieved from iframe is same as that of option id then only open the popup */
              if (paymodeId === optionId) {
                Object(logger["log"])({ eventType: logger["EVENT"].POPUP_WINDOW });
                Object(formPost["c" /* openPopUpWindow */])(_this.props.cache);
              }
              break;
            }
          case constants["g" /* default */].GET_TXN_TOKEN_PAYLOAD:
            {
              Object(logger["log"])({ eventType: logger["EVENT"].BOC_GET_TXN_TOKEN_PAYLOAD });
              _this.props.cache.getData(constants["a" /* CACHE */].API).getAsyncPayload(constant["a" /* API */].PT, _this.hasValidationError).then(function (payload) {
                if (_this.state.passcodeRequired) {
                  var _tokenData = _this.props.cache.getData(constants["a" /* CACHE */].TOKEN_DATA);
                  var config = _this.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
                  var orderId = _this.props.cache.getData(constants["a" /* CACHE */].ORDER_ID);
                  if (config && config.flow === constant["h" /* FLOW */].DEFERRED) {
                    payload.data.body.orderId = orderId;
                    payload.query.orderId = orderId;
                  }

                  var reqData = {
                    body: {
                      type: constants["g" /* default */].SUBMIT_WITH_TOKEN,
                      targetURL: payload.url + '?' + Object(common["o" /* getEncodedQs */])(payload.query),
                      queryParams: payload.query,
                      method: payload.method,
                      requestData: bankOrCredit__extends({}, payload.data),
                      paymode: { id: _this.props.option.id, type: _this.props.option.type },
                      paymentMode: _this.props.paymentMode,
                      authMode: constants["g" /* default */].OTP,
                      selectedPaymentModeId: _this.props.option.id,
                      guestFlow: _tokenData.tokenType !== constant["n" /* TOKEN */].TXN || false // because of use of sso token guest flow will be set to true
                    }
                  };
                  reqData = bankOrCredit__extends({}, payload.data.body, reqData.body);
                  reqData.inputLength = 4;

                  _this.frame && _this.frame.postDataToIframe(reqData);
                } else {
                  var payloadObj = {
                    paymentMode: _this.props.paymentMode,
                    authMode: constants["g" /* default */]['3D'],
                    selectedPaymentModeId: _this.props.option.id
                  };
                  var _config = _this.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
                  var _orderId = _this.props.cache.getData(constants["a" /* CACHE */].ORDER_ID);
                  if (_config && _config.flow === constant["h" /* FLOW */].DEFERRED) {
                    payloadObj.data.body.orderId = _orderId;
                    payloadObj.query.orderId = _orderId;
                  }

                  Object(logger["log"])({
                    eventType: logger["EVENT"].BOC_SUBMIT,
                    paymentMode: payload.paymentMode,
                    payMode: _this.props && _this.props.option && _this.props.option.type
                  });
                  _this.props.cache.getData(constants["a" /* CACHE */].API).pay(payload).then(function (res) {
                    var notifyMerchant = Object(common["q" /* getKey */])(_this.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG), 'handler.notifyMerchant', undefined);
                    if (Object(common["q" /* getKey */])(res, 'body.resultInfo.resultStatus', undefined) === 'S') {} else {
                      var errorMsg = Object(common["q" /* getKey */])(res, 'body.resultInfo.resultMsg', constants["g" /* default */].GENERIC_ERROR);
                      if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
                        notifyMerchant(constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.PAYMENT_ERROR, res);
                      }
                      _this.setState({ showError: true, errorText: errorMsg });
                    }
                    Object(formPost["f" /* postInWindow */])(_this.handleAfterPay(res), _this.props.cache);
                  }).catch(function (err) {
                    var notifyMerchant = Object(common["q" /* getKey */])(_this.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG), 'handler.notifyMerchant', undefined);
                    if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
                      notifyMerchant(constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.PAYMENT_ERROR, err);
                    }
                    Object(formPost["f" /* postInWindow */])({}, _this.props.cache);
                  });
                }
              }).catch(function () {
                // close processing screen
                _this.props.onOverlayValueChange('');
              });
              break;
            }
          default:
            {
              break;
            }
        }
      }
    };

    _this.handleAfterPay = function (response) {
      /* if paymode is postpaid just handle response like in case of wallet */
      if (_this.props.paymentMode === constants["g" /* default */].POSTPAID) {
        var _getKey = Object(common["q" /* getKey */])(response, 'body', {}),
            callBackUrl = _getKey.callBackUrl,
            txnInfo = _getKey.txnInfo;

        response.body.content = txnInfo;
        response.body.callbackUrl = callBackUrl;
        Object(formPost["b" /* handlePostData */])(response, _this.props.cache);
        return response;
      }

      var _getKey2 = Object(common["q" /* getKey */])(response, 'body.bankForm.redirectForm', {}),
          actionUrl = _getKey2.actionUrl,
          content = _getKey2.content;

      response.body.content = content;
      response.body.callbackUrl = actionUrl;
      return response;
    };

    _this.enableButton = function () {
      return true;
    };

    _this.onOptionSelect = function (option) {
      _this.props.onOptionSelect(option);
    };

    _this.frame = undefined;
    _this.state = {
      insufficientBalance: true,
      balanceData: {},
      iframeError: false,
      balanceFetched: false,
      passcodeRequired: _this.props.passcodeRequired,
      showError: false,
      errorText: '',
      payError: false,
      genericErrorMsg: constants["g" /* default */].GENERIC_ERROR,
      sufficientBalanceForPaymentChecked: false // adding this variable so that on component did update we can check whether to call for sifficient amount check
    };
    return _this;
  }

  BOC.prototype.componentDidMount = function componentDidMount() {
    this.fetchBalance();
  };

  BOC.prototype.componentDidUpdate = function componentDidUpdate(previousProps) {
    if (this.props.option && this.props.selected && this.props.option.id !== this.props.selected.id) {
      if (this.state.showError) this.setState({
        showError: false,
        errorText: '',
        sufficientBalanceForPaymentChecked: false
      });
    }
    /*
    on paymode change sufficientBalanceForPaymentChecked msg in set state to false since in add and pay
    sufficientBalanceForPaymentChecked was set true hence sufficient balance was not being called and pay button remained
    enabled in case of insufficient balance also
    * */
    if (Object(common["q" /* getKey */])(this.props, 'option.id') !== Object(common["q" /* getKey */])(this.props, 'selected.id') && this.state.sufficientBalanceForPaymentChecked) {
      this.setState({ sufficientBalanceForPaymentChecked: false });
    }

    var walletUsed = Object(common["q" /* getKey */])(this.props, 'wallet.isUsed', false);
    var payEnabled = Object(common["q" /* getKey */])(this.props, 'payEnabled', false);
    var previousPropsWalletUsed = Object(common["q" /* getKey */])(previousProps, 'wallet.isUsed', false);
    var previousPropsPayEnabled = Object(common["q" /* getKey */])(previousProps, 'payEnabled', false);
    /*
     * if wallet is toggled or the sufficientBalanceForPaymentChecked is false
     * (on paymode change sufficientBalanceForPaymentChecked msg in state is set to false)
     * also checking for payenabled since pay button is being disabled but when pcf is called paybutton
     * is being enabled again  so checking if paybutton val has changed from previous value then
     * also check for sufficient balance
     *  */

    if (this.props.option && this.props.selected && this.props.option.id === this.props.selected.id && Object(common["j" /* equalsIgnoreCase */])(Object(common["q" /* getKey */])(this.props.selected, 'paymentMode'), this.props.paymentMode) && (!this.state.sufficientBalanceForPaymentChecked || walletUsed !== previousPropsWalletUsed || payEnabled !== previousPropsPayEnabled)) {
      this.checkForSufficientBalance();
    }
  };

  BOC.prototype.render = function render(_ref, _ref2) {
    var _this2 = this;

    var option = _ref.option,
        isActive = _ref.isActive,
        initializeObject = _ref.initializeObject,
        isPromoAvailable = _ref.isPromoAvailable,
        offers = _ref.offers,
        paymentMode = _ref.paymentMode,
        instanceKey = _ref.instanceKey;
    var insufficientBalance = _ref2.insufficientBalance,
        balanceFetched = _ref2.balanceFetched,
        balanceData = _ref2.balanceData,
        passcodeRequired = _ref2.passcodeRequired,
        showError = _ref2.showError,
        errorText = _ref2.errorText;

    var offer = isPromoAvailable ? option && isActive ? Object(common["q" /* getKey */])(offers, paymentMode) : Object(common["q" /* getKey */])(option, 'paymentOfferDetails') : null;

    if (initializeObject) {
      initializeObject = bankOrCredit__extends({}, initializeObject, { instanceKey: instanceKey, inputLength: this.inputLength });
    }
    /* using string fromcodepoint to convert the entity to javascript object */
    var label = initializeObject.messageObj && initializeObject.messageObj.label.availableBalance;
    label = Object(common["h" /* convertRupeeCharToUnicode */])(label);

    return Object(preact_min["h"])(
      'div',
      {
        className: 'ptm-pay-method ptm-w100-ib checkout-bank-credit-' + paymentMode + ' boc-' + paymentMode,
        id: 'checkout-bank-credit',
        ref: function ref(componentRef) {
          _this2.componentRef = componentRef;
        }
      },
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-radio-wrap' },
        Object(preact_min["h"])(
          'label',
          { className: 'ptm-lbl' },
          Object(preact_min["h"])('input', {
            type: 'radio',
            name: 'verify' + instanceKey,
            className: 'ptm-margin0',
            checked: isActive,
            onClick: function onClick() {
              _this2.onOptionSelect(option);
            }
          }),
          bankOrCredit__ref3,
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-pay-method-cont' },
            Object(preact_min["h"])(
              'p',
              { className: 'ptm-paymode-name' },
              option.displayName,
              ' '
            ),
            !balanceFetched && Object(preact_min["h"])(
              'p',
              { className: 'ptm-small-txt-link', onClick: function onClick() {
                  return _this2.fetchBalance();
                } },
              initializeObject.messageObj && initializeObject.messageObj.label.checkBalance
            ),
            !insufficientBalance && balanceFetched && balanceData && balanceData.value && Object(preact_min["h"])(
              'p',
              { className: 'ptm-small-txt' },
              label,
              Object(common["g" /* commas */])(balanceData.value)
            ),
            insufficientBalance && balanceFetched && Object(preact_min["h"])(
              'p',
              { className: 'ptm-small-txt ptm-msg-red' },
              initializeObject.messageObj && initializeObject.messageObj.label.insufficientBalance
            )
          )
        )
      ),
      option && isActive && !insufficientBalance && balanceFetched && passcodeRequired && this.enableButton() && Object(preact_min["h"])(iframe_Iframe, bankOrCredit__extends({
        ref: function ref(r) {
          return _this2.frame = r;
        },
        classname: 'ptm-ppb-iframe',
        option: option,
        postMessageHandler: this.messageHandler,
        src: Object(common["U" /* staticPath */])() + '/assets/iframes/passcode.html'
      }, { initializeObject: initializeObject })),
      offer && Object(preact_min["h"])(offers_paymodeOffer, { offer: offer, applied: isActive }),
      option && isActive && bankOrCredit__ref4,
      showError && isActive ? Object(preact_min["h"])(
        'p',
        { className: 'ptm-msg-red ptm-ppbl-msg' },
        errorText
      ) : null
    );
  };

  return BOC;
}(preact_min["Component"]);

/* harmony default export */ var bankOrCredit = (Object(preact["connect"])('selected, wallet, payEnabled, cache, instanceKey, subscription', onChange)(bankOrCredit_BOC));
// CONCATENATED MODULE: ./components/ppb/index.js
var ppb__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function ppb__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ppb__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ppb__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ppb_PPB = function (_Component) {
  ppb__inherits(PPB, _Component);

  function PPB(props) {
    ppb__classCallCheck(this, PPB);

    var _this = ppb__possibleConstructorReturn(this, _Component.call(this, props));

    _this.submit = function () {
      typeof _this.boc._component.submit === 'function' && _this.boc._component.submit() || typeof _this.boc.submit === 'function' && _this.boc.submit();
    };

    var _this$props$cache$get = _this.props.cache.getData(constants["a" /* CACHE */].API).requestPayload(constant["a" /* API */].PT),
        url = _this$props$cache$get.url,
        query = _this$props$cache$get.query,
        method = _this$props$cache$get.method,
        data = _this$props$cache$get.data;

    data.body = ppb__extends({}, query);
    var newStyle = '\n    .ptm-card-input{\n      border-color:' + _this.props.AppStyle.borderColor + ';\n    }\n    .ptm-card-input::placeholder{\n      color:' + _this.props.AppStyle.bodyColor + ';\n    }\n      .ptm-card-input:focus{\n        border-color:' + _this.props.AppStyle.themeBackgroundColor + ';\n        caret-color:' + _this.props.AppStyle.themeBackgroundColor + ';\n        color:' + _this.props.AppStyle.bodyColor + ';\n      }\n    ';
    var Locale = Object(common["e" /* clientMessage */])(constant["m" /* PAYMODE */].PAYMENT_BANK.toLowerCase(), _this.props.cache);
    _this.state = {
      initializeObject: {
        type: 'INITIALIZE',
        paymode: {
          type: _this.props.option.type,
          id: _this.props.option.id
        },
        requestPayload: {
          targetURL: url + '?' + Object(common["o" /* getEncodedQs */])(query),
          queryParams: query,
          requestData: data,
          method: method
        },
        style: newStyle,
        messageObj: {
          label: Locale.label,
          error: Locale.error
        }
      }
    };
    return _this;
  }

  PPB.prototype.render = function render(_ref, _ref2) {
    var _this2 = this;

    var option = _ref.option,
        isActive = _ref.isActive,
        onOptionSelect = _ref.onOptionSelect,
        offers = _ref.offers,
        isPromoAvailable = _ref.isPromoAvailable;
    var initializeObject = _ref2.initializeObject;

    return Object(preact_min["h"])(bankOrCredit, ppb__extends({ option: option, isActive: isActive, onOptionSelect: onOptionSelect, offers: offers, isPromoAvailable: isPromoAvailable }, {
      paymentMode: constants["g" /* default */].PPBL,
      ref: function ref(r) {
        return _this2.boc = r;
      },
      passcodeRequired: true
    }, { initializeObject: initializeObject }));
  };

  return PPB;
}(preact_min["Component"]);

/* harmony default export */ var ppb = (Object(preact["connect"])('AppStyle, cache')(ppb_PPB));
// CONCATENATED MODULE: ./components/postpaid/index.js
var postpaid__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function postpaid__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function postpaid__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function postpaid__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var postpaid_PDC = function (_Component) {
  postpaid__inherits(PDC, _Component);

  function PDC(props) {
    postpaid__classCallCheck(this, PDC);

    var _this = postpaid__possibleConstructorReturn(this, _Component.call(this, props));

    _this.submit = function () {
      typeof _this.boc._component.submit === 'function' && _this.boc._component.submit() || typeof _this.boc.submit === 'function' && _this.boc.submit();
    };

    var locale = Object(common["e" /* clientMessage */])(constant["m" /* PAYMODE */].POSTPAID.toLowerCase(), _this.props.cache);
    _this.state = {
      initializeObject: {
        type: 'INITIALIZE',
        messageObj: {
          label: locale.label,
          error: locale.error
        }
      }
    };
    return _this;
  }

  PDC.prototype.render = function render(_ref, _ref2) {
    var _this2 = this;

    var option = _ref.option,
        onOptionSelect = _ref.onOptionSelect,
        isActive = _ref.isActive,
        offers = _ref.offers,
        isPromoAvailable = _ref.isPromoAvailable;
    var initializeObject = _ref2.initializeObject;

    return Object(preact_min["h"])(bankOrCredit, postpaid__extends({ option: option, isActive: isActive, onOptionSelect: onOptionSelect, offers: offers, isPromoAvailable: isPromoAvailable }, {
      paymentMode: constants["g" /* default */].POSTPAID,
      ref: function ref(r) {
        return _this2.boc = r;
      },
      passcodeRequired: option.passcodeRequired
    }, { initializeObject: initializeObject }));
  };

  return PDC;
}(preact_min["Component"]);

/* harmony default export */ var postpaid = (Object(preact["connect"])('cache')(postpaid_PDC));
// CONCATENATED MODULE: ./components/emiBankList/index.js




var emiBankList_EmiBankList = function EmiBankList(props) {
  var emiBankDetails = props.cache.getData(constants["a" /* CACHE */].EMI_BANK_LIST);
  return Object(preact_min["h"])(
    'div',
    { className: 'ptm-emi-dropdown-wrap' },
    Object(preact_min["h"])(
      'div',
      { className: 'ptm-close-wrap ptm-pos-a', onClick: props.hideBankList },
      Object(preact_min["h"])('span', { className: 'ptm-cross ptm-pos-r' })
    ),
    Object(preact_min["h"])(
      'div',
      { className: 'ptm-emi-bankcard-wrapper ptm-pos-r' },
      emiBankDetails && emiBankDetails.map(function (emiTypeBanks) {
        return Object(preact_min["h"])(
          'div',
          { className: 'ptm-emi-type-block' },
          Object(preact_min["h"])(
            'h3',
            { 'class': 'ptm-body-bg ptm-body-color' },
            emiTypeBanks.displayLabel
          ),
          emiTypeBanks.cardTypes.map(function (card) {
            return Object(preact_min["h"])(
              'div',
              {
                className: 'ptm-emi-bankcard ptm-pos-r nb-border',
                onClick: function onClick() {
                  props.closeBankList(card);
                }
              },
              Object(preact_min["h"])(
                'div',
                { className: 'ptm-emi-cardimg ptm-pos-a ptm-global-border' },
                Object(preact_min["h"])('img', {
                  className: 'ptm-margin0 ptm-centralized ptm-pos-a',
                  src: card.bankLogoUrl,
                  alt: card.bankCode
                })
              ),
              Object(preact_min["h"])(
                'span',
                { className: 'ptm-body-color ' + (card.isDisabled ? 'ptm-disabledCard' : '') },
                card.displayName ? card.displayName : card.bankName
              ),
              card.isDisabled && Object(preact_min["h"])(
                'p',
                { className: 'ptm-low-success' },
                'Emi option is not available'
              )
            );
          })
        );
      })
    )
  );
};

/* harmony default export */ var components_emiBankList = (Object(preact["connect"])('cache')(emiBankList_EmiBankList));
// CONCATENATED MODULE: ./components/emi/index.js
var components_emi__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var emi__class, emi__temp, emi__initialiseProps;



function emi__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function emi__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function emi__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var emi__ref3 = Object(preact_min["h"])('span', { className: 'ptm-checkmark' });

var emi__ref4 = Object(preact_min["h"])(components_loader, null);

var emi__ref5 = Object(preact_min["h"])('span', { className: 'ptm-checkmark' });

var emi__ref6 = Object(preact_min["h"])(components_loader, null);

var emi__ref7 = Object(preact_min["h"])(components_loader, null);

var emi_EMI = (emi__temp = emi__class = function (_Component) {
  emi__inherits(EMI, _Component);

  function EMI(props) {
    emi__classCallCheck(this, EMI);

    var _this = emi__possibleConstructorReturn(this, _Component.call(this, props));

    emi__initialiseProps.call(_this);

    var locale = Object(common["e" /* clientMessage */])(constant["m" /* PAYMODE */].CARD.toLowerCase(), _this.props.cache);
    var emiLocale = Object(common["e" /* clientMessage */])(constant["m" /* PAYMODE */].EMI.toLowerCase(), _this.props.cache);

    var _this$props$cache$get = _this.props.cache.getData(constants["a" /* CACHE */].API).requestPayload(constant["a" /* API */].BIN),
        query = _this$props$cache$get.query,
        data = _this$props$cache$get.data;

    data.body = components_emi__extends({}, query);
    var payloadData = _this.props.cache.getData(constants["a" /* CACHE */].API).requestPayload(constant["a" /* API */].CARD_DETAILS);
    var fetchCardQuery = payloadData.query;
    var fetchCardData = payloadData.data;
    fetchCardData.body = components_emi__extends({}, fetchCardQuery);
    var newStyle = '.ptm-card-input:focus{\n      border-color:' + _this.props.AppStyle.themeBackgroundColor + ';\n      caret-color:' + _this.props.AppStyle.themeBackgroundColor + ';\n    }\n    #mm:focus+span+input+p.hidden-border,#yy:focus+p.hidden-border{\n      background:' + _this.props.AppStyle.themeBackgroundColor + ';\n      border-color:transparent;\n    }\n    .ptm-change-plan{\n      background:' + _this.props.AppStyle.bodyBackgroundColor + ';\n      border:1px solid ' + (_this.props.AppStyle.borderColor || '#86a0c2') + ';\n    }\n    .card-content{\n      border-color:' + _this.props.AppStyle.borderColor + ';\n      color:' + _this.props.AppStyle.bodyColor + ';\n    }\n    .ptm-card-input,.ptm-emi-bank-select,.card-expiry{\n      border-color:' + _this.props.AppStyle.borderColor + ';\n      color:' + _this.props.AppStyle.bodyColor + ';\n    }\n    \n    .ptm-emi-bank-select:after{\n      border-color:' + _this.props.AppStyle.borderColor + ';\n    }\n    .ptm-msg-red {\n      color: #ff585d;\n    }\n    #changeCard,#changePlan{\n      color:' + _this.props.AppStyle.themeBackgroundColor + ';\n    }\n    .ptm-card-input::placeholder,#save-card-container,.ptm-paymode-name,.ptm-total-amount,.ptm-emi-cal,#shortCardNumber,.slash{\n      color:' + _this.props.AppStyle.bodyColor + ';\n    }\n    .hidden-border{\n      background-color: ' + _this.props.AppStyle.borderColor + ';\n    }\n    .ptm-check, .ptm-container:hover input ~ .ptm-check{\n      border-color: ' + _this.props.AppStyle.bodyColor + ';\n    }\n    .ptm-container input:checked ~ .ptm-check{\n      background-color: ' + _this.props.AppStyle.themeBackgroundColor + ';\n      border: 2px solid ' + _this.props.AppStyle.themeBackgroundColor + ';\n    }';
    var isEmiSubventionFlow = _this.props.cache.getData(constants["g" /* default */].IS_EMISUBVENTION_ACCESS_TOKEN_FLOW);
    var mConfig = _this.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
    _this.state = {
      showBankList: false,
      showSavedCard: false,
      savedCardPayMode: null,
      bankLabel: 'Select Bank',
      useAnotherCard: false,
      showEmiPlans: false,
      selectedPlan: null,
      planDetails: null,
      selectedCard: null,
      bankError: false,
      initializeObject: {
        type: 'INITIALIZE',
        paymode: {
          type: _this.props.option.type,
          id: _this.props.option.id
        },
        requestPayload: Object(common["p" /* getIframeRequestPayload */])(_this.props.cache, constant["a" /* API */].BIN),
        requestCacheCardTokenPayload: isEmiSubventionFlow ? Object(common["p" /* getIframeRequestPayload */])(_this.props.cache, constant["a" /* API */].CACHE_CARD_TOKEN) : {},
        // in case it is emi subvention flow do not call card Details since after card completion two api calls would be going unncecessarily
        requestCardDetailsPayload: !isEmiSubventionFlow ? Object(common["p" /* getIframeRequestPayload */])(_this.props.cache, constant["a" /* API */].CARD_DETAILS) : {},
        style: newStyle,
        messageObj: {
          label: locale.label,
          error: locale.error,
          emiLabel: emiLocale.label,
          emiError: emiLocale.error
        },
        instanceKey: _this.props.instanceKey,
        isEmiSubventionFlow: isEmiSubventionFlow,
        customerId: Object(common["q" /* getKey */])(mConfig, 'emiSubvention.customerId', null),
        mid: _this.props.cache.getData(constants["a" /* CACHE */].MID)
      },
      loader: false,
      errorHeading: '',
      errorSubText: '',
      bankListError: ''
    };
    _this.frame = undefined;
    return _this;
  }

  EMI.prototype.getApplyPromoBaseRequestPayload = function getApplyPromoBaseRequestPayload() {
    if (!offers_isPromoAvailable(this.props.cache)) {
      return null;
    }

    var mConfig = this.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
    var customerId = Object(common["q" /* getKey */])(mConfig, 'emiSubvention.customerId', null);
    var payload = Object(common["p" /* getIframeRequestPayload */])(this.props.cache, constant["a" /* API */].APPLY_PROMO);
    payload.requestData.body = components_emi__extends({}, payload.requestData.body, getApplyPromoBaseRequestObj(this.props.cache, customerId));

    return payload;
  };

  EMI.prototype.updateinitializeObject = function updateinitializeObject() {
    var _this2 = this;

    this.setState(function (prevState) {
      return {
        initializeObject: components_emi__extends({}, prevState.initializeObject, {
          applyPromoRequestPayload: _this2.getApplyPromoBaseRequestPayload()
        })
      };
    });
  };

  // focusOnHiddenInput = () => {
  //   setTimeout(() => {
  //     const hiddenInput = document.getElementById('ptm-hidden-input');
  //     isMobileDevice() && !isIphoneDevice() && hiddenInput && hiddenInput.focus();
  //   }, 50);
  // };

  EMI.prototype.componentDidUpdate = function componentDidUpdate(previousProps) {
    // when paymode is changed reset all data
    var optionId = Object(common["q" /* getKey */])(this.props, 'option.id', null);
    var selectedId = Object(common["q" /* getKey */])(this.props, 'selected.id', null);
    var previousPropsWallet = Object(common["q" /* getKey */])(previousProps, 'wallet', null);
    var currentPropsWallet = Object(common["q" /* getKey */])(this.props, 'wallet', null);
    if (optionId && selectedId && optionId === selectedId && previousPropsWallet && currentPropsWallet && currentPropsWallet.isUsed !== previousPropsWallet.isUsed) {
      this.setState({ selectedPlan: null, showEmiPlanDetails: false });
      this.frame && this.frame && this.frame.postDataToIframe({
        type: constants["g" /* default */].HIDE_SAVED_CARD_AND_PLAN,
        paymode: { id: this.props.option.id, type: this.props.option.type }
      });
      this.props.onSelectedPlan(null);
    }
    if (selectedId && optionId && optionId !== selectedId) {
      if (this.state.bankLabel !== 'Select Bank') {
        this.setState({
          bankLabel: 'Select Bank',
          showSavedCard: false,
          savedCardPayMode: null,
          selectedCard: null,
          useAnotherCard: false
        });
        this.props.onSelectedPlan(null);
      }
      /* if option has changed then remove the local selected plan from payment */
      if (!this.props.selectedEmiPlan && this.state.selectedPlan) {
        this.setState({ selectedPlan: null });
      }
    }
  };

  EMI.prototype.getSelectedEmiBankMatchedSavedCards = function getSelectedEmiBankMatchedSavedCards(savedInstruments, cardType, bankCode) {
    return (savedInstruments || []).reduce(function (acc, cur) {
      if (Object(common["q" /* getKey */])(cur, 'cardDetails.cardType') === cardType && cur.issuingBank === bankCode && cur.isEmiAvailable) {
        var newPayMode = components_emi__extends({}, cur, {
          id: 'emi-' + cur.id,
          isEmiSc: true
        });
        delete newPayMode.reference;
        acc.push(newPayMode);
      }
      return acc;
    }, []);
  };

  EMI.prototype.disableWallet = function disableWallet(paymentOptions) {
    var wallet = components_emi__extends({}, paymentOptions.wallet, { isUsed: false });
    this.props.cache.setData(constants["a" /* CACHE */].PAYMENT_OPTIONS, components_emi__extends({}, paymentOptions, {
      wallet: wallet
    }));
    this.props.onWalletToggle(wallet);
  };

  // scrollToInputField = () => {
  // const iframeOffsetTop = getKey(this.frame, 'iframe.offsetTop', 0);
  // scrollWithTimeout(iframeOffsetTop, 0);
  // };

  EMI.prototype.render = function render(_ref, _ref2) {
    var _this3 = this;

    var option = _ref.option,
        instanceKey = _ref.instanceKey,
        selected = _ref.selected,
        isActive = _ref.isActive,
        offers = _ref.offers,
        cache = _ref.cache;
    var showBankList = _ref2.showBankList,
        bankLabel = _ref2.bankLabel,
        savedCardPayMode = _ref2.savedCardPayMode,
        showSavedCard = _ref2.showSavedCard,
        useAnotherCard = _ref2.useAnotherCard,
        initializeObject = _ref2.initializeObject,
        showEmiPlans = _ref2.showEmiPlans,
        selectedCard = _ref2.selectedCard,
        showMiniCart = _ref2.showMiniCart,
        selectedPlan = _ref2.selectedPlan,
        loader = _ref2.loader,
        bankError = _ref2.bankError,
        errorSubText = _ref2.errorSubText,
        errorHeading = _ref2.errorHeading,
        bankListError = _ref2.bankListError,
        error = _ref2.error;

    var planDetails = cache.getData(constants["a" /* CACHE */].PLAN_DETAILS);
    var locale = Object(common["e" /* clientMessage */])(constant["m" /* PAYMODE */].EMI.toLowerCase(), cache);
    var emiFrameInitData = components_emi__extends({}, initializeObject);
    var onOptionSelect = this.onOptionSelect;

    var emiOffer = Object(common["q" /* getKey */])(offers, constant["m" /* PAYMODE */].EMI);

    var isEmiSubventionFlow = cache.getData(constants["g" /* default */].IS_EMISUBVENTION_ACCESS_TOKEN_FLOW);
    var miniCart = cache.getData(constants["g" /* default */].SUBVENTION_MINI_CART_OBJ);
    return Object(preact_min["h"])(
      'div',
      {
        className: 'ptm-emi-main',
        ref: function ref(componentRef) {
          _this3.componentRef = componentRef;
        }
      },
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-pay-method ptm-w100-ib' },
        Object(preact_min["h"])(
          'div',
          {
            className: 'ptm-radio-wrap ptm-pt11',
            onClick: function onClick() {
              onOptionSelect(option);
            }
          },
          Object(preact_min["h"])(
            'label',
            { className: 'ptm-lbl', htmlFor: 'emi-radio' },
            Object(preact_min["h"])('input', {
              type: 'radio',
              name: 'verify-emi' + instanceKey,
              id: 'emi-radio',
              checked: isActive
            }),
            emi__ref3,
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-pay-method-cont' },
              Object(preact_min["h"])(
                'p',
                { className: 'ptm-paymode-name' },
                'EMI'
              )
            )
          )
        ),
        option && isActive && Object(preact_min["h"])(
          'div',
          { className: 'ptm-emi-innermain' },
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-emi-inner ptm-emi-innerwrap' },
            Object(preact_min["h"])(
              'div',
              {
                className: 'ptm-emi-bank-select ptm-pos-r ptm-input-common ptm-select-bank ptm-body-color',
                onClick: this.getBankList
              },
              Object(preact_min["h"])(
                'span',
                { className: 'ptm-emi-bank-txt ptm-body-color' },
                bankLabel
              ),
              loader && bankLabel === 'Select Bank' && Object(preact_min["h"])(
                'div',
                { className: 'ptm-select-loader' },
                emi__ref4
              )
            ),
            bankListError && Object(preact_min["h"])(
              'div',
              { className: 'ptm-small-txt ptm-msg-red banklist-error' },
              bankListError
            ),
            showSavedCard && savedCardPayMode.map(function (option, index) {
              var isDisplay = true;
              var isActive = !!(selected.subOption && selected.subOption.id === option.id && !useAnotherCard);
              return Object(preact_min["h"])(sc, components_emi__extends({
                isEmi: true,
                key: index,
                useAnotherCard: useAnotherCard
              }, {
                option: option,
                isDisplay: isDisplay,
                isActive: isActive,
                onOptionSelect: onOptionSelect
              }, {
                ref: function ref(k) {
                  option.reference = k;
                }
              }));
            }),
            selectedCard && Object(preact_min["h"])(
              'div',
              {
                className: 'ptm-radio-wrap ptm-pt11',
                id: 'use-another-card',
                onClick: function onClick() {
                  _this3.selectNewCard();
                }
              },
              Object(preact_min["h"])(
                'label',
                { className: 'ptm-lbl' },
                Object(preact_min["h"])('input', {
                  type: 'radio',
                  name: 'verify' + instanceKey,
                  id: 'use-another-card-radio',
                  checked: useAnotherCard
                }),
                emi__ref5,
                Object(preact_min["h"])(
                  'div',
                  { className: 'ptm-pay-method-cont' },
                  Object(preact_min["h"])(
                    'p',
                    { className: 'ptm-paymode-name' },
                    'Use Another Card'
                  )
                )
              )
            ),
            useAnotherCard && Object(preact_min["h"])(iframe_Iframe, {
              ref: function ref(r) {
                return _this3.frame = r;
              },
              classname: 'ptm-card-iframe',
              unload: this.updateIframeHeight,
              postMessageHandler: this.messageHandler,
              src: Object(common["U" /* staticPath */])() + '/assets/iframes/emi.html',
              initializeObject: emiFrameInitData
            }),
            error && Object(preact_min["h"])(
              'p',
              { className: 'ptm-small-txt ptm-msg-red' },
              error
            )
          ),
          showBankList && Object(preact_min["h"])(
            'div',
            { className: 'ptm-emi-overlay' },
            Object(preact_min["h"])(
              components_OverlayWrap,
              null,
              Object(preact_min["h"])(components_emiBankList, {
                hideBankList: this.hideBankList,
                closeBankList: this.closeBankList
              })
            ),
            loader && Object(preact_min["h"])(
              'div',
              { className: 'ptm-loader-overlay' },
              Object(preact_min["h"])(
                'div',
                { className: 'ptm-inn-load-wrap ptm-centralized ptm-pos-a' },
                emi__ref6
              )
            )
          ),
          showEmiPlans && Object(preact_min["h"])(
            'div',
            { className: 'ptm-emi-overlay' },
            Object(preact_min["h"])(
              components_OverlayWrap,
              null,
              Object(preact_min["h"])(components_emiPlans, {
                planDetails: planDetails,
                hideEmiPlans: this.hideEmiPlans,
                setEmiPlan: this.setEmiPlan,
                showMiniCart: this.showMiniCart,
                selectEmiPlan: this.selectEmiPlan,
                miniCart: miniCart
              })
            ),
            loader && Object(preact_min["h"])(
              'div',
              { className: 'ptm-loader-overlay' },
              Object(preact_min["h"])(
                'div',
                { className: 'ptm-inn-load-wrap ptm-centralized ptm-pos-a' },
                emi__ref7
              )
            )
          ),
          showMiniCart && (planDetails.cart || isEmiSubventionFlow && miniCart) && selectedPlan && Object(preact_min["h"])(
            'div',
            { className: 'ptm-emi-overlay' },
            Object(preact_min["h"])(
              components_OverlayWrap,
              null,
              Object(preact_min["h"])(components_miniCart, {
                cart: planDetails.cart,
                selectedPlan: selectedPlan,
                closeMiniCart: this.closeMiniCart,
                isEmiSubventionFlow: isEmiSubventionFlow,
                miniCart: miniCart
              })
            )
          ),
          bankError && Object(preact_min["h"])(
            'div',
            { className: 'ptm-emi-overlay-bank-error' },
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-modal-wrapper ptm-body-bg' },
              Object(preact_min["h"])(
                'div',
                { className: 'ptm-excl-box ptm-pos-r' },
                Object(preact_min["h"])(
                  'span',
                  { className: 'ptm-centralized ptm-pos-a' },
                  '!'
                )
              ),
              Object(preact_min["h"])(
                'h2',
                { className: 'ptm-body-color' },
                errorHeading
              ),
              Object(preact_min["h"])(
                'p',
                { className: 'ptm-body-color' },
                errorSubText
              ),
              Object(preact_min["h"])(
                'button',
                { onClick: this.hideShowError },
                locale.error.errorBtn
              )
            )
          ),
          emiOffer && Object(preact_min["h"])(offers_paymodeOffer, { offer: emiOffer })
        ),
        Object(preact_min["h"])('p', { className: 'ptm-global-bottom-border' })
      )
    );
  };

  return EMI;
}(preact_min["Component"]), emi__initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.hasValidationError = true;
  this.hiddenInputRef = '';

  this.getBankList = function () {
    if (!_this4.props.cache.getData(constants["a" /* CACHE */].EMI_BANK_LIST)) {
      _this4.setState({ loader: true });
      // get call from cart for getting the bank list
      Object(logger["log"])({
        eventType: constants["b" /* EVENTS */].EMI_FETCH_BANK
      });
      var subventionObject = _this4.props.cache.getData(constants["g" /* default */].SUBVENTION_OBJ);
      emiApi(_this4.props.cache).getBankList(subventionObject).then(function (emiBankList) {
        /* in case of 3rd party EMI subvention returning error for the same */
        _this4.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ stopScroll: true });
        _this4.setState({ showBankList: true, loader: false, bankListError: '' });
        _this4.props.cache.setData(constants["a" /* CACHE */].EMI_BANK_LIST, emiBankList);
      }).catch(function (error) {
        Object(logger["log"])({
          eventType: constants["b" /* EVENTS */].EMI_FETCH_BANK_ERROR,
          error: error
        });
        _this4.props.cache.setData(constants["a" /* CACHE */].EMI_BANK_LIST, null);
        _this4.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ stopScroll: false });
        _this4.setState({
          showBankList: false,
          loader: false,
          bankListError: error.message
        });
        var config = _this4.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
        var notifyMerchant = Object(common["q" /* getKey */])(config, 'handler.notifyMerchant', undefined);
        if (notifyMerchant && notifyMerchant.constructor === Function) {
          notifyMerchant(constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.FETCH_EMI_BANK_LIST_ERROR, error.message);
        }
      });
    } else {
      _this4.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ stopScroll: true });
      _this4.setState({ showBankList: true, bankListError: '' });
    }
  };

  this.onOptionSelect = function (option) {
    var paymentOptions = components_emi__extends({}, _this4.props.cache.getData('paymentOptions'));
    if (option.isHybridDisabled && Object(common["q" /* getKey */])(_this4.props, 'wallet.isUsed', false) && Object(common["z" /* isHybridOrAddNPay */])(paymentOptions, _this4.props.cache)) {
      var emiLocale = Object(common["e" /* clientMessage */])(constant["m" /* PAYMODE */].EMI.toLowerCase(), _this4.props.cache);
      var wallet = components_emi__extends({}, paymentOptions.wallet, { isUsed: false });
      paymentOptions.wallet = wallet;
      var txnAmount = _this4.props.cache.getData(constants["g" /* default */].TXN_AMOUNT);
      var amountPayable = Object(common["c" /* calculateAmountPayable */])(txnAmount, paymentOptions.wallet);
      _this4.props.cache.setData(constants["a" /* CACHE */].PAYMENT_OPTIONS, paymentOptions);
      _this4.props.onWalletToggle(wallet);
      var text = Object(common["q" /* getKey */])(emiLocale, 'label.emiHybridDisabledText', 'Paytm Balance and EMI cannot be used together for this payment');
      _this4.props.onNotificationTextChange(text);
      _this4.props.onBtnTextChange(en["a" /* default */].payButton.text + amountPayable);
    }
    /* if selected type is sc */
    if (option.type === 'sc') {
      _this4.setState({ showSavedCard: true, useAnotherCard: false, error: '' });
    }
    _this4.props.onOptionSelect(option);
    _this4.props.onPayChange(true);
  };

  this.hideBankList = function () {
    _this4.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ stopScroll: false });
    _this4.setState({ showBankList: false });
  };

  this.closeBankList = function (cardData) {
    // if card is disabled prevent the click
    if (cardData.isDisabled) {
      return;
    }
    var request = {
      bankCode: cardData.bankCode,
      cardType: cardData.cardType,
      bankName: cardData.bankName,
      bankLogoUrl: cardData.bankLogoUrl
    };
    _this4.setState({ loader: true, error: '', activeBank: request });
    Object(logger["log"])({
      eventType: constants["b" /* EVENTS */].EMI_FETCH_PLANS,
      bankCode: request.bankCode,
      cardType: request.cardType
    });
    _this4.props.updateSelectedPayModePcfWithInstId(cardData.bankCode);
    request = Object(common["Y" /* updatePayloadForTenureEMI */])(_this4.props.cache, request);
    emiApi(_this4.props.cache).getEmiPlans(request).then(function (response) {
      _this4.setState({ showBankList: false, loader: false });
      var emiPlans = response.emiPlans,
          isHybridDisabled = response.isHybridDisabled;


      if (emiPlans) {
        var paymentOptions = components_emi__extends({}, _this4.props.cache.getData('paymentOptions'));
        var savedInstruments = Object(common["q" /* getKey */])(paymentOptions, 'merchantPayOption.savedInstruments', []);
        _this4.props.cache.setData(constants["a" /* CACHE */].PLAN_DETAILS, response);
        _this4.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ stopScroll: false });
        _this4.props.onSelectedPlan(null);

        if (_this4.frame) {
          _this4.frame.postDataToIframe({ type: constants["g" /* default */].REMOVE_CARD_NUMBER });
          _this4.frame.postDataToIframe({ type: constants["g" /* default */].HIDE_SAVED_CARD_AND_PLAN });
          /* if frame exists after selecting bank scroll to the same */
          // this.scrollToInputField();
        }

        if (isHybridDisabled) {
          _this4.disableWallet(paymentOptions);
        }

        var bankCode = emiPlans.bankCode,
            cardType = emiPlans.cardType,
            bankName = emiPlans.bankName;

        if (bankCode && cardType && bankName) {
          var matchedEmiBankSavedCards = _this4.getSelectedEmiBankMatchedSavedCards(savedInstruments, cardType, bankCode);

          if (matchedEmiBankSavedCards && matchedEmiBankSavedCards.length) {
            _this4.props.onOptionSelect(matchedEmiBankSavedCards[0]);
            _this4.setState({
              bankLabel: bankName,
              showSavedCard: true,
              savedCardPayMode: matchedEmiBankSavedCards,
              selectedCard: true,
              useAnotherCard: false
            });
            // const defaultSelectedPaymodeOffSetTop = getKey(
            //   this.props.selected,
            //   'reference._component.componentRef.offsetTop',
            //   0
            // );
            /* scrolling 131 which is the height of sc with cvv iframe */
            // scrollWithTimeout(defaultSelectedPaymodeOffSetTop + 131);
          } else {
            /* if new card is alredy being used and on bank change again post msg to iframe */
            if (_this4.state.useAnotherCard) {
              _this4.postMessageToHideCVVExpiry();
            }
            _this4.setState({
              bankLabel: bankName,
              useAnotherCard: true,
              selectedCard: false,
              savedCardPayMode: null,
              showSavedCard: false
            });
            _this4.updateinitializeObject();
          }
        } else {
          _this4.setBankError(cardData);
        }
      } else {
        _this4.setBankError(cardData);
      }
    }).catch(function (err) {
      Object(logger["log"])({
        eventType: constants["b" /* EVENTS */].EMI_FETCH_PLANS_ERROR,
        error: err.message
      });
      _this4.hideLoaderInIframe();
      _this4.setBankError(cardData);
    });
  };

  this.setBankError = function (cardData) {
    var emiBankList = _this4.props.cache.getData(constants["a" /* CACHE */].EMI_BANK_LIST);
    // finding the index of the emi type in emi bank list
    var index = Object(common["m" /* findIndex */])(emiBankList, function (list) {
      return list.type === cardData.emiType;
    });
    emiBankList[index].cardTypes.forEach(function (card) {
      if (card.cardType === cardData.cardType && card.bankCode === cardData.bankCode) {
        // setting the disabled key for the bank to show in bank list
        card.isDisabled = true;
      }
    });
    _this4.props.cache.setData(constants["a" /* CACHE */].EMI_BANK_LIST, emiBankList);

    var locale = Object(common["e" /* clientMessage */])(constant["m" /* PAYMODE */].EMI.toLowerCase(), _this4.props.cache);
    _this4.setState({
      loader: false,
      bankError: true,
      errorHeading: locale.error.emiBankListErrorHeading,
      errorSubText: locale.error.emiBankListErrorSubtext
    });
  };

  this.hideEmiPlans = function () {
    _this4.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ stopScroll: false });
    _this4.setState({ showEmiPlans: false });
  };

  this.getEMIPlans = function (payload) {
    _this4.setState({ loader: true, error: '' });
    Object(logger["log"])({
      eventType: constants["b" /* EVENTS */].EMI_FETCH_PLANS,
      bankCode: payload.bankCode,
      cardType: payload.cardType
    });
    payload = Object(common["Y" /* updatePayloadForTenureEMI */])(_this4.props.cache, payload);
    emiApi(_this4.props.cache).getEmiPlans(payload).then(function (data) {
      _this4.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ stopScroll: true });
      _this4.setState({ loader: false });
      _this4.props.cache.setData(constants["a" /* CACHE */].PLAN_DETAILS, data);
      _this4.setState({ showEmiPlans: true });
      _this4.hideLoaderInIframe();
    }).catch(function (err) {
      Object(logger["log"])({
        eventType: constants["b" /* EVENTS */].EMI_FETCH_PLANS_ERROR,
        error: err.message
      });
      _this4.hideLoaderInIframe();
      _this4.setState({ error: err.message, loader: false });
    });
  };

  this.hideLoaderInIframe = function () {
    var postMessageIframeObj = {
      type: constants["g" /* default */].HIDE_RING_LODER
    };
    _this4.frame && _this4.frame.postDataToIframe(postMessageIframeObj);
  };

  this.messageHandler = function (event) {
    if (!_this4.props.cache.getData(constants["a" /* CACHE */].STORE) || Object(common["q" /* getKey */])(event, 'data.calledFrom') !== 'emi' || Object(common["q" /* getKey */])(event, 'data.instanceKey') !== _this4.props.instanceKey) {
      return;
    }

    var notifyMerchant = Object(common["q" /* getKey */])(_this4.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG), 'handler.notifyMerchant', undefined);

    if (typeof Object(common["q" /* getKey */])(event, 'data.type') === 'string') {
      switch (event.data.type) {
        case constants["g" /* default */].PAY_SUCCESS:
          {
            _this4.props.onOverlayValueChange(constants["g" /* default */].PROCESSING);
            var response = Object(common["q" /* getKey */])(event, 'data.response', undefined);

            var _getKey = Object(common["q" /* getKey */])(response, 'body.bankForm.redirectForm', {}),
                actionUrl = _getKey.actionUrl,
                content = _getKey.content;

            response.body.content = content;
            response.body.callbackUrl = actionUrl;
            Object(formPost["f" /* postInWindow */])(response, _this4.props.cache);
            break;
          }
        case constants["g" /* default */].PAY_FAIL:
          {
            var data = event.data.response;
            if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
              notifyMerchant(constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.PAYMENT_ERROR, data);
            }
            if (Object(common["q" /* getKey */])(data, 'body.resultInfo.resultStatus') === 'F' && Object(common["q" /* getKey */])(data, 'body.resultInfo.retry') === false) {
              data.body.content = data.body.txnInfo;
              Object(formPost["b" /* handlePostData */])(data, _this4.props.cache);
            } else if (Object(common["q" /* getKey */])(data, 'body.resultInfo.resultStatus') === 'F' && Object(common["q" /* getKey */])(data, 'body.resultInfo.retry') === true) {
              _this4.props.cache.getData(constants["a" /* CACHE */].STORE).setState({
                overlayValue: constants["g" /* default */].RETRY,
                retryMessage: Object(common["q" /* getKey */])(data, 'body.resultInfo.resultMsg')
              });

              //  in case of reyr get fallback token from cache and set current access token
              //  and remove txn token to fetch new txn token
              if (_this4.props.cache.getData(constants["g" /* default */].IS_EMISUBVENTION_ACCESS_TOKEN_FLOW)) {
                var mConfig = _this4.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
                var tokenData = _this4.props.cache.getData(constants["a" /* CACHE */].FALLBACK_TOKEN_DATA, {
                  token: Object(common["q" /* getKey */])(mConfig, 'data.token', ''),
                  tokenType: constant["n" /* TOKEN */].ACCESS
                });
                _this4.props.cache.setData(constants["a" /* CACHE */].TOKEN_DATA, {
                  token: tokenData.token,
                  tokenType: tokenData.tokenType
                });
              }
            }
            Object(formPost["f" /* postInWindow */])(data, _this4.props.cache);
            break;
          }
        case constants["g" /* default */].SESSION_EXPIRED:
          {
            if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
              notifyMerchant(constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.SESSION_EXPIRED, {
                message: constants["g" /* default */].SESSION_EXPIRED
              });
            }
            _this4.props.onOverlayValueChange('');
            break;
          }
        case constants["g" /* default */].SHOW_PROCESSING:
          {
            _this4.props.onOverlayValueChange(constants["g" /* default */].PROCESSING);
            break;
          }
        case constants["g" /* default */].INITIALIZED:
          {
            _this4.postMessageToHideCVVExpiry();
            break;
          }
        case 'CARD_NUMBER_FOCUS':
          {
            // this.scrollToInputField();
            break;
          }
        case constants["g" /* default */].HIDECN:
          {
            _this4.frame && _this4.frame.postDataToIframe({
              type: constants["g" /* default */].HIDECN,
              paymode: { id: _this4.props.option.id, type: _this4.props.option.type }
            });
            break;
          }
        case constants["g" /* default */].HIDECVVEXPIRY:
          {
            _this4.frame && _this4.frame.postDataToIframe({
              type: constants["g" /* default */].HIDECVVEXPIRY,
              paymode: { id: _this4.props.option.id, type: _this4.props.option.type }
            });
            break;
          }
        case constants["g" /* default */].SHOW_EMI_PLAN_LIST:
          {
            _this4.setCardDetailsAndCallEmiPlans(event);
            break;
          }
        case constants["g" /* default */].CLIENT_VALIDATION:
          Object(logger["log"])({ eventType: logger["EVENT"].CARD_EVENT_CLIENT_VALIDATION });
          Object(formPost["f" /* postInWindow */])({}, _this4.props.cache); // close popup window as client side validation failed
          break;
        case constants["g" /* default */].CARD_NOT_SUPPORTED:
          {
            Object(logger["log"])({
              eventType: 'Checkout_Card_Pay_Error',
              error: constants["g" /* default */].CARD_NOT_SUPPORTED
            });
            break;
          }
        case constants["g" /* default */].SET_VALIDATION_STATUS:
          {
            _this4.hasValidationError = Object(common["q" /* getKey */])(event, 'data.hasError');
            break;
          }
        case constants["g" /* default */].GET_TXN_TOKEN_PAYLOAD:
          {
            _this4.props.cache.getData(constants["a" /* CACHE */].API).getAsyncPayload(constant["a" /* API */].PT, _this4.hasValidationError).then(function (payload) {
              var tokenData = _this4.props.cache.getData(constants["a" /* CACHE */].TOKEN_DATA);
              var config = _this4.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
              var orderId = _this4.props.cache.getData(constants["a" /* CACHE */].ORDER_ID);
              if (config && config.flow === constant["h" /* FLOW */].DEFERRED) {
                payload.data.body.orderId = orderId;
                payload.query.orderId = orderId;
              }
              var emiPlans = _this4.props.cache.getData(constants["a" /* CACHE */].EMI_PLANS);
              payload.data.body = components_emi__extends({}, payload.data.body, payload.query);
              var reqData = {
                paymentMode: constant["m" /* PAYMODE */].EMI,
                type: constants["g" /* default */].SUBMIT_WITH_TOKEN,
                targetURL: payload.url + '?' + Object(common["o" /* getEncodedQs */])(payload.query),
                queryParams: payload.query,
                method: payload.method,
                requestData: components_emi__extends({}, payload.data),
                paymode: { id: _this4.props.option.id, type: _this4.props.option.type },
                guestFlow: tokenData.tokenType !== constant["n" /* TOKEN */].TXN || false,
                isEmi: true,
                planId: emiPlans && emiPlans.pgPlanId
              };
              _this4.frame && _this4.frame.postDataToIframe(reqData);
            }).catch(function () {
              _this4.props.onOverlayValueChange('');
            });
            break;
          }
        case constants["g" /* default */].HELPER_TYPE.CVV_HELPER:
          {
            Object(logger["log"])({ eventType: logger["EVENT"].CARD_EVENT_CVV_HELPER });
            _this4.props.onHelperOverlayToggle(constants["g" /* default */].HELPER_TYPE.CVV_HELPER);
            break;
          }
        case constants["g" /* default */].UPDATE_HEIGHT:
          {
            _this4.updateIframeHeight(event.data.height);
            break;
          }
        case constants["g" /* default */].LOG_CARD_DETAILS:
          {
            Object(logger["log"])(components_emi__extends({ eventType: logger["EVENT"].CARD_EVENT_CARD_DETAILS }, event.data.detail));
            break;
          }
        case constants["g" /* default */].HANDLE_PROMO_RESPONSE:
          {
            if (event.data.error) {
              _this4.props.handlePromoErrorFromCard(event.data.error, event.data.payMethod, event.data.bankCode);
            } else {
              _this4.props.handlePromoResponseFromCard(event.data.response, event.data.bankCode);
            }
            break;
          }
        case constants["g" /* default */].CVV_EXPIRY_FOCUS:
          {
            // const iframeOffsetTop = getKey(this.frame, 'iframe.offsetTop', 0);
            // scrollWithTimeout(iframeOffsetTop + 100);

            break;
          }
        case constants["g" /* default */].CACHE_CARD_TOKEN:
          {
            var token = Object(common["q" /* getKey */])(event, 'data.token', null);
            _this4.props.cache.setData(constants["g" /* default */].CACHE_CARD_TOKEN, token);
            break;
          }
        case constants["g" /* default */].CARD_NUMBER_RESET:
          /* on card number reset remove any error if any */
          _this4.setState({ error: '' });
          break;
        default:
          {
            break;
          }
      }
    }
  };

  this.updateIframeHeight = function () {
    var height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    var iframe = Object(common["q" /* getKey */])(_this4.frame, 'iframe');
    if (iframe) {
      iframe.style.minHeight = height;
    }
  };

  this.setCardDetailsAndCallEmiPlans = function (event) {
    var planDetails = _this4.props.cache.getData(constants["a" /* CACHE */].PLAN_DETAILS);
    var paymentIntent = [];
    if (_this4.props.wallet && _this4.props.wallet.isUsed) {
      paymentIntent.push({
        mode: constant["m" /* PAYMODE */].WALLET,
        txnAmount: _this4.props.wallet.walletBalance
      });
    }
    var cardDetails = Object(common["q" /* getKey */])(event, 'data.cardDetails', null);
    var binDetail = Object(common["q" /* getKey */])(event, 'data.cardDetails.details.binDetail', null);
    if (cardDetails && cardDetails.cardHash && binDetail) {
      paymentIntent.push({
        banks: [event.data.cardDetails.details.binDetail.issuingBankCode],
        cardHash: event.data.cardDetails.cardHash,
        channels: [event.data.cardDetails.details.binDetail.channelName],
        mode: constant["m" /* PAYMODE */].EMI,
        mode_type: event.data.cardDetails.details.binDetail.paymentMode,
        txnAmount: _this4.props.wallet && _this4.props.wallet.isUsed ? planDetails.payableAmount - _this4.props.wallet.walletBalance : planDetails.payableAmount
      });
      var payload = {
        bankCode: _this4.state.activeBank.bankCode,
        bankName: _this4.state.activeBank.bankName,
        cardType: _this4.state.activeBank.cardType,
        payment_intent: paymentIntent
      };
      _this4.props.cache.setData(constants["a" /* CACHE */].PAYMENT_INTENT, paymentIntent);
      _this4.setState({ payment_intent: paymentIntent, cardDetails: event.data.cardDetails });
      _this4.getEMIPlans(payload);
    } else {
      _this4.setState({ cardDetails: cardDetails });
      var _payload = {
        bankCode: _this4.state.activeBank.bankCode,
        bankName: _this4.state.activeBank.bankName,
        cardType: _this4.state.activeBank.cardType
      };
      _this4.getEMIPlans(_payload);
    }
  };

  this.selectNewCard = function () {
    _this4.props.setEmiOfferNull();
    _this4.setState({ useAnotherCard: true, error: '', loader: false });
    _this4.updateinitializeObject();
    /* on selecting new card setting emi plan in store to nul to fix the emi html height issue */
    _this4.props.onSelectedPlan(null);
  };

  this.setEmiPlan = function (plan) {
    _this4.setState({ selectedPlan: plan });
  };

  this.selectEmiPlan = function (plan) {
    _this4.setState({ loader: true });
    var itemHash = {};
    _this4.props.onSelectedPlan(plan);
    var planDetails = components_emi__extends({}, _this4.props.cache.getData(constants["a" /* CACHE */].PLAN_DETAILS));
    var paymentIntent = _this4.props.cache.getData(constants["a" /* CACHE */].PAYMENT_INTENT);

    Object(common["q" /* getKey */])(planDetails, 'cart.cart_items', []).map(function (item) {
      var offerId = Object(common["q" /* getKey */])(item, 'emi_offers.' + plan.planId + '.offerId');
      itemHash[item.item_id] = offerId ? { offer_id: offerId } : {};
      return item;
    });

    var requestPayload = {
      plan_id: plan.planId,
      pgPlanId: plan.pgPlanId,
      item_map: itemHash,
      payment_intent: paymentIntent,
      bankCode: planDetails.bankCode,
      planId: plan.planId // adding a duplicate since in another place this needs to be used and camel case is not being allowed by eslint
    };

    Object(logger["log"])({
      eventType: constants["b" /* EVENTS */].EMI_APPLY_PLAN,
      plan_id: plan.planId,
      item_map: itemHash
    });

    /* check for plans gratification to check whether the planselected is standard emi or subvented emi */
    var gratifications = Object(common["q" /* getKey */])(plan, 'gratifications', []);
    var isStandardEmi = !gratifications.length;
    requestPayload = Object(common["Z" /* updatePayloadForValidateEMI */])(_this4.props.cache, plan, requestPayload, _this4.props.cache.getData(constants["g" /* default */].CACHE_CARD_TOKEN));
    /* if plan selected is not subvented emi call default flow function in case of validate emi that
     is  not to make validate emi api call */
    emiApi(_this4.props.cache, isStandardEmi).applyEmi(requestPayload).then(function (_ref8) {
      var apiResponse = _ref8.apiResponse,
          hasEmiPlans = _ref8.hasEmiPlans,
          fallBackAmount = _ref8.fallBackAmount,
          txnAmount = _ref8.txnAmount;

      if (apiResponse) {
        var emiSubventionToken = apiResponse.emiSubventionToken;

        _this4.props.cache.setData(constants["g" /* default */].EMISUBVENTION_TOKEN, emiSubventionToken);
      }

      _this4.setState({ loader: false });

      if (!hasEmiPlans) {
        _this4.setState({
          bankError: true,
          errorHeading: 'Error',
          errorSubText: 'Selected Plan is not offered by bank'
        });
        return;
      }

      var paymentOptions = _this4.props.cache.getData('paymentOptions');
      var walletObj = components_emi__extends({}, paymentOptions.wallet);
      _this4.props.cache.setData(constants["g" /* default */].FALLBACK_TXN_AMOUNT, fallBackAmount);
      _this4.props.cache.setData(constants["g" /* default */].TXN_AMOUNT, txnAmount);
      _this4.props.setPayableAmount(null, walletObj, paymentOptions, null, true);
      var gratification = Object(common["q" /* getKey */])(plan, 'gratifications', null);
      if (gratification) {
        gratification = gratification[0];
      }

      var emiText = 'EMI of \u20B9' + plan.emi + ' for ' + plan.interval + ' months @ ' + plan.rate + '% p.a.';
      var totalText = 'Total \u20B9 ' + plan.effectivePrice;

      /* using string fromcodepoint to convert the entity to javascript object */
      emiText = Object(common["h" /* convertRupeeCharToUnicode */])(emiText);
      totalText = Object(common["h" /* convertRupeeCharToUnicode */])(totalText);
      var postMessageIframeObj = {
        type: constants["g" /* default */].SHOW_SAVED_CARD_AND_PLAN,
        savedCard: _this4.state.cardDetails,
        plan: plan,
        emiText: emiText,
        total: totalText
      };
      // setTimeout(() => {
      //   this.hiddenInputRef && this.hiddenInputRef.focus();
      // }, 0);

      if (gratification) {
        var gratificationText = 'EMI offer of \u20B9' + gratification.value + ' ' + gratification.label + ' successfully applied';
        gratificationText = Object(common["h" /* convertRupeeCharToUnicode */])(gratificationText);
        postMessageIframeObj.gratification = gratificationText;
      }

      _this4.frame && _this4.frame.postDataToIframe(postMessageIframeObj);
      _this4.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ stopScroll: false });
      _this4.setState({ showEmiPlans: false, selectedPlan: plan, error: null });
      _this4.props.cache.setData(constants["a" /* CACHE */].EMI_PLANS, requestPayload);
    }).catch(function (err) {
      Object(logger["log"])({
        eventType: constants["b" /* EVENTS */].EMI_APPLY_PLAN_ERROR,
        error: err
      });
      _this4.props.onSelectedPlan(null);
      var locale = Object(common["e" /* clientMessage */])(constant["m" /* PAYMODE */].EMI.toLowerCase(), _this4.props.cache);
      _this4.setState({
        loader: false,
        bankError: true,
        errorHeading: locale.error.emiPlanError,
        errorSubText: err.message || locale.error.emiPlanSubtext
      });
    });
  };

  this.showMiniCart = function (plan) {
    _this4.setState({ showMiniCart: true, selectedPlan: plan });
  };

  this.closeMiniCart = function () {
    _this4.setState({ showMiniCart: false });
  };

  this.submit = function () {
    if (_this4.state.useAnotherCard) {
      var tokenData = _this4.props.cache.getData(constants["a" /* CACHE */].TOKEN_DATA);
      var payload = _this4.props.cache.getData(constants["a" /* CACHE */].API).requestPayload(constant["a" /* API */].PT);
      var config = _this4.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
      var orderId = _this4.props.cache.getData(constants["a" /* CACHE */].ORDER_ID);
      if (config && config.flow === constant["h" /* FLOW */].DEFERRED) {
        payload.data.body.orderId = orderId;
        payload.query.orderId = orderId;
      }
      payload.data.body = components_emi__extends({}, payload.query);
      var emiPlans = _this4.props.cache.getData(constants["a" /* CACHE */].EMI_PLANS);
      var reqData = {
        paymentMode: constant["m" /* PAYMODE */].EMI,
        type: constants["g" /* default */].SUBMIT,
        targetURL: payload.url + '?' + Object(common["o" /* getEncodedQs */])(payload.query),
        queryParams: payload.query,
        method: payload.method,
        requestData: components_emi__extends({}, payload.data),
        paymode: { id: _this4.props.option.id, type: _this4.props.option.type },
        isEmi: true,
        planId: emiPlans && emiPlans.pgPlanId,
        guestFlow: tokenData.tokenType !== constant["n" /* TOKEN */].TXN || false
      };
      !_this4.hasValidationError && Object(formPost["c" /* openPopUpWindow */])(_this4.props.cache);
      _this4.frame && _this4.frame.postDataToIframe(reqData);
    } else if (_this4.props.selected && _this4.props.selected.subOption && _this4.props.selected.subOption && _this4.props.selected.subOption.reference) {
      _this4.props.selected.subOption.reference._component.submit();
    }
  };

  this.hideShowError = function () {
    _this4.setState({ bankError: false, errorHeading: '', errorSubText: '' });
  };

  this.postMessageToHideCVVExpiry = function () {
    _this4.frame && _this4.frame.postDataToIframe({
      type: constants["g" /* default */].HIDECVVEXPIRY,
      paymode: { id: _this4.props.option.id, type: _this4.props.option.type }
    });
  };
}, emi__temp);


/* harmony default export */ var emi = (Object(preact["connect"])('selected, AppStyle, wallet, selectedEmiPlan, cache, instanceKey', onChange)(emi_EMI));
// CONCATENATED MODULE: ./components/upipush/index.js


function upipush__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function upipush__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function upipush__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






// import { postInWindow } from '../../utils/formPost';






var upipush__ref3 = Object(preact_min["h"])('span', { 'class': 'ptm-checkmark' });

var upipush__ref4 = Object(preact_min["h"])(renewal, null);

var upipush_UPIPUSH = function (_Component) {
  upipush__inherits(UPIPUSH, _Component);

  function UPIPUSH(props) {
    upipush__classCallCheck(this, UPIPUSH);

    var _this = upipush__possibleConstructorReturn(this, _Component.call(this, props));

    _this.submit = function () {
      var payload = {
        authMode: constants["g" /* default */]['3D'],
        payerAccount: _this.props.option.vpaId,
        paymentMode: constants["g" /* default */].UPI, // on saved vpas to opayment mode has to be sent as upi instead of upi push
        selectedPaymentModeId: _this.props.option.id
      };
      // this.props.onOverlayValueChange(CONSTANTS.PROCESSING);
      _this.props.cache.setData(constants["g" /* default */].IS_BANKPAGE_REQUIRED_BLOCKED, true);
      _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: constants["g" /* default */].PROCESSING });

      upi_proceedToCollectFlow(payload, _this.props.cache, _this.props.option.vpaId).then(function (res) {
        _this.setState(res);
      }).catch(function (err) {
        _this.setState(err);
      });

      // this.props.cache
      //   .getData(CACHE.API)
      //   .pay(payload)
      //   .then(res => {
      //     const notifyMerchant = getKey(
      //       this.props.cache.getData(CACHE.MERCHANT_CONFIG),
      //       'handler.notifyMerchant',
      //       undefined
      //     );
      //     const status = getKey(res, 'body.resultInfo.resultStatus', 'F');
      //     if (status === 'S') {
      //       this.props.cache.getData(CACHE.STORE).setState({ overlayValue: CONSTANTS.PROCESSING });
      //       const { actionUrl, content } = getKey(res, 'body.bankForm.redirectForm', {});
      //       res.body.content = content;
      //       res.body.callbackUrl = actionUrl;
      //     } else {
      //       const errorMsg = getKey(res, 'body.resultInfo.resultMsg', CONSTANTS.GENERIC_ERROR);
      //       if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
      //         notifyMerchant(CONSTANTS.NOTIFY_MERCHANT_EVENTS.PAYMENT_ERROR, res);
      //       }
      //       this.props.onOverlayValueChange('');
      //       this.setState({ showError: true, errorText: errorMsg });
      //     }
      //     postInWindow(res, this.props.cache);
      //   })
      //   .catch(err => {
      //     const errorMsg = getKey(err, 'body.resultInfo.resultMsg', CONSTANTS.GENERIC_ERROR);
      //     const notifyMerchant = getKey(
      //       this.props.cache.getData(CACHE.MERCHANT_CONFIG),
      //       'handler.notifyMerchant',
      //       undefined
      //     );
      //     if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
      //       notifyMerchant(CONSTANTS.NOTIFY_MERCHANT_EVENTS.PAYMENT_ERROR, err);
      //     }
      //     this.props.onOverlayValueChange('');
      //     this.setState({ showError: true, errorText: errorMsg });
      //   });
    };

    _this.onOptionSelect = function (option) {
      _this.props.onOptionSelect(option);
    };

    _this.state = {
      showError: false,
      errorText: '',
      isUpiPollingRequired: false,
      pollingData: {}
    };
    return _this;
  }

  UPIPUSH.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (this.props.option && this.props.selected && this.props.option.id !== this.props.selected.id) {
      if (this.state.showError) this.setState({ showError: false, errorText: '' });
    }
    if (Object(common["q" /* getKey */])(prevState, 'isUpiPollingRequired', false) === true && Object(common["q" /* getKey */])(prevProps, 'isPollingRequired', false) === true && Object(common["q" /* getKey */])(this.props, 'isPollingRequired', true) === false) {
      this.setState({ pollingData: {}, isUpiPollingRequired: false });
    }
  };

  UPIPUSH.prototype.render = function render(_ref, _ref2) {
    var _this2 = this;

    var offers = _ref.offers,
        instanceKey = _ref.instanceKey,
        isPromoAvailable = _ref.isPromoAvailable,
        option = _ref.option,
        isActive = _ref.isActive;
    var showError = _ref2.showError,
        errorText = _ref2.errorText,
        isUpiPollingRequired = _ref2.isUpiPollingRequired,
        pollingData = _ref2.pollingData;

    var upiOffer = isPromoAvailable ? isActive ? Object(common["q" /* getKey */])(offers, constant["m" /* PAYMODE */].UPI) : Object(common["q" /* getKey */])(option, 'paymentOfferDetails') : null;

    return Object(preact_min["h"])(
      'div',
      {
        className: 'ptm-pay-method ptm-w100-ib ' + (isUpiPollingRequired ? 'ptm-pos-s ptm-upipolling-stretched' : ''),
        id: 'checkout-upi-push',
        ref: function ref(componentRef) {
          _this2.componentRef = componentRef;
        }
      },
      Object(preact_min["h"])(
        'div',
        {
          className: 'ptm-radio-wrap ptm-pt11',
          onClick: function onClick() {
            _this2.onOptionSelect(option);
          }
        },
        Object(preact_min["h"])(
          'label',
          { 'class': 'ptm-lbl' },
          Object(preact_min["h"])('input', {
            type: 'radio',
            name: 'verify' + instanceKey,
            checked: isActive,
            className: 'ptm-margin0'
          }),
          upipush__ref3,
          Object(preact_min["h"])(
            'div',
            { 'class': 'ptm-pay-method-cont' },
            Object(preact_min["h"])(
              'p',
              { 'class': 'ptm-paymode-name' },
              Object(preact_min["h"])(
                'span',
                { className: 'ptm-svpa-bank ptm-body-color' },
                option.displayName
              ),
              ' XX',
              option.bankAccountNo,
              Object(preact_min["h"])(
                'span',
                { className: 'ptm-svpa-upi' },
                Object(preact_min["h"])('img', {
                  src: Object(common["U" /* staticPath */])() + '/assets/images/logo-upi.svg',
                  alt: '',
                  className: 'ptm-margin0'
                })
              )
            )
          )
        )
      ),
      upiOffer && Object(preact_min["h"])(offers_paymodeOffer, { offer: upiOffer, applied: isActive }),
      option && isActive && upipush__ref4,
      showError ? Object(preact_min["h"])(
        'p',
        { className: 'ptm-msg-red' },
        errorText
      ) : null,
      pollingData && isUpiPollingRequired && pollingData.vpaID && Object(preact_min["h"])(upipolling, { pollingData: pollingData })
    );
  };

  return UPIPUSH;
}(preact_min["Component"]);

/* harmony default export */ var upipush = (Object(preact["connect"])('selected, cache, instanceKey, isPollingRequired', onChange)(upipush_UPIPUSH));
// EXTERNAL MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/utils/common.js
var utils_common = __webpack_require__("y11t");

// CONCATENATED MODULE: ./controllers/bank-mandate.js
var bank_mandate__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var numberRegex = /^[0-9a-zA-Z]+$/;
var nameRegex = /^[0-9a-zA-Z ]+$/;
var ifscRegex = /^[A-Za-z]{4}[a-zA-Z0-9]{7}$/;

var bank_mandate_setOptedBankData = function setOptedBankData(data) {
  Object(logger["log"])({
    eventType: logger["EVENT"].BM_BANK_SELECT,
    data: {
      payMode: constants["g" /* default */].BM,
      bankSelected: data.channelName,
      bankCode: data.channelCode,
      mandateBankCode: data.mandateBankCode,
      haslowSuccess: Object(common["q" /* getKey */])(data, 'data.hasLowSuccess.status', ''),
      lowSuccessMsg: Object(common["q" /* getKey */])(data, 'data.hasLowSuccess.msg', '')
    }
  });
  return {
    showAccountDetailsScreen: true,
    showBanksScreen: false
  };
};

var bank_mandate_changeBank = function changeBank() {
  Object(logger["log"])({
    eventType: logger["EVENT"].BM_CHANGE_BANK_CLICK,
    payMode: constants["g" /* default */].BM
  });
  return {
    showAccountDetailsScreen: false,
    showBanksScreen: true
  };
};

var setAccountDetails = function setAccountDetails(accountData) {
  var account = {};
  bank_mandate__extends(account, accountData);
  if (account.maskedAccountNumber) {
    account.accountNumber = account.maskedAccountNumber;
  }
  return account;
};

var isBankDetailsEditable = function isBankDetailsEditable(accountData) {
  if (accountData && accountData.accountNumber) {
    return false;
  }
  return true;
};

var displayConfirmationScreen = function displayConfirmationScreen() {
  return {
    showConfirmationScreen: true
  };
};

var accountInpRestricted = function accountInpRestricted(ev) {
  var digit = String.fromCharCode(ev.which);
  if (ev.key !== undefined) {
    digit = ev.key;
  }
  // any other character than alphanumeric
  if (!numberRegex.test(digit)) {
    if (ev.which !== 8 && ev.which !== 9 && ev.which !== 37 && ev.which !== 39) {
      ev.preventDefault();
    }
  }
};

var nameInpRestricted = function nameInpRestricted(ev) {
  var digit = String.fromCharCode(ev.which);
  if (ev.key !== undefined) {
    digit = ev.key;
  }
  // any other character than alphanumeric and space
  if (!nameRegex.test(digit)) {
    if (ev.which !== 8 && ev.which !== 9 && ev.which !== 37 && ev.which !== 39) {
      ev.preventDefault();
    }
  }
};

var validateAuthMode = function validateAuthMode(value) {
  if (!value || value.length < 1) {
    return 'blank';
  }
  return false;
};

var validateMandateAuthDetails = function validateMandateAuthDetails(authMode, authModeData) {
  var stateData = {};
  var _ref = [validateAuthMode(authMode)],
      invalidAuth = _ref[0];

  if (invalidAuth) {
    stateData = { authModeError: authModeData[invalidAuth] };
  }
  var data = { stateData: stateData, submit: false };
  if (!invalidAuth) {
    data.submit = true;
  }
  return data;
};

var bank_mandate_validateAccountNumber = function validateAccountNumber(value) {
  if (!value || value.length < 1) {
    return 'blank';
  }
  if (value.length >= constants["g" /* default */].ACCOUNT_NUMBER_MIN_LENGTH && value.length <= constants["g" /* default */].ACCOUNT_NUMBER_MAX_LENGTH && numberRegex.test(value)) {
    return false;
  }
  return 'invalid';
};

var bank_mandate_validateAccountName = function validateAccountName(value) {
  if (!value || value.length < 1) {
    return 'blank';
  }
  if (value.length >= constants["g" /* default */].ACCOUNT_NAME_MIN_LENGTH && value.length <= constants["g" /* default */].ACCOUNT_NAME_MAX_LENGTH && nameRegex.test(value)) {
    return false;
  }
  return 'invalid';
};

var bank_mandate_validateAccountIfsc = function validateAccountIfsc(value) {
  if (!value || value.length < 1) {
    return 'blank';
  }
  if (value.length === constants["g" /* default */].ACCOUNT_IFSC_LENGTH && ifscRegex.test(value)) {
    return false;
  }
  return 'invalid';
};

var validateAccountDetails = function validateAccountDetails(name, number, ifsc, authMode, nameData, numberData, ifscData, authModeData) {
  var stateData = {};
  var _ref2 = [bank_mandate_validateAccountName(name), bank_mandate_validateAccountNumber(number), bank_mandate_validateAccountIfsc(ifsc), validateAuthMode(authMode)],
      invaildName = _ref2[0],
      invaildNumber = _ref2[1],
      invaildIfsc = _ref2[2],
      invalidAuth = _ref2[3];

  if (invaildName) {
    stateData = { nameError: nameData[invaildName], isNameError: true };
  } else if (invaildNumber) {
    stateData = { numberError: numberData[invaildNumber], isNumberError: true };
  } else if (invaildIfsc) {
    stateData = { ifscError: ifscData[invaildIfsc], isIfscError: true };
  } else if (invalidAuth) {
    stateData = { authModeError: authModeData[invalidAuth], isAuthModeError: true };
  }
  var data = { stateData: stateData, submit: false };
  if (!invaildName && !invaildNumber && !invaildIfsc && !invalidAuth) {
    data.submit = true;
  }
  return data;
};

var updateInputValue = function updateInputValue(ev, currValue, key) {
  var _stateData;

  var value = ev.target.value;

  var regex = key === 'accountHolderName' ? nameRegex : numberRegex;
  var stateData = (_stateData = {}, _stateData[key] = currValue, _stateData);
  if (value === '' || regex.test(value)) {
    var _stateData2;

    stateData = (_stateData2 = {}, _stateData2[key] = value, _stateData2);
  }
  return stateData;
};

var clearFieldError = function clearFieldError(type) {
  var stateData = {};
  if (type === 'name') {
    stateData = { nameError: '', isNameError: false };
  } else if (type === 'number') {
    stateData = { numberError: '', isNumberError: false };
  } else if (type === 'ifsc') {
    stateData = { ifscError: '', isIfscError: false };
  } else if (type === 'authMode') {
    stateData = { authModeError: '', isAuthModeError: false };
  }
  return stateData;
};

var bank_mandate_selectIfscFromBank = function selectIfscFromBank(key, data, cache) {
  Object(logger["log"])({
    eventType: logger["EVENT"].BM_FIND_IFSC_CLICK,
    payMode: constants["g" /* default */].BM,
    bankData: data
  });
  // Capitalise all request params
  for (var prop in data) {
    if (data[prop]) {
      data[prop] = data[prop].toUpperCase();
    }
  }
  return new Promise(function (resolve, reject) {
    if (!cache.getData(key)) {
      getApi(cache).getIfsc(data).then(function (res) {
        if (res && res.statusMessage && res.statusMessage === 'SUCCESS' && res.response) {
          var ifscData = res.response;
          cache.setData(key, ifscData);
          resolve(ifscData);
        } else {
          var _ifscData = constants["g" /* default */].GENERIC_ERROR;
          if (res && res.statusMessage) {
            _ifscData = res.statusMessage;
          }
          reject(_ifscData);
        }
      }).catch(function (res) {
        var ifscData = constants["g" /* default */].GENERIC_ERROR;
        if (res && res.statusMessage) {
          ifscData = res.statusMessage;
        }
        reject(ifscData);
      });
    } else {
      resolve(cache.getData(key));
    }
  });
};

var bank_mandate_validateIfscInput = function validateIfscInput(data, ifscAPIData, cache) {
  for (var prop in data) {
    if (data[prop]) {
      data[prop] = data[prop].toUpperCase();
    }
  }
  if (data.ifscCode === (ifscAPIData && ifscAPIData.toUpperCase())) {
    return Promise.resolve({ ifscCode: ifscAPIData });
  }
  return new Promise(function (resolve, reject) {
    getApi(cache).validateIfsc(data).then(function (res) {
      if (res && res.statusMessage && res.statusMessage === 'SUCCESS' && res.response) {
        var ifscData = res.response;
        resolve(ifscData);
      } else {
        var _ifscData2 = constants["g" /* default */].GENERIC_ERROR;
        if (res && res.statusMessage) {
          _ifscData2 = res.statusMessage;
        }
        reject(_ifscData2);
      }
    }).catch(function (res) {
      var ifscData = constants["g" /* default */].GENERIC_ERROR;
      if (res && res.statusMessage) {
        ifscData = res.statusMessage;
      }
      reject(ifscData);
    });
  });
};
var closeSubsConfirmScreen = function closeSubsConfirmScreen() {
  return { showConfirmationScreen: false, genericError: '', btnDisabled: false };
};

var subsDateFormat = function subsDateFormat(dateStr) {
  var date = '';
  if (dateStr && typeof date === 'string') {
    date = dateStr.split(' ');
    if (date.length === 6) {
      date = Array.prototype.join.call([date[2], date[1], date[5]], ' ');
    } else {
      date = '';
    }
  }
  return date;
};

var bank_mandate_onConfirmSubmit = function onConfirmSubmit(accountDetails, bankData, isSI, cache) {
  var data = {
    body: {
      paymentMode: constants["g" /* default */].BM,
      mandateAuthMode: accountDetails.mandateAuthMode,
      bankIfsc: accountDetails.ifsc,
      accountType: 'OTHERS',
      userName: accountDetails.accountHolderName,
      bankName: bankData.channelName,
      channelCode: bankData.channelCode
    },
    showLoader: true
  };
  if (accountDetails.ifsc) {
    data.body.bankIfsc = accountDetails.ifsc;
  }
  if (isSI) {
    // in case of smb type (saved mandate bank)
    data.body.upiAccRefId = accountDetails.accRefId;
  } else {
    // in other cases
    data.body.accountNumber = accountDetails.accountNumber;
  }

  return new Promise(function (resolve, reject) {
    getApi(cache).pay(data.body).then(function (response) {
      resolve(response);
    }).catch(function (err) {
      var resultStatus = Object(common["q" /* getKey */])(err, 'body.resultInfo.resultStatus');
      var errObj = { genericError: constants["g" /* default */].GENERIC_ERROR, btnDisabled: false };
      if (resultStatus && resultStatus === 'F') {
        var resultMsg = Object(common["q" /* getKey */])(err, 'body.resultInfo.resultMsg');
        errObj.genericError = resultMsg;
      }
      return reject(errObj);
    });
  });
};

var lastFourAccountNumber = function lastFourAccountNumber(number) {
  if (number) {
    return number.substring(number.length - 4);
  }
  return null;
};

// Keep NET BANKING on top
var bank_mandate_sortAuthModes = function sortAuthModes(modes) {
  if (modes && modes.length) {
    var NBMode = modes.filter(function (item) {
      return item === constants["g" /* default */].NB_AUTH_MODE;
    });
    var otherModes = modes.filter(function (item) {
      return item !== constants["g" /* default */].NB_AUTH_MODE;
    });
    return NBMode.concat(otherModes);
  }
  return [];
};

var isAmountZero = function isAmountZero(amt) {
  if (!Number(amt) || Number.isNaN(amt)) {
    return '';
  }
  return amt;
};

var bank_mandate_formatData = function formatData(data) {
  if (!data) {
    data = [];
  }
  data = data.sort(function (first, second) {
    var bankName = first.displayName ? 'displayName' : 'channelName';
    // null check for displayName
    if (!Object(common["q" /* getKey */])(first, 'displayName', false) || Object(utils_common["g" /* isNull */])(first.displayName)) {
      first.displayName = '';
    }
    if (!Object(common["q" /* getKey */])(first, 'channelName', false) || Object(utils_common["g" /* isNull */])(first.channelName)) {
      first.channelName = '';
    }
    if (!Object(common["q" /* getKey */])(second, 'displayName', false) || Object(utils_common["g" /* isNull */])(second.displayName)) {
      second.displayName = '';
    }
    if (!Object(common["q" /* getKey */])(second, 'channelName', false) || Object(utils_common["g" /* isNull */])(second.channelName)) {
      second.channelName = '';
    }
    return first[bankName].localeCompare(second[bankName]);
  });

  return data;
};

var filterBanks = function filterBanks(value, data) {
  var result = data.filter(function (record) {
    var bankName = record.displayName ? 'displayName' : 'channelName';
    return record[bankName].toLowerCase().indexOf(value.toLowerCase()) !== -1;
  });
  return result;
};

var filterByAlphabet = function filterByAlphabet(alphabet, data) {
  return data.filter(function (record) {
    var bankName = record[record.displayName ? 'displayName' : 'channelName'].toLowerCase();
    return !!(bankName && bankName.charAt(0) === alphabet.toLowerCase());
  });
};
// CONCATENATED MODULE: ./components/bank-mandate/bank-authenticate.js


function bank_authenticate__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function bank_authenticate__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function bank_authenticate__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var bank_authenticate__ref3 = Object(preact_min["h"])('span', { 'class': 'ptm-checkmark', 'area-hidden': 'true' });

var bank_authenticate_BankAuthenticate = function (_Component) {
  bank_authenticate__inherits(BankAuthenticate, _Component);

  function BankAuthenticate(props) {
    bank_authenticate__classCallCheck(this, BankAuthenticate);

    var _this = bank_authenticate__possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      selectAuthMode: props.populateMode ? props.populateMode : '',
      authError: '',
      authModes: bank_mandate_sortAuthModes(props.authenticateModes || [])
    };
    return _this;
  }

  BankAuthenticate.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (props.authModeError !== this.state.authError) {
      this.setState({ authError: props.authModeError });
    }
    this.setState({ authModes: bank_mandate_sortAuthModes(props.authenticateModes) });
  };

  BankAuthenticate.prototype.componentDidMount = function componentDidMount() {
    var banksLenght = Object(common["q" /* getKey */])(this.state, 'authModes.length', 0);
    // Auto select first mode
    if (banksLenght > 0) {
      if (this.props.selectMode && typeof this.props.selectMode === 'function') {
        this.props.selectMode(this.state.authModes[0]);
      }
    }
  };

  BankAuthenticate.prototype.render = function render(_ref, _ref2) {
    var selectMode = _ref.selectMode,
        populateMode = _ref.populateMode;
    var authModes = _ref2.authModes,
        authError = _ref2.authError;

    return Object(preact_min["h"])(
      'div',
      { className: 'ptm-auth-wrap ptm-w100-ib  ptm-pos-r' },
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-auth-text' },
        Object(i18n["a" /* locale */])('bm.authenticate.using')
      ),
      authModes && authModes.map(function (mode) {
        return Object(preact_min["h"])(
          'div',
          { className: 'ptm-bm-radio-wrap' },
          Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(
              'label',
              { 'class': 'ptm-lbl' },
              Object(preact_min["h"])('input', {
                type: 'radio',
                'class': 'ptm-margin0',
                name: 'authenticatemode',
                value: mode,
                checked: populateMode === mode,
                onClick: function onClick() {
                  return selectMode(mode);
                }
              }),
              bank_authenticate__ref3,
              Object(preact_min["h"])(
                'div',
                { className: ' ptm-pay-method-cont  ptm-pos-r' },
                constants["g" /* default */].MANDATE_AUTH_MODES[mode]
              )
            )
          )
        );
      }),
      Object(preact_min["h"])(
        'p',
        { className: 'ptm-small-txt ptm-msg-red' },
        authError
      )
    );
  };

  return BankAuthenticate;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./controllers/select-ifsc.js
/**
 * formats the array data
 *
 * @param {Array} data - array of banks/channels data
 * @returns {Object} - returns the foratted data object
 */
var formatList = function formatList(data) {
  if (!data) {
    data = [];
  }
  data = data.map(function (item) {
    return typeof item === 'string' ? { displayName: item } : item;
  });
  data = data.sort(function (first, second) {
    return first.displayName.localeCompare(second.displayName);
  });

  return data;
};

/**
 * filters the banks/channels array corresponding to search value
 *
 * @param {Object} e - input onKeyUp event object
 * @param {Array} data - array of banks/channels
 * @returns {Object} - return the state data object with bank lists and search value
 */
var filterList = function filterList(value, data) {
  data = data.filter(function (item) {
    return item.displayName.toLowerCase().indexOf(value.toLowerCase()) !== -1;
  });
  return { listData: formatList(data), searchValue: value };
};

/**
 * Empty the search value ins state and resets the other banks data
 *
 * @param {Array} banks - array of banks/channels
 * @returns {Object} - returns  the state data object with the banks/channels array and empty searchValue
 */
var clearSearch = function clearSearch(banks) {
  return { listData: formatList(banks), searchValue: '' };
};
// CONCATENATED MODULE: ./components/select-ifsc/list.js


function list__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function list__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function list__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var list__ref3 = Object(preact_min["h"])(notFound, null);

var list_List = function (_Component) {
  list__inherits(List, _Component);

  function List(props) {
    list__classCallCheck(this, List);

    var _this = list__possibleConstructorReturn(this, _Component.call(this, props));

    _this.filterListData = function (e) {
      var stateData = filterList(e.target.value, _this.props.list);
      _this.setState(stateData);
    };

    _this.clearSearchData = function () {
      var stateData = clearSearch(_this.props.list);
      _this.setState(stateData);
    };

    _this.state = {
      searchValue: '',
      listData: props.list
    };
    _this.contentArea = '';
    return _this;
  }

  List.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.setState({ searchValue: '', listData: nextProps.list });
    if (this.props.heading !== nextProps.heading) {
      this.contentArea.scrollTop = 0;
    }
  };

  List.prototype.render = function render(_ref, _ref2) {
    var _this2 = this;

    var heading = _ref.heading,
        backButtonFn = _ref.backButtonFn,
        placeholder = _ref.placeholder,
        selectListData = _ref.selectListData;
    var searchValue = _ref2.searchValue,
        listData = _ref2.listData;

    return Object(preact_min["h"])(
      'div',
      { className: 'ptm-content-section' },
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-content-top cont-top-global' },
        Object(preact_min["h"])(
          'h2',
          null,
          heading
        ),
        Object(preact_min["h"])(
          'div',
          { className: 'ptm-close-wrap ptm-pos-a ptm-closeIcon', onClick: backButtonFn },
          Object(preact_min["h"])('span', { className: 'ptm-cross ptm-pos-r' })
        ),
        Object(preact_min["h"])(
          'div',
          {
            className: 'ptm-ib ptm-w100-ib ptm-pos-r ptm-search-field ptm-nb-boxinput ptm-pos-r'
          },
          Object(preact_min["h"])('input', {
            type: 'text ',
            placeholder: Object(i18n["a" /* locale */])('bm.search.' + placeholder),
            className: 'ptm-margin0 ptm-dropdown-input ptm-input-common',
            value: searchValue,
            onKeyUp: this.filterListData,
            ref: function ref(inp) {
              _this2.search = inp;
            }
          }),
          Object(preact_min["h"])('img', {
            className: 'ptm-search-img ptm-pos-a',
            src: Object(common["U" /* staticPath */])() + '/assets/images/search-icon.svg',
            alt: ''
          }),
          searchValue && Object(preact_min["h"])(
            'div',
            {
              className: 'ptm-clear-wrap ptm-closeIcon ',
              onClick: function onClick() {
                return _this2.clearSearchData();
              }
            },
            Object(preact_min["h"])('span', { className: 'ptm-cross ptm-pos-r' })
          )
        )
      ),
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-content-mid ptm-pos-r', ref: function ref(ele) {
            return _this2.contentArea = ele;
          } },
        listData.length === 0 && list__ref3,
        Object(preact_min["h"])(
          'section',
          { className: 'ptm-bank-result' },
          !!listData.length && Object(preact_min["h"])(
            'ul',
            { className: 'bsl bsl-global' },
            listData.map(function (item) {
              return Object(preact_min["h"])(
                'li',
                {
                  className: 'ptm-pos-r ptm-w100-ib ptm-bank-result-list ptm-border-global',
                  onClick: function onClick() {
                    return selectListData(item);
                  }
                },
                Object(preact_min["h"])(
                  'label',
                  { 'for': '', 'class': 'ptm-ib ptm-vm overflow-h' },
                  Object(preact_min["h"])(
                    'span',
                    { className: 'fs14 c1' },
                    item.displayName
                  )
                )
              );
            })
          )
        )
      )
    );
  };

  return List;
}(preact_min["Component"]);
// CONCATENATED MODULE: ./components/select-ifsc/index.js


function select_ifsc__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function select_ifsc__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function select_ifsc__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function select_ifsc__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var select_ifsc_SelectIfsc = function (_Component) {
  select_ifsc__inherits(SelectIfsc, _Component);

  function SelectIfsc(props) {
    select_ifsc__classCallCheck(this, SelectIfsc);

    var _this = select_ifsc__possibleConstructorReturn(this, _Component.call(this, props));

    _this.backButtonFn = function (isData) {
      if (isData === true && _this.ifscData) {
        _this.props.closeSelectIfsc(true, _this.ifscData);
      } else if (_this.openedList === _this.stateKey) {
        _this.props.closeSelectIfsc(false, {});
      } else if (_this.openedList === _this.bankKey) {
        _this.showCityList();
      } else if (_this.openedList === _this.cityKey) {
        _this.showStateList();
      }
    };

    _this.showStateList = function () {
      _this.openedList = _this.stateKey;
      _this.setState({
        heading: _this.stateHeading,
        listData: _this.stateListData,
        key: _this.openedList
      });
    };

    _this.showCityList = function () {
      _this.openedList = _this.cityKey;
      _this.setState({
        heading: _this.cityHeading,
        listData: _this.cityListData,
        key: _this.openedList
      });
    };

    _this.showBankList = function () {
      _this.openedList = _this.bankKey;
      _this.setState({
        heading: _this.bankHeading,
        listData: _this.bankListData,
        key: _this.openedList
      });
    };

    _this.filterListData = function (e) {
      var stateData = filterList(e.target.value, _this.props.bankList);
      _this.setState(stateData);
    };

    _this.clearSearchData = function () {
      _this.search.value = '';
      var stateData = clearSearch(_this.props.bankList);
      _this.setState(stateData);
    };

    _this.selectListData = function (data) {
      if (_this.openedList === _this.bankKey) {
        _this.ifscData = data;
        _this.backButtonFn(true);
      } else if (_this.openedList === _this.cityKey) {
        var apiData = {
          key: (_this.props.bank.channelCode + '_' + _this.state.selectedState + '_' + data.displayName).split(' ').join('_') + '_IFSC_bank_list',
          request: {
            bankName: _this.props.bank.channelName,
            state: _this.state.selectedState,
            city: data.displayName
          }
        };
        bank_mandate_selectIfscFromBank(apiData.key, apiData.request, _this.props.cache).then(function (res) {
          _this.bankListData = formatList(res.bankBranchList);
          _this.showBankList();
        }).catch(function (error) {
          _this.props.showSelectIFSCError(error);
        });
      } else if (_this.openedList === _this.stateKey) {
        _this.setState({ selectedState: data.displayName });
        var _apiData = {
          key: (_this.props.bank.channelCode + '_' + data.displayName).split(' ').join('_') + '_IFSC_city_list',
          request: { bankName: _this.props.bank.channelName, state: data.displayName }
        };
        bank_mandate_selectIfscFromBank(_apiData.key, _apiData.request, _this.props.cache).then(function (res) {
          _this.cityListData = formatList(res.list);
          _this.showCityList();
        }).catch(function (error) {
          _this.props.showSelectIFSCError(error);
        });
      }
    };

    _this.stateHeading = Object(i18n["a" /* locale */])('bm.select.state');
    _this.cityHeading = Object(i18n["a" /* locale */])('bm.select.city');
    _this.bankHeading = Object(i18n["a" /* locale */])('bm.select.bank');
    _this.stateListData = formatList(props.ifscStateData);
    _this.bankListData = '';
    _this.cityListData = '';
    _this.openedList = 'state';
    _this.state = {
      heading: '',
      listData: [],
      key: '',
      selectedState: ''
    };
    _this.stateKey = 'state';
    _this.bankKey = 'bank';
    _this.cityKey = 'city';
    _this.showStateList();
    _this.ifscData = '';
    return _this;
  }

  SelectIfsc.prototype.render = function render(_ref, _ref2) {
    var heading = _ref2.heading,
        listData = _ref2.listData,
        key = _ref2.key;

    select_ifsc__objectDestructuringEmpty(_ref);

    return Object(preact_min["h"])(list_List, {
      selectListData: this.selectListData,
      heading: heading,
      list: listData,
      placeholder: key,
      clearSearchData: this.clearSearchData,
      filterListData: this.filterListData,
      backButtonFn: this.backButtonFn
    });
  };

  return SelectIfsc;
}(preact_min["Component"]);

/* harmony default export */ var select_ifsc = (Object(preact["connect"])('cache', null)(select_ifsc_SelectIfsc));
// CONCATENATED MODULE: ./components/bank-mandate/bank-account-details.js


function bank_account_details__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function bank_account_details__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function bank_account_details__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var bank_account_details_BankAccountDetails = function (_Component) {
  bank_account_details__inherits(BankAccountDetails, _Component);

  function BankAccountDetails(props) {
    bank_account_details__classCallCheck(this, BankAccountDetails);

    var _this = bank_account_details__possibleConstructorReturn(this, _Component.call(this, props));

    _this.closeSelectIfsc = function (isData, data) {
      if (isData) {
        _this.setState({ ifsc: data.ifscCode, ifscAPIData: data.ifscCode });
      }
      _this.setState({ showIfscList: false });
    };

    _this.selectIfsc = function () {
      var apiData = {
        key: _this.props.bank.channelCode + '_IFSC_state_list',
        request: { bankName: _this.props.bank.channelName }
      };
      bank_mandate_selectIfscFromBank(apiData.key, apiData.request, _this.props.cache).then(function (ifsc) {
        _this.setState({ showIfscList: true, isIfscError: false });
        _this.selectIfscData = ifsc.list;
      }).catch(function (error) {
        _this.setState({ showIfscList: false, ifscError: error, isIfscError: true });
      });
    };

    _this.showSelectIFSCError = function (error) {
      _this.setState({ showIfscList: false, ifscError: error, isIfscError: true });
    };

    _this.clearError = function (type) {
      _this.setState(clearFieldError(type));
    };

    _this.componentDidMount = function () {
      !_this.state.accountNumber && _this.accName && _this.accName.focus();
    };

    _this.onProceed = function () {
      if (_this.props.bankDetailsEditable) {
        var data = validateAccountDetails(_this.state.accountHolderName, _this.state.accountNumber, _this.state.ifsc, _this.state.mandateAuthMode, _this.nameData, _this.numberData, _this.ifscData, _this.authModeData);
        if (data.stateData) {
          _this.setState(data.stateData);
          if (data.submit) {
            var _this$state = _this.state,
                accountNumber = _this$state.accountNumber,
                accountHolderName = _this$state.accountHolderName,
                ifsc = _this$state.ifsc,
                mandateAuthMode = _this$state.mandateAuthMode;

            var req = { ifscCode: ifsc };

            bank_mandate_validateIfscInput(req, _this.state.ifscAPIData, _this.props.cache).then(function (res) {
              res.ifscCode && _this.props.onProceedSubmit(accountNumber, accountHolderName, ifsc, mandateAuthMode);
            }).catch(function (res) {
              _this.setState({ ifscError: res, isIfscError: true });
            });
          } else {
            Object(logger["log"])({
              eventType: 'BM_EVENT_CLIENT_VALIDATION'
            });
          }
        }
      } else {
        var _data = validateMandateAuthDetails(_this.state.mandateAuthMode, _this.authModeData);
        if (_data) {
          _this.setState(_data.stateData);
          if (_data.submit) {
            var _this$props$accountDe = _this.props.accountDetails,
                _accountNumber = _this$props$accountDe.accountNumber,
                _accountHolderName = _this$props$accountDe.accountHolderName,
                _ifsc = _this$props$accountDe.ifsc;

            var _mandateAuthMode = _this.state.mandateAuthMode;
            _this.props.onProceedSubmit(_accountNumber, _accountHolderName, _ifsc, _mandateAuthMode);
          } else {
            Object(logger["log"])({
              eventType: 'BM_EVENT_CLIENT_VALIDATION'
            });
          }
        }
      }
    };

    _this.checkAccountNumber = function (e) {
      _this.clearError('number');
      accountInpRestricted(e);
    };

    _this.setAccountNumber = function (e) {
      if (e && e.target) {
        var stateData = updateInputValue(e, _this.state.accountNumber, 'accountNumber');
        _this.setState(stateData);
      }
    };

    _this.checkAccountName = function (e) {
      _this.clearError('name');
      nameInpRestricted(e);
    };

    _this.setAccountName = function (e) {
      if (e && e.target) {
        var stateData = updateInputValue(e, _this.state.accountHolderName, 'accountHolderName');
        _this.setState(stateData);
      }
    };

    _this.checkAccountIfsc = function (e) {
      accountInpRestricted(e);
    };

    _this.setAccountIfsc = function (e) {
      _this.clearError('ifsc');
      if (e && e.target) {
        var stateData = updateInputValue(e, _this.state.ifsc, 'ifsc');
        _this.setState(stateData);
      }
    };

    _this.selectAuthMode = function (mode) {
      _this.setState({ mandateAuthMode: mode });
      _this.clearError('authMode');
      Object(logger["log"])({ eventType: logger["EVENT"].INPUT_ELE_CLICKED, paymode: constants["g" /* default */].BM, elementName: mode });
    };

    _this.state = {
      accountNumber: Object(common["q" /* getKey */])(props, 'accountDetails.accountNumber', ''),
      accountHolderName: props.accountDetails.accountHolderName ? props.accountDetails.accountHolderName : '',
      ifsc: props.accountDetails.ifsc ? props.accountDetails.ifsc : '',
      mandateAuthMode: '',
      nameError: '',
      numberError: '',
      ifscError: '',
      authModeError: '',
      isNumberError: false,
      isNameError: false,
      isIfscError: false,
      isAuthModeError: false,
      showIfscList: false,
      ifscAPIData: ''
    };

    _this.nameData = { blank: Object(i18n["a" /* locale */])('bm.blank.name'), invalid: Object(i18n["a" /* locale */])('bm.invalid.name') };
    _this.numberData = { blank: Object(i18n["a" /* locale */])('bm.blank.number'), invalid: Object(i18n["a" /* locale */])('bm.invalid.number') };
    _this.ifscData = { blank: Object(i18n["a" /* locale */])('bm.blank.ifsc'), invalid: Object(i18n["a" /* locale */])('bm.invalid.ifsc') };
    _this.authModeData = { blank: Object(i18n["a" /* locale */])('bm.blank.auth') };
    _this.selectIfscData = {};
    _this.accName = '';
    return _this;
  }

  BankAccountDetails.prototype.render = function render(_ref, _ref2) {
    var _this2 = this;

    var bank = _ref.bank,
        changeBank = _ref.changeBank,
        authenticateModes = _ref.authenticateModes,
        bankDetailsEditable = _ref.bankDetailsEditable;
    var accountNumber = _ref2.accountNumber,
        accountHolderName = _ref2.accountHolderName,
        ifsc = _ref2.ifsc,
        mandateAuthMode = _ref2.mandateAuthMode,
        nameError = _ref2.nameError,
        numberError = _ref2.numberError,
        ifscError = _ref2.ifscError,
        showIfscList = _ref2.showIfscList,
        authModeError = _ref2.authModeError,
        isNameError = _ref2.isNameError,
        isNumberError = _ref2.isNumberError,
        isIfscError = _ref2.isIfscError;

    return Object(preact_min["h"])(
      'div',
      { className: 'ptm-account-details' },
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-selected-bank ptm-w100-ib' },
        Object(preact_min["h"])(
          'div',
          { className: 'ptm-left' },
          Object(preact_min["h"])('img', { className: 'ptm-bank-logo-pic ptm-left', src: bank.iconUrl, alt: '' }),
          Object(preact_min["h"])(
            'span',
            { className: 'ptm-left ptm-bank-logo-name' },
            bank.channelName
          )
        ),
        bankDetailsEditable && Object(preact_min["h"])(
          'div',
          { className: 'ptm-changebank ptm-primary ptm-left', onClick: changeBank },
          Object(i18n["a" /* locale */])('bm.change.bank')
        )
      ),
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-w100-ib' },
        Object(preact_min["h"])(
          'div',
          { className: 'ptm-inputfield-wrap' },
          Object(preact_min["h"])('input', {
            type: 'text',
            className: 'ptm-inputfield',
            placeholder: Object(i18n["a" /* locale */])('bm.enter.name'),
            onKeyDown: this.checkAccountName,
            onClick: function onClick() {
              return Object(logger["log"])({
                eventType: logger["EVENT"].INPUT_ELE_CLICKED,
                paymode: constants["g" /* default */].BM,
                elementName: 'account_Holder_Name'
              });
            },
            onInput: this.setAccountName,
            value: accountHolderName,
            maxLength: constants["g" /* default */].ACCOUNT_NAME_MAX_LENGTH,
            autocomplete: 'off',
            ref: function ref(fl) {
              _this2.accName = fl;
            },
            readOnly: !bankDetailsEditable,
            disabled: !bankDetailsEditable
          }),
          isNameError && Object(preact_min["h"])(
            'p',
            { className: 'ptm-small-txt ptm-msg-red ptm-pos-a' },
            nameError
          )
        ),
        Object(preact_min["h"])(
          'div',
          { className: 'ptm-inputfield-wrap' },
          Object(preact_min["h"])('input', {
            type: 'text',
            className: 'ptm-inputfield',
            placeholder: Object(i18n["a" /* locale */])('bm.enter.number'),
            onKeyDown: this.checkAccountNumber,
            onClick: function onClick() {
              return Object(logger["log"])({
                eventType: logger["EVENT"].INPUT_ELE_CLICKED,
                paymode: constants["g" /* default */].BM,
                elementName: 'account_Number'
              });
            },
            onInput: this.setAccountNumber,
            value: accountNumber,
            maxLength: constants["g" /* default */].ACCOUNT_NUMBER_MAX_LENGTH,
            autocomplete: 'off',
            readOnly: !bankDetailsEditable,
            disabled: !bankDetailsEditable
          }),
          isNumberError && Object(preact_min["h"])(
            'p',
            { className: 'ptm-small-txt ptm-msg-red ptm-pos-a' },
            numberError
          )
        ),
        Object(preact_min["h"])(
          'div',
          { className: 'ptm-inputfield-wrap ptm-pos-r' },
          Object(preact_min["h"])('input', {
            type: 'text',
            className: 'ptm-inputfield  upper',
            placeholder: Object(i18n["a" /* locale */])('bm.enter.ifsc'),
            onKeyDown: this.checkAccountIfsc,
            onClick: function onClick() {
              return Object(logger["log"])({
                eventType: logger["EVENT"].INPUT_ELE_CLICKED,
                paymode: constants["g" /* default */].BM,
                elementName: 'account_Ifsc'
              });
            },
            onInput: this.setAccountIfsc,
            value: ifsc,
            maxLength: constants["g" /* default */].ACCOUNT_IFSC_LENGTH,
            autocomplete: 'off',
            readOnly: !bankDetailsEditable,
            disabled: !bankDetailsEditable
          }),
          isIfscError && Object(preact_min["h"])(
            'p',
            { className: 'ptm-small-txt ptm-msg-red ptm-pos-r' },
            ifscError
          ),
          bankDetailsEditable && Object(preact_min["h"])(
            'div',
            { className: 'ptm-primary ptm-ifsc ptm-pos-a ', onClick: this.selectIfsc },
            Object(i18n["a" /* locale */])('bm.find.ifsc')
          )
        )
      ),
      Object(preact_min["h"])(bank_authenticate_BankAuthenticate, {
        authenticateModes: authenticateModes,
        selectMode: this.selectAuthMode,
        authModeError: authModeError,
        populateMode: mandateAuthMode
      }),
      showIfscList && Object(preact_min["h"])(
        'div',
        { className: 'ptm-emi-overlay' },
        Object(preact_min["h"])(
          components_OverlayWrap,
          null,
          Object(preact_min["h"])(select_ifsc, {
            bank: bank,
            ifscStateData: this.selectIfscData,
            closeSelectIfsc: this.closeSelectIfsc,
            showSelectIFSCError: this.showSelectIFSCError
          })
        )
      )
    );
  };

  return BankAccountDetails;
}(preact_min["Component"]);

/* harmony default export */ var bank_account_details = (Object(preact["connect"])('cache', null)(bank_account_details_BankAccountDetails));
// CONCATENATED MODULE: ./components/bank-mandate/bank-details-confirm.js


function bank_details_confirm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function bank_details_confirm__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function bank_details_confirm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var bank_details_confirm_BankDetailsConfirm = function (_Component) {
  bank_details_confirm__inherits(BankDetailsConfirm, _Component);

  function BankDetailsConfirm(props) {
    bank_details_confirm__classCallCheck(this, BankDetailsConfirm);

    var _this = bank_details_confirm__possibleConstructorReturn(this, _Component.call(this, props));

    _this.componentDidMount = function () {
      var paymentOptions = _this.props.cache.getData(constants["a" /* CACHE */].PAYMENT_OPTIONS);
      // added empty check so that if merchant details is not found an empty object is there to set values
      var merchantDetails = paymentOptions.merchantDetails || {};
      var merchantConfig = _this.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
      var merchantNameFromConfig = '';
      // setting name and logo from merchant config  if it exists instead from api
      merchantNameFromConfig = Object(common["q" /* getKey */])(merchantConfig, 'merchant.name', null);
      var merchantLogoFromConfig = Object(common["q" /* getKey */])(merchantConfig, 'merchant.logo', null);
      var merchantBrandName = Object(common["q" /* getKey */])(merchantDetails, 'merchantDisplayName', null);
      if (merchantNameFromConfig) {
        merchantDetails.merchantName = merchantNameFromConfig;
      }
      if (merchantLogoFromConfig) {
        merchantDetails.merchantLogo = merchantLogoFromConfig;
      }
      _this.setState({
        merchant: {
          name: merchantDetails.merchantName || merchantBrandName,
          logo: merchantDetails.merchantLogo
        }
      });
    };

    _this.merchantLogoCb = function (isLoaded) {
      _this.setState({ merchantLogoLoaded: isLoaded });
    };

    _this.state = {
      merchantLogoLoaded: !!(props.merchant && !Object(utils_common["g" /* isNull */])(props.merchant.logo)),
      merchant: {
        name: null,
        logo: null
      }
    };
    var txnAmount = _this.props.cache.getData(constants["g" /* default */].TXN_AMOUNT);
    _this.amount = Object(common["g" /* commas */])(txnAmount);
    return _this;
  }

  BankDetailsConfirm.prototype.render = function render(_ref, _ref2) {
    var _this2 = this;

    var subscription = _ref.subscription,
        optedBankData = _ref.optedBankData,
        accountDetails = _ref.accountDetails,
        closeConfirmScreen = _ref.closeConfirmScreen,
        genericError = _ref.genericError,
        btnDisabled = _ref.btnDisabled;
    var merchantLogoLoaded = _ref2.merchantLogoLoaded,
        merchant = _ref2.merchant;

    return Object(preact_min["h"])(
      'div',
      { className: 'ptm-emi-plan-wrap ptm-h100' },
      Object(preact_min["h"])(
        'div',
        { className: 'top-header top-headerbox' },
        Object(preact_min["h"])(
          'div',
          { className: 'ptm-close-wrap ptm-pos-a ptm-closeIcon', onClick: closeConfirmScreen },
          Object(preact_min["h"])('span', { className: 'ptm-cross ptm-pos-r' })
        )
      ),
      Object(preact_min["h"])(
        'div',
        { className: 'sticky-head ptm-w100 ptm-pos-r' },
        Object(preact_min["h"])(
          'div',
          { className: 'willFixed  ptm-pos-r vt ptm-w100-ib reduce relative' },
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-sub-mer-wrap' },
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-w100-ib ptm-vm' },
              merchant && Object(preact_min["h"])(
                'div',
                { className: 'ptm-left ptm-sub-mer' },
                merchantLogoLoaded && Object(preact_min["h"])('img', {
                  className: 'offusImg',
                  src: '' + merchant.logo,
                  height: '35',
                  onload: function onload() {
                    return _this2.merchantLogoCb(true);
                  },
                  onerror: function onerror() {
                    return _this2.merchantLogoCb(false);
                  }
                }),
                !merchantLogoLoaded && Object(preact_min["h"])(
                  'span',
                  { className: 'ptm-txt-control' },
                  merchant.name
                )
              ),
              isAmountZero(this.amount) && Object(preact_min["h"])(
                'section',
                { className: 'ptm-sec-label ptm-right' },
                Object(preact_min["h"])(
                  'span',
                  { className: 'ptm-pay-txt' },
                  'Pay \u20B9',
                  this.amount
                ),
                Object(preact_min["h"])(
                  'div',
                  { className: 'ptm-pos-r ptm-sub-txt-header' },
                  '(',
                  Object(i18n["a" /* locale */])('bm.amt.deduct'),
                  ')'
                )
              )
            )
          )
        )
      ),
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-bmdetail' },
        Object(preact_min["h"])(
          'div',
          { className: 'ptm-sub-detail ptm-separator ' },
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-sub-heading' },
            Object(i18n["a" /* locale */])('bm.subscription.details')
          ),
          accountDetails.accountHolderName && Object(preact_min["h"])(
            'div',
            { className: 'ptm-sub-list-wrap ptm-w100-ib' },
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-sub-name ptm-ib' },
              Object(i18n["a" /* locale */])('bm.customer.name')
            ),
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-sub-value ptm-ib ptm-right' },
              accountDetails.accountHolderName
            )
          ),
          subscription.subsfrequency && Object(preact_min["h"])(
            'div',
            { className: 'ptm-sub-list-wrap ptm-w100-ib' },
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-sub-name ptm-ib' },
              Object(i18n["a" /* locale */])('bm.frequency')
            ),
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-sub-value ptm-ib ptm-right' },
              subscription.subsfrequency === constants["g" /* default */].SUBS_FREQ_ONDEMAND ? Object(i18n["a" /* locale */])('bm.subs.on.demand') : subscription.subsfrequency
            )
          ),
          subscription.maxAmount && Object(preact_min["h"])(
            'div',
            { className: 'ptm-sub-list-wrap ptm-w100-ib' },
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-sub-name ptm-ib' },
              Object(i18n["a" /* locale */])('bm.max.amount')
            ),
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-sub-value ptm-ib ptm-right' },
              '\u20B9',
              Object(common["g" /* commas */])(subscription.maxAmount)
            )
          ),
          subsDateFormat(subscription.startDate) && Object(preact_min["h"])(
            'div',
            { className: 'ptm-sub-list-wrap ptm-w100-ib' },
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-sub-name ptm-ib' },
              Object(i18n["a" /* locale */])('bm.start.date')
            ),
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-sub-value ptm-ib ptm-right' },
              subsDateFormat(subscription.startDate)
            )
          ),
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-sub-list-wrap ptm-w100-ib' },
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-sub-name ptm-ib' },
              Object(i18n["a" /* locale */])('bm.exp.date')
            ),
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-sub-value ptm-ib ptm-right' },
              subsDateFormat(subscription.endDate) ? subsDateFormat(subscription.endDate) : Object(i18n["a" /* locale */])('bm.until.cancelled')
            )
          ),
          subscription.subscriptionPurpose && Object(preact_min["h"])(
            'div',
            { className: 'ptm-sub-list-wrap ptm-w100-ib' },
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-sub-name ptm-ib' },
              Object(i18n["a" /* locale */])('bm.purpose')
            ),
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-sub-value ptm-ib ptm-right' },
              subscription.subscriptionPurpose
            )
          )
        ),
        Object(preact_min["h"])(
          'div',
          { className: 'ptm-bank-detail ptm-pos-r' },
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-sub-heading' },
            Object(i18n["a" /* locale */])('bm.bank.acc.details')
          ),
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-sub-list-wrap ptm-w100-ib' },
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-sub-name ptm-ib' },
              optedBankData.channelName,
              ' ',
              'XX ' + accountDetails.accountNumber.slice(-4)
            )
          ),
          accountDetails.ifsc && Object(preact_min["h"])(
            'div',
            { className: 'ptm-sub-list-wrap ptm-w100-ib' },
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-sub-name ptm-ib' },
              Object(i18n["a" /* locale */])('bm.ifsc.code'),
              ': ',
              accountDetails.ifsc
            )
          ),
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-sub-list-wrap ptm-w100-ib' },
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-sub-name ptm-ib' },
              Object(i18n["a" /* locale */])('bm.account.saving')
            )
          ),
          optedBankData.iconUrl && Object(preact_min["h"])(
            'div',
            { className: 'ptm-pos-a ptm-opt-img ptm-bm-bank-border' },
            Object(preact_min["h"])('img', {
              className: 'ptm-banking-logo centerlized',
              src: optedBankData.iconUrl,
              alt: ''
            })
          ),
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-sub-confirm' },
            Object(i18n["a" /* locale */])('bm.confirm.' + accountDetails.mandateAuthMode)
          ),
          Object(preact_min["h"])(
            'div',
            { className: 'ifsc-inputwrap ptm-pos-r' },
            Object(preact_min["h"])(
              'p',
              { className: 'ptm-small-txt ptm-msg-red' },
              genericError
            )
          )
        )
      ),
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-btn-wrapper ptm-body-bg' },
        Object(preact_min["h"])(
          'button',
          {
            className: 'ptm-custom-btn',
            disabled: btnDisabled,
            onClick: function onClick() {
              _this2.props.onConfirm();
            }
          },
          Object(i18n["a" /* locale */])('bm.confirm')
        )
      ),
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-sub-footer-area' },
        Object(preact_min["h"])('img', { src: Object(common["U" /* staticPath */])() + '/assets/images/nach.png', alt: '' }),
        Object(preact_min["h"])(
          'span',
          { className: 'ptm-footer-txt' },
          Object(i18n["a" /* locale */])('bm.mandate.powered')
        ),
        Object(preact_min["h"])('img', { src: Object(common["U" /* staticPath */])() + '/assets/images/npci.png', alt: '' })
      )
    )
    // </div>
    ;
  };

  return BankDetailsConfirm;
}(preact_min["Component"]);

/* harmony default export */ var bank_details_confirm = (Object(preact["connect"])('cache,subscription', onChange)(bank_details_confirm_BankDetailsConfirm));
// CONCATENATED MODULE: ./components/bank-mandate/index.js
var components_bank_mandate__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function bank_mandate__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function bank_mandate__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function bank_mandate__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var bank_mandate__ref3 = Object(preact_min["h"])('span', { 'class': 'ptm-checkmark' });

var bank_mandate_BankMandate = function (_Component) {
  bank_mandate__inherits(BankMandate, _Component);

  function BankMandate(props) {
    bank_mandate__classCallCheck(this, BankMandate);

    var _this = bank_mandate__possibleConstructorReturn(this, _Component.call(this, props));

    _this.closeOtherBankList = function () {
      _this.setState({ showOtherBanks: false });
    };

    _this.populateBank = function () {
      var _this$accountDetails = _this.accountDetails,
          channelName = _this$accountDetails.channelName,
          channelCode = _this$accountDetails.channelCode,
          iconUrl = _this$accountDetails.iconUrl,
          mandateAuthMode = _this$accountDetails.mandateAuthMode;

      channelCode && _this.setSelectedBank({
        channelName: channelName,
        channelCode: channelCode,
        iconUrl: iconUrl,
        mandateAuthMode: mandateAuthMode
      });
    };

    _this.getPopularBanks = function (banks) {
      banks = banks || [];
      return banks.slice(0, 5);
    };

    _this.onOptionSelect = function (option) {
      _this.props.onOptionSelect(option);
      _this.props.onBtnTextChange('Proceed');
      _this.props.onPayChange(true);
    };

    _this.submit = function () {
      _this.child._component.onProceed();
    };

    _this.onProceedSubmit = function (accountNumber, accountHolderName, ifsc, mandateAuthMode) {
      _this.accountDetails = setAccountDetails({
        accountNumber: accountNumber,
        accountHolderName: accountHolderName,
        ifsc: ifsc,
        mandateAuthMode: mandateAuthMode
      });
      var stateData = displayConfirmationScreen();
      _this.setState(stateData);
    };

    _this.selectOtherBankList = function () {
      _this.setState({ showOtherBanks: true });
      Object(logger["log"])({ eventType: logger["EVENT"].BM_SELECT_OTHER_BANKS_CLICK, payMode: constants["g" /* default */].BM });
      _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ stopScroll: true });
    };

    _this.setSelectedBank = function (data) {
      _this.optedBankData = data;
      _this.cancel();
      _this.authenticateModes = data.mandateAuthMode;
      var stateData = bank_mandate_setOptedBankData(data);
      _this.setState(stateData);
      _this.clearSeacrh();
    };

    _this.changeSlectedBank = function () {
      var stateData = bank_mandate_changeBank();
      _this.setState(stateData);
    };

    _this.accountDetails = function (data) {
      _this.accountDetails = setAccountDetails(data);
    };

    _this.closeConfirmScreen = function () {
      _this.setState(closeSubsConfirmScreen());
    };

    _this.onConfirm = function () {
      _this.setState({ genericError: '', btnDisabled: false });
      _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: constants["g" /* default */].PROCESSING });
      Object(logger["log"])({ eventType: logger["EVENT"].BUTTON_CLICK, payMode: constants["g" /* default */].BM });
      bank_mandate_onConfirmSubmit(_this.accountDetails, _this.optedBankData, false, _this.props.cache).then(function (response) {
        var notifyMerchant = Object(common["q" /* getKey */])(_this.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG), 'handler.notifyMerchant', {});
        if (Object(common["q" /* getKey */])(response, 'body.resultInfo.resultStatus', undefined) === 'S') {
          var _getKey = Object(common["q" /* getKey */])(response, 'body.bankForm.redirectForm', undefined),
              actionUrl = _getKey.actionUrl,
              content = _getKey.content;

          response.body.content = content;
          response.body.callbackUrl = actionUrl;
          _this.setState({ genericError: '', btnDisabled: false });
        } else {
          _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: '' });
          var errorMsg = Object(common["q" /* getKey */])(response, 'body.resultInfo.resultMsg', constants["g" /* default */].GENERIC_ERROR);
          if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
            notifyMerchant(constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.PAYMENT_ERROR, response);
          }
          _this.setState({ genericError: errorMsg, btnDisabled: true });
        }
        Object(formPost["f" /* postInWindow */])(response, _this.props.cache);
      }).catch(function (res) {
        _this.setState(res);
        var notifyMerchant = Object(common["q" /* getKey */])(_this.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG), 'handler.notifyMerchant', {});
        _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: '' });
        if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
          notifyMerchant(constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.PAYMENT_ERROR, constants["g" /* default */].GENERIC_ERROR);
        }
        Object(formPost["f" /* postInWindow */])({}, _this.props.cache); // close window in case of network error
      });
    };

    _this.clearSeacrh = function () {
      _this.setState({ filterBankData: [], showFilteredData: false, isSearchFocused: false });
    };

    _this.focusIn = function () {
      if (!_this.isSearchFocusedLogged) {
        _this.isSearchFocusedLogged = true;
      }
      _this.setState({ isSearchFocused: true });
    };

    _this.cancel = function () {
      if (document.getElementById('searchBar')) {
        document.getElementById('searchBar').value = '';
        document.getElementById('searchBar').blur();
      }
      _this.setState(function () {
        return {
          showOtherBanks: false,
          filterBankData: {},
          showFilteredData: false,
          isSearchFocused: false
        };
      });
      _this.props.onStopScroll(false);
    };

    _this.filterBanks = function (e) {
      if (e.currentTarget.value) {
        _this.setState(function (prevState) {
          return {
            filterBankData: filterBanks(e.currentTarget.value, prevState.bankListsData),
            showFilteredData: true
          };
        });
      } else {
        _this.setState(function (prevState) {
          return {
            filterBankData: {},
            bankListsData: prevState.bankListsData,
            showFilteredData: false
          };
        });
      }
    };

    _this.alphabetFilter = function (alphabet) {
      _this.setState(function (prevState) {
        return {
          filterBankData: filterByAlphabet(alphabet, prevState.bankListsData),
          showFilteredData: true
        };
      });
    };

    _this.state = {
      showBanksScreen: true,
      showOtherBanks: false,
      showAccountDetailsScreen: false,
      showConfirmationScreen: false,
      isSearchFocused: false,
      bankListsData: props.option.payChannelOptions || {},
      filterBankData: {},
      showFilteredData: false
    };
    _this.optedBankData = {};
    _this.isSearchFocusedLogged = false;
    _this.authenticateModes = [];
    _this.popularBanks = _this.getPopularBanks(_this.state.bankListsData);
    _this.accountDetails = setAccountDetails(props.mandateAccountDetails);
    _this.populateBank();
    _this.bankDetailsEditable = isBankDetailsEditable(props.mandateAccountDetails);
    return _this;
  }

  BankMandate.prototype.render = function render(_ref, _ref2) {
    var _this2 = this;

    var option = _ref.option,
        isActive = _ref.isActive,
        instanceKey = _ref.instanceKey;
    var showBanksScreen = _ref2.showBanksScreen,
        showFilteredData = _ref2.showFilteredData,
        isSearchFocused = _ref2.isSearchFocused,
        filterBankData = _ref2.filterBankData,
        bankListsData = _ref2.bankListsData,
        showOtherBanks = _ref2.showOtherBanks,
        showAccountDetailsScreen = _ref2.showAccountDetailsScreen,
        showConfirmationScreen = _ref2.showConfirmationScreen,
        btnDisabled = _ref2.btnDisabled,
        genericError = _ref2.genericError;

    return Object(preact_min["h"])(
      'section',
      { className: 'ptm-bm-main-wrap' },
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-pay-method ptm-w100-ib', id: 'checkout-bm' },
        Object(preact_min["h"])(
          'div',
          { className: 'ptm-radio-wrap ptm-pt11' },
          Object(preact_min["h"])(
            'label',
            { className: 'ptm-lbl' },
            Object(preact_min["h"])('input', {
              type: 'radio',
              name: 'verify' + instanceKey,
              className: 'ptm-margin0',
              checked: isActive,
              onClick: function onClick() {
                _this2.onOptionSelect(option);
              }
            }),
            bank_mandate__ref3,
            Object(preact_min["h"])(
              'div',
              { 'class': 'ptm-pay-method-cont' },
              Object(preact_min["h"])(
                'p',
                { 'class': 'ptm-paymode-name ' },
                option.displayName
              )
            )
          )
        ),
        option && isActive && showBanksScreen && Object(preact_min["h"])(
          'div',
          { className: 'ptm-nb-inner ptm-pl-35' },
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-nb-list ptm-w100-ib' },
            this.popularBanks.map(function (bank) {
              return Object(preact_min["h"])(
                'div',
                null,
                Object(preact_min["h"])(
                  'div',
                  {
                    className: 'ptm-nb-list-item paytm-txt-center',
                    onClick: function onClick() {
                      return _this2.setSelectedBank(bank);
                    }
                  },
                  Object(preact_min["h"])(
                    'div',
                    { className: 'ptm-pos-r ptm-nb-img ptm-bm-bank-border' },
                    Object(preact_min["h"])('img', { className: 'ptm-pos-a', src: bank.iconUrl, alt: '' })
                  ),
                  Object(preact_min["h"])(
                    'div',
                    { className: 'ptm-bank-name ptm-body-color' },
                    bank.channelCode
                  )
                )
              );
            })
          ),
          bankListsData && bankListsData.length && bankListsData.length > 5 && Object(preact_min["h"])(
            'div',
            { className: 'ptm-bm-select ptm-body-color', onClick: this.selectOtherBankList },
            Object(i18n["a" /* locale */])('bm.select.other.bank'),
            Object(preact_min["h"])('img', {
              className: 'ptm-right ptm-margin0',
              src: Object(common["U" /* staticPath */])() + '/assets/images/ic-dropdown-light.svg',
              alt: ''
            })
          )
        ),
        option && isActive && showAccountDetailsScreen && Object(preact_min["h"])(bank_account_details, {
          ref: function ref(k) {
            return _this2.child = k;
          },
          onProceedSubmit: this.onProceedSubmit,
          bank: this.optedBankData,
          changeBank: this.changeSlectedBank,
          authenticateModes: this.authenticateModes,
          buttonData: this.buttonData,
          accountDetails: this.accountDetails,
          bankDetailsEditable: this.bankDetailsEditable
        })
      ),
      showOtherBanks && Object(preact_min["h"])(BankListsWrapper_BankListsWrapper, {
        bankListsData: bank_mandate_formatData(bankListsData),
        filterBankData: filterBankData,
        cancel: this.cancel,
        filterBanks: this.filterBanks,
        BankOptionClick: this.setSelectedBank,
        showFilteredData: showFilteredData,
        alphabetFilter: this.alphabetFilter,
        isSearchFocused: isSearchFocused,
        focusIn: this.focusIn,
        clearSeacrh: this.clearSeacrh
      }),
      showConfirmationScreen && Object(preact_min["h"])(
        'div',
        { className: 'ptm-emi-ovelay' },
        Object(preact_min["h"])(
          components_OverlayWrap,
          null,
          Object(preact_min["h"])(bank_details_confirm, components_bank_mandate__extends({
            optedBankData: this.optedBankData,
            accountDetails: this.accountDetails
          }, { btnDisabled: btnDisabled, genericError: genericError }, {
            onConfirm: this.onConfirm,
            closeConfirmScreen: this.closeConfirmScreen
          }))
        )
      ),
      Object(preact_min["h"])('p', { className: 'ptm-global-bottom-border' })
    );
  };

  return BankMandate;
}(preact_min["Component"]);

/* harmony default export */ var bank_mandate = (Object(preact["connect"])('cache, instanceKey', onChange)(bank_mandate_BankMandate));
// CONCATENATED MODULE: ./components/savedBankMandate/index.js
var savedBankMandate__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function savedBankMandate__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function savedBankMandate__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function savedBankMandate__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var savedBankMandate__ref3 = Object(preact_min["h"])('span', { 'class': 'ptm-checkmark' });

var savedBankMandate_SavedBankMandate = function (_Component) {
  savedBankMandate__inherits(SavedBankMandate, _Component);

  function SavedBankMandate(props) {
    savedBankMandate__classCallCheck(this, SavedBankMandate);

    var _this = savedBankMandate__possibleConstructorReturn(this, _Component.call(this, props));

    _this.populateBank = function () {
      _this.accountDetails.channelCode && _this.setSelectedBank();
    };

    _this.setSelectedBank = function () {
      _this.optedBankData = {
        iconUrl: _this.accountDetails.iconUrl,
        mandateAuthMode: _this.accountDetails.mandateAuthMode,
        channelName: _this.accountDetails.channelName,
        channelCode: _this.accountDetails.channelCode
      };
      _this.authenticateModes = _this.accountDetails.mandateAuthMode;
    };

    _this.clearError = function (type) {
      _this.setState(clearFieldError(type));
    };

    _this.selectAuthMode = function (mode) {
      _this.setState({ mandateAuthMode: mode });
      _this.clearError('authMode');
    };

    _this.closeConfirmScreen = function () {
      _this.setState(closeSubsConfirmScreen());
    };

    _this.submit = function () {
      _this.onProceed();
    };

    _this.onProceed = function () {
      var data = validateMandateAuthDetails(_this.state.mandateAuthMode, _this.authModeData);
      if (data) {
        _this.setState(data.stateData);
        if (data.submit) {
          var mandateAuthMode = _this.state.mandateAuthMode;
          _this.accountDetails = setAccountDetails(savedBankMandate__extends({}, _this.accountDetails, { mandateAuthMode: mandateAuthMode }));
          var stateData = displayConfirmationScreen();
          _this.setState(stateData);
        }
      }
    };

    _this.onOptionSelect = function (option) {
      _this.props.onOptionSelect(option);
      _this.props.onBtnTextChange('Proceed');
      _this.props.onPayChange(true);
    };

    _this.onConfirm = function () {
      _this.setState({ genericError: '', btnDisabled: false });
      _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: constants["g" /* default */].PROCESSING });
      Object(logger["log"])({ eventType: logger["EVENT"].BUTTON_CLICK, payMode: constants["g" /* default */].SBM });
      bank_mandate_onConfirmSubmit(_this.accountDetails, _this.optedBankData, true, _this.props.cache).then(function (response) {
        var notifyMerchant = Object(common["q" /* getKey */])(_this.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG), 'handler.notifyMerchant', undefined);
        if (Object(common["q" /* getKey */])(response, 'body.resultInfo.resultStatus', undefined) === 'S') {
          var _getKey = Object(common["q" /* getKey */])(response, 'body.bankForm.redirectForm', undefined),
              actionUrl = _getKey.actionUrl,
              content = _getKey.content;

          response.body.content = content;
          response.body.callbackUrl = actionUrl;
          _this.setState({ genericError: '', btnDisabled: false });
        } else {
          _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: '' });
          var errorMsg = Object(common["q" /* getKey */])(response, 'body.resultInfo.resultMsg', constants["g" /* default */].GENERIC_ERROR);
          if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
            notifyMerchant(constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.PAYMENT_ERROR, response);
          }
          _this.setState({ genericError: errorMsg, btnDisabled: true });
        }
        Object(formPost["f" /* postInWindow */])(response, _this.props.cache);
      }).catch(function (res) {
        _this.setState(res);
        var notifyMerchant = Object(common["q" /* getKey */])(_this.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG), 'handler.notifyMerchant', undefined);
        _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: '' });
        if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
          notifyMerchant(constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.PAYMENT_ERROR, constants["g" /* default */].GENERIC_ERROR);
        }
        Object(formPost["f" /* postInWindow */])({}, _this.props.cache); // close window in case of network error
      });
    };

    _this.state = {
      showConfirmationScreen: false,
      authModeError: '',
      isAuthModeError: false,
      mandateAuthMode: '',
      authenticateModes: [],
      btnDisabled: false,
      genericError: ''
    };
    _this.accountDetails = setAccountDetails(props.option || {});
    _this.populateBank();
    _this.authModeData = { blank: Object(i18n["a" /* locale */])('bm.blank.auth') };
    return _this;
  }

  SavedBankMandate.prototype.render = function render(_ref, _ref2) {
    var _this2 = this;

    var showLoader = _ref.showLoader,
        option = _ref.option,
        isActive = _ref.isActive,
        instanceKey = _ref.instanceKey;
    var mandateAuthMode = _ref2.mandateAuthMode,
        authModeError = _ref2.authModeError,
        showConfirmationScreen = _ref2.showConfirmationScreen,
        genericError = _ref2.genericError;

    return Object(preact_min["h"])(
      'section',
      { className: 'ptm-sbm-main-wrap' },
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-pay-method ptm-w100-ib', id: 'checkout-sbm' },
        Object(preact_min["h"])(
          'div',
          { className: 'ptm-radio-wrap' },
          Object(preact_min["h"])(
            'label',
            { className: 'ptm-lbl' },
            Object(preact_min["h"])('input', {
              type: 'radio',
              name: 'verify' + instanceKey,
              className: 'ptm-margin0',
              checked: isActive,
              onClick: function onClick() {
                _this2.onOptionSelect(option);
              }
            }),
            savedBankMandate__ref3,
            Object(preact_min["h"])(
              'div',
              { 'class': 'ptm-pay-method-cont' },
              Object(preact_min["h"])(
                'p',
                { 'class': 'ptm-paymode-name ' },
                option.displayName,
                Object(preact_min["h"])('span', { className: 'ptm-card-type-img ' + option.cardScheme })
              ),
              Object(preact_min["h"])(
                'p',
                { 'class': 'ptm-small-txt' },
                Object(preact_min["h"])(
                  'span',
                  null,
                  'A/C No. XXXX ',
                  option.lastFour
                ),
                option.iconUrl && Object(preact_min["h"])('img', { className: 'ptm-ib ptm-vm ptm-mand-img', src: option.iconUrl, alt: '' })
              )
            )
          )
        )
      ),
      option && isActive && Object(preact_min["h"])(
        'div',
        { className: 'ptm-nb-inner ptm-pl-35' },
        Object(preact_min["h"])(bank_authenticate_BankAuthenticate, {
          authenticateModes: this.authenticateModes,
          selectMode: this.selectAuthMode,
          authModeError: authModeError,
          populateMode: mandateAuthMode
        }),
        showConfirmationScreen && Object(preact_min["h"])(
          components_OverlayWrap,
          null,
          Object(preact_min["h"])(bank_details_confirm, savedBankMandate__extends({
            optedBankData: this.optedBankData,
            accountDetails: this.accountDetails
          }, { genericError: genericError, showLoader: showLoader }, {
            onConfirm: this.onConfirm,
            closeConfirmScreen: this.closeConfirmScreen
          }))
        )
      )
    );
  };

  return SavedBankMandate;
}(preact_min["Component"]);

/* harmony default export */ var savedBankMandate = (Object(preact["connect"])('cache, instanceKey', onChange)(savedBankMandate_SavedBankMandate));
// CONCATENATED MODULE: ./components/ProcessLoader/index.js


var ProcessLoader__ref = Object(preact_min["h"])(
  "div",
  { id: "ptm-spinner" },
  Object(preact_min["h"])("div", { className: "bounce1" }),
  Object(preact_min["h"])("div", { className: "bounce2" }),
  Object(preact_min["h"])("div", { className: "bounce3" }),
  Object(preact_min["h"])("div", { className: "bounce4" }),
  Object(preact_min["h"])("div", { className: "bounce5" })
);

var ProcessLoader = function ProcessLoader() {
  return ProcessLoader__ref;
};

/* harmony default export */ var components_ProcessLoader = (ProcessLoader);
// CONCATENATED MODULE: ./components/overlaybox/index.js


function overlaybox__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function overlaybox__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function overlaybox__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var overlaybox__ref2 = Object(preact_min["h"])(components_ProcessLoader, null);

var overlaybox__ref3 = Object(preact_min["h"])(components_ProcessLoader, null);

var overlaybox_Overlay = function (_Component) {
  overlaybox__inherits(Overlay, _Component);

  function Overlay(props) {
    overlaybox__classCallCheck(this, Overlay);

    var _this = overlaybox__possibleConstructorReturn(this, _Component.call(this, props));

    _this.processingLabel = Object(common["e" /* clientMessage */])(constants["g" /* default */].PROCESSING.toLowerCase(), _this.props.cache).label;
    _this.retryLabel = Object(common["e" /* clientMessage */])(constants["g" /* default */].RETRY.toLowerCase(), _this.props.cache).label;
    return _this;
  }

  Overlay.prototype.render = function render(_ref) {
    var overlayValue = _ref.overlayValue,
        onOverlayValueChange = _ref.onOverlayValueChange,
        retryMessage = _ref.retryMessage,
        customOverlayData = _ref.customOverlayData;

    return Object(preact_min["h"])(
      'div',
      { id: 'checkout-overlay-box' },
      overlayValue && Object(preact_min["h"])(
        components_OverlayWrap,
        null,
        Object(preact_min["h"])(
          'div',
          null,
          overlayValue === constants["g" /* default */].CUSTOM_PROCESSING && customOverlayData && customOverlayData.heading && (customOverlayData.desc || customOverlayData.handlerText && customOverlayData.handler) && Object(preact_min["h"])(
            'div',
            { 'class': 'ptm-process-wrap' },
            Object(preact_min["h"])(
              'div',
              null,
              Object(preact_min["h"])(
                'span',
                { 'class': 'ptm-process-heading ptm-body-color' },
                customOverlayData.heading
              ),
              overlaybox__ref2
            ),
            customOverlayData.desc && Object(preact_min["h"])(
              'p',
              { 'class': 'ptm-overlay-txt ptm-body-color' },
              customOverlayData.desc
            ),
            customOverlayData.handlerText && Object(preact_min["h"])(
              'p',
              {
                'class': 'ptm-overlay-txt ptm-primary ptm-semibold ptm-body-color',
                onClick: customOverlayData.handler
              },
              customOverlayData.handlerText
            )
          ),
          overlayValue === constants["g" /* default */].PROCESSING && Object(preact_min["h"])(
            'div',
            { 'class': 'ptm-process-wrap' },
            Object(preact_min["h"])(
              'div',
              null,
              Object(preact_min["h"])(
                'span',
                { 'class': 'ptm-process-heading ptm-body-color' },
                this.processingLabel.heading
              ),
              overlaybox__ref3
            ),
            Object(preact_min["h"])(
              'p',
              { 'class': 'ptm-overlay-txt ptm-body-color' },
              this.processingLabel.info
            )
          ),
          overlayValue === constants["g" /* default */].RETRY && Object(preact_min["h"])(
            'div',
            { 'class': 'pay-failed' },
            Object(preact_min["h"])(
              'h4',
              { 'class': 'ptm-pay-heading ptm-red-bg ptm-body-color' },
              this.retryLabel.paymentFailed,
              Object(preact_min["h"])('img', {
                className: 'ptm-right ptm-margin0',
                src: Object(common["U" /* staticPath */])() + '/assets/images/ic-failed.svg',
                alt: ''
              })
            ),
            Object(preact_min["h"])(
              'div',
              { 'class': 'ptm-retry-box' },
              Object(preact_min["h"])(
                'span',
                { 'class': 'ptm-sugg-txt ptm-txtcolor ptm-body-color' },
                retryMessage || this.retryLabel.info
              ),
              Object(preact_min["h"])(
                'button',
                {
                  'class': 'ptm-retry-btn ptm-right border-button ptm-custom-btn',
                  onClick: function onClick() {
                    return onOverlayValueChange('');
                  },
                  type: 'button'
                },
                'Retry'
              )
            )
          )
        )
      )
    );
  };

  return Overlay;
}(preact_min["Component"]);

/* harmony default export */ var overlaybox = (Object(preact["connect"])('overlayValue, retryMessage, customOverlayData, cache', onChange)(overlaybox_Overlay));
// CONCATENATED MODULE: ./controllers/switch-user.js








function updateOnNewFPO(response, cache, checkoutElementPayMode, subscription, methods) {
  var _ref = methods || {},
      onSelectChange = _ref.onSelectChange,
      onLoginDataChange = _ref.onLoginDataChange,
      onBtnTextChange = _ref.onBtnTextChange;

  var payOptions = Object(common["K" /* loggedInChanged */])(response, cache, checkoutElementPayMode);
  var selected = Object(common["i" /* defaultSelected */])(payOptions.cashierData, cache);
  // if (selected) {
  //   scrollToSelectedOption(selected);
  // }
  onSelectChange && onSelectChange(selected);
  onLoginDataChange && onLoginDataChange(payOptions.cashierData);
  if (Object(common["j" /* equalsIgnoreCase */])(Object(utils_common["b" /* getKey */])(selected, 'type'), constant["m" /* PAYMODE */].LOGIN)) {
    /*
     * if selected component is login then change btn text to proceed instead of pay
     * */
    var _locale = Object(common["e" /* clientMessage */])(constants["g" /* default */].LOGIN.toLowerCase(), cache);
    onBtnTextChange && onBtnTextChange(_locale.label.btnSendOtpText);
  } else {
    var txnAmount = cache.getData(constants["g" /* default */].TXN_AMOUNT);
    var amountPayable = Object(common["c" /* calculateAmountPayable */])(txnAmount, payOptions.cashierData.wallet, true, subscription);

    var btnText = Object(i18n["a" /* locale */])('payButton.text') + amountPayable;
    if (Object(common["w" /* isAddNPay */])(payOptions.cashierData, cache) && !Object(common["j" /* equalsIgnoreCase */])(Object(utils_common["b" /* getKey */])(selected, 'type'), constants["g" /* default */].MGV)) {
      var _locale2 = Object(i18n["a" /* locale */])('payButton.text'),
          addNPayText = _locale2.addNPayText;

      btnText = addNPayText.replace('amount', amountPayable);
    }
    onBtnTextChange && onBtnTextChange(btnText);
  }
}

function logoutUser(cache, checkoutElementPayMode, subscription, methods) {
  return new Promise(function (resolve, reject) {
    cache.getData(constants["a" /* CACHE */].API).logout().then(function (res) {
      res = res.body;
      if (res && Object(utils_common["b" /* getKey */])(res, 'resultInfo')) {
        if (Object(utils_common["b" /* getKey */])(res, 'txnInfo.RESPCODE', '') === '1006' || Object(utils_common["b" /* getKey */])(res, 'resultInfo.resultCode', '') === '1006') {
          var mConfig = cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
          cache.getData(constants["a" /* CACHE */].STORE).setState({ sessionExpired: true });
          var notifyMerchant = Object(utils_common["b" /* getKey */])(mConfig, 'handler.notifyMerchant', undefined);
          if (notifyMerchant && notifyMerchant.constructor === Function) {
            notifyMerchant(constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.SESSION_EXPIRED, res);
          }
        }
        var resultCode = Object(utils_common["b" /* getKey */])(res, 'resultInfo.resultStatus', '');
        var isSuccess = Object(common["j" /* equalsIgnoreCase */])(resultCode, constants["d" /* RESPONSE_STATUS */].S) || Object(common["j" /* equalsIgnoreCase */])(resultCode, constants["d" /* RESPONSE_STATUS */].SUCCESS);
        if (isSuccess) {
          Object(logger["log"])({
            eventType: 'Checkout_Logout',
            logOutSuccess: true
          });
          if (checkoutElementPayMode) {
            var _globaleStore$setStat;

            var clonedResponse = Object(common["f" /* cloneObject */])(res);
            common_cache["b" /* globaleStore */].setState((_globaleStore$setStat = {}, _globaleStore$setStat[constants["c" /* GLOBAL_STORE */].FPO_UPDATED_RESPONSE] = clonedResponse, _globaleStore$setStat));
          } else {
            updateOnNewFPO(res, cache, checkoutElementPayMode, subscription, methods);
          }
          resolve({ response: res, isSuccess: isSuccess });
        } else {
          var errorMsg = Object(utils_common["b" /* getKey */])(res, 'resultInfo.resultMsg', constants["g" /* default */].GENERIC_ERROR);
          Object(logger["log"])({
            eventType: 'Checkout_Logout',
            logOutSuccess: false,
            errorMsg: errorMsg
          });
          reject(res);
        }
      }
    }).catch(function (err) {
      var errorMsg = Object(utils_common["b" /* getKey */])(err, 'body.resultInfo.resultMsg', constants["g" /* default */].GENERIC_ERROR);
      Object(logger["log"])({
        eventType: 'Checkout_Logout',
        logOutSuccess: false,
        errorMsg: errorMsg
      });
      reject(err);
    });
  });
}
// EXTERNAL MODULE: ./common/localStorage.js
var localStorage = __webpack_require__("/tqE");

// CONCATENATED MODULE: ./components/LoginComponent/loginComponent.js


function loginComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function loginComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function loginComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var loginComponent__ref3 = Object(preact_min["h"])('span', { 'class': 'ptm-checkmark' });

var loginComponent__ref4 = Object(preact_min["h"])('span', { className: 'ptm-check' });

var loginComponent_LoginComponent = function (_Component) {
  loginComponent__inherits(LoginComponent, _Component);

  function LoginComponent(props) {
    loginComponent__classCallCheck(this, LoginComponent);

    var _this = loginComponent__possibleConstructorReturn(this, _Component.call(this, props));

    _this.numberRegex = /[^0-9]/g;
    _this.mobileRef = '';
    _this.interval = null;
    _this.otpRef = '';

    _this.focusOnMobileInput = function () {
      try {
        Object(logger["log"])({ eventType: logger["EVENT"].MOBILE_NUMBER_FOCUS });
        /* setting timeout since coming from  change number input was not being focused */
        setTimeout(function () {
          !Object(common["C" /* isIphoneDevice */])() && Object(common["E" /* isMobileDevice */])() && _this.mobileRef && _this.mobileRef.focus();
          var loginElement = document.getElementById('checkout-login');
          var loginComponentOffsetTop = Object(common["q" /* getKey */])(loginElement, 'offsetTop', 0);
          Object(common["R" /* scrollInContentWrap */])(loginComponentOffsetTop + 16);
        }, 100);
        /* setting timeout scrolling since when keyboard opens the height changes , and it will
        scrolleffectively to the paymode
        when setimeout is removed it scrolls and then keyboard opens because of which the scrolling
         doest happen perfectly */
        // setTimeout(() => {
        // if (deviceHeightLessThan640()) {
        //   /*
        //  scrolling down some extra px  so that when scrolled to element header is fixed the field is focused the
        //  field is visible and keyboard doesnt overlap
        // */
        //   scrollInContentWrap(loginComponentOffsetTop + 16);
        // } else {
        //   // for devices with height greater than 640 there is no issue of overlap so scroll to component works
        //   scrollInContentWrap(loginComponentOffsetTop + 16);
        // }
        // }, 350);
      } catch (error) {
        Object(logger["log"])({ eventType: logger["EVENT"].MOBILE_NUMBER_FOCUS, error: error });
      }
    };

    _this.focusOnOTPInput = function () {
      try {
        Object(logger["log"])({ eventType: logger["EVENT"].OTP_FOCUS });
        setTimeout(function () {
          !Object(common["C" /* isIphoneDevice */])() && _this.otpRef && _this.otpRef.focus();
        }, 100);
        /*
          scrolling down 280px  (calculated by elements height above the input) so that when the field is focused the
          field is visible  and keyboard doesnt overlap
         */
        Object(common["R" /* scrollInContentWrap */])(285);
      } catch (error) {
        Object(logger["log"])({ eventType: logger["EVENT"].OTP_FOCUS_ERROR, error: error });
      }
    };

    _this.handleComponentClick = function () {
      _this.props.onSelectChange(_this.props.option);
      _this.props.updatePcfAmount(null);
      _this.props.applyPromoForPayMode();
      setTimeout(function () {
        if (!_this.state.showOtpInput) {
          /* focus on mobile number input t */
          // this.focusOnMobileInput();
          _this.props.onBtnTextChange(_this.label.btnSendOtpText);
        } else {
          /* focus on otp input */
          // this.focusOnOTPInput();
          _this.props.onBtnTextChange(_this.label.btnVerifyOtpText);
        }
      }, 0);
      _this.setState({ sendOtpApiMsg: false, invalidMobileNumber: false, showOtpInputErr: false });
      _this.props.onPayChange(true);
    };

    _this.submit = function () {
      if (!_this.state.showOtpInput) {
        _this.sendOtp(false);
      } else {
        _this.verifyOtp(_this.state.otp);
      }
    };

    _this.restrictInput = function (ev) {
      var digit = String.fromCharCode(ev.which);
      if (ev.key !== undefined) {
        digit = ev.key;
      }
      // any other character than digit
      if (!/^\d+$/.test(digit)) {
        if (ev.which !== 8 && ev.which !== 9 && ev.which !== 37 && ev.which !== 39) {
          ev.preventDefault();
        }
      }
      _this.setState({ showMobileInputErr: false });
    };

    _this.handleFocusInMobile = function () {
      _this.setState({ monileNumberFocus: true, otpFocus: false });
    };

    _this.handleFocusInOtp = function () {
      _this.setState({ monileNumberFocus: false, otpFocus: true });
    };

    _this.keyUpMobile = function (e, inputLength) {
      e.currentTarget.value = e.currentTarget.value.replace(_this.numberRegex, '');
      if (e.currentTarget.value.length > inputLength) {
        e.currentTarget.value = e.currentTarget.value.substring(0, e.currentTarget.value.length - 1);
      }
      _this.mobileRef.value = e.currentTarget.value;
      _this.setState({
        invalidMobileNumber: false,
        sendOtpApiMsg: false,
        mobileNumber: _this.mobileRef.value
      });
    };

    _this.keyUpOtp = function (e, inputLength) {
      e.currentTarget.value = e.currentTarget.value.replace(_this.numberRegex, '');
      if (e.currentTarget.value.length > inputLength) {
        e.currentTarget.value = e.currentTarget.value.substring(0, e.currentTarget.value.length - 1);
      }
      _this.setState({ otp: e.currentTarget.value, showOtpInputErr: false });
    };

    _this.hideOtpSentMessage = function () {
      _this.props.onOtpSentChange(false);
    };

    _this.sendOtp = function () {
      var isResend = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (isResend) {
        Object(logger["log"])({ eventType: logger["EVENT"].REQUEST_ANOTHER_OTP });
      }
      var mobileNumber = _this.mobileRef.value;
      if (Number.isNaN(mobileNumber) || mobileNumber.toString().length !== 10) {
        _this.setState({ invalidMobileNumber: true, showOtpInput: false });
      } else {
        _this.props.onPayChange(false);
        _this.props.cache.getData(constants["a" /* CACHE */].API).sendOtp(mobileNumber).then(function (res) {
          _this.props.onPayChange(true);
          res = res.body;
          _this.setState({ showMobileInputErr: false, invalidMobileNumber: false });
          if (res && Object(common["q" /* getKey */])(res, 'resultInfo.resultStatus')) {
            if (res.resultInfo.resultStatus === 'S' || res.resultInfo.resultStatus === 'SUCCESS') {
              _this.setState({ showOtpInput: true });
              _this.props.onOtpSentChange(true);
              _this.props.onBtnTextChange(_this.label.btnVerifyOtpText);
              _this.interval = setTimeout(_this.hideOtpSentMessage.bind(_this), 5000);
              /* focus on otp input */
              // this.focusOnOTPInput();
            } else if (Object(common["q" /* getKey */])(res, 'resultInfo.resultMsg')) {
              _this.setState({
                sendOtpApiMsg: res.resultInfo.resultMsg,
                showOtpInput: false,
                showMobileInputErr: true
              });
            }
          }
        }).catch(function () {
          _this.props.onPayChange(true);
        });
      }
    };

    _this.handlePastedInput = function (e) {
      var clipboard = e.clipboardData || window.clipboardData;
      var output = '';
      if (clipboard) {
        output = clipboard.getData && clipboard.getData('text') || '';
      }
      var otp = output.replace(/\D/g, '');
      otp = otp.substring(0, 6);
      e.target.value = otp;
      _this.setState({ otp: otp });
      e.preventDefault();
    };

    _this.verifyOtp = function (otp) {
      if (Number.isNaN(otp) || otp.toString().length !== 6) {
        Object(logger["log"])({ eventType: logger["EVENT"].CLIENT_VALIDATION_INVALID_OTP, value: otp });
        _this.setState({
          showOtpInputErr: true,
          VerifyOtpMsg: _this.error.invalidOtpLength
        });
      } else {
        Object(logger["log"])({ eventType: logger["EVENT"].MANUAL_LOGIN });
        _this.props.onPayChange(false);
        var _rememberMe = _this.state.rememberMe;
        _this.props.cache.getData(constants["a" /* CACHE */].API).verifyOtp(otp, _rememberMe).then(function (res) {
          _this.props.onPayChange(true);
          res = res.body;
          if (res && Object(common["q" /* getKey */])(res, 'resultInfo')) {
            if (res.resultInfo.resultStatus === 'S' || res.resultInfo.resultStatus === 'SUCCESS') {
              Object(logger["log"])({ eventType: logger["EVENT"].LOGIN_SUCCESSFUL });
              /* adding try catch so that if there is error in processing logging  data txn flow is not affected  */
              try {
                var cashierData = JSON.parse(JSON.stringify(Object(common["q" /* getKey */])(res, 'cashierData', null)));
                /* Adding Logic for using saved Paymode in local Storage when user is logged in */
                _this.props.cache.setData(constants["g" /* default */].IS_LOGGED_IN, Object(common["q" /* getKey */])(cashierData, 'loginInfo.userLoggedIn'));
                if (_this.props.cache.getData(constants["g" /* default */].IS_LOGGED_IN) && _this.props.cache.getData(constants["g" /* default */].IS_LOCAL_STORAGE_ALLOWED)) {
                  _this.props.cache.setData(constants["g" /* default */].MOBILE_NO, Object(common["q" /* getKey */])(cashierData.userDetails, 'mobile'));
                  Object(localStorage["b" /* processLocalStorage */])(_this.props.cache);
                }
                var cashierDataForLogging = Object(common["Q" /* removeDataForLogging */])(cashierData);
                Object(logger["log"])({ eventType: logger["EVENT"].LOGIN_FPO_RESPONSE, cashierData: cashierDataForLogging });
              } catch (error) {
                Object(logger["log"])({ eventType: logger["EVENT"].LOGIN_FPO_RESPONSE_ERROR, error: error });
              }
              _this.setState({ isOtpValid: true, showOtpInputErr: false });
              if (_this.props.checkoutElementPayMode) {
                var _globaleStore$setStat;

                common_cache["b" /* globaleStore */].setState((_globaleStore$setStat = {}, _globaleStore$setStat[constants["c" /* GLOBAL_STORE */].FPO_UPDATED_RESPONSE] = Object(common["f" /* cloneObject */])(res), _globaleStore$setStat));
              } else {
                var _this$props = _this.props,
                    onSelectChange = _this$props.onSelectChange,
                    onLoginDataChange = _this$props.onLoginDataChange,
                    onBtnTextChange = _this$props.onBtnTextChange;

                updateOnNewFPO(res, _this.props.cache, _this.props.checkoutElementPayMode, _this.props.subscription, {
                  onSelectChange: onSelectChange,
                  onLoginDataChange: onLoginDataChange,
                  onBtnTextChange: onBtnTextChange
                });
                // scrollInContentWrap(60);
              }
              _this.clearOtp();
            } else {
              var errorMsg = Object(common["q" /* getKey */])(res, 'resultInfo.resultMsg', constants["g" /* default */].GENERIC_ERROR);
              _this.setState({
                isOtpValid: false,
                showOtpInputErr: true,
                VerifyOtpMsg: errorMsg
              });
            }
          }
        }).catch(function (err) {
          _this.props.onPayChange(true);
          var errorMsg = Object(common["q" /* getKey */])(err, 'body.resultInfo.resultMsg', constants["g" /* default */].GENERIC_ERROR);
          _this.setState({
            showOtpInputErr: true,
            VerifyOtpMsg: errorMsg
          });
        });
      }
    };

    _this.rememberMe = function () {
      _this.setState(function (prevState) {
        Object(logger["log"])({ eventType: logger["EVENT"].REMEMBER_ME, value: !prevState.rememberMe });
        return { rememberMe: !prevState.rememberMe };
      });
    };

    _this.changeNumber = function () {
      Object(logger["log"])({ eventType: logger["EVENT"].CHANGE_MOBILE_NUMBER });
      _this.setState({ showOtpInput: false });
      // this.focusOnMobileInput();
      _this.props.onBtnTextChange(_this.label.btnSendOtpText);
      _this.hideOtpSentMessage(); // hide send otp text when change is tapped and if msg is still visible
      clearInterval(_this.interval); // clear the setTimeoutinterval for hiding the sent message timeout
      _this.clearOtp(); // clear the previously entered OTP
    };

    _this.clearOtp = function () {
      if (_this.otpRef) {
        _this.otpRef.value = '';
      }
    };

    _this.setInitialState();
    var locale = Object(common["e" /* clientMessage */])(constants["g" /* default */].LOGIN.toLowerCase(), _this.props.cache);
    _this.label = locale.label;
    _this.error = locale.error;
    return _this;
  }

  LoginComponent.prototype.setInitialState = function setInitialState() {
    var resetRememberMe = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    var state = {
      showOtpInput: false,
      invalidMobileNumber: false,
      sendOtpApiMsg: false,
      validateOtpErrMsg: '',
      showMobileInputErr: false,
      otpInput: '',
      isOtpValid: false,
      showOtpInputErr: false,
      mobileNumber: '',
      otp: '',
      monileNumberFocus: false,
      otpFocus: false,
      VerifyOtpMsg: '',
      pwpEnabled: Object(common["q" /* getKey */])(this.props.cache.getData(constants["a" /* CACHE */].PAYMENT_OPTIONS, {}), 'pwpEnabled')
    };

    if (resetRememberMe) {
      state.rememberMe = false;
      state.showRememberStrip = false;
    }

    this.setState(state);
  };

  LoginComponent.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var _rememberMe = this.props.cache.getData('paymentOptions').loginInfo && this.props.cache.getData('paymentOptions').loginInfo.pgAutoLoginEnabled;
    this.setState({ rememberMe: _rememberMe, showRememberStrip: _rememberMe });
    var paymentMode = Object(common["q" /* getKey */])(this.props, 'selected.paymentMode', null);
    if (Object(common["j" /* equalsIgnoreCase */])(paymentMode, constant["m" /* PAYMODE */].LOGIN)) {
      // this.focusOnMobileInput();
      setTimeout(function () {
        _this2.props.onBtnTextChange(_this2.label.btnSendOtpText);
      }, 0);
    }
  };

  LoginComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(previousProps) {
    var selected = Object(common["q" /* getKey */])(this.props, 'selected', null);

    if (selected && Object(common["j" /* equalsIgnoreCase */])(selected.type, constant["m" /* PAYMODE */].LOGIN) && previousProps.selected !== this.props.selected) {
      this.setInitialState(false);
    }
  };

  LoginComponent.prototype.render = function render(_ref, _ref2) {
    var _this3 = this;

    var instanceKey = _ref.instanceKey,
        selected = _ref.selected,
        loginInfo = _ref.loginInfo,
        option = _ref.option,
        isActive = _ref.isActive,
        isPromoAvailable = _ref.isPromoAvailable;
    var showOtpInput = _ref2.showOtpInput,
        sendOtpApiMsg = _ref2.sendOtpApiMsg,
        invalidMobileNumber = _ref2.invalidMobileNumber,
        showMobileInputErr = _ref2.showMobileInputErr,
        showOtpInputErr = _ref2.showOtpInputErr,
        VerifyOtpMsg = _ref2.VerifyOtpMsg,
        rememberMe = _ref2.rememberMe,
        showRememberStrip = _ref2.showRememberStrip,
        pwpEnabled = _ref2.pwpEnabled;

    return Object(preact_min["h"])(
      'div',
      { 'class': 'ptm-pay-method ptm-w100-ib', id: 'checkout-login' },
      Object(preact_min["h"])(
        'div',
        { 'class': 'ptm-radio-wrap', onClick: function onClick() {
            return _this3.handleComponentClick();
          } },
        Object(preact_min["h"])(
          'label',
          { 'class': 'ptm-lbl' },
          Object(preact_min["h"])('input', {
            type: 'radio',
            name: 'verify' + instanceKey,
            checked: isActive,
            className: 'ptm-margin0'
          }),
          loginComponent__ref3,
          Object(preact_min["h"])(
            'div',
            { 'class': 'ptm-pay-method-cont' },
            Object(preact_min["h"])(
              'p',
              { 'class': 'ptm-paymode-name' },
              Object(preact_min["h"])('img', {
                className: 'ptm-wallet-logo ptm-pos-r ptm-left ',
                src: Object(common["U" /* staticPath */])() + '/assets/images/logo-paytm.svg',
                alt: 'paytm'
              }),
              'Account'
            ),
            Object(preact_min["h"])(
              'p',
              { className: 'ptm-small-txt' },
              this.label.labelMessage
            )
          )
        )
      ),
      loginInfo && selected && selected.id === option.id && Object(preact_min["h"])(
        'div',
        { className: 'ptm-pl-35' },
        Object(preact_min["h"])(
          'div',
          { className: ' ptm-inner-input-wrap ptm-pos-r ' + (showOtpInput ? 'ptm-hidden' : '') },
          Object(preact_min["h"])('input', {
            className: 'ptm-pos-r ptm-margin0 ptm-pb-input ' + (showMobileInputErr ? 'err' : '') + ' ptm-input-common ',
            id: 'mobile_input',
            type: 'tel',
            maxLength: '10',
            ref: function ref(r) {
              return _this3.mobileRef = r;
            },
            onKeyDown: function onKeyDown(e) {
              return _this3.restrictInput(e, 10);
            },
            onKeyUp: function onKeyUp(e) {
              return _this3.keyUpMobile(e, 10);
            },
            onFocusIn: function onFocusIn() {
              return _this3.handleFocusInMobile();
            }
          }),
          Object(preact_min["h"])(
            'p',
            {
              className: 'ptm-body-color ptm-placeholder-txt ptm-pos-a ' + (this.mobileRef && this.mobileRef.value ? 'ptm-has-value' : '')
            },
            'Mobile Number'
          ),
          isPromoAvailable && pwpEnabled && Object(preact_min["h"])(
            'p',
            { className: 'ptm-small-txt ptm-pwp-bo-warn' },
            Object(i18n["a" /* locale */])('offers.pwpPreLogin')
          ),
          invalidMobileNumber && Object(preact_min["h"])(
            'p',
            { className: 'ptm-small-txt ptm-msg-red' },
            this.error.invalidMobileInput
          ),
          sendOtpApiMsg && Object(preact_min["h"])(
            'p',
            { className: 'ptm-small-txt ptm-msg-red ptm-session-exp' },
            sendOtpApiMsg
          ),
          showRememberStrip && !showOtpInput && Object(preact_min["h"])(
            'label',
            { className: 'ptm-container ptm-mt-16' },
            Object(preact_min["h"])('input', {
              id: 'storeCard',
              type: 'checkbox',
              className: 'ptm-margin0',
              checked: rememberMe,
              onClick: function onClick() {
                return _this3.rememberMe();
              }
            }),
            loginComponent__ref4,
            this.label.rememberMe
          )
        ),
        Object(preact_min["h"])(
          'div',
          { className: '\'otp-wrap\' ' + (!showOtpInput ? 'ptm-hidden' : '') + ' ptm-otp-input-wrap' },
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-otp-heading' },
            Object(preact_min["h"])(
              'span',
              { className: 'ptm-otp-txt ptm-body-color' },
              this.label.otpSentNumberMessage
            ),
            Object(preact_min["h"])(
              'p',
              { className: 'ptm-mo-number ptm-body-color' },
              this.state.mobileNumber,
              Object(preact_min["h"])(
                'span',
                {
                  className: 'ptm-primary ptm-right ptm-change-number',
                  onClick: this.changeNumber
                },
                'Change Number'
              )
            )
          ),
          Object(preact_min["h"])(
            'p',
            { className: 'ptm-otp ptm-body-color ptm-global-border' },
            'OTP'
          ),
          Object(preact_min["h"])('input', {
            type: 'tel',
            id: 'ptm-otp-input',
            maxlength: '6',
            autofocus: true,
            ref: function ref(r) {
              return _this3.otpRef = r;
            },
            className: 'ptm-margin0 ptm-input-common ptm-enter-otp ' + (showOtpInputErr ? 'err' : ''),
            onKeyDown: function onKeyDown(e) {
              return _this3.restrictInput(e, 6);
            },
            onKeyUp: function onKeyUp(e) {
              return _this3.keyUpOtp(e, 6);
            },
            onFocusIn: function onFocusIn() {
              return _this3.handleFocusInOtp();
            },
            onPaste: function onPaste(e) {
              _this3.handlePastedInput(e);
            }
          }),
          showOtpInputErr && Object(preact_min["h"])(
            'p',
            { className: 'ptm-small-txt ptm-msg-red' },
            VerifyOtpMsg
          ),
          Object(preact_min["h"])(
            'p',
            { className: 'ptm-resend ptm-body-color' },
            this.label.otpNotreceived,
            Object(preact_min["h"])(
              'span',
              { className: 'ptm-primary ptm-resend-otp', onClick: function onClick() {
                  return _this3.sendOtp();
                } },
              this.label.requestOtp
            )
          )
        )
      )
    );
  };

  return LoginComponent;
}(preact_min["Component"]);

/* harmony default export */ var loginComponent = (Object(preact["connect"])('selected,loginInfo, cache, instanceKey, checkoutElementPayMode, subscription', onChange)(loginComponent_LoginComponent));
// CONCATENATED MODULE: ./components/footer/index.js


function footer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function footer__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function footer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var footer_Footer = function (_Component) {
  footer__inherits(Footer, _Component);

  function Footer(props) {
    footer__classCallCheck(this, Footer);

    var _this = footer__possibleConstructorReturn(this, _Component.call(this, props));

    _this.label = Object(common["e" /* clientMessage */])(constants["g" /* default */].FOOTER.toLowerCase(), _this.props.cache).label;
    return _this;
  }

  Footer.prototype.render = function render() {
    return Object(preact_min["h"])(
      'div',
      { 'class': 'ptm-footer ptm-lightblue-bg', id: 'checkout-footer' },
      Object(preact_min["h"])('img', {
        src: Object(common["U" /* staticPath */])() + '/assets/images/secure.png',
        alt: 'secure',
        className: 'ptm-margin0'
      }),
      Object(preact_min["h"])(
        'span',
        { 'class': 'ptm-text-blue' },
        this.label.message
      )
    );
  };

  return Footer;
}(preact_min["Component"]);

/* harmony default export */ var footer = (Object(preact["connect"])('cache')(footer_Footer));
// CONCATENATED MODULE: ./components/notification/index.js


function notification__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function notification__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function notification__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function notification__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var notification_Notification = function (_Component) {
  notification__inherits(Notification, _Component);

  function Notification() {
    var _temp, _this, _ret;

    notification__classCallCheck(this, Notification);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = notification__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.hideNotificationBar = function () {
      _this.props.onNotificationTextChange(null);
    }, _temp), notification__possibleConstructorReturn(_this, _ret);
  }

  Notification.prototype.render = function render(_ref, _ref2) {
    var notificationMsg = _ref.notificationMsg;

    notification__objectDestructuringEmpty(_ref2);

    return Object(preact_min["h"])(
      'div',
      { className: 'ptm-notify-box' },
      Object(preact_min["h"])(
        'p',
        { className: 'ptm-notify-txt' },
        notificationMsg
      ),
      Object(preact_min["h"])(
        'div',
        {
          className: 'ptm-notify-btn ptm-centralized ptm-pos-a',
          onClick: this.hideNotificationBar
        },
        'OK'
      )
    );
  };

  return Notification;
}(preact_min["Component"]);

/* harmony default export */ var notification = (Object(preact["connect"])('notificationMsg', onChange)(notification_Notification));
// EXTERNAL MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/index.api.js + 16 modules
var index_api = __webpack_require__("NOly");

// CONCATENATED MODULE: ./controllers/pcf.js
var pcf__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var _PCF_KEY_DELIMITER = '@';

/* -------------------------------------------------------------------------- */
/*                              DEFAULT FLOW PCF                              */
/* -------------------------------------------------------------------------- */

function _fetchPcfDetailsForDefault(cache, payMode, txnAmount) {
  return getApi(cache).fetchPcfDetails(payMode, txnAmount).then(function (response) {
    return ifSuccessOrThrowError(response, function (callBackResponse) {
      return callBackResponse;
    });
  });
}

/* -------------------------------------------------------------------------- */
/*                              PCF API Evaluation                            */
/* -------------------------------------------------------------------------- */

function _getPcfApi() {
  // To be later used when deferred is in place.
  // const { flow } = cache.getData(CACHE.MERCHANT_CONFIG);

  // return equalsIgnoreCase(flow, FLOW.DEFERRED) ?
  //     _fetchPcfDetailsForDeferred :
  //     _fetchPcfDetailsForDefault;

  return _fetchPcfDetailsForDefault;
}

/* -------------------------------------------------------------------------- */
/*                              PCF methods                            */
/* -------------------------------------------------------------------------- */

function _getPcfKeyPayMethodObj(payMethodObj) {
  var prefixedInstId = payMethodObj.instId ? _PCF_KEY_DELIMITER + payMethodObj.instId : '';

  return payMethodObj.payMethod + prefixedInstId;
}
function _getPayMethodObj(payMode, channelCode) {
  var payMethodObj = {};

  if (Object(common["j" /* equalsIgnoreCase */])(payMode.type, 'sc')) {
    payMethodObj.payMethod = Object(common["q" /* getKey */])(payMode, 'cardDetails.cardType', '').toUpperCase();
    payMethodObj.instId = Object(common["q" /* getKey */])(payMode, 'issuingBank');
  } else {
    payMethodObj.payMethod = payMode.paymentMode.toUpperCase();

    if (channelCode) {
      payMethodObj.instId = channelCode;
    }
  }

  return payMethodObj;
}

/* -------------------------------------------------------------------------- */
/*                              PCF methods                            */
/* -------------------------------------------------------------------------- */

function _fetchPcf(cache, payMethods, txnAmount) {
  return _getPcfApi()(cache, payMethods, txnAmount).then(function (response) {
    var consultDetails = Object(common["q" /* getKey */])(response, 'consultDetails', {});
    var convenienceCharges = pcf__extends({}, cache.getData(constants["a" /* CACHE */].CONVENIENCE_CHARGES, {}));
    var isSinglePayMethods = payMethods.length === 1;

    Object.keys(consultDetails).forEach(function (payMode) {
      var payModeKey = isSinglePayMethods ? _getPcfKeyPayMethodObj(payMethods[0]) : payMode;
      convenienceCharges[payModeKey] = consultDetails[payMode];
    });

    cache.setData(constants["a" /* CACHE */].CONVENIENCE_CHARGES, convenienceCharges);

    return convenienceCharges;
  });
}

function fetchPcfForPayMode(cache, payMode, channelCode) {
  var txnAmount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  if (Object.prototype.hasOwnProperty.call(payMode, 'isWalletOnly')) {
    payMode = pcf__extends({}, payMode, { paymentMode: constants["g" /* default */].WALLET });
  }

  var payMethodObj = _getPayMethodObj(payMode, channelCode);
  var payModeKey = _getPcfKeyPayMethodObj(payMethodObj);
  var savedConvenienceCharges = cache.getData(constants["a" /* CACHE */].CONVENIENCE_CHARGES, {});
  var cachedChargesForPayMode = savedConvenienceCharges[payModeKey];

  if (cachedChargesForPayMode) {
    return Promise.resolve(cachedChargesForPayMode);
  }

  return _fetchPcf(cache, [payMethodObj], txnAmount).then(function () {
    var convenienceCharges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return convenienceCharges[payModeKey];
  });
}

function fetchPcfForAllPayModes(cache) {
  var txnAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var paymentOptions = cache.getData('paymentOptions');
  var paymentModes = [].concat(Object(common["q" /* getKey */])(paymentOptions, 'payData.paymentModes', []));

  // Manually append wallet pay mode since wallet is not available in pay modes cache.
  if (Object(common["q" /* getKey */])(paymentOptions, 'wallet')) {
    paymentModes.push({ paymentMode: constants["g" /* default */].WALLET });
  }

  var payMethods = [];
  paymentModes.forEach(function (mode) {
    if (Object(common["j" /* equalsIgnoreCase */])(mode.paymentMode, constant["m" /* PAYMODE */].LOGIN)) {
      return;
    }

    // Need to append CC or DC as only one card type is included
    // in pay mode during parsing of pay modes.
    if (Object(common["j" /* equalsIgnoreCase */])(mode.paymentMode, constants["g" /* default */].CC)) {
      payMethods.push(_getPayMethodObj({
        paymentMode: constants["g" /* default */].DC
      }));
    } else if (Object(common["j" /* equalsIgnoreCase */])(mode.paymentMode, constants["g" /* default */].DC)) {
      payMethods.push(_getPayMethodObj({
        paymentMode: constants["g" /* default */].CC
      }));
    }

    payMethods.push(_getPayMethodObj(mode));
  });

  if (payMethods.length) {
    return _fetchPcf(cache, payMethods, txnAmount).then(function (charges) {
      return Object.keys(charges).reduce(function (acc, chargeKey) {
        if (chargeKey.indexOf(_PCF_KEY_DELIMITER) === -1) {
          acc[chargeKey] = charges[chargeKey];
        }
        return acc;
      }, {});
    });
  }

  return Promise.resolve({});
}

function pcf_isPcfEnabled(cache) {
  // Currently PCF is not supported for DEFERRED
  var _cache$getData = cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG),
      flow = _cache$getData.flow;

  if (Object(common["j" /* equalsIgnoreCase */])(flow, constant["h" /* FLOW */].DEFERRED)) {
    return false;
  }

  var paymentOptions = cache.getData(constants["a" /* CACHE */].PAYMENT_OPTIONS, {});
  return Object(common["q" /* getKey */])(paymentOptions, 'pcfEnabled', false);
}

function updatedPcfAmountAndReturn(cache, pcf) {
  var txnAmount = cache.getData(constants["g" /* default */].TXN_AMOUNT);
  var fallBackAmount = cache.getData(constants["g" /* default */].WITHOUT_PCF_TXN_AMOUNT, txnAmount);
  var pcfFeeAmount = 0;
  var newTransactionAmount = fallBackAmount;

  cache.setData(constants["g" /* default */].WITHOUT_PCF_TXN_AMOUNT, fallBackAmount);

  if (pcf) {
    var taxAmount = pcf.taxAmount,
        feeAmount = pcf.feeAmount;

    pcfFeeAmount = Number(taxAmount.value) + Number(feeAmount.value);
    newTransactionAmount = Object(common["L" /* money */])(Number(fallBackAmount) + pcfFeeAmount);
  }

  cache.setData(constants["g" /* default */].TXN_AMOUNT, newTransactionAmount);
  return pcfFeeAmount;
}

function updatePcfInCache(cache, payMode, channelCode, pcf) {
  var convenienceCharges = pcf__extends({}, cache.getData(constants["a" /* CACHE */].CONVENIENCE_CHARGES, {}));
  var payMethodObj = _getPayMethodObj(payMode, channelCode);
  var payModeKey = _getPcfKeyPayMethodObj(payMethodObj);
  convenienceCharges[payModeKey] = pcf;
  cache.setData(constants["a" /* CACHE */].CONVENIENCE_CHARGES, convenienceCharges);
}
// CONCATENATED MODULE: ./components/convHelp/index.js





var convHelp__ref2 = Object(preact_min["h"])(RupeeSymbol, null);

var convHelp_ConvenienceHelp = function ConvenienceHelp(_ref) {
  var convChargeDetails = _ref.convChargeDetails;

  var varyAmount = {
    NET_BANKING: Object(i18n["a" /* locale */])('pcf.nb'),
    CREDIT_CARD: Object(i18n["a" /* locale */])('pcf.cc')
  };

  return Object(preact_min["h"])(
    'div',
    {
      'class': 'ptm-body-bg ptm-ttp ptm-white-bg ptm-pos-a ptm-ttp-bottom popup-global cnvc-before-icon'
    },
    Object(preact_min["h"])(
      'label',
      { 'class': 'ptm-ccl ptm-d-block ptm-body-color' },
      Object(i18n["a" /* locale */])('pcf.convenience.charge')
    ),
    Object(preact_min["h"])(
      'ul',
      { 'class': 'ptm-details sub-txt-global' },
      Object.keys(convChargeDetails).map(function (data) {
        return Object(preact_min["h"])(
          'li',
          { 'class': 'ptm-w100-ib ptm-vt ptm-body-color' },
          Object(preact_min["h"])(
            'div',
            { 'class': 'ptm-left ptm-body-color' },
            convChargeDetails[data].displayText,
            varyAmount[data] && Object(preact_min["h"])(
              'span',
              { className: 'ptm-body-color' },
              '*'
            ),
            varyAmount[data] && Object(preact_min["h"])(
              'div',
              { 'class': 'ptm-apx-amnt ptm-max-150 sub-txt-global ptm-body-color' },
              Object(preact_min["h"])(
                'span',
                { className: 'ptm-body-color' },
                '*'
              ),
              varyAmount[data]
            )
          ),
          Object(preact_min["h"])(
            'div',
            { 'class': 'ptm-right ptm-body-color' },
            convHelp__ref2,
            ' ',
            Object(preact_min["h"])(
              'span',
              { 'class': 'ptm-semibold ptm-body-color' },
              Object(common["g" /* commas */])(convChargeDetails[data].feeAmount.value.indexOf('.') >= 0 ? '' + convChargeDetails[data].feeAmount.value.split('.')[0] : convChargeDetails[data].feeAmount.value)
            ),
            convChargeDetails[data].feeAmount.value.indexOf('.') >= 0 ? Object(preact_min["h"])(
              'span',
              { 'class': 'sub-txt-global ptm-body-color' },
              '.',
              convChargeDetails[data].feeAmount.value.split('.')[1]
            ) : null,
            '+ GST ',
            Object(i18n["a" /* locale */])('pcf.applicable')
          )
        );
      })
    )
  );
};

/* harmony default export */ var convHelp = (convHelp_ConvenienceHelp);
// CONCATENATED MODULE: ./components/convenienceChg/index.js


function convenienceChg__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function convenienceChg__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function convenienceChg__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var convenienceChg__ref3 = Object(preact_min["h"])(RupeeSymbol, null);

var convenienceChg_ConvenienceCharge = function (_Component) {
  convenienceChg__inherits(ConvenienceCharge, _Component);

  function ConvenienceCharge(props) {
    convenienceChg__classCallCheck(this, ConvenienceCharge);

    var _this = convenienceChg__possibleConstructorReturn(this, _Component.call(this, props));

    _this.toggleHelp = function () {
      _this.setState(function (prevState) {
        return {
          isAllModePcfDetailsVisible: !prevState.isAllModePcfDetailsVisible
        };
      });
    };

    _this.closeHelp = function () {
      _this.setState({ isAllModePcfDetailsVisible: false });
    };

    _this.mouseDownEvent = function (e) {
      if (e) {
        _this.closeHelp();
        e.stopPropagation();
      }
    };

    _this.cnvBoxClick = function (e) {
      e.stopPropagation();
    };

    _this.state = {
      isAllModePcfDetailsVisible: false,
      convChargeDetails: {}
    };
    return _this;
  }

  ConvenienceCharge.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    document.addEventListener('mouseup', this.mouseDownEvent);
    var txnAmount = 0;
    if (this.props.cache.getData(constants["g" /* default */].IS_EMISUBVENTION_ACCESS_TOKEN_FLOW)) {
      txnAmount = this.props.cache.getData(constants["g" /* default */].TXN_AMOUNT);
    }
    fetchPcfForAllPayModes(this.props.cache, txnAmount).then(function (convChargeDetails) {
      _this2.setState({ convChargeDetails: convChargeDetails });
    }).catch(function () {
      _this2.setState({ convChargeDetails: {} });
    });
  };

  ConvenienceCharge.prototype.componentDidUpdate = function componentDidUpdate(previousProps) {
    if (this.props.headerFixClass !== previousProps.headerFixClass && this.state.isAllModePcfDetailsVisible) {
      this.closeHelp();
    }
  };

  ConvenienceCharge.prototype.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('mouseup', this.mouseDownEvent);
  };

  ConvenienceCharge.prototype.render = function render(_ref, _ref2) {
    var pcfFeeAmount = _ref.pcfFeeAmount;
    var isAllModePcfDetailsVisible = _ref2.isAllModePcfDetailsVisible,
        convChargeDetails = _ref2.convChargeDetails;

    var intPart = void 0;
    var floatPart = void 0;
    if (pcfFeeAmount && !Number.isNaN(pcfFeeAmount)) {
      var feeAmountArr = Object(common["g" /* commas */])(pcfFeeAmount).split('.');
      intPart = feeAmountArr[0] || '0';
      floatPart = feeAmountArr[1] || '00';
    }

    return Object(preact_min["h"])(
      'section',
      { className: 'ptm-con-subheading ptm-header-color' },
      pcfFeeAmount !== 0 && Object(preact_min["h"])(
        'div',
        null,
        isAllModePcfDetailsVisible && Object(preact_min["h"])(
          'span',
          { onMouseUp: this.cnvBoxClick },
          Object(preact_min["h"])(convHelp, { convChargeDetails: convChargeDetails })
        ),
        Object(preact_min["h"])(
          'p',
          { 'class': 'ptm-c-p', onMouseUp: this.cnvBoxClick },
          Object(preact_min["h"])(
            'label',
            { onClick: this.toggleHelp },
            Object(i18n["a" /* locale */])('pcf.inclusive'),
            ' ',
            convenienceChg__ref3,
            Object(preact_min["h"])(
              'span',
              { 'class': 'ib ptm-vt' },
              Object(preact_min["h"])(
                'span',
                { 'class': 'ptm-semibold' },
                intPart
              ),
              Object(preact_min["h"])(
                'span',
                { 'class': 'decimal sub-txt-header-global' },
                '.',
                floatPart
              )
            ),
            Object(preact_min["h"])(
              'span',
              null,
              '(',
              Object(i18n["a" /* locale */])('pcf.convenience.gst'),
              ') '
            ),
            Object(preact_min["h"])('span', { 'class': 'ptm-arrow-down' })
          )
        )
      )
    );
  };

  return ConvenienceCharge;
}(preact_min["Component"]);

/* harmony default export */ var convenienceChg = (Object(preact["connect"])('cache')(convenienceChg_ConvenienceCharge));
// CONCATENATED MODULE: ./components/userIcon/index.js


var userIcon__ref = Object(preact_min["h"])(
  "svg",
  {
    className: "ptm-centralized",
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "13",
    viewBox: "0 0 12 13"
  },
  Object(preact_min["h"])("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M6 7.106c2.945 0 5.333 2.49 5.333 5.56H.667c0-3.07 2.388-5.56 5.333-5.56zM6 0c1.657 0 3 1.4 3 3.128 0 1.727-1.343 3.127-3 3.127s-3-1.4-3-3.127C3 1.4 4.343 0 6 0z"
  })
);

var UserIcon = function UserIcon() {
  return userIcon__ref;
};
// CONCATENATED MODULE: ./components/header/index.js
var header__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function header__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function header__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function header__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var header__ref4 = Object(preact_min["h"])(UserIcon, null);

var header__ref5 = Object(preact_min["h"])(RupeeSymbol, null);

var header__ref6 = Object(preact_min["h"])('span', { className: 'ptm-arrow-down ptm-arrow-color' });

var header__ref7 = Object(preact_min["h"])(notification, null);

var header_Header = function (_Component) {
  header__inherits(Header, _Component);

  function Header(props) {
    header__classCallCheck(this, Header);

    var _this = header__possibleConstructorReturn(this, _Component.call(this, props));

    _this.showHideUserDetails = function (e, toShowUserDetails) {
      _this.setState({ toShowUserDetails: !toShowUserDetails });
      e.stopPropagation();
    };

    _this.headerClickHandle = function (toShowUserDetails) {
      if (toShowUserDetails) {
        _this.setState({ toShowUserDetails: false });
      }
    };

    _this.showSubsDetail = function () {
      _this.props.onHelperOverlayToggle(constants["g" /* default */].HELPER_TYPE.SUBS_DETAILS_HELPER);
    };

    _this.closeApplication = function () {
      Object(logger["log"])({ eventType: logger["EVENT"].APP_CLOSE });
      var notifyMerchant = Object(common["q" /* getKey */])(_this.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG), 'handler.notifyMerchant', undefined);
      if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
        notifyMerchant(constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.APP_CLOSED, {
          message: 'App closed from the header icon'
        });
      }

      var closeHandler = _this.props.cache.getData(constants["a" /* CACHE */].CLOSE_HANDLER);
      Object(common["y" /* isFunction */])(closeHandler) && closeHandler();
    };

    _this.userLoggedOut = function () {
      var _this$props = _this.props,
          cache = _this$props.cache,
          checkoutElementPayMode = _this$props.checkoutElementPayMode,
          onSelectChange = _this$props.onSelectChange,
          onLoginDataChange = _this$props.onLoginDataChange,
          onBtnTextChange = _this$props.onBtnTextChange;


      logoutUser(cache, checkoutElementPayMode, _this.props.subscription, {
        onSelectChange: onSelectChange,
        onLoginDataChange: onLoginDataChange,
        onBtnTextChange: onBtnTextChange
      }).then(function (_ref) {
        var isSuccess = _ref.isSuccess;

        isSuccess && _this.setState({ toShowUserDetails: false });
      }).catch(function () {});
    };

    _this.state = {
      toShowUserDetails: false,
      isLogoLoadedSuccessfully: true
    };
    var locale = Object(common["e" /* clientMessage */])(constants["g" /* default */].HEADER.toLowerCase(), _this.props.cache);
    _this.label = locale.label;
    _this.error = locale.error;
    return _this;
  }

  Header.prototype.render = function render(_ref2, _ref3) {
    var _this2 = this;

    var loginInfo = _ref2.loginInfo,
        headerFixClass = _ref2.headerFixClass,
        showOtpSent = _ref2.showOtpSent,
        notificationMsg = _ref2.notificationMsg,
        pcfFeeAmount = _ref2.pcfFeeAmount,
        isPcfEnabled = _ref2.isPcfEnabled,
        subscription = _ref2.subscription,
        cache = _ref2.cache;
    var toShowUserDetails = _ref3.toShowUserDetails,
        isLogoLoadedSuccessfully = _ref3.isLogoLoadedSuccessfully;

    var merchantDetails = {};
    var userDetails = {};
    var orderId = '';
    var merchantBrandName = '';
    var merchantNameFromConfig = '';
    var txnAmount = '';
    var logoAvailable = false;
    var merchantConfig = cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
    if (typeof cache.getData(constants["a" /* CACHE */].PAYMENT_OPTIONS) === 'object') {
      var paymentOptions = cache.getData(constants["a" /* CACHE */].PAYMENT_OPTIONS);
      // added empty check so that if merchant details is not found an empty object is there to set values
      merchantDetails = paymentOptions.merchantDetails || {};
      // setting name and logo from merchant config  if it exists instead from api
      merchantNameFromConfig = Object(common["q" /* getKey */])(merchantConfig, 'merchant.name', null);
      var merchantLogoFromConfig = Object(common["q" /* getKey */])(merchantConfig, 'merchant.logo', null);
      merchantBrandName = Object(common["q" /* getKey */])(merchantDetails, 'merchantDisplayName', null);
      if (merchantNameFromConfig) {
        merchantDetails.merchantName = merchantNameFromConfig;
      }
      if (merchantLogoFromConfig) {
        merchantDetails.merchantLogo = merchantLogoFromConfig;
      }
      /* checking that the merchant logo receieved from api is a valid logo */
      logoAvailable = isLogoLoadedSuccessfully && Boolean(merchantDetails.merchantLogo);
      userDetails = paymentOptions.userDetails;
      orderId = Object(common["q" /* getKey */])(merchantConfig, 'data.orderId', '');
      txnAmount = cache.getData(constants["g" /* default */].TXN_AMOUNT);
      txnAmount === '0' && Object(common["q" /* getKey */])(subscription, 'isEnabled', false) && (txnAmount = constants["g" /* default */].SUBS_PAYMODE_MIN_AMOUNT);
    }
    return Object(preact_min["h"])(
      'div',
      {
        id: 'ptm-checkout-header',
        'class': 'ptm-header ptm-header-bg ptm-pos-a ' + (headerFixClass ? 'ptm-header_fix' : ''),
        ref: function ref(headerElem) {
          _this2.headerElem = headerElem;
        },
        onClick: function onClick() {
          _this2.headerClickHandle(toShowUserDetails);
        }
      },
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-header-top' },
        !merchantConfig.root && Object(preact_min["h"])('span', { className: 'ptm-cross ptm-pos-r', onClick: function onClick() {
            return _this2.closeApplication();
          } }),
        Object(preact_min["h"])(
          'span',
          { className: 'ptm-select-txt ptm-uppercase ptm-head-select ptm-pos-r ptm-hidden' },
          Object(common["q" /* getKey */])(subscription, 'isEnabled', false) ? this.label.subscriptionOption : this.label.selectOption
        ),
        loginInfo && loginInfo.userLoggedIn && Object(preact_min["h"])(
          'div',
          { className: 'ptm-right ptm-pos-r' },
          Object(preact_min["h"])(
            'div',
            {
              'class': 'ptm-user-bg ptm-pos-r ptm-user-box',
              onClick: function onClick(e) {
                _this2.showHideUserDetails(e, toShowUserDetails);
              }
            },
            header__ref4
          ),
          userDetails && Object(preact_min["h"])(
            'div',
            { 'class': 'ptm-user-detail ptm-pos-a ' + (toShowUserDetails ? '' : 'ptm-hidden') },
            userDetails.userName && Object(preact_min["h"])(
              'div',
              { 'class': 'ptm-user-name' },
              userDetails.userName
            ),
            userDetails.mobile && Object(preact_min["h"])(
              'div',
              { 'class': 'ptm-user-number' },
              userDetails.mobile
            ),
            merchantConfig.flow === index_api["d" /* FLOW */].DEFAULT && Object(preact_min["h"])(
              'div',
              {
                'class': 'ptm-switch-acc',
                id: 'ptm-switch-account',
                onClick: function onClick() {
                  return _this2.userLoggedOut();
                }
              },
              this.label.switch,
              Object(preact_min["h"])('img', {
                src: Object(common["U" /* staticPath */])() + '/assets/images/logo-paytm.svg',
                alt: 'paytm',
                className: 'ptm-margin0'
              }),
              this.label.account
            )
          )
        )
      ),
      Object(preact_min["h"])(
        'div',
        { 'class': 'ptm-header-bottom' },
        Object(preact_min["h"])(
          'div',
          { 'class': 'ptm-w100-ib' },
          merchantDetails && merchantDetails.merchantLogo && merchantConfig && merchantConfig.flow === index_api["d" /* FLOW */].DEFAULT && logoAvailable && Object(preact_min["h"])(
            'div',
            { 'class': 'ptm-mer-logo ptm-left ptm-pos-r' },
            Object(preact_min["h"])('img', {
              'class': 'ptm-brand-logo ptm-margin0 ptm-pos-a',
              src: merchantDetails && merchantDetails.merchantLogo,
              alt: 'merchant logo',
              onError: function onError() {
                _this2.setState({ isLogoLoadedSuccessfully: false });
              }
            })
          ),
          !logoAvailable && merchantConfig && merchantConfig.flow === index_api["d" /* FLOW */].DEFAULT && Object(preact_min["h"])(
            'div',
            { className: 'ptm-logo-name ptm-pos-r ptm-fixheader-logo' },
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-logobox ptm-pos-r' },
              Object(preact_min["h"])('img', {
                src: Object(common["U" /* staticPath */])() + '/assets/images/merc-default.svg',
                className: 'ptm-centralized',
                alt: 'mer-logo'
              })
            )
          ),
          Object(preact_min["h"])(
            'div',
            { 'class': 'ptm-amount ptm-right ptm-amount-color ptm-pos-r' },
            Object(preact_min["h"])(
              'span',
              { className: 'ptm-paytxt ptm-header-color' },
              'Pay'
            ),
            Object(preact_min["h"])(
              'span',
              { className: 'ptm-header-color' },
              header__ref5,
              ' ',
              Object(common["g" /* commas */])(txnAmount)
            )
          )
        ),
        Object(preact_min["h"])(
          'div',
          { 'class': 'ptm-subheading ptm-header-color ptm-w100-ib' },
          Object(preact_min["h"])(
            'span',
            { 'class': 'ptm-left' },
            merchantConfig && merchantConfig.flow === index_api["d" /* FLOW */].DEFAULT && Object(preact_min["h"])(
              'span',
              { 'class': 'ptm-name-txt ptm-ellipsis ptm-header-color' },
              merchantDetails && (merchantNameFromConfig || merchantBrandName || merchantDetails.merchantName)
            ),
            subscription && subscription.isEnabled && subscription.showDetails && Object(preact_min["h"])(
              'div',
              { 'class': 'ptm-view-details ptm-header-color', onClick: this.showSubsDetail },
              this.label.viewSubsDetail,
              header__ref6
            )
          ),
          orderId && Object(preact_min["h"])(
            'span',
            { className: 'ptm-right  ptm-order-txt ptm-header-color' },
            this.label.orderID,
            ': ',
            orderId
          )
        ),
        Object(preact_min["h"])(
          'div',
          { 'class': 'ptm-con-wrap ptm-header-color' },
          isPcfEnabled && Object(preact_min["h"])(convenienceChg, header__extends({ pcfFeeAmount: pcfFeeAmount }, { headerFixClass: headerFixClass }))
        )
      ),
      showOtpSent && Object(preact_min["h"])(
        'p',
        { className: 'ptm-top-msg ptm-green-bh ptm-pos-a' },
        this.label.otpSend
      ),
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-notify-wrap ptm-pos-a' },
        notificationMsg && header__ref7
      )
    );
  };

  return Header;
}(preact_min["Component"]);

/* harmony default export */ var header = (Object(preact["connect"])('loginInfo, showOtpSent, notificationMsg, cache, checkoutElementPayMode, subscription', onChange)(header_Header));
// CONCATENATED MODULE: ./components/timeOut/index.js



var timeOut_Timeout = function Timeout() {
  return Object(preact_min["h"])(
    "div",
    { className: "ptm-time-out-wrap" },
    Object(preact_min["h"])("img", {
      src: Object(common["U" /* staticPath */])() + "/assets/images/timeout.png",
      alt: "time out",
      className: "ptm-margin0"
    }),
    Object(preact_min["h"])(
      "div",
      { className: "ptm-main-text ptm-body-color" },
      "Your session has timed out due to inactivity"
    ),
    Object(preact_min["h"])(
      "div",
      { className: "ptm-sub-text ptm-body-color" },
      "Please go back to try again."
    )
  );
};
// CONCATENATED MODULE: ./components/CvvHelper/index.js


function CvvHelper__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function CvvHelper__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function CvvHelper__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function CvvHelper__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var CvvHelper_CvvHelper = function (_Component) {
  CvvHelper__inherits(CvvHelper, _Component);

  function CvvHelper(props) {
    CvvHelper__classCallCheck(this, CvvHelper);

    var _this = CvvHelper__possibleConstructorReturn(this, _Component.call(this, props));

    _this.closeOverlayWrap = function () {
      _this.props.onHelperOverlayToggle('');
    };

    _this.swipeDist = 0;
    _this.threshold = 10; // required min distance traveled to be considered swipe
    _this.startX = 0;
    _this.startY = 0;
    _this.state = {
      currentSlide: 0,
      activeInd: 0,
      initialAnimation: false
    };
    _this.helpText = [{
      textSrc: 'A three-digit code on the back panel of your card',
      imgSrc: Object(common["U" /* staticPath */])() + '/assets/images/cvv_help.png'
    }, {
      textSrc: 'A four-digit code on the front panel of your card',
      imgSrc: Object(common["U" /* staticPath */])() + '/assets/images/amex_cvv_help.png'
    }];
    return _this;
  }

  CvvHelper.prototype.detectTouchStart = function detectTouchStart(e) {
    var coord = Object(common["W" /* touchStart */])(e);
    this.startX = coord.startX;
    this.startY = coord.startY;
  };

  CvvHelper.prototype.detectTouchEnd = function detectTouchEnd(e, index) {
    var isrightswipe = Object(common["V" /* touchEnd */])(e, this.startX, this.threshold);
    this.handleswipe(isrightswipe, index);
    e.preventDefault();
  };

  CvvHelper.prototype.detectTouchMove = function detectTouchMove(e) {
    e.preventDefault();
  };

  CvvHelper.prototype.handleswipe = function handleswipe(isrightswipe, index) {
    var res = Object(common["u" /* handleSwipeCtrl */])(isrightswipe, index, this.helpText);
    this.setState({
      activeInd: res.actvInd,
      okBtn: res.okBtnVal,
      initialAnimation: true
    });
  };

  CvvHelper.prototype.updateSlide = function updateSlide(index) {
    this.setState({
      activeInd: index,
      initialAnimation: true
    });
  };

  CvvHelper.prototype.render = function render(_ref, _ref2) {
    var _this2 = this;

    var activeInd = _ref2.activeInd,
        initialAnimation = _ref2.initialAnimation;

    CvvHelper__objectDestructuringEmpty(_ref);

    var dot = 'ptm-dot';
    var dotAct = 'ptm-dot ptm-btn-active';
    var slideAct = 'slide ptm-hidden';
    var slide = 'slide';
    return Object(preact_min["h"])(
      'div',
      { className: 'ptm-cvvHelper' },
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-close-wrap ptm-pos-a ptm-closeIcon', onClick: this.closeOverlayWrap },
        Object(preact_min["h"])('span', { className: 'ptm-cross ptm-pos-r' })
      ),
      Object(preact_min["h"])(
        'h3',
        { className: 'ptm-cvv-heading ptm-body-color' },
        'What is CVV '
      ),
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-sliderWrap paytm-txt-center' },
        Object(preact_min["h"])(
          'ul',
          { className: 'ptm-upiWorkSlides' },
          this.helpText && this.helpText.length > 0 && this.helpText.map(function (data, index) {
            return Object(preact_min["h"])(
              'li',
              {
                onTouchStart: function onTouchStart(e) {
                  return _this2.detectTouchStart(e);
                },
                onTouchMove: function onTouchMove(e) {
                  _this2.detectTouchMove(e);
                },
                onTouchEnd: function onTouchEnd(e) {
                  return _this2.detectTouchEnd(e, index);
                },
                className: (index === activeInd ? slide : slideAct) + ' ' + (index ? 'ptm-animated ptmslideInRight faster' : initialAnimation ? 'ptm-animated ptmslideInLeft faster' : '')
              },
              Object(preact_min["h"])(
                'p',
                { className: 'ptm-cvv-para ptm-body-color' },
                data.textSrc
              ),
              Object(preact_min["h"])('img', { src: data.imgSrc, alt: '', className: 'ptm-margin0 ptm-image' })
            );
          })
        )
      ),
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-btn-slider' },
        this.helpText && this.helpText.length > 0 && this.helpText.map(function (data, index) {
          return Object(preact_min["h"])('span', {
            className: index === activeInd ? dotAct : dot,
            onclick: function onclick() {
              return _this2.updateSlide(index);
            }
          });
        })
      )
    );
  };

  return CvvHelper;
}(preact_min["Component"]);

/* harmony default export */ var components_CvvHelper = (Object(preact["connect"])('', onChange)(CvvHelper_CvvHelper));
// CONCATENATED MODULE: ./components/subscription/details/index.js


function details__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function details__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function details__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function details__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var details_Details = function (_Component) {
  details__inherits(Details, _Component);

  function Details(props) {
    details__classCallCheck(this, Details);

    var _this = details__possibleConstructorReturn(this, _Component.call(this, props));

    _this.closeOverlayWrap = function () {
      _this.props.onHelperOverlayToggle('');
    };

    _this.label = Object(common["e" /* clientMessage */])(constants["g" /* default */].SUBSCRIPTION.toLowerCase(), _this.props.cache).label;
    return _this;
  }

  Details.prototype.merchantTitle = function merchantTitle() {
    var merchantDetails = void 0;
    var title = '';
    var merchantConfig = this.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
    if (typeof this.props.cache.getData(constants["a" /* CACHE */].PAYMENT_OPTIONS) === 'object') {
      var paymentOptions = this.props.cache.getData(constants["a" /* CACHE */].PAYMENT_OPTIONS);
      merchantDetails = paymentOptions.merchantDetails;
      var merchantName = Object(common["q" /* getKey */])(merchantConfig, 'merchant.name', null);
      if (merchantName) {
        merchantDetails.merchantName = merchantName;
      }
    }
    Object(common["q" /* getKey */])(merchantDetails, 'merchantName') && (title = '( ' + this.label.sharedBy + ' ' + merchantDetails.merchantName + ' )');
    return title;
  };

  Details.prototype.render = function render(_ref, _ref2) {
    var subscription = _ref.subscription;

    details__objectDestructuringEmpty(_ref2);

    return Object(preact_min["h"])(
      'section',
      { className: 'ptm-subsDetails' },
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-close-wrap ptm-pos-a closeIcon', onClick: this.closeOverlayWrap },
        Object(preact_min["h"])('span', { className: 'ptm-cross ptm-pos-r' })
      ),
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-s-title ptm-txtcolor' },
        this.label.details
      ),
      Object(preact_min["h"])(
        'p',
        { className: 'ptm-extend-txt ptm-txtcolor' },
        this.merchantTitle()
      ),
      subscription && subscription.details && Object(preact_min["h"])(
        'div',
        null,
        subscription.subsType === constants["g" /* default */].SUBS_TYPE.VARIABLE && Object(preact_min["h"])(
          'p',
          { className: 'ptm-sub-upto ptm-body-color' },
          this.label.upto
        ),
        subscription.details.frequencyKey && Object(preact_min["h"])(
          'p',
          { 'class': 'ptm-sub-tip-text ptm-txtcolor' },
          subscription.details.frequencyKey,
          Object(preact_min["h"])(
            'span',
            { className: 'ptm-right ptm-txtcolor' },
            '\u20B9' + subscription.details.frequencyValue
          )
        ),
        subscription.details.nextPaymentKey && Object(preact_min["h"])(
          'p',
          { 'class': 'ptm-sub-tip-text ptm-txtcolor' },
          subscription.details.nextPaymentKey,
          Object(preact_min["h"])(
            'span',
            { className: 'ptm-right ptm-txtcolor' },
            subscription.details.nextPaymentValue
          )
        )
      )
    );
  };

  return Details;
}(preact_min["Component"]);

/* harmony default export */ var details = (Object(preact["connect"])('subscription, cache', onChange)(details_Details));
// CONCATENATED MODULE: ./utils/websocket.js
var websocket__this = this;

// custom client side library for socketcluster

/* Example

import WS from '../src/utils/websocket';

const ws = WS({
  url: 'ws://localhost:5000/websocket/',
  retryInterval: count => {
    if (count >= 10) {
      return 'stop';
    }
    return 1000; // retry after 1 sec ( 1000 millisecond)
  }
});

ws.on('open', () => {
  ws.on('JOIN_ROOMS', data => {
    console.log('data from server => ', data);
  });
  ws.emit('JOIN_ROOMS', 'JOIN_ROOMS_FROM_WS');
});

* */

var configuration = function configuration() {
  return {
    url: '',
    retry: true,
    retryInterval: function retryInterval(count) {
      if (count >= 5) {
        return 'stop'; // return anything apart from number value to stop retries connection
      }
      return 1000; // retry after milliseconds ( 1 sec )
    }
  };
};

var merge = function merge(first, second) {
  Object.keys(second).forEach(function (key) {
    if ((second[key] !== undefined || second[key] !== null) && Object.prototype.hasOwnProperty.call(first, key) && first[key].constructor === second[key].constructor) {
      if (second[key].constructor === Object) {
        first[key] = merge(first[key], second[key]);
      } else {
        first[key] = second[key];
      }
    } else {
      // eslint-disable-next-line no-console
      console.log('valid websocket configuration => ', configuration());
      throw new Error('invalid websocket configuration');
    }
  });
  return first;
};

var broadcastEvent = function broadcastEvent(listeners, data) {
  if (listeners) {
    listeners.forEach(function (listener) {
      listener(data);
    });
  }
};

var createWebSocket = function createWebSocket(option) {
  var ws = new WebSocket(option.url);
  ws.addEventListener('open', function () {
    ws.send(JSON.stringify({ event: '#handshake', data: { authToken: null }, cid: 1 }));
    broadcastEvent(websocket__this._events.open);
  });
  ws.addEventListener('message', function (event) {
    try {
      if (event.data === '#1') {
        // heartbeat data
        ws.send('#2');
        return;
      }
      var message = JSON.parse(event.data);
      if (message.event) {
        // event based data from socketcluster
        broadcastEvent(websocket__this._events[message.event], message.data);
        return;
      }

      if (message.rid) {
        // websocket meta data from socketcluster
        websocket__this.id = message.data.id;
        return;
      }
    } catch (e) {}
    broadcastEvent(websocket__this._events.message, event.data);
  });
  ws.addEventListener('error', function () {
    if (option.retry) {
      var timeInterval = option.retryInterval(websocket__this._currentRetryCount);
      websocket__this._currentRetryCount += 1;
      if (timeInterval && timeInterval.constructor === Number) {
        setTimeout(function () {
          websocket__this._ws = createWebSocket(option);
        }, timeInterval);
      } else {
        websocket__this._currentRetryCount = 0; // reset retry count as retryInterval stop retry
        broadcastEvent(websocket__this._events.error);
      }
    } else {
      broadcastEvent(websocket__this._events.error);
    }
  });
  ws.addEventListener('close', function (event) {
    broadcastEvent(websocket__this._events.close, {
      code: event.code,
      reason: event.reason
    });
  });
  return ws;
};

var SocketCluster = function SocketCluster(option) {
  websocket__this._events = {};
  websocket__this.id = '';
  websocket__this._currentRetryCount = 0;
  websocket__this._ws = createWebSocket(option);
};

SocketCluster.prototype.on = function (event, cb) {
  if (!Object.prototype.hasOwnProperty.call(websocket__this._events, event)) {
    websocket__this._events[event] = [];
  }
  websocket__this._events[event].push(cb);
};

SocketCluster.prototype.emit = function (event, data) {
  websocket__this._ws.send(JSON.stringify({ event: event, data: data }));
};

SocketCluster.prototype.close = function (code, reason) {
  websocket__this._ws.close(code || 1000, reason);
};

/* harmony default export */ var websocket = (function (option) {
  if (!window.WebSocket) {
    throw new Error("Browser doesn't support websocket protocol");
  }
  return new SocketCluster(merge(configuration(), option));
});
// CONCATENATED MODULE: ./controllers/qr.js







var _MAX_DELAY = 3000;
var _ITERATION = 3;

var parsePayload = function parsePayload(response) {
  if (response && Object.prototype.hasOwnProperty.call(response, 'acquirementId')) {
    response.transId = response.acquirementId;
  }
  return response;
};

var qr__socketConfig = function _socketConfig(id) {
  return {
    url: '' + constants["g" /* default */].QR.QR_HOST + constants["g" /* default */].QR.WS + '?DEVICE=web&ID=' + id,
    retryInterval: function retryInterval(count) {
      if (count >= _ITERATION) {
        return 'stop';
      }
      return _MAX_DELAY; // retry after 3 sec till websocket connection not established
    }
  };
};

var qr__getJoinRoomKey = function _getJoinRoomKey(cache) {
  var config = cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG) || {};
  var mId = cache.getData(constants["a" /* CACHE */].MID, '');
  var orderId = Object(common["q" /* getKey */])(config, 'data.orderId');

  return mId + '_' + orderId;
};

var qr_checkTransactionStatus = function checkTransactionStatus(cache) {
  Object(formPost["e" /* paymentConfirmation */])(cache);
};

var qr_expire = function expire(cache) {
  cache.getData(constants["a" /* CACHE */].STORE).setState({ sessionExpired: true });
};

var _priorSocket = void 0;
var _isConnected = false;
var _queuedOptions = {};

var qr_initSocket = function initSocket(qr, options, cache, instanceKey) {
  var socket = void 0;
  var joinRoom = qr__getJoinRoomKey(cache);
  _queuedOptions[instanceKey] = options;

  try {
    if (_priorSocket) {
      if (_isConnected) {
        Object(common["y" /* isFunction */])(Object(common["q" /* getKey */])(options, 'connect')) && options.connect();
      }
      socket = _priorSocket;
    } else {
      socket = websocket(qr__socketConfig(joinRoom));
    }
  } catch (error) {
    Object(logger["log"])({ eventType: logger["EVENT"].WS_INIT_ERROR, error: error });
    return null;
  }

  if (!_priorSocket) {
    socket.on('open', function () {
      _isConnected = true;
      Object(utils_common["j" /* objectValues */])(_queuedOptions).forEach(function (instanceOptions) {
        Object(common["y" /* isFunction */])(Object(common["q" /* getKey */])(instanceOptions, 'connect')) && instanceOptions.connect();
      });
      socket.emit('JOIN_ROOMS', joinRoom);

      Object(logger["log"])({ eventType: logger["EVENT"].JOIN_ROOM, room: joinRoom });

      socket.on(joinRoom, function (response) {
        var output = {
          response: {},
          showPRN: false,
          hideQR: false,
          showProcessing: false
        };

        try {
          var parsedQrResponse = parsePayload(response);
          output.response = parsedQrResponse;
          Object(logger["log"])({
            eventType: logger["EVENT"].QR_STATUS,
            status: parsedQrResponse.status
          });

          if (parsedQrResponse) {
            if (parsedQrResponse.status === constants["d" /* RESPONSE_STATUS */].PROCESSING) {
              Object(logger["log"])({ eventType: logger["EVENT"].QR_PROCESSING });
              output.showProcessing = true;
            } else if (parsedQrResponse.status === constants["d" /* RESPONSE_STATUS */].SUCCESS) {
              Object(logger["log"])({ eventType: logger["EVENT"].QR_SUCCESS });
              output.hideQR = true;
              if (qr.prn) {
                // prn screen shown
                Object(logger["log"])({ eventType: logger["EVENT"].PRN_FLOW });
                output.showPRN = true;
                output.timeout = true;
                output.showProcessing = false;
                socket.close();
              } else {
                qr_checkTransactionStatus(cache);
              }
            } else if (parsedQrResponse.status === constants["d" /* RESPONSE_STATUS */].FAIL) {
              Object(logger["log"])({ eventType: logger["EVENT"].QR_FAIL });
              output.hideQR = true;
              qr_checkTransactionStatus(cache);
            } else if (parsedQrResponse.status === constants["d" /* RESPONSE_STATUS */].REDIRECT) {
              output.isPending = true;
            }
          }
        } catch (e) {} finally {
          Object(utils_common["j" /* objectValues */])(_queuedOptions).forEach(function (instanceOptions) {
            Object(common["y" /* isFunction */])(Object(common["q" /* getKey */])(instanceOptions, 'roomListener')) && instanceOptions.roomListener(output);
          });
        }
      });
    });

    socket.on('close', function (data) {
      try {
        var _ref;

        var _instanceKey = Object(common["q" /* getKey */])(data, 'reason');
        var processOptions = _instanceKey ? (_ref = {}, _ref[_instanceKey] = _queuedOptions[_instanceKey], _ref) : _queuedOptions;

        Object.keys(processOptions).forEach(function (key) {
          var instanceOptions = _queuedOptions[key];
          if (instanceOptions) {
            Object(common["y" /* isFunction */])(Object(common["q" /* getKey */])(instanceOptions, 'disconnect')) && instanceOptions.disconnect();
            Object(common["y" /* isFunction */])(Object(common["q" /* getKey */])(instanceOptions, 'reload')) && instanceOptions.reload(true);
            delete _queuedOptions[key];
          }
        });

        if (!Object.keys(_queuedOptions).length) {
          _isConnected = false;
          _priorSocket = null;
          _queuedOptions = {};
          socket.close();
        }
      } catch (ex) {}
    });

    socket.on('error', function () {
      Object(logger["log"])({
        eventType: logger["EVENT"].QR_ERROR,
        message: 'unable to connect to websocket server'
      });
    });

    _priorSocket = socket;
  }

  return socket;
};

var qr_attachEvents = function attachEvents(qr, cache) {
  var timeout = null;
  if (qr.pageTimeout) {
    timeout = setTimeout(function () {
      Object(logger["log"])({ eventType: logger["EVENT"].QR_SESSION_TIMEOUT });
      qr_expire(cache);
    }, qr.pageTimeout);
  }
  return timeout;
};

var qr_qr = {
  attachEvents: qr_attachEvents,
  expire: qr_expire,
  checkTransactionStatus: qr_checkTransactionStatus,
  initSocket: qr_initSocket,
  parsePayload: parsePayload
};

/* harmony default export */ var controllers_qr = (qr_qr);
// CONCATENATED MODULE: ./components/qr/prn/index.js


function prn__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function prn__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function prn__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function prn__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











function isDigit(input) {
  return (/^[0-9]+$/.test(input)
  );
}

var PRN_LENGTH = 8;

var prn__ref3 = Object(preact_min["h"])(
  'div',
  { 'class': 'ptm-inline-spinner' },
  Object(preact_min["h"])(components_ProcessLoader, null)
);

var prn_PRN = function (_Component) {
  prn__inherits(PRN, _Component);

  function PRN() {
    var _temp, _this, _ret;

    prn__classCallCheck(this, PRN);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = prn__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      showError: false,
      error: '',
      showLoader: false,
      prn: '',
      timeout: null
    }, _this.onKeyDownBox = function (event) {
      var element = event.target;
      var elementIndex = Number(element.getAttribute('data-key').replace('box-', ''));

      if ((event.which === 8 || event.while === 46) && elementIndex > 0 && Object(common["q" /* getKey */])(element, 'previousSibling.focus')) {
        // in case of backspace or delete key press move to previous element
        element.previousSibling.focus();
      }

      if (!isDigit(element.value)) {
        element.value = '';
        return;
      }

      if (elementIndex < PRN_LENGTH - 1 && Object(common["q" /* getKey */])(element, 'nextSibling.focus')) {
        element.nextSibling.focus();
      }
    }, _this.initInputBox = function () {
      return Array.from({ length: PRN_LENGTH }).map(function (_, index) {
        return Object(preact_min["h"])('input', {
          key: 'box-' + index,
          'data-type': 'prn-box',
          className: 'ptm-pnr-input',
          'data-key': 'box-' + index,
          type: 'text',
          maxLength: '1',
          onKeyDown: function onKeyDown(event) {
            setTimeout(function () {
              _this.onKeyDownBox(event);
            }, 0);
          }
        });
      });
    }, _this.verifyPRN = function () {
      var inputBoxes = document.querySelectorAll('input[data-type="prn-box"]');
      var prn = Array.from(inputBoxes).reduce(function (acc, inputBox) {
        return acc + inputBox.value;
      }, '') || '';

      if (prn.length !== PRN_LENGTH) {
        // invalid prn
        _this.setState({ showError: true, error: Object(i18n["a" /* locale */])('qr.prn.incorrect') });
        return;
      }

      // disabled verify button and show loader on it
      _this.setState({
        showError: false,
        showLoader: true
      });

      getApi(_this.props.cache).validatePRN({ prnCode: prn }).then(function (res) {
        var _res$body = res.body,
            status = _res$body.status,
            retryAllowed = _res$body.retryAllowed,
            resultInfo = _res$body.resultInfo;


        Object(logger["log"])({
          eventType: logger["EVENT"].PRN_VALIDATE_API,
          apiStatus: true,
          status: status,
          retryAllowed: retryAllowed
        });

        if (status === constants["d" /* RESPONSE_STATUS */].SUCCESS) {
          controllers_qr.checkTransactionStatus();
        } else if (retryAllowed) {
          // show error message to user
          _this.setState({
            showError: true,
            error: resultInfo.resultMsg,
            showLoader: false
          });
        } else {
          controllers_qr.checkTransactionStatus();
        }
      }).catch(function (err) {
        var msg = '';

        if (Object(common["q" /* getKey */])(err, 'body.resultInfo.resultStatus') === constants["d" /* RESPONSE_STATUS */].F) {
          var _err$body = err.body,
              resultInfo = _err$body.resultInfo,
              retryAllowed = _err$body.retryAllowed;


          Object(logger["log"])({
            eventType: logger["EVENT"].PRN_VALIDATE_API,
            apiStatus: false,
            retryAllowed: retryAllowed,
            message: resultInfo.resultMsg
          });

          if (retryAllowed) {
            msg = resultInfo.resultMsg;
          } else {
            controllers_qr.checkTransactionStatus();
            return;
          }
        } else {
          msg = constants["g" /* default */].GENERIC_ERROR;
        }

        _this.setState({
          showError: true,
          error: msg,
          showLoader: false
        });
      });
    }, _temp), prn__possibleConstructorReturn(_this, _ret);
  }

  PRN.prototype.componentDidMount = function componentDidMount() {
    if (this.props && this.props.qr) {
      this.setState({
        timeout: setTimeout(function () {
          controllers_qr.checkTransactionStatus();
        }, this.props.qr.pageTimeout)
      });
    }
  };

  PRN.prototype.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.state.timeout);
    this.setState({ timeout: null });
  };

  PRN.prototype.render = function render(_ref, _ref2) {
    var showError = _ref2.showError,
        error = _ref2.error,
        showLoader = _ref2.showLoader;

    prn__objectDestructuringEmpty(_ref);

    return Object(preact_min["h"])(
      'div',
      { className: 'ptm-pnr-overlay', 'data-key': 'prn-section' },
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-pnr-container ptm-body-bg' },
        Object(preact_min["h"])(
          'div',
          { className: 'ptm-pnr-inner paytm-txt-center' },
          Object(preact_min["h"])('img', {
            src: Object(common["U" /* staticPath */])() + '/assets/images/qr-succes.png',
            className: 'ptm-prn-img',
            alt: 'prn success',
            'data-key': 'prn-success'
          }),
          Object(preact_min["h"])(
            'h6',
            { className: 'ptm-pnr-heading ptm-body-color' },
            Object(i18n["a" /* locale */])('qr.prn')
          ),
          Object(preact_min["h"])(
            'p',
            { className: 'ptm-pnr-description paytm-txt-center ptm-body-color' },
            Object(i18n["a" /* locale */])('qr.prn.description')
          ),
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-pnr-box' },
            this.initInputBox(),
            showError && Object(preact_min["h"])(
              'p',
              { className: 'ptm-pnr-error paytm-txt-center', 'data-key': 'prn-error' },
              error
            ),
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-pnr-verify' },
              Object(preact_min["h"])(
                'button',
                { disabled: showLoader, className: 'ptm-custom-btn', onClick: this.verifyPRN },
                !showLoader && Object(i18n["a" /* locale */])('login.btn.verifyOtp.text'),
                showLoader && prn__ref3
              )
            )
          )
        )
      )
    );
  };

  return PRN;
}(preact_min["Component"]);

/* harmony default export */ var qr_prn = (Object(preact["connect"])('cache')(prn_PRN));
// CONCATENATED MODULE: ./components/qr/refresh/index.js


function refresh__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function refresh__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function refresh__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var refresh_Refresh = function (_Component) {
  refresh__inherits(Refresh, _Component);

  function Refresh() {
    var _temp, _this, _ret;

    refresh__classCallCheck(this, Refresh);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = refresh__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.refresh = function () {
      _this.props.reloadQR && _this.props.reloadQR();
    }, _temp), refresh__possibleConstructorReturn(_this, _ret);
  }

  Refresh.prototype.render = function render() {
    return Object(preact_min["h"])(
      'div',
      { className: 'ptm-refresh-wrap ptm-pos-r', onClick: this.refresh, 'data-key': 'refresh-section' },
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-refresh-inner ptm-centralized' },
        Object(preact_min["h"])('img', { src: Object(common["U" /* staticPath */])() + '/assets/images/refresh.png', alt: 'Refresh' }),
        Object(preact_min["h"])(
          'p',
          { className: 'ptm-reload-txt paytm-txt-center' },
          Object(i18n["a" /* locale */])('qr.reload')
        )
      )
    );
  };

  return Refresh;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/qr/scale/index.js


function scale__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function scale__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function scale__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function scale__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var scale__ref3 = Object(preact_min["h"])('span', { className: 'ptm-cross' });

var scale_ScaleQR = function (_Component) {
  scale__inherits(ScaleQR, _Component);

  function ScaleQR(props) {
    scale__classCallCheck(this, ScaleQR);

    var _this = scale__possibleConstructorReturn(this, _Component.call(this, props));

    _this.zoomOut = function (event, isZoom) {
      _this.props.notify && _this.props.notify(event, isZoom);
    };

    var merchantDetails = _this.props.cache.getData(constants["a" /* CACHE */].PAYMENT_OPTIONS, {}).merchantDetails;
    _this.merchantName = merchantDetails && (Object(common["q" /* getKey */])(_this.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG), 'merchant.name') || Object(common["q" /* getKey */])(merchantDetails, 'merchantDisplayName') || merchantDetails.merchantName || '');
    _this.logo = {
      paytm: Object(common["U" /* staticPath */])() + '/assets/images/logo-paytm.svg',
      upi: Object(common["U" /* staticPath */])() + '/assets/images/logo-upi.svg'
    };
    return _this;
  }

  ScaleQR.prototype.render = function render(_ref, _ref2) {
    var _this2 = this;

    var qrCode = _ref.qrCode,
        upiQR = _ref.upiQR;

    scale__objectDestructuringEmpty(_ref2);

    var txnAmount = Object(common["h" /* convertRupeeCharToUnicode */])('\u20B9' + Object(common["L" /* money */])(this.props.cache.getData(constants["g" /* default */].TXN_AMOUNT)));

    return Object(preact_min["h"])(
      'div',
      {
        className: 'ptm-qr-scale-wrapper',
        onClick: function onClick(e) {
          return _this2.zoomOut(e, false);
        },
        'data-key': 'scale-section'
      },
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-qr-scale-container ptm-body-bg' },
        Object(preact_min["h"])(
          'div',
          { className: 'ptm-scale-inner' },
          Object(preact_min["h"])(
            'div',
            { className: 'paytm-txt-center ptm-qr-scale-txt1 ptm-semibold ptm-body-color' },
            Object(i18n["a" /* locale */])('qr.pay')
          ),
          Object(preact_min["h"])(
            'div',
            { className: 'paytm-txt-center ptm-qr-scale-txt2 ptm-body-color' },
            this.merchantName
          ),
          Object(preact_min["h"])('img', { src: qrCode, className: 'ptm-qr-scaled-img', 'data-key': 'scale-qr' }),
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-scale-amount ptm-body-color' },
            txnAmount
          )
        ),
        Object(preact_min["h"])(
          'div',
          {
            className: 'ptm-qr-type ptm-scale-qr-type ptm-pos-r paytm-txt-center ptm-body-color'
          },
          upiQR ? Object(i18n["a" /* locale */])('qr.scan.qrcode.upi') : Object(i18n["a" /* locale */])('qr.scan.qrcode'),
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-qr-logo paytm-txt-center ptm-qr-scale-logo' },
            Object(preact_min["h"])('img', { src: this.logo.paytm, 'data-key': 'qr-paytm' }),
            upiQR ? Object(preact_min["h"])(
              'span',
              { className: 'ptm-qr-pipe' },
              ' | '
            ) : '',
            upiQR && Object(preact_min["h"])('img', { src: this.logo.upi, 'data-key': 'qr-upi' })
          )
        ),
        Object(preact_min["h"])(
          'div',
          { className: 'ptm-close-wrap ptm-qr-scale-close', onClick: function onClick(e) {
              return _this2.zoomOut(e, false);
            } },
          scale__ref3
        )
      )
    );
  };

  return ScaleQR;
}(preact_min["Component"]);

/* harmony default export */ var scale = (Object(preact["connect"])('cache')(scale_ScaleQR));
// CONCATENATED MODULE: ./components/tooltip/index.js


function tooltip__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function tooltip__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function tooltip__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var tooltip_ToolTip = function (_Component) {
  tooltip__inherits(ToolTip, _Component);

  function ToolTip(props) {
    tooltip__classCallCheck(this, ToolTip);

    var _this = tooltip__possibleConstructorReturn(this, _Component.call(this, props));

    _this.stopE = function (ev) {
      if (ev) {
        ev.preventDefault();
        ev.stopPropagation();
      }
    };

    _this.onToolTipClick = function (ev) {
      var isToolTip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      _this.stopE(ev);
      _this.toggleTooltipCloseEventListner(isToolTip);
      _this.setState({ isToolTipOpen: isToolTip });
    };

    _this.state = {
      isToolTipOpen: false
    };
    return _this;
  }

  ToolTip.prototype.componentWillUnmount = function componentWillUnmount() {
    this.toggleTooltipCloseEventListner(false);
  };

  ToolTip.prototype.toggleTooltipCloseEventListner = function toggleTooltipCloseEventListner(addListner) {
    var appEl = document.querySelector('#paytm-app');
    if (appEl) {
      if (addListner) {
        appEl.addEventListener('click', this.onToolTipClick);
      } else {
        appEl.removeEventListener('click', this.onToolTipClick);
      }
    }
  };

  ToolTip.prototype.render = function render(_ref, _ref2) {
    var _this2 = this;

    var title = _ref.title,
        desc = _ref.desc;
    var isToolTipOpen = _ref2.isToolTipOpen;

    return Object(preact_min["h"])(
      'div',
      { className: 'ptm-tt-wrap' },
      Object(preact_min["h"])('img', {
        onClick: function onClick(e) {
          _this2.onToolTipClick(e, !isToolTipOpen);
        },
        className: 'ptm-info-icon ptm-pointer-cursor',
        src: Object(common["U" /* staticPath */])() + '/assets/images/info.svg',
        alt: 'i'
      }),
      isToolTipOpen && Object(preact_min["h"])(
        'section',
        {
          onClick: function onClick(e) {
            _this2.stopE(e);
          },
          className: 'ptm-tool-tip ptm-pos-a ptm-body-bg'
        },
        Object(preact_min["h"])(
          'div',
          { className: 'ptm-tt-content ptm-pos-r' },
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-tt-title ptm-fs12 ptm-semibold ptm-body-color' },
            title
          ),
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-tt-text ptm-fs10 ptm-body-color' },
            desc
          )
        )
      ),
      Object(preact_min["h"])('div', { className: 'ptm-triangle ptm-body-bg' })
    );
  };

  return ToolTip;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/qr/index.js


function qr__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function qr__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function qr__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var qr__ref3 = Object(preact_min["h"])(components_ProcessLoader, null);

var qr__ref4 = Object(preact_min["h"])('div', { 'class': 'ptm-global-bottom-border ptm-qr-bottom-border' });

var qr_QRCode = function (_Component) {
  qr__inherits(QRCode, _Component);

  function QRCode(props) {
    qr__classCallCheck(this, QRCode);

    var _this = qr__possibleConstructorReturn(this, _Component.call(this, props));

    _this.socketConnectListener = function () {
      _this.setState({ wsConnect: true });
      Object(logger["log"])({ eventType: logger["EVENT"].WS_CREATE });
    };

    _this.socketDisconnectListener = function () {
      Object(logger["log"])({ eventType: logger["EVENT"].WS_DISCONNECT });
      _this.setState({ wsConnect: false });
      _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: '' });
      clearTimeout(_this.state.sessionTimeOut);
    };

    _this.roomListener = function (option) {
      if (option) {
        if (_this.state.showProcessing !== option.showProcessing) {
          _this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({
            overlayValue: option.showProcessing ? constants["g" /* default */].PROCESSING : ''
          });
        }

        _this.setState({
          socketResponse: option.response,
          showPRN: option.showPRN,
          hideQR: option.hideQR,
          showProcessing: option.showProcessing
        });

        if (option.isPending) {
          _this.props.onNotificationTextChange(Object(i18n["a" /* locale */])('qr.scan.pending'));
        }

        if (Object.prototype.hasOwnProperty.call(option, 'timeout')) {
          clearTimeout(_this.state.sessionTimeOut);
        }
      }
    };

    _this.reloadQR = function (qr) {
      _this.initWebSocket(qr);
      _this.setReload(false);
    };

    _this.setReload = function (reload) {
      _this.setState({ reload: reload });
    };

    _this.initWebSocket = function (qr) {
      var socket = controllers_qr.initSocket(qr, {
        connect: _this.socketConnectListener,
        disconnect: _this.socketDisconnectListener,
        roomListener: _this.roomListener,
        reload: _this.setReload
      }, _this.props.cache, _this.props.instanceKey);

      _this.setState({
        socket: socket,
        hideQR: !socket,
        sessionTimeOut: controllers_qr.attachEvents(qr, _this.props.cache)
      });
    };

    _this.enlarge = function (event, isZoom) {
      _this.setState({
        zoom: Object(utils_common["g" /* isNull */])(isZoom) ? !_this.state.zoom : isZoom
      });
    };

    _this.state = {
      socketResponse: {}, // kafka payload
      sessionTimeOut: null, // timeout after which abandon transaction call
      wsConnect: false, // websocket connection created or not
      qrCode: '', // qr code
      showPRN: false, // show prn screen,
      reload: false, // show reload qr if connection not established
      socket: null, // websocket connection object
      zoom: false, // is qr code in zoom
      hideQR: false,
      showProcessing: false
    };

    if (props.qr) {
      _this.state.qrCode = 'data:image/png;base64,' + props.qr.dataUrl;
    }

    _this.logo = {
      paytm: Object(common["U" /* staticPath */])() + '/assets/images/logo-paytm.svg',
      upi: Object(common["U" /* staticPath */])() + '/assets/images/logo-upi.svg'
    };
    return _this;
  }

  QRCode.prototype.componentDidMount = function componentDidMount() {
    this.initWebSocket(this.props.qr);
  };

  QRCode.prototype.componentWillUnmount = function componentWillUnmount() {
    Object(common["y" /* isFunction */])(Object(common["q" /* getKey */])(this.state, 'socket.close')) && this.state.socket.close(1000, this.props.instanceKey);
  };

  QRCode.prototype.render = function render(_ref, _ref2) {
    var _this2 = this;

    var qr = _ref.qr;
    var showPRN = _ref2.showPRN,
        qrCode = _ref2.qrCode,
        wsConnect = _ref2.wsConnect,
        socketResponse = _ref2.socketResponse,
        reload = _ref2.reload,
        zoom = _ref2.zoom,
        hideQR = _ref2.hideQR;

    return Object(preact_min["h"])(
      'div',
      null,
      Object(preact_min["h"])(
        'div',
        { className: 'ptm-qr-wrap ptm-body-color' },
        Object(preact_min["h"])(
          'div',
          { className: 'ptm-left' },
          Object(preact_min["h"])(
            'p',
            { className: 'ptm-select-txt ptm-uppercase ptm-qr-pay-text' },
            Object(i18n["a" /* locale */])('qr.pay')
          ),
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-qr-type ptm-pos-r ptm-body-color' },
            qr.upiQR ? Object(i18n["a" /* locale */])('qr.scan.qrcode.upi') : Object(i18n["a" /* locale */])('qr.scan.qrcode'),
            Object(preact_min["h"])(tooltip_ToolTip, {
              title: qr.upiQR ? Object(i18n["a" /* locale */])('qr.scan.upi') : Object(i18n["a" /* locale */])('qr.scan.paytm'),
              desc: qr.upiQR ? Object(i18n["a" /* locale */])('qr.all.apps') : ''
            })
          ),
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-qr-logo' },
            Object(preact_min["h"])('img', { src: this.logo.paytm, 'data-key': 'qr-paytm' }),
            qr.upiQR ? Object(preact_min["h"])(
              'span',
              { className: 'ptm-qr-pipe' },
              ' | '
            ) : '',
            qr.upiQR && Object(preact_min["h"])('img', { src: this.logo.upi, 'data-key': 'qr-upi' })
          )
        ),
        !hideQR && Object(preact_min["h"])(
          'div',
          { className: 'ptm-right ptm-qr-right' },
          !wsConnect && reload && Object(preact_min["h"])(refresh_Refresh, { reloadQR: function reloadQR() {
              return _this2.reloadQR(qr);
            } }),
          !wsConnect && !reload && Object(preact_min["h"])(
            'div',
            { className: 'ptm-qr-overlay ptm-border-color' },
            qr__ref3
          ),
          wsConnect && Object(preact_min["h"])(
            'div',
            { className: 'ptm-qr-img-container' },
            Object(preact_min["h"])(
              'div',
              { className: 'ptm-qr-zoom-wrap ptm-border-color' },
              Object(preact_min["h"])('img', { src: qrCode, alt: '', 'data-key': 'qr-code' }),
              Object(preact_min["h"])(
                'div',
                { className: 'ptm-qr-desc' },
                Object(preact_min["h"])(
                  'p',
                  {
                    className: 'ptm-qr-zoom paytm-txt-center ptm-body-color',
                    onClick: function onClick(e) {
                      return _this2.enlarge(e);
                    },
                    'data-key': 'qr-zoom'
                  },
                  Object(i18n["a" /* locale */])('qr.click.enlarge')
                )
              )
            )
          )
        ),
        zoom && Object(preact_min["h"])(scale, { qrCode: qrCode, upiQR: qr.upiQR, notify: this.enlarge }),
        showPRN && Object(preact_min["h"])(qr_prn, { socketResponse: socketResponse, qr: qr })
      ),
      qr__ref4
    );
  };

  return QRCode;
}(preact_min["Component"]);

/* harmony default export */ var components_qr = (Object(preact["connect"])('cache, instanceKey', onChange)(qr_QRCode));
// EXTERNAL MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/utils/http.js
var http = __webpack_require__("1Lr7");

// CONCATENATED MODULE: ./components/offers/index.js


function offers__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function offers__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function offers__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function offers__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var offers_Offers = function (_Component) {
  offers__inherits(Offers, _Component);

  function Offers(props) {
    offers__classCallCheck(this, Offers);

    var _this = offers__possibleConstructorReturn(this, _Component.call(this, props));

    _this.toggleOffersVisibility = function () {
      _this.setState(function (prevState) {
        return {
          areOffersVisible: !prevState.areOffersVisible
        };
      });
    };

    _this.closeTermsAndConditions = function () {
      _this.setState(function (prevState) {
        return {
          isTermsAndCondistionVisible: !prevState.isTermsAndCondistionVisible
        };
      });
    };

    _this.showTermsAndConditions = function (url, termsTitle) {
      _this.setState(function (prevState) {
        return {
          isTermsAndCondistionVisible: !prevState.isTermsAndCondistionVisible,
          termsAndConditions: {
            termsTitle: termsTitle
          }
        };
      });

      if (Object(common["J" /* isValidUrl */])(url)) {
        Object(http["b" /* get */])(url, { noQueryParam: true }).then(function (termsAndConditions) {
          _this.setState({
            termsAndConditions: Object(common["G" /* isObject */])(termsAndConditions) ? termsAndConditions : { termsTitle: termsTitle }
          });
        }).catch(function (error) {
          _this.setTermsAndConditionError(Object(common["q" /* getKey */])(error, 'message', constants["g" /* default */].GENERIC_ERROR), termsTitle);
        });
      } else {
        _this.setTermsAndConditionError(Object(i18n["a" /* locale */])('offers.invalidTermsAndConditionUrl'), termsTitle);
      }
    };

    _this.state = {
      offers: [],
      areOffersVisible: false,
      isTermsAndCondistionVisible: false,
      termsAndConditions: null
    };
    return _this;
  }

  Offers.prototype.componentDidMount = function componentDidMount() {
    this.setState({
      offers: Object(common["q" /* getKey */])(this.props.cache.getData(constants["a" /* CACHE */].PAYMENT_OPTIONS), 'paymentOffers', [])
    });
  };

  Offers.prototype.setTermsAndConditionError = function setTermsAndConditionError(errorMessage, termsTitle) {
    this.setState({
      termsAndConditions: {
        error: errorMessage,
        termsTitle: termsTitle
      }
    });
  };

  Offers.prototype.render = function render(_ref, _ref2) {
    var _this2 = this;

    var offers = _ref2.offers,
        areOffersVisible = _ref2.areOffersVisible,
        isTermsAndCondistionVisible = _ref2.isTermsAndCondistionVisible,
        termsAndConditions = _ref2.termsAndConditions;

    offers__objectDestructuringEmpty(_ref);

    var isSingleOffer = offers.length === 1;

    return Object(preact_min["h"])(
      'div',
      null,
      Boolean(offers.length) && Object(preact_min["h"])(
        'div',
        {
          onClick: this.toggleOffersVisibility,
          'class': 'ptm-pointer-cursor ptm-offer-strip ptm-lightgreen-bg ' + (isSingleOffer ? 'ptm-single-offer' : ''),
          id: 'checkout-offers'
        },
        isSingleOffer && offers[0].offer && Object(preact_min["h"])(
          'span',
          null,
          Object(preact_min["h"])('img', { 'class': 'ptm-inline-offer-image', src: offers[0].offer.icon }),
          Object(preact_min["h"])(
            'div',
            { className: 'ptm-ex-offer' },
            Object(preact_min["h"])(
              'div',
              null,
              offers[0].offer.title
            ),
            Object(preact_min["h"])(
              'div',
              { 'class': 'ptm-small-txt' },
              offers[0].offer.text
            )
          )
        ),
        offers.length > 1 && Object(preact_min["h"])(
          'span',
          { 'class': 'ptm-multi-offer' },
          Object(preact_min["h"])('img', {
            src: Object(common["U" /* staticPath */])() + '/assets/images/ic-offers.svg',
            alt: 'ptm-ofer-img',
            className: 'ptm-margin0 ptm-ribbon-img '
          }),
          Object(preact_min["h"])(
            'span',
            null,
            offers.length,
            ' ',
            Object(i18n["a" /* locale */])('offers.message')
          )
        ),
        Object(preact_min["h"])('img', {
          className: 'pos-r ptm-margin0 ptm-ex-drop ptm-right',
          src: Object(common["U" /* staticPath */])() + '/assets/images/ic-dropdown-light.svg',
          alt: 'dropdown'
        })
      ),
      areOffersVisible && Object(preact_min["h"])(
        components_OverlayWrap,
        null,
        Object(preact_min["h"])(
          'div',
          { className: 'ptm-close-wrap ptm-pos-a closeIcon ptm-pointer-cursor' },
          Object(preact_min["h"])('span', { className: 'ptm-cross ptm-pos-r', onClick: this.toggleOffersVisibility })
        ),
        Object(preact_min["h"])(
          'div',
          null,
          Object(preact_min["h"])(
            'h2',
            { 'class': 'ptm-body-bg ptm-offers-header' },
            Object(i18n["a" /* locale */])('offers.bankOffers')
          ),
          Object(preact_min["h"])(
            'div',
            { 'class': 'ptm-content-wrapper' },
            offers && offers.map(function (offerDetail) {
              return Object(preact_min["h"])(
                'div',
                { 'class': 'ptm-offer-container' },
                offerDetail.offer && Object(preact_min["h"])(
                  'div',
                  null,
                  Object(preact_min["h"])(
                    'div',
                    { 'class': 'ptm-left ptm-pos-r ptm-offer-image ptm-global-border' },
                    Object(preact_min["h"])('img', { className: 'ptm-centralized', src: offerDetail.offer.icon })
                  ),
                  Object(preact_min["h"])(
                    'div',
                    { 'class': 'ptm-offer-details' },
                    Object(preact_min["h"])(
                      'p',
                      { 'class': 'ptm-offer-title' },
                      offerDetail.offer.title
                    ),
                    Object(preact_min["h"])(
                      'p',
                      { 'class': 'ptm-small-txt' },
                      offerDetail.offer.text
                    ),
                    offerDetail.termsUrl && Object(preact_min["h"])(
                      'p',
                      {
                        'class': 'ptm-small-txt-link ptm-offer-tnc',
                        onClick: function onClick() {
                          _this2.showTermsAndConditions(offerDetail.termsUrl, offerDetail.termsTitle);
                        }
                      },
                      Object(i18n["a" /* locale */])('offers.termsAndCondition')
                    )
                  )
                )
              );
            })
          )
        )
      ),
      isTermsAndCondistionVisible && Object(preact_min["h"])(
        components_OverlayWrap,
        null,
        Object(preact_min["h"])(
          'div',
          { className: 'ptm-close-wrap ptm-pos-a closeIcon ptm-pointer-cursor' },
          Object(preact_min["h"])('span', { className: 'ptm-cross ptm-pos-r', onClick: this.closeTermsAndConditions })
        ),
        termsAndConditions && Object(preact_min["h"])(
          'div',
          null,
          Object(preact_min["h"])(
            'h2',
            { 'class': 'body-bg ptm-offers-header' },
            termsAndConditions.termsTitle
          ),
          termsAndConditions.error && Object(preact_min["h"])(
            'div',
            { 'class': 'ptm-content-wrapper ptm-tnc-box ' },
            termsAndConditions.error
          ),
          termsAndConditions.terms && !termsAndConditions.error && Object(preact_min["h"])(
            'div',
            { 'class': 'ptm-content-wrapper ptm-tnc-box' },
            Object(preact_min["h"])('div', { dangerouslySetInnerHTML: { __html: termsAndConditions.terms } })
          )
        )
      )
    );
  };

  return Offers;
}(preact_min["Component"]);

/* harmony default export */ var components_offers = (Object(preact["connect"])('cache')(offers_Offers));
// CONCATENATED MODULE: ./components/switchUser/index.js


function switchUser__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function switchUser__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function switchUser__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var switchUser_SwitchUser = function (_Component) {
  switchUser__inherits(SwitchUser, _Component);

  function SwitchUser(props) {
    switchUser__classCallCheck(this, SwitchUser);

    var _this = switchUser__possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      isProcessing: false
    };

    _this.logoutUser = function () {
      _this.setState({ isProcessing: true });
      var _this$props = _this.props,
          cache = _this$props.cache,
          checkoutElementPayMode = _this$props.checkoutElementPayMode,
          onSelectChange = _this$props.onSelectChange,
          onLoginDataChange = _this$props.onLoginDataChange,
          onBtnTextChange = _this$props.onBtnTextChange;


      logoutUser(cache, checkoutElementPayMode, _this.props.subscription, {
        onSelectChange: onSelectChange,
        onLoginDataChange: onLoginDataChange,
        onBtnTextChange: onBtnTextChange
      }).catch(function () {}).then(function () {
        _this.setState({ isProcessing: false });
      });
    };

    _this.label = Object(common["e" /* clientMessage */])(constants["g" /* default */].LOGIN.toLowerCase(), _this.props.cache).label;
    return _this;
  }

  SwitchUser.prototype.render = function render(_ref, _ref2) {
    var userDetails = _ref.userDetails;
    var isProcessing = _ref2.isProcessing;

    if (!userDetails) {
      return '';
    }

    return Object(preact_min["h"])(
      'div',
      { className: 'ptm-txt-right' },
      Object(preact_min["h"])(
        'span',
        null,
        this.label.mobileNumber,
        ' '
      ),
      Object(preact_min["h"])(
        'span',
        { className: 'ptm-semibold' },
        userDetails.mobile,
        ' '
      ),
      Object(preact_min["h"])(
        'span',
        {
          className: 'ptm-switch-num ' + (isProcessing ? 'ptm-disbled-cursor' : 'ptm-pointer-cursor'),
          onClick: !isProcessing && this.logoutUser
        },
        this.label.changeNumber
      )
    );
  };

  return SwitchUser;
}(preact_min["Component"]);

/* harmony default export */ var switchUser = (Object(preact["connect"])('cache, checkoutElementPayMode, subscription', onChange)(switchUser_SwitchUser));
// CONCATENATED MODULE: ./components/elements-header/index.js


function elements_header__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function elements_header__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function elements_header__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var elements_header__ref2 = Object(preact_min["h"])(notification, null);

var elements_header_ElementsHeader = function (_Component) {
  elements_header__inherits(ElementsHeader, _Component);

  function ElementsHeader(props) {
    elements_header__classCallCheck(this, ElementsHeader);

    var _this = elements_header__possibleConstructorReturn(this, _Component.call(this, props));

    _this.label = Object(utils_common["b" /* getKey */])(Object(common["e" /* clientMessage */])(constants["g" /* default */].HEADER.toLowerCase(), _this.props.cache), 'label', {});
    return _this;
  }

  ElementsHeader.prototype.render = function render(_ref) {
    var showOtpSent = _ref.showOtpSent,
        notificationMsg = _ref.notificationMsg,
        loginInfo = _ref.loginInfo,
        _ref$sessionExpired = _ref.sessionExpired,
        sessionExpired = _ref$sessionExpired === undefined ? false : _ref$sessionExpired,
        cache = _ref.cache,
        checkoutElementPayMode = _ref.checkoutElementPayMode;

    var paymentOption = cache.getData('paymentOptions');
    var userDetails = Object(utils_common["b" /* getKey */])(paymentOption, 'userDetails');
    var isPayWithPaytmElementPayMode = Object(common["j" /* equalsIgnoreCase */])(checkoutElementPayMode, constant["c" /* ELEMENT_PAYMODE */].PAY_WITH_PAYTM);
    return Object(preact_min["h"])(
      'div',
      null,
      showOtpSent && Object(preact_min["h"])(
        'p',
        { className: 'ptm-top-msg ptm-green-bh ptm-pos-a' },
        this.label.otpSend
      ),
      notificationMsg && Object(preact_min["h"])(
        'div',
        { className: 'ptm-notify-wrap ptm-top-msg ptm-pos-a' },
        elements_header__ref2
      ),
      isPayWithPaytmElementPayMode && Object(utils_common["b" /* getKey */])(loginInfo, 'userLoggedIn') && !sessionExpired && Object(preact_min["h"])(
        'div',
        { className: 'ptm-switch-userwrap' },
        Object(preact_min["h"])(switchUser, { userDetails: userDetails })
      )
    );
  };

  return ElementsHeader;
}(preact_min["Component"]);

/* harmony default export */ var elements_header = (Object(preact["connect"])('showOtpSent, notificationMsg, cache, loginInfo, sessionExpired, checkoutElementPayMode')(elements_header_ElementsHeader));
// CONCATENATED MODULE: ./components/home/index.js
var home__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var home__class, home__temp, home__initialiseProps;



function home__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function home__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function home__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






































// import DirectBank from '../directBank';

var home__ref3 = Object(preact_min["h"])(elements_header, null);

var home__ref4 = Object(preact_min["h"])(components_offers, null);

var home__ref5 = Object(preact_min["h"])(timeOut_Timeout, null);

var home__ref6 = Object(preact_min["h"])(footer, null);

var home__ref7 = Object(preact_min["h"])(overlaybox, null);

var home__ref8 = Object(preact_min["h"])(components_CvvHelper, null);

var home__ref9 = Object(preact_min["h"])(details, null);

var home_Home = (home__temp = home__class = function (_Component) {
  home__inherits(Home, _Component);

  function Home(props) {
    home__classCallCheck(this, Home);

    var _this = home__possibleConstructorReturn(this, _Component.call(this, props));

    home__initialiseProps.call(_this);

    _this.selected = undefined;
    _this.idPayBankValidateDisabled = false;
    var paymentOptions = _this.props.cache.getData('paymentOptions');

    _this.state = {
      upiIntentApps: [],
      showAllSavedCards: false,
      headerFixClass: '',
      pcfFeeAmount: 0,
      isPcfEnabled: pcf_isPcfEnabled(_this.props.cache),
      isPromoAvailable: false,
      payModeBasedOffers: null,
      mandateAccountDetails: Object(common["q" /* getKey */])(paymentOptions, 'mandateAccountDetails', null),
      qr: Object(common["j" /* equalsIgnoreCase */])(_this.props.checkoutElementPayMode, constant["c" /* ELEMENT_PAYMODE */].SCAN_AND_PAY) || !Object(common["q" /* getKey */])(_this.props, 'loginInfo.userLoggedIn') ? Object(common["q" /* getKey */])(_this.props.cache.getData('paymentOptions'), 'qrDetail') : null
    };
    _this.updatePromoEnableStatus();
    _this.onBtnClick = _this.onBtnClick.bind(_this);
    _this.amountPayable = Object(common["c" /* calculateAmountPayable */])(_this.props.cache.getData(constants["g" /* default */].TXN_AMOUNT), _this.props.wallet, true, _this.props.subscription);
    window.upiIntent = {};
    window.upiIntent.setUpiIntentApps = _this.setUpiIntentApps.bind(_this);
    // this.setUpiIntentApps({
    //   Paytm: 'net.one97.paytm',
    //   Airtel: 'net.one97.payt',
    //   BHIM: 'net.one97.patm',
    //   PhonePe: 'net.one97.pytm',
    //   Google: 'net.one97.aytm',
    //   Samsung: 'net.one97paytm',
    //   Axis: 'net.one9.paytm'
    // });
    _this.showMoreSavedCardsLinkTxt = en["a" /* default */].savedCard['label.viewMore'];
    _this.firstPreferredPayment = '';
    _this.label = Object(common["e" /* clientMessage */])(constants["g" /* default */].STATIC.toLowerCase(), _this.props.cache).label;
    _this.isWeb = !Object(common["E" /* isMobileDevice */])();
    _this.setSinglePaymodeSingleSelection(_this.props);
    return _this;
  }

  Home.prototype.componentWillUnmount = function componentWillUnmount() {
    this.globaleStoreSubs && this.globaleStoreSubs();
    this.props.cache.setData(constants["a" /* CACHE */].GLOBAL_STORE_UNSUBSCRIPTION, null);
  };

  Home.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.props.checkoutElementPayMode && this.updatePaymentDataOnFPOUpdate();
    var config = this.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
    var paymentOptions = this.props.cache.getData('paymentOptions');
    var txnAmount = this.props.cache.getData(constants["g" /* default */].TXN_AMOUNT);
    this.props.selected && this.onOptionSelect(this.props.selected, true);
    this.amountPayable = Object(common["c" /* calculateAmountPayable */])(txnAmount, this.props.wallet, true, this.props.subscription);
    var payAmountText = en["a" /* default */].payButton.text + this.amountPayable;
    if (Object(common["w" /* isAddNPay */])(paymentOptions, this.props.cache) && Object(common["q" /* getKey */])(this.props, 'selected.type') !== 'mgv') {
      var addNPayText = en["a" /* default */].payButton.addNPayText;
      payAmountText = addNPayText.replace('amount', this.amountPayable);
    }
    if (Object(common["q" /* getKey */])(this.props.selected, 'type', '') === 'login' || Object(common["q" /* getKey */])(this.props.selected, 'type', '') === constants["g" /* default */].BANK_MANDATE_PAY_TYPE || Object(common["q" /* getKey */])(this.props.selected, 'type', '') === constants["g" /* default */].SAVED_BANK_MANDATE_PAY_TYPE) {
      /*
       * if selected component is login then change btn text to proceed instead of pay
       * */
      var locale = Object(common["e" /* clientMessage */])(constants["g" /* default */].LOGIN.toLowerCase(), this.props.cache);
      this.props.onBtnTextChange(locale.label.btnSendOtpText);
    } else {
      this.props.onBtnTextChange(payAmountText);
    }

    this.mainComp.addEventListener('scroll', function (e) {
      if (Object(common["q" /* getKey */])(e, 'srcElement') && Object(common["q" /* getKey */])(_this2.headerComp, '_component.headerElem.clientHeight')) {
        if (e.srcElement.scrollTop >= _this2.headerComp._component.headerElem.clientHeight) {
          if (!_this2.state.headerFixClass) {
            _this2.setState({ headerFixClass: 'ptm-header_fix' });
          }
        } else if (_this2.state.headerFixClass) {
          _this2.setState({ headerFixClass: '' });
        }
      }
    }, false);

    setTimeout(this.handleSelfExpiration.bind(this), config.expireDuration || 3600000, Date.now(), config.expireDuration);
    var retryData = this.props.cache.getData(constants["a" /* CACHE */].RETRY_DATA);
    if (retryData) {
      this.props.cache.getData(constants["a" /* CACHE */].STORE).setState({
        retryMessage: retryData.retryErrorMsg || constants["g" /* default */].GENERIC_ERROR,
        overlayValue: constants["g" /* default */].RETRY
      });
    }
    if (this.props.selected && this.props.cache.getData(constants["g" /* default */].STORAGE_USED)) {
      this.mainComp.scrollBy(0, this.props.selected.reference.base.offsetTop - 100);
    }
  };

  Home.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (Object(common["q" /* getKey */])(this.props, 'loginInfo.userLoggedIn') !== Object(common["q" /* getKey */])(nextProps, 'loginInfo.userLoggedIn')) {
      this.setSinglePaymodeSingleSelection(nextProps);
      this.setState({
        qr: Object(common["j" /* equalsIgnoreCase */])(this.props.checkoutElementPayMode, constant["c" /* ELEMENT_PAYMODE */].SCAN_AND_PAY) || !Object(common["q" /* getKey */])(nextProps, 'loginInfo.userLoggedIn') ? Object(common["q" /* getKey */])(this.props.cache.getData('paymentOptions'), 'qrDetail') : null
      });
      this.updatePromoEnableStatus(null, nextProps.selected);
    }
  };

  Home.prototype.disabledWalletAndSelectNewPaymode = function disabledWalletAndSelectNewPaymode(paymentOptions) {
    var wallet = home__extends({}, Object(common["q" /* getKey */])(paymentOptions, 'wallet'));
    wallet.isUsed = false;
    wallet.isEnabled = false;
    this.props.onWalletToggle(wallet);

    var newSelected = Object(common["i" /* defaultSelected */])(paymentOptions, this.props.cache);
    newSelected && this.onOptionSelect(newSelected);
  };

  Home.prototype.setSinglePaymodeSingleSelection = function setSinglePaymodeSingleSelection(props) {
    var balancePaymodeCount = Object(common["q" /* getKey */])(props, 'loginInfo.userLoggedIn') && Object(common["q" /* getKey */])(props, 'wallet') ? 1 : 0;
    var isSingleSelection = false;
    var checkoutElementPayMode = Object(common["q" /* getKey */])(props, 'checkoutElementPayMode');
    if (checkoutElementPayMode && balancePaymodeCount + Number(Boolean(Object(common["q" /* getKey */])(props, 'mgv.isEnabled'))) + Object(common["q" /* getKey */])(props, 'payData.paymentModes', []).length + Object(common["q" /* getKey */])(props, 'payData.savedVPas', []).length + Object(common["q" /* getKey */])(props, 'payData.savedInstruments', []).length === 1 || Object(common["j" /* equalsIgnoreCase */])(constant["c" /* ELEMENT_PAYMODE */].EMI, checkoutElementPayMode)) {
      isSingleSelection = true;
    }

    this.isSingleSelection = isSingleSelection;
    this.hidePaymodeLabel = isSingleSelection && !(this.isWeb && Object(common["q" /* getKey */])(this.state, 'qr.enabled') && Object(common["q" /* getKey */])(this.state, 'qr.dataUrl')) && Boolean(Object(common["q" /* getKey */])(props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG), 'hidePaymodeLabel', false));
  };

  /* when a new card is selected set paymode based offers as null since it was showing previously
  selected bank offer and also reset payable amount */


  Home.prototype.render = function render(_ref, _ref2) {
    var _this3 = this;

    var payData = _ref.payData,
        wallet = _ref.wallet,
        mgv = _ref.mgv,
        selected = _ref.selected,
        subscription = _ref.subscription,
        loginInfo = _ref.loginInfo,
        btnText = _ref.btnText,
        _ref$sessionExpired = _ref.sessionExpired,
        sessionExpired = _ref$sessionExpired === undefined ? false : _ref$sessionExpired,
        _ref$stopScroll = _ref.stopScroll,
        stopScroll = _ref$stopScroll === undefined ? false : _ref$stopScroll,
        _ref$showHelperOverla = _ref.showHelperOverlay,
        showHelperOverlay = _ref$showHelperOverla === undefined ? '' : _ref$showHelperOverla,
        cache = _ref.cache,
        checkoutElementPayMode = _ref.checkoutElementPayMode;
    var upiIntentApps = _ref2.upiIntentApps,
        showAllSavedCards = _ref2.showAllSavedCards,
        headerFixClass = _ref2.headerFixClass,
        pcfFeeAmount = _ref2.pcfFeeAmount,
        isPcfEnabled = _ref2.isPcfEnabled,
        payModeBasedOffers = _ref2.payModeBasedOffers,
        isPromoAvailable = _ref2.isPromoAvailable,
        mandateAccountDetails = _ref2.mandateAccountDetails,
        qr = _ref2.qr;

    var paymentOption = cache.getData('paymentOptions');
    var insufficientBalance = Object(common["B" /* isInsufficientBalance */])(paymentOption, cache);
    var isMgvBalSufficient = Object(common["D" /* isMgvSufficient */])(mgv, cache);
    var offers = Object(common["q" /* getKey */])(payModeBasedOffers, 'offerBreakup');

    var isMgvActive = false;
    if (!cache.getData(constants["g" /* default */].CURRENT_PAYMODE) || Object(common["q" /* getKey */])(cache.getData(constants["g" /* default */].CURRENT_PAYMODE), 'paymentMode') === 'GIFT_VOUCHER') {
      selected && selected.id && mgv && (isMgvActive = selected.id === mgv.id);
    }

    var hidePaytmBranding = Object(common["q" /* getKey */])(cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG), 'merchant.hidePaytmBranding', undefined);
    var onOptionSelect = this.onOptionSelect,
        updatePcfAmount = this.updatePcfAmount,
        updateSelectedPayModePcfWithInstId = this.updateSelectedPayModePcfWithInstId,
        fetchPcf = this.fetchPcf,
        applyPromoForPayMode = this.applyPromoForPayMode,
        handlePromoResponseFromCard = this.handlePromoResponseFromCard,
        handlePromoErrorFromCard = this.handlePromoErrorFromCard,
        updatePromoEnableStatus = this.updatePromoEnableStatus,
        setEmiOfferNull = this.setEmiOfferNull,
        setPayableAmount = this.setPayableAmount;

    var amountPayable = Object(common["c" /* calculateAmountPayable */])(cache.getData(constants["g" /* default */].TXN_AMOUNT), wallet, true, this.props.subscription);
    var toShowSelectOPtionText = true;
    var channels = {
      collectEnabled: false,
      intentEnabled: false,
      pushEnabled: false
    };

    selected && (this.selected = selected.reference);
    payData && payData.paymentModes && payData.paymentModes.map(function (option) {
      if (option.type === 'upi') {
        option.payChannelOptions && option.payChannelOptions.forEach(function (channel) {
          switch (channel.channelCode) {
            case 'UPI':
              channels.collectEnabled = true;
              break;

            case 'UPIPUSH':
              channels.intentEnabled = true;
              break;

            case 'UPIPUSHEXPRESS':
              channels.pushEnabled = true;
              break;
            default:
              break;
          }
        });
      }
      return option;
    });
    var isEmiElementPaymode = Object(common["j" /* equalsIgnoreCase */])(constant["c" /* ELEMENT_PAYMODE */].EMI, checkoutElementPayMode);
    var isScanAndPayPaymode = Object(common["j" /* equalsIgnoreCase */])(constant["c" /* ELEMENT_PAYMODE */].SCAN_AND_PAY, checkoutElementPayMode);

    return Object(preact_min["h"])(
      'div',
      {
        id: 'checkout-home',
        'class': (selected && !sessionExpired ? 'ptm-btn-visible' : '') + ' ptm-main ' + (checkoutElementPayMode ? 'ptm-checkout-element' : '') + ' ' + (this.isSingleSelection ? 'ptm-single-selection' : '') + ' ' + (this.hidePaymodeLabel ? 'ptm-no-paymode-label' : '') + ' ' + (isScanAndPayPaymode ? 'ptm-scan-and-pay-element' : '')
      },
      checkoutElementPayMode ? home__ref3 : Object(preact_min["h"])(header, home__extends({ headerFixClass: headerFixClass, isPcfEnabled: isPcfEnabled, pcfFeeAmount: pcfFeeAmount }, {
        ref: function ref(headerComp) {
          _this3.headerComp = headerComp;
        }
      })),
      Object(preact_min["h"])(
        'div',
        {
          'class': 'payment-content-wrap ptm-body-bg ' + (stopScroll ? 'stop-scroll' : '') + ' ' + (stopScroll ? 'ptm-hide-btn' : ''),
          ref: function ref(mainComp) {
            _this3.mainComp = mainComp;
          }
        },
        !sessionExpired &&
        /* if hidePaytmBranding is set true then need to add a class to paymodes to prevent
        overlapping of button from last paymode */
        Object(preact_min["h"])(
          'div',
          { 'class': 'payment-mode-warp ' + (hidePaytmBranding ? 'hide-paytm-branding' : '') },
          isPromoAvailable && !checkoutElementPayMode && home__ref4,
          this.isWeb && qr && qr.enabled && qr.dataUrl && Object(preact_min["h"])(components_qr, { qr: qr }),
          loginInfo && loginInfo.userLoggedIn && Object(preact_min["h"])(
            'h4',
            { className: 'ptm-select-txt ptm-uppercase' },
            Object(common["q" /* getKey */])(subscription, 'isEnabled', false) ? this.label.subscriptionSelection : this.label.paymodeSelection
          ),
          mgv && mgv.isEnabled && Object(preact_min["h"])(components_mgv, home__extends({ isMgvBalSufficient: isMgvBalSufficient, isMgvActive: isMgvActive, onOptionSelect: onOptionSelect }, {
            ref: function ref(k) {
              mgv.reference = k;
            }
          })),
          loginInfo && loginInfo.userLoggedIn && wallet && Object(preact_min["h"])(components_wallet, home__extends({
            insufficientBalance: insufficientBalance,
            fetchPcf: fetchPcf,
            applyPromoForPayMode: applyPromoForPayMode,
            offers: offers,
            isPromoAvailable: isPromoAvailable,
            updatePromoEnableStatus: updatePromoEnableStatus
          }, {
            ref: function ref(k) {
              wallet.reference = k;
            }
          })),
          payData && payData.savedVPas && payData.savedVPas.map(function (option) {
            var Paymode = _this3.components[option.type];
            toShowSelectOPtionText = false;
            if (Paymode) {
              var isActive = !!(selected && selected.id === option.id);
              return Object(preact_min["h"])(Paymode, home__extends({
                option: option,
                channels: channels,
                isActive: isActive,
                onOptionSelect: onOptionSelect,
                amountPayable: amountPayable,
                offers: offers,
                updatePcfAmount: updatePcfAmount,
                updateSelectedPayModePcfWithInstId: updateSelectedPayModePcfWithInstId,
                applyPromoForPayMode: applyPromoForPayMode,
                isPromoAvailable: isPromoAvailable
              }, {
                ref: function ref(k) {
                  option.reference = k;
                }
              }));
            }
            return option;
          }),
          !isEmiElementPaymode && payData && payData.savedInstruments && payData.savedInstruments.length > 0 && loginInfo && !loginInfo.userLoggedIn && Object(preact_min["h"])(
            'h4',
            { className: 'ptm-select-txt ptm-uppercase' },
            this.label.saveCardSelection
          ),
          Object(preact_min["h"])(
            'div',
            { 'class': 'ptm-pay-method-wrap' },
            !isEmiElementPaymode && payData && payData.savedInstruments && payData.savedInstruments.map(function (option, index) {
              var Paymode = _this3.components[option.type];
              toShowSelectOPtionText = false;
              var isDisplay = true;
              if (index > 1 && !showAllSavedCards && loginInfo && !loginInfo.userLoggedIn) {
                isDisplay = false;
                _this3.state.showMoreSavedCardsLink = true;
              }
              var isActive = !!(selected && selected.id === option.id);
              if (Paymode) {
                return Object(preact_min["h"])(Paymode, home__extends({
                  option: option,
                  offers: offers,
                  channels: channels,
                  upiIntentApps: upiIntentApps,
                  isDisplay: isDisplay,
                  isActive: isActive,
                  onOptionSelect: onOptionSelect,
                  fetchPcf: fetchPcf,
                  applyPromoForPayMode: applyPromoForPayMode,
                  isPromoAvailable: isPromoAvailable
                }, {
                  ref: function ref(k) {
                    option.reference = k;
                  }
                }));
              }
              return option;
            }),
            this.state.showMoreSavedCardsLink && loginInfo && !loginInfo.userLoggedIn && Object(preact_min["h"])(
              'p',
              { className: 'ptm-small-txt-link ptm-cardtxt', onClick: this.showHideSavedCards },
              this.showMoreSavedCardsLinkTxt
            ),
            payData && payData.savedMandateBanks && payData.savedMandateBanks.map(function (option) {
              var Paymode = _this3.components[option.type];
              toShowSelectOPtionText = false;
              if (Paymode) {
                var isActive = !!(selected && selected.id === option.id);
                return Object(preact_min["h"])(Paymode, home__extends({
                  option: option,
                  channels: channels,
                  isActive: isActive,
                  onOptionSelect: onOptionSelect,
                  amountPayable: amountPayable,
                  offers: offers,
                  updatePcfAmount: updatePcfAmount,
                  updateSelectedPayModePcfWithInstId: updateSelectedPayModePcfWithInstId,
                  applyPromoForPayMode: applyPromoForPayMode,
                  isPromoAvailable: isPromoAvailable
                }, {
                  ref: function ref(k) {
                    option.reference = k;
                  }
                }));
              }
              return option;
            }),
            loginInfo && !loginInfo.userLoggedIn && toShowSelectOPtionText && Object(preact_min["h"])(
              'h4',
              { className: 'ptm-select-txt ptm-uppercase' },
              Object(common["q" /* getKey */])(subscription, 'isEnabled', false) ? this.label.subscriptionSelection : this.label.paymodeSelection
            ),
            loginInfo && !loginInfo.userLoggedIn && !toShowSelectOPtionText && Object(preact_min["h"])(
              'h4',
              { className: 'ptm-select-txt ptm-uppercase' },
              this.label.paymodeOtherSelection
            ),
            payData && payData.paymentModes && payData.paymentModes.map(function (option) {
              var Paymode = _this3.components[option.type];
              var isActive = !!(selected && selected.id === option.id);
              if (Paymode && option.isEnabled) {
                return Object(preact_min["h"])(Paymode, home__extends({
                  option: option,
                  channels: channels,
                  upiIntentApps: upiIntentApps,
                  isActive: isActive,
                  onOptionSelect: onOptionSelect,
                  offers: offers,
                  updatePcfAmount: updatePcfAmount,
                  updateSelectedPayModePcfWithInstId: updateSelectedPayModePcfWithInstId,
                  applyPromoForPayMode: applyPromoForPayMode,
                  handlePromoResponseFromCard: handlePromoResponseFromCard,
                  isPromoAvailable: isPromoAvailable,
                  handlePromoErrorFromCard: handlePromoErrorFromCard,
                  mandateAccountDetails: mandateAccountDetails,
                  setEmiOfferNull: setEmiOfferNull,
                  setPayableAmount: setPayableAmount
                }, {
                  ref: function ref(k) {
                    option.reference = k;
                  }
                }));
              }
              return option;
            })
          )
        ),
        sessionExpired && home__ref5,
        !hidePaytmBranding && home__ref6
      ),
      selected && !sessionExpired && Object(preact_min["h"])(btn, { onBtnClick: this.onBtnClick, btnText: btnText }),
      home__ref7,
      showHelperOverlay !== '' && Object(preact_min["h"])(
        components_OverlayWrap,
        null,
        showHelperOverlay === constants["g" /* default */].HELPER_TYPE.CVV_HELPER && home__ref8,
        showHelperOverlay === constants["g" /* default */].HELPER_TYPE.SUBS_DETAILS_HELPER && home__ref9
      ),
      Object(preact_min["h"])('input', {
        className: 'ptm-hidden-input',
        id: 'ptm-hidden-input',
        ref: function ref(r) {
          return _this3.hiddenInputRef = r;
        },
        type: 'tel'
      })
    );
  };

  return Home;
}(preact_min["Component"]), home__initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.inProcessPcf = null;
  this.hiddenInputRef = '';
  this.components = {
    ppbl: ppb,
    pdc: postpaid,
    card: components_card,
    nb: nb,
    sc: sc,
    wallet: components_wallet,
    mgv: components_mgv,
    emi: emi,
    // cod: COD,
    upi: components_upi,
    upipush: upipush,
    login: loginComponent,
    BANK_MANDATE: bank_mandate,
    sbm: savedBankMandate
    // ada: ADA,
    // aoa:AOA,
  };

  this.updatePaymentDataOnFPOUpdate = function () {
    var lastFPOResponse = null;
    _this4.globaleStoreSubs = common_cache["b" /* globaleStore */].subscribe(function (state) {
      try {
        var newFPOResponse = state[constants["c" /* GLOBAL_STORE */].FPO_UPDATED_RESPONSE];
        if (newFPOResponse !== lastFPOResponse) {
          newFPOResponse = Object(common["f" /* cloneObject */])(newFPOResponse);
          var _props = _this4.props,
              onSelectChange = _props.onSelectChange,
              onLoginDataChange = _props.onLoginDataChange,
              onBtnTextChange = _props.onBtnTextChange;

          updateOnNewFPO(newFPOResponse, _this4.props.cache, _this4.props.checkoutElementPayMode, _this4.props.subscription, {
            onSelectChange: onSelectChange,
            onLoginDataChange: onLoginDataChange,
            onBtnTextChange: onBtnTextChange
          });
          lastFPOResponse = newFPOResponse;
        }
      } catch (ex) {}
    });
    _this4.props.cache.setData(constants["a" /* CACHE */].GLOBAL_STORE_UNSUBSCRIPTION, _this4.globaleStoreSubs);
  };

  this.handleSelfExpiration = function () {
    // if (Math.abs(time - Date.now()) > duration) {
    //
    // }
    Object(logger["log"])({ eventType: logger["EVENT"].APP_AUTO_CLOSE });
    var notifyMerchant = Object(common["q" /* getKey */])(_this4.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG), 'handler.notifyMerchant', undefined);
    if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
      notifyMerchant(constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.PAYMENT_ERROR, {
        message: 'Auto closed App'
      });
    }

    var closeHandler = _this4.props.cache.getData(constants["a" /* CACHE */].CLOSE_HANDLER);
    Object(common["y" /* isFunction */])(closeHandler) && closeHandler();
  };

  this.setUpiIntentApps = function (packageNames) {
    var appObj = JSON.parse(packageNames);
    if (appObj) {
      var map = [];
      for (var app in appObj) {
        if (Object.prototype.hasOwnProperty.call(appObj, app)) {
          map.push({
            name: app.split(' ').length > 2 ? app.split(' ')[1] : app.split(' ')[0],
            displayName: app,
            packageName: appObj[app]
          });
        }
      }
      _this4.setState({ upiIntentApps: map });
    }
  };

  this.onBtnClick = function (e) {
    e.preventDefault();

    if (Object(common["q" /* getKey */])(_this4.state.payModeBasedOffers, 'hasValidationError', false)) {
      _this4.props.onHighlightOfferError(true);
      setTimeout(function () {
        _this4.props.onHighlightOfferError(false);
      }, 1000);
      return;
    }

    Object(logger["log"])({
      eventType: logger["EVENT"].BUTTON_CLICK,
      payMode: _this4.props.selected && _this4.props.selected.paymentMode
    });
    if (_this4.props.selected && _this4.props.selected.paymentMode === constant["m" /* PAYMODE */].LOGIN) {
      _this4.callComponentSubmit();
    } else {
      var merchantConfig = _this4.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
      if (merchantConfig.flow === index_api["d" /* FLOW */].DEFERRED) {
        _this4.handleTokenForDeferredFlow();
      } else {
        _this4.callComponentSubmit();
      }
    }
  };

  this.handleTokenForDeferredFlow = function () {
    var emiPlans = _this4.props.cache.getData(constants["a" /* CACHE */].EMI_PLANS);
    var paymentIntent = _this4.props.cache.getData(constants["a" /* CACHE */].PAYMENT_INTENT);
    var paymentIntents = [];
    // if paymode is emi or sc used the payment intent stored in cache or create new one
    if (_this4.props.selected.name === constant["m" /* PAYMODE */].EMI || _this4.props.selected.type === 'sc' && emiPlans) {
      paymentIntents = paymentIntent;
    } else {
      var txnAmount = _this4.props.cache.getData(constants["g" /* default */].TXN_AMOUNT);
      if (_this4.props.wallet && _this4.props.wallet.isUsed) {
        paymentIntents.push({
          mode: constant["m" /* PAYMODE */].WALLET,
          txnAmount: parseFloat(_this4.props.wallet.walletBalance) >= parseFloat(txnAmount) ? txnAmount : _this4.props.wallet.walletBalance
        });
      }
      var intent = _this4.createPaymentIntentObject();
      if (intent) {
        paymentIntents.push(intent);
      }
    }

    _this4.props.cache.setData(constants["a" /* CACHE */].PAYMENT_INTENT, paymentIntents);
    // let tokenData = cache.getData(CACHE.TOKEN_DATA);
    // let config = cache.getData(CACHE.MERCHANT_CONFIG);

    _this4.callComponentSubmit();
  };

  this.callComponentSubmit = function () {
    var paymentOption = _this4.props.cache.getData('paymentOptions');
    var insufficientBalance = Object(common["B" /* isInsufficientBalance */])(paymentOption, _this4.props.cache);
    if (!_this4.selected && !insufficientBalance && _this4.props.wallet && _this4.props.wallet.isUsed) {
      _this4.props.wallet.reference._component.submit();
    } else if (_this4.selected) {
      typeof _this4.selected._component.submit === 'function' && _this4.selected._component.submit() || typeof _this4.selected.submit === 'function' && _this4.selected.submit();
    } else if (!_this4.selected && _this4.props.selected) {
      typeof _this4.props.selected.reference._component.submit === 'function' && _this4.props.selected.reference._component.submit();
    }
  };

  this.showHideSavedCards = function () {
    var showAllSavedCards = !_this4.state.showAllSavedCards;
    if (!showAllSavedCards) {
      _this4.showMoreSavedCardsLinkTxt = en["a" /* default */].savedCard['label.viewMore'];
    } else {
      _this4.showMoreSavedCardsLinkTxt = en["a" /* default */].savedCard['label.viewLess'];
    }
    _this4.setState(function (prevState) {
      return { showAllSavedCards: !prevState.showAllSavedCards };
    });
  };

  this.updatePromoEnableStatus = function (selected, nextSelectable) {
    if (!getSimplifiedPaymentOffers(_this4.props.cache)) {
      _this4.setState({ isPromoAvailable: null, payModeBasedOffers: null });
      return;
    }

    var prevIsPromoAvailable = _this4.state.isPromoAvailable;
    var currentIsPromoAvailable = offers_isPromoAvailable(_this4.props.cache);
    _this4.props.cache.setData(constants["g" /* default */].TXN_AMOUNT, _this4.props.cache.getData(constants["g" /* default */].UNMODIFIED_TXN_AMOUNT));
    _this4.setState({
      isPromoAvailable: currentIsPromoAvailable,
      payModeBasedOffers: null
    });

    if (Object(common["j" /* equalsIgnoreCase */])(Object(common["q" /* getKey */])(nextSelectable, 'paymentMode'), constant["m" /* PAYMODE */].LOGIN)) {
      return;
    }

    if (prevIsPromoAvailable !== currentIsPromoAvailable) {
      selected && _this4.props.onSelectChange(null);
      setTimeout(function () {
        // Force re-render for opened paymode data update inorder prevent stale offer esp. in case of iframes
        selected && _this4.props.onSelectChange(selected);
        nextSelectable && _this4.applyPromoForPayMode(nextSelectable);
      }, 0);
    } else if (nextSelectable) {
      _this4.applyPromoForPayMode(nextSelectable);
    }
  };

  this.onOptionSelect = function (option) {
    var isInitialSelection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _this4.props.cache.setData(constants["g" /* default */].CURRENT_PAYMODE, option);
    // if same option is selected again, don't entertain
    if (!isInitialSelection && Object(common["q" /* getKey */])(_this4.props, 'selected.id') === Object(common["q" /* getKey */])(option, 'id')) {
      return;
    }

    /* if after validate emi paymode is changed set emi subvention token as null since on paymode change
     * emi subvention token is going in initiate txn call
     *  */

    if (_this4.props.cache.getData(constants["g" /* default */].EMISUBVENTION_TOKEN)) {
      _this4.props.cache.setData(constants["g" /* default */].EMISUBVENTION_TOKEN, null);
    }
    /* if  option is different from the selected set the emi plan in store to null */
    if (option && _this4.props.selected && option.id !== _this4.props.selected.id) {
      _this4.props.onSelectedPlan(null);
    }
    /* If flow type is deferred and paymode is changed delete current txn token and set  fallback sso token
     * as token type
     * */

    /* If payment option is being changed set the emi plan selected in cache to null */
    _this4.props.cache.setData(constants["a" /* CACHE */].EMI_PLANS, null);
    var fallBackAmount = _this4.props.cache.getData(constants["g" /* default */].FALLBACK_TXN_AMOUNT);
    if (fallBackAmount) {
      _this4.props.cache.setData(constants["g" /* default */].TXN_AMOUNT, fallBackAmount);
    }
    _this4.idPayBankValidateDisabled && _this4.props.onPayChange(true);
    var config = _this4.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
    var fallbackTokenData = _this4.props.cache.getData(constants["a" /* CACHE */].FALLBACK_TOKEN_DATA);
    var tokenData = _this4.props.cache.getData(constants["a" /* CACHE */].TOKEN_DATA);

    if (tokenData.tokenType === constant["n" /* TOKEN */].TXN && config.flow === index_api["d" /* FLOW */].DEFERRED) {
      _this4.props.cache.setData(constants["a" /* CACHE */].TOKEN_DATA, {
        token: fallbackTokenData.token,
        tokenType: constant["n" /* TOKEN */].SSO
      });
    }

    // setting selected bank on option change to be included in defered flow
    _this4.props.cache.setData(constants["a" /* CACHE */].SELECTEDBANK, null);
    _this4.props.cache.setData(constants["a" /* CACHE */].CARD_DETAILS, null);
    var tempPaymode = Object(common["q" /* getKey */])(option, 'paymentMode') || Object(common["q" /* getKey */])(option, 'type') || Object(common["q" /* getKey */])(option, 'id') || '';
    if (Object(common["q" /* getKey */])(option, 'cardDetails.cardType')) {
      tempPaymode = tempPaymode + '_' + Object(common["q" /* getKey */])(option, 'cardDetails.cardType');
    }
    Object(logger["log"])({
      eventType: logger["EVENT"].SELECTED_PAYMODE,
      payMode: tempPaymode.toUpperCase()
    });
    if (!_this4.firstPreferredPayment) {
      _this4.firstPreferredPayment = option.displayName;
    }
    var paymentOptions = home__extends({}, _this4.props.cache.getData('paymentOptions'));
    var walletObj = home__extends({}, paymentOptions.wallet);
    var insufficientBalance = Object(common["B" /* isInsufficientBalance */])(paymentOptions, _this4.props.cache);
    if (paymentOptions && paymentOptions.wallet) {
      if (!insufficientBalance) {
        walletObj.isUsed = false;
        _this4.props.onWalletToggle(walletObj);
      } else {
        _this4.handleHybridCasesForWallet(paymentOptions, option);
      }
    }

    paymentOptions.wallet = walletObj;
    _this4.props.cache.setData(constants["a" /* CACHE */].PAYMENT_OPTIONS, paymentOptions);
    var selectedType = Object(common["q" /* getKey */])(_this4.props, 'selected.type', null);
    // this.props.onSelectChange(option);
    if (selectedType && selectedType === 'emi' && option.isEmiSc) {
      // in case of emi previously selected and option is sc on emi set subselected as sc
      var selected = home__extends({}, _this4.props.selected);
      selected.subOption = option;
      _this4.props.onSelectChange(selected);
      _this4.applyPromoForPayMode(selected, Object(common["q" /* getKey */])(option, 'issuingBank'), null, null, Object(common["q" /* getKey */])(option, 'cardDetails.cardId'));
    } else {
      _this4.props.onSelectChange(option);
      // Move to next event loop so that wallet correct used status is
      // available on immediate switching from wallet to other paymode.
      setTimeout(function () {
        _this4.fetchPcf(option);
      }, 0);
      _this4.applyPromoForPayMode(option);
    }
    // todo check for this usage
    // walletObj = { ...paymentOptions.wallet };
    // setTimeout(() => {
    //   scrollToSelectedOption(option);
    // }, 0);

    _this4.setPayableAmount(option, walletObj, paymentOptions);
  };

  this.applyPromoForPayMode = function (paymode, channelCode, cardNumber, vpa, savedCardId) {
    if (!_this4.state.isPromoAvailable) {
      return Promise.resolve();
    }

    _this4.setState({ payModeBasedOffers: {} });
    _this4.props.cache.setData(constants["g" /* default */].TXN_AMOUNT, _this4.props.cache.getData(constants["g" /* default */].UNMODIFIED_TXN_AMOUNT));
    _this4.setPayableAmount();
    _this4.props.onPayChange(false);
    var mConfig = _this4.props.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
    var customerId = Object(common["q" /* getKey */])(mConfig, 'emiSubvention.customerId', null);

    return applyPromo(_this4.props.cache, paymode, channelCode, cardNumber, vpa, savedCardId, customerId).then(function (response) {
      return response;
    }).catch(function () {
      return null;
    }).then(function (response) {
      return _this4.processPromoResponse(response, paymode);
    });
  };

  this.processPromoResponse = function (payModeBasedOffers, paymode) {
    // Prevent in case of isPromoAvailable value changed to false before late apply api response.
    if (!_this4.state.isPromoAvailable) {
      _this4.props.onPayChange(true);
      return;
    }

    _this4.setState({ payModeBasedOffers: payModeBasedOffers });

    var totalCashbackAmount = Number(Object(common["q" /* getKey */])(payModeBasedOffers, 'totalCashbackAmount', 0));
    var totalInstantDiscount = Number(Object(common["q" /* getKey */])(payModeBasedOffers, 'totalInstantDiscount', 0));
    var txnAmount = Number(_this4.props.cache.getData(constants["g" /* default */].UNMODIFIED_TXN_AMOUNT, 0));
    var isEmiSubventionFlow = _this4.props.cache.getData(constants["g" /* default */].IS_EMISUBVENTION_ACCESS_TOKEN_FLOW);
    var selectedType = Object(common["q" /* getKey */])(_this4, 'props.selected.type', null);
    _this4.props.cache.setData(constants["g" /* default */].BANK_OFFER_TXN_AMOUNT, null);
    if (isEmiSubventionFlow) {
      _this4.handleProcessPromoResponseForAceessToken(payModeBasedOffers, paymode);
    }
    // if selectedType is sc or emi then change the  update the cart or amount based on cashback/discount
    if (isEmiSubventionFlow && (selectedType === 'emi' || selectedType === 'sc')) {
      _this4.handleEmiSubventionAmount(totalInstantDiscount, txnAmount);
    }

    _this4.props.cache.setData(constants["g" /* default */].TXN_AMOUNT, Object(common["L" /* money */])(txnAmount - totalInstantDiscount));
    _this4.setPayableAmount(null, null, null, totalCashbackAmount);
    _this4.props.onPayChange(true);
  };

  this.handleProcessPromoResponseForAceessToken = function (payModeBasedOffers, paymode) {
    /*
    this is being done since in cache object we have offer against paymode but to be sent to
    merchant it has to be done the way received in response */
    var totalCashbackAmount = Number(Object(common["q" /* getKey */])(payModeBasedOffers, 'totalCashbackAmount', 0));
    var totalInstantDiscount = Number(Object(common["q" /* getKey */])(payModeBasedOffers, 'totalInstantDiscount', 0));
    var selected = Object(common["q" /* getKey */])(_this4, 'props.selected', {});
    /* if paymode is available then choose paymode else choose selected for getting the key for which
     * offer object is stored against */
    var selectedPaymode = paymode ? (paymode.paymentMode || paymode.type).toUpperCase() : (selected.paymentMode || selected.type).toUpperCase();
    /* for card the selected paymode set in key is card and ot creditcard/debit card */
    if (selectedPaymode === constants["g" /* default */].CC || selectedPaymode === constants["g" /* default */].DC) {
      selectedPaymode = constant["m" /* PAYMODE */].CARD;
    }
    var offer = Object(common["q" /* getKey */])(payModeBasedOffers, 'offerBreakup.' + selectedPaymode, {});
    delete offer.validationErrorMessage;
    var paymodeOffer = {
      offerBreakup: [offer],
      totalCashbackAmount: totalCashbackAmount,
      totalInstantDiscount: totalInstantDiscount
    };

    _this4.props.cache.setData(constants["g" /* default */].PAYMODE_BASED_OFFER, paymodeOffer);
    var txnAmount = Number(_this4.props.cache.getData(constants["g" /* default */].UNMODIFIED_TXN_AMOUNT, 0));
    var selectedType = Object(common["q" /* getKey */])(_this4, 'props.selected.type', null);
    // if selectedType is sc or emi then change the  update the cart or amount based on cashback/discount
    if (selectedType === 'emi' || selectedType === 'sc') {
      _this4.handleEmiSubventionAmount(totalInstantDiscount, txnAmount);
    }

    _this4.props.cache.setData(constants["g" /* default */].TXN_AMOUNT, Object(common["L" /* money */])(txnAmount - totalInstantDiscount));
    _this4.setPayableAmount(null, null, null, totalCashbackAmount);
    _this4.props.onPayChange(true);
  };

  this.handlePromoResponseFromCard = function (response, bankCode) {
    var parsedResponse = parseApplyPromoResponse(_this4.props.cache, false, bankCode, response);
    _this4.processPromoResponse(parsedResponse);
  };

  this.handlePromoErrorFromCard = function (error, payMethod, bankcode) {
    var parsedResponse = handleApplyPromoError(_this4.props.cache, error, payMethod, bankcode);
    _this4.processPromoResponse(parsedResponse);
  };

  this.fetchPcf = function (option, instId) {
    var txnAmount = 0;
    var isWalletPayMode = false;

    // if selected option is login then no need to call fetch pcf for the selected paymode
    if (!option || option.type === 'login' || !_this4.state.isPcfEnabled || _this4.inProcessPcf && _this4.inProcessPcf.option === option && _this4.inProcessPcf.instId === instId || !Object.prototype.hasOwnProperty.call(option, 'isWalletOnly') && Object(common["q" /* getKey */])(_this4.props, 'wallet.isUsed', false)) {
      isWalletPayMode = option && Object.prototype.hasOwnProperty.call(option, 'isWalletOnly');
      return Promise.resolve();
    }

    if (isWalletPayMode && !option.isUsed) {
      _this4.updatePcfAmount(null, false);
      return Promise.resolve();
    }

    _this4.setState({ pcfFeeAmount: 0 });
    _this4.inProcessPcf = { option: option, instId: instId };

    /* passing txn amount since in case of access token flow amount has to be passed in fetch pcf details */
    if (_this4.props.cache.getData(constants["g" /* default */].IS_EMISUBVENTION_ACCESS_TOKEN_FLOW)) {
      txnAmount = _this4.props.cache.getData(constants["g" /* default */].TXN_AMOUNT);
    }
    return fetchPcfForPayMode(_this4.props.cache, option, instId, txnAmount).then(function (pcf) {
      _this4.updatePcfAmount(pcf, false);
      _this4.inProcessPcf = null;
      var paymentOptions = _this4.props.cache.getData(constants["a" /* CACHE */].PAYMENT_OPTIONS);

      // Disable wallet and select new paymode if selected mode is wallet,
      // payment flow is none and wallet balance is less than pcf inclusive
      // txn amount.
      if (isWalletPayMode && Object(common["j" /* equalsIgnoreCase */])(Object(common["q" /* getKey */])(paymentOptions, 'paymentFlow'), constant["l" /* PAYMENT_FLOW */].NONE) && Number(_this4.props.cache.getData(constants["g" /* default */].TXN_AMOUNT, 0)) > Number(Object(common["q" /* getKey */])(option, 'walletBalance', 0))) {
        _this4.disabledWalletAndSelectNewPaymode(paymentOptions);
      }
    }).catch(function (e) {
      _this4.updatePcfAmount(null, false);
      _this4.inProcessPcf = null;
      _this4.props.onNotificationTextChange(e && e.message);
    });
  };

  this.updateSelectedPayModePcfWithInstId = function (instId) {
    // Delay to handle in case where option selection and
    // this function call happens at same time.
    setTimeout(function () {
      _this4.fetchPcf(_this4.props.selected, instId);
    }, 100);
  };

  this.setPayableAmount = function (option, wallet, paymentOptions, cachback) {
    var useCachedCashbackValue = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    paymentOptions = paymentOptions || _this4.props.cache.getData('paymentOptions');
    wallet = wallet || _this4.props.wallet;
    option = option || _this4.props.selected;
    cachback = useCachedCashbackValue ? Number(Object(common["q" /* getKey */])(_this4.state.payModeBasedOffers, 'totalCashbackAmount', 0)) : cachback;

    if (Object(common["j" /* equalsIgnoreCase */])(Object(common["q" /* getKey */])(option, 'type'), constant["m" /* PAYMODE */].LOGIN)) {
      var locale = Object(common["e" /* clientMessage */])(constants["g" /* default */].LOGIN.toLowerCase(), _this4.props.cache);
      _this4.props.onBtnTextChange(locale.label.btnSendOtpText);
    } else {
      var amountPayable = Object(common["c" /* calculateAmountPayable */])(_this4.props.cache.getData(constants["g" /* default */].TXN_AMOUNT), wallet, false, _this4.props.subscription);

      var payAmountText = en["a" /* default */].payButton.text + Object(common["g" /* commas */])(amountPayable);

      if (Object(common["w" /* isAddNPay */])(paymentOptions, _this4.props.cache) && option && option.type !== 'mgv') {
        payAmountText = en["a" /* default */].payButton.addNPayText.replace('amount', Object(common["g" /* commas */])(amountPayable));
      }

      var cachbackText = cachback ? Object(common["h" /* convertRupeeCharToUnicode */])(en["a" /* default */].payButton.effectivePrice.replace('amount', Object(common["g" /* commas */])(cachback)).replace('effectPrice', Object(common["g" /* commas */])(Number(amountPayable) - Number(cachback)))) : null;

      _this4.props.onBtnTextChange(payAmountText, cachbackText);
    }
    _this4.props.onPayChange(true);
  };

  this.updatePcfAmount = function (pcf) {
    var isNotCalledFromFetchPcf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (!_this4.state.isPcfEnabled || isNotCalledFromFetchPcf && Object(common["q" /* getKey */])(_this4.props, 'wallet.isUsed', false)) {
      return;
    }

    var pcfFeeAmount = updatedPcfAmountAndReturn(_this4.props.cache, pcf);
    _this4.setState({ pcfFeeAmount: pcfFeeAmount });
    _this4.setPayableAmount();
  };

  this.handleHybridCasesForWallet = function (paymentOptions, option) {
    if (paymentOptions.paymentFlow === constant["l" /* PAYMENT_FLOW */].HYBRID) {
      var walletObj = home__extends({}, paymentOptions.wallet);
      if (option.isHybridDisabled && walletObj && walletObj.isUsed) {
        walletObj.isUsed = false;
        walletObj.isEnabled = false;
        if (option.type === 'emi') {
          var locale = Object(common["e" /* clientMessage */])(constant["m" /* PAYMODE */].EMI.toLowerCase(), _this4.props.cache);
          var text = locale.label.emiHybridDisabledText;
          _this4.props.onNotificationTextChange(text);
        }
      } else if (walletObj) {
        walletObj.isEnabled = !(!walletObj.isUsed && option.isHybridDisabled);
      }
      paymentOptions.wallet = walletObj;
      /* setting wallet obj in payment options to set wallet isUsed in cache for other use cases */
      _this4.props.cache.setData(constants["a" /* CACHE */].PAYMENT_OPTIONS, paymentOptions);
      walletObj && _this4.props.onWalletToggle(walletObj);
      var txnAmount = _this4.props.cache.getData(constants["g" /* default */].TXN_AMOUNT);
      _this4.amountPayable = Object(common["c" /* calculateAmountPayable */])(txnAmount, walletObj, true, _this4.props.subscription);
      var payAmountText = en["a" /* default */].payButton.text + _this4.amountPayable;
      _this4.props.onBtnTextChange(payAmountText);
    }
  };

  this.createPaymentIntentObject = function () {
    var wallet = _this4.props.wallet;

    var txnAmount = _this4.props.cache.getData(constants["g" /* default */].TXN_AMOUNT);
    var selected = _this4.props.selected;
    // if selected doesnt have paymode return null

    if (!selected.paymentMode && selected.type !== 'sc') {
      return null;
    }
    var intent = {
      mode: selected.paymentMode || selected.cardDetails && selected.cardDetails.cardType,
      txnAmount: wallet && wallet.isUsed ? txnAmount - _this4.props.wallet.walletBalance : txnAmount
    };

    if (selected.issuingBank || _this4.props.cache.getData(constants["a" /* CACHE */].SELECTEDBANK)) {
      intent.banks = [selected.issuingBank || _this4.props.cache.getData(constants["a" /* CACHE */].SELECTEDBANK).channelCode];
    }

    if (selected && selected.paymentMode === constant["m" /* PAYMODE */].PAYMENT_BANK) {
      intent.mode = constants["g" /* default */].NB;
      intent.banks = [constants["g" /* default */].PPBL];
    }
    if (selected.cardDetails && selected.cardDetails.cardHash) {
      intent.cardHash = selected.cardDetails.cardHash;
    }

    // if new card is added get card hash and bank code stored in this.props.cache
    var cardDetails = _this4.props.cache.getData(constants["a" /* CACHE */].CARD_DETAILS);

    if (selected.type === 'card' && cardDetails) {
      var issuingBankCode = Object(common["q" /* getKey */])(cardDetails, 'details.binDetail.issuingBankCode', null);
      intent.cardHash = cardDetails.cardHash;
      intent.banks = [issuingBankCode];
    }
    if (selected.channelCode) {
      intent.channels = [selected.channelCode];
    }
    // in case of pdc remove  bank
    if (selected.type === 'pdc') {
      delete intent.banks;
    }
    return intent;
  };

  this.handleEmiSubventionAmount = function (totalInstantDiscount, txnAmount) {
    /* for every paymode change the amount will be calculated again since for different paymodes
     * different discount can be there
     * also if total discount exists then only change the price else keep it existing.
     * eg - like for one paymode it may be discount and for other it may be cashback
     *  */
    if (totalInstantDiscount) {
      var discountPercentage = totalInstantDiscount / txnAmount * 100;
      var isEmiSubventionFlow = _this4.props.cache.getData(constants["g" /* default */].IS_EMISUBVENTION_ACCESS_TOKEN_FLOW);
      // using stringify and parse since on destructuring also the original object was being changed
      var subventionObject = JSON.parse(JSON.stringify(_this4.props.cache.getData(constants["g" /* default */].SUBVENTION_OBJ_INITIAL)));
      var emiStrategy = _this4.props.cache.getData(constants["g" /* default */].EMISUBVENTION_STATEGY);
      if (isEmiSubventionFlow) {
        if (emiStrategy === constant["e" /* EMI_SUBVENTION_STRATEGY */].ITEM_BASED) {
          var items = Object(common["q" /* getKey */])(subventionObject, 'items', []);
          items = items.map(function (item) {
            item.price -= discountPercentage / 100 * item.price;
            return item;
          });
          _this4.props.cache.setData(constants["g" /* default */].SUBVENTION_OBJ, { items: items });
        } else {
          var price = subventionObject.price,
              subventionAmount = subventionObject.subventionAmount;

          price -= discountPercentage / 100 * price;
          subventionAmount -= discountPercentage / 100 * subventionAmount;
          _this4.props.cache.setData(constants["g" /* default */].SUBVENTION_OBJ, {
            price: price,
            subventionAmount: subventionAmount
          });
        }
      }
      _this4.props.cache.setData(constants["g" /* default */].BANK_OFFER_TXN_AMOUNT, Object(common["L" /* money */])(txnAmount - totalInstantDiscount));
    } else {
      _this4.props.cache.setData(constants["g" /* default */].BANK_OFFER_TXN_AMOUNT, Object(common["L" /* money */])(txnAmount));
      _this4.props.cache.setData(constants["g" /* default */].SUBVENTION_OBJ, _this4.props.cache.getData(constants["g" /* default */].SUBVENTION_OBJ_INITIAL));
    }
  };

  this.setEmiOfferNull = function () {
    _this4.setState({ payModeBasedOffers: {} });
    var fallBackAmount = _this4.props.cache.getData(constants["g" /* default */].FALLBACK_TXN_AMOUNT);
    if (fallBackAmount) {
      _this4.props.cache.setData(constants["g" /* default */].TXN_AMOUNT, fallBackAmount);
    }
    _this4.setPayableAmount();
  };
}, home__temp);

/* harmony default export */ var home = (Object(preact["connect"])('payData, wallet, mgv,selected, loginInfo,btnText, subSelected, stopScroll,\n  sessionExpired, showHelperOverlay, subscription, cache, checkoutElementPayMode, directBankData', onChange)(home_Home));
// CONCATENATED MODULE: ./components/StyleComponent.js





var convertJsonToCss = function convertJsonToCss() {
  var styleObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var containerClass = arguments[1];

  return Object.keys(styleObject).reduce(function (style, selector) {
    var selectorValue = styleObject[selector];
    var selectorProperties = Object.keys(selectorValue);

    var selectorCss = selectorProperties.reduce(function (selectorCssValue, property) {
      var value = selectorValue[property];

      if (value) {
        selectorCssValue += property + ': ' + value + ';\n';
      }

      return selectorCssValue;
    }, '');

    if (selectorCss.length) {
      style += '\n';

      var prefixedSelector = selector.split(',').map(function (currentSelector) {
        return currentSelector.indexOf(containerClass) === -1 ? currentSelector.replace('#paytm-app', '#paytm-app.' + containerClass) : currentSelector;
      }).join(',');

      style += prefixedSelector + '{\n' + selectorCss + '\n}\n';
    }
    return style;
  }, '');
};

var StyleComponent_StyleComponent = function StyleComponent(_ref) {
  var AppStyle = _ref.AppStyle,
      containerClass = _ref.containerClass,
      cache = _ref.cache;

  var mConfig = cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
  var isGradientEffectEnable = Object(common["q" /* getKey */])(mConfig, 'isGradientEffectEnable', false);
  var gradient = AppStyle.gradient;
  var headerBg = void 0;
  var buttonBg = void 0;
  if (isGradientEffectEnable && gradient && gradient.headerGradientsColors && gradient.headerGradientsColors.length) {
    headerBg = 'linear-gradient(to bottom, ' + gradient.headerGradientsColors[0] + ', ' + gradient.headerGradientsColors[1] + ')';
  } else {
    headerBg = AppStyle.headerBackgroundColor;
  }
  if (isGradientEffectEnable && gradient && gradient.buttonGradientsColors && gradient.buttonGradientsColors.length) {
    buttonBg = 'linear-gradient(to top, ' + gradient.buttonGradientsColors[0] + ', ' + gradient.buttonGradientsColors[1] + ')';
  } else {
    buttonBg = AppStyle.themeBackgroundColor;
  }
  var styleObject = {
    '#paytm-app': {
      color: AppStyle.bodyColor
    },
    '#paytm-app .ptm-border-color,#paytm-app .ptm-tool-tip,#paytm-app .ptm-triangle': {
      'border-color': AppStyle.borderColor
    },
    '#paytm-app .ptm-small-txt,#paytm-app .ptm-body-color,#paytm-app .ptm-input-common,#paytm-app .ptm-select-txt,#paytm-app .ptm-card-input,#paytm-app .ptm-upi-input,#paytm-app .ptm-container .ptm-paymode-name,#paytm-app .ptm-input-common::placeholder,#paytm-app .ptm-upi-input::placeholder,#paytm-app .ptm-container, #paytm-app .ptm-paymode-name': {
      color: AppStyle.bodyColor
    },
    '#paytm-app .ptm-input-common,#paytm-app .ptm-pnr-input,#paytm-app .ptm-global-border,#paytm-app span.ptm-global-border,#paytm-app .ptm-card-input,#paytm-app .ptm-upi-input,#paytm-app .ptm-emi-main .ptm-pay-method .ptm-pay-method,#paytm-app .ptm-select-bank:after,#paytm-app .cnvc-before-icon,#paytm-app .ptm-qr-zoom-wrap,#paytm-app .cnvc-before-icon:before,#paytm-app .ptm-change-plan': {
      'border-color': AppStyle.borderColor
    },
    '#paytm-app,#paytm-app .ptm-body-bg': {
      'background-color': AppStyle.bodyBackgroundColor
    },
    '#paytm-app .ptm-checkmark': {
      'background-color': 'transparent'
    },
    '#paytm-app ptm-lightblue-bg': {
      'background-color': AppStyle.headerColor
    },
    '#paytm-app .ptm-header-bg': {
      background: headerBg
    },
    ' #paytm-app .ptm-footer,#paytm-app .ptm-closeIcon': {
      background: AppStyle.headerBackgroundColor
    },
    '#paytm-app .ptm-pay-method::after,#paytm-app .nb-border:after,#paytm-app .ptm-global-bottom-border': {
      background: AppStyle.borderColor
    },
    '#paytm-app .ptm-header-color,#paytm-app .ptm-footer .ptm-text-blue,#paytm-app .ptm-logo-name': {
      color: AppStyle.headerColor
    },
    '#ptm-checkout-header .ptm-select-txt': {
      color: '#1d252d'
    },
    '#paytm-app .cnvc-before-icon:before,#paytm-app .ptm-tool-tip::after': {
      background: AppStyle.bodyBackgroundColor
    },
    '#paytm-app .ptm-header-color .ptm-arrow-down': {
      'border-color': AppStyle.headerColor
    },
    '#paytm-app .ptm-amount-color, #paytm-app .ptm-c-p label, #paytm-app .ptm-c-p span': {
      color: AppStyle.headerColor
    },
    '#paytm-app .arrow-color': {
      'border-color': AppStyle.headerColor
    },

    '#paytm-app .ptm-cross:before,#paytm-app .ptm-cross:after,#paytm-app .ptm-close-wrap .ptm-cross:before,#paytm-app .ptm-close-wrap .ptm-cross:after': {
      background: AppStyle.headerColor
    },
    '#paytm-app .ptm-cross.ptm-black:before,#paytm-app .ptm-cross.ptm-black:after': {
      background: '#000000'
    },
    '#paytm-app .ptm-custom-btn': {
      background: buttonBg,
      color: AppStyle.themeColor
    },
    '#paytm-app button, #paytm-app .ptm-scale-qr-type': {
      background: AppStyle.themeBackgroundColor,
      color: AppStyle.themeColor
    },
    '#paytm-app .ptm-nb-cancel-btn': {
      background: 'transparent',
      color: AppStyle.themeBackgroundColor
    },
    '#paytm-app span.ptm-btn-active,#paytm-app .ptm-close-wrap': {
      background: AppStyle.themeBackgroundColor
    },
    '#paytm-app .ptm-checkmark,#paytm-app .check,#paytm-app .ptm-check,#paytm-app .ptm-container:hover input ~ .ptm-check': {
      'border-color': AppStyle.bodyColor
    },
    '#paytm-app .ptm-lbl input:checked ~ .ptm-checkmark': {
      'border-color': AppStyle.themeBackgroundColor,
      background: 'transparent'
    },
    '#paytm-app .ptm-lbl .ptm-checkmark:after': {
      background: AppStyle.themeBackgroundColor
    },
    '#paytm-app .ptm-small-txt-link': {
      color: AppStyle.themeBackgroundColor
    },
    '#paytm-app .ptm-activeBank': {
      'border-color': AppStyle.themeBackgroundColor
    },
    '#paytm-app .ptm-tick': {
      background: AppStyle.themeBackgroundColor,
      'border-color': AppStyle.themeBackgroundColor
    },
    '#paytm-app .ptm-sign1,#paytm-app .ptm-sign2': {
      color: AppStyle.themeColor
    },
    '#paytm-app .ptm-primary, #paytm-app a.ptm-primary': {
      color: AppStyle.themeBackgroundColor
    },
    '#paytm-app .ptm-input-common:focus': {
      'border-color': AppStyle.themeBackgroundColor,
      'caret-color': AppStyle.themeBackgroundColor
    },
    '#paytm-app .ptm-container input:checked ~ .ptm-check': {
      'background-color': AppStyle.themeBackgroundColor,
      'border-color': AppStyle.themeBackgroundColor
    },
    '#paytm-app .ptm-container .check:after': {
      'border-color': AppStyle.themeColor
    },
    '#paytm-app .ptm-card-input:focus,#paytm-app .ptm-upi-input:focus, #paytm-app .ptm-pnr-input': {
      'border-color': AppStyle.themeBackgroundColor,
      'caret-color': AppStyle.themeBackgroundColor
    },
    '#paytm-app .ptm-lbl:hover input ~ .ptm-checkmark': {
      background: 'transparent'
    },
    '#paytm-app .border-button': {
      'border-color': AppStyle.themeBackgroundColor
    },
    '#paytm-app .ptm-txtcolor': {
      color: AppStyle.bodyColor
    },
    '#paytm-app .ptm-msg-red': {
      color: AppStyle.errorColor || '#ff585d' // adding default error color in case merchant doesnt pass the error color was being overwritten by body color
    },
    '#paytm-app .ptm-msg-info': {
      color: AppStyle.infoColor,
      background: AppStyle.infoBackgroundColor
    },
    '#paytm-app .successColor': {
      color: AppStyle.successColor
    },
    '#paytm-app .ptm-green-bh': {
      background: AppStyle.successColor
    },
    '#paytm-app .ptm-note-listing>li:before': {
      background: AppStyle.bodyColor
    },
    '#paytm-app .ptm-user-bg': {
      background: AppStyle.headerBackgroundColor,
      'border-color': AppStyle.headerColor
    },
    '#paytm-app .ptm-user-bg svg path': {
      fill: AppStyle.headerColor
    },
    '#paytm-app .ptm-header': {
      'box-shadow': '0 0 8px 0 rgba(0,0,0,.22)'
    },
    '#paytm-app .ptm-header_fix .ptm-amount span': {
      color: '#182233'
    },
    '#paytm-app .ptm-header_fix .ptm-amount div': {
      color: '#182233'
    },
    // css added in discussion with aditya related to opacity and color of button in disabled state
    '#paytm-app .ptm-disabled-btn': {
      background: '#4d4d4d',
      opacity: 0.2,
      'pointer-events': 'none'
    }
  };
  var css = convertJsonToCss(styleObject, containerClass);
  return Object(preact_min["h"])(
    'style',
    null,
    css
  );
};

/* harmony default export */ var components_StyleComponent = (Object(preact["connect"])('AppStyle, cache')(StyleComponent_StyleComponent));
// CONCATENATED MODULE: ./components/app.js


function app__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function app__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function app__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var app__ref = Object(preact_min["h"])(home, null);

var app_App = function (_Component) {
  app__inherits(App, _Component);

  function App(props) {
    app__classCallCheck(this, App);

    var _this = app__possibleConstructorReturn(this, _Component.call(this, props));

    var cacheInstance = common_cache["a" /* default */].getInstance(_this.props.instanceKey);
    _this.store = cacheInstance ? cacheInstance.getData('store') : Object(unistore_es["a" /* default */])({});
    var mConfigInput = document.getElementById('mconfig');
    mConfigInput && mConfigInput.parentNode.removeChild(mConfigInput);
    _this.containerClass = Object(common["j" /* equalsIgnoreCase */])(_this.props.instanceKey, constants["g" /* default */].DEFAULT_INSTANCE_KEY) ? '' : 'ptm-wrapper-' + _this.props.instanceKey;
    return _this;
  }

  App.prototype.render = function render() {
    var _this2 = this;

    return Object(preact_min["h"])(
      preact["Provider"],
      { store: this.store },
      Object(preact_min["h"])(
        'div',
        {
          id: 'paytm-app',
          className: 'paytm-wrapper ptm-pos-r ' + this.containerClass,
          ref: function ref(wrapperComp) {
            _this2.wrapperComp = wrapperComp;
          }
        },
        app__ref,
        Object(preact_min["h"])(components_StyleComponent, { containerClass: this.containerClass })
      )
    );
  };

  return App;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./index.js



/* harmony default export */ var index_0 = __webpack_exports__["default"] = (app_App);

/***/ }),

/***/ "KD7D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/node_modules/unistore/dist/unistore.es.js
var unistore_es = __webpack_require__("2FAC");

// EXTERNAL MODULE: ./common/cache.js
var common_cache = __webpack_require__("WsRd");

// EXTERNAL MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/index.api.js + 16 modules
var index_api = __webpack_require__("NOly");

// EXTERNAL MODULE: ./utils/formPost.js
var formPost = __webpack_require__("AWfl");

// EXTERNAL MODULE: ./utils/common.js
var common = __webpack_require__("ocZ9");

// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__("hafV");

// EXTERNAL MODULE: ./utils/error-codes.js
var error_codes = __webpack_require__("gKfx");

// EXTERNAL MODULE: ./common/merchant-config.js
var merchant_config = __webpack_require__("lRnM");

// EXTERNAL MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/constant.js
var constant = __webpack_require__("TwIz");

// EXTERNAL MODULE: ./common/logger.js
var logger = __webpack_require__("lq6S");

// EXTERNAL MODULE: ./utils/deferred-utils.js
var deferred_utils = __webpack_require__("6SrU");

// CONCATENATED MODULE: ./utils/token.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









function updateOrderIdInMiddleWare(cache, orderId) {
  cache.getData(constants["a" /* CACHE */].API).middleware.add(function (currentOptions) {
    var options = _extends({}, currentOptions);
    Object(common["q" /* getKey */])(options, 'data.body', {}).orderId = orderId;
    Object(common["q" /* getKey */])(options, 'query', {}).orderId = orderId;
    return options;
  });
}

var token_getValidTokenForFlow = function getValidTokenForFlow(cache) {
  return new Promise(function (resolve, reject) {
    var config = cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
    var tokenData = cache.getData(constants["a" /* CACHE */].TOKEN_DATA);
    var txnAmount = cache.getData(constants["g" /* default */].UNMODIFIED_TXN_AMOUNT);
    var payableAmount = cache.getData(constants["g" /* default */].TXN_AMOUNT);
    var emiSubventionToken = cache.getData(constants["g" /* default */].EMISUBVENTION_TOKEN);
    var offer = cache.getData(constants["g" /* default */].PAYMODE_BASED_OFFER);
    if (tokenData.tokenType === constant["n" /* TOKEN */].ACCESS) {
      Object(logger["log"])({
        eventType: constants["b" /* EVENTS */].ACCESS_TOKEN_INITIATE_TXN
      });
      var merchantConfig = cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
      var initiateTxnHandler = Object(common["q" /* getKey */])(merchantConfig, 'handler.initiateTransaction', undefined);
      var notifyMerchant = Object(common["q" /* getKey */])(cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG), 'handler.notifyMerchant', undefined);
      if (typeof initiateTxnHandler === 'function') {
        var response = initiateTxnHandler(emiSubventionToken, payableAmount, txnAmount, offer);
        if (response && response.then) {
          // returned promise from the user intiatetxnHandler
          response.then(function (data) {
            cache.setData(constants["a" /* CACHE */].TOKEN_DATA, { token: data.token, tokenType: constant["n" /* TOKEN */].TXN });
            var config = cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
            if (config.data) {
              config.data.orderId = data.orderId;
            }
            cache.setData(constants["a" /* CACHE */].MERCHANT_CONFIG, config);
            resolve(data);
          });
        } else if (typeof response === 'object') {
          // returned string from the intiatetxnHandler
          cache.setData(constants["a" /* CACHE */].TOKEN_DATA, { token: response.token, tokenType: constant["n" /* TOKEN */].TXN });
          var _config = cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
          if (_config.data) {
            _config.data.orderId = response.orderId;
          }
          cache.setData(constants["a" /* CACHE */].MERCHANT_CONFIG, _config);
          resolve(response);
        } else {
          if (typeof notifyMerchant === 'function') {
            notifyMerchant(constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.HANDLER_ERROR, {
              message: 'initiateTxnHandler should either return a promise or a object having orderId and token value'
            });
          }
          reject(response);
        }
      }
    } else if (config.flow === constant["h" /* FLOW */].DEFERRED) {
      // const initiateTxnHandler = getKey(config, 'handler.initiateTransaction', undefined);
      var emiPlans = cache.getData(constants["a" /* CACHE */].EMI_PLANS);
      var paymentIntent = cache.getData(constants["a" /* CACHE */].PAYMENT_INTENT);
      var obj = {
        payment_intent: paymentIntent
      };
      if (emiPlans) {
        obj.emi_plans = emiPlans;
      }
      Object(deferred_utils["b" /* initiateCheckout */])(obj).then(function (data) {
        var token = Object(common["q" /* getKey */])(data, 'token', null);
        var orderId = Object(common["q" /* getKey */])(data, 'orderId', null);
        cache.setData(constants["a" /* CACHE */].TOKEN_DATA, { token: token, tokenType: constant["n" /* TOKEN */].TXN });
        cache.setData(constants["a" /* CACHE */].ORDER_ID, orderId.toString());
        var config = _extends({}, cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG));
        config.data.orderid = orderId;
        cache.setData(constants["a" /* CACHE */].MERCHANT_CONFIG, config);
        updateOrderIdInMiddleWare(cache, orderId);
        // this.callComponentSubmit();
        return resolve({ data: data });
      }).catch(function (err) {
        Object(logger["log"])({
          eventType: constants["b" /* EVENTS */].DEFERRED_INITIATE_TXN_ERROR,
          error: err
        });
        var notifyMerchant = Object(common["q" /* getKey */])(cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG), 'handler.notifyMerchant', undefined);

        Object(formPost["f" /* postInWindow */])({}, cache, true); // close popup window as txn token api response failed
        if (notifyMerchant) {
          notifyMerchant(constants["g" /* default */].HANDLER_ERROR, {
            message: 'initiateTxnHandler should either return a promise or a object having orderId and token value'
          });
        }
        return reject(err);
      });
    } else {
      resolve();
    }
  });
};

var token_customPay = function customPay(payCallback, cache, payload) {
  var shouldPopupOpen = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  shouldPopupOpen && Object(formPost["d" /* openWindowPopup */])(cache);
  return new Promise(function (resolve, reject) {
    token_getValidTokenForFlow(cache).then(function () {
      payCallback(payload).then(function (res) {
        resolve(res);
      }, function (err) {
        reject(err);
      });
    }).catch(function (err) {
      reject(err);
    });
  });
};

var token_getAsyncPayload = function getAsyncPayload(payload, cache, url) {
  // if (url === API.PT) {
  Object(formPost["d" /* openWindowPopup */])(cache);
  // }
  return new Promise(function (resolve, reject) {
    token_getValidTokenForFlow(cache).then(function () {
      resolve(payload(url));
    }).catch(function (err) {
      reject(err);
    });
  });
};
// EXTERNAL MODULE: ./common/localStorage.js
var localStorage = __webpack_require__("/tqE");

// EXTERNAL MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/utils/common.js
var utils_common = __webpack_require__("y11t");

// CONCATENATED MODULE: ./common/checkout.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return checkout_init; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "close", function() { return checkout_close; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initLib", function() { return initLib; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PAYMODE", function() { return PAYMODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ELEMENT_PAYMODE", function() { return ELEMENT_PAYMODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOKEN", function() { return TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FLOW", function() { return FLOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BASE_INSTANCE_KEY", function() { return BASE_INSTANCE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEFERRED_EVENTS", function() { return DEFERRED_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NOTIFY_MERCHANT_EVENTS", function() { return NOTIFY_MERCHANT_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "helpers", function() { return helpers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createInstance", function() { return createInstance; });
var checkout__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _this = this;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }















var _mid = void 0;
/**
 * All the functions that are not member functions can be added here
 */

var checkout_getTokenData = function getTokenData(cache) {
  return cache.getData(constants["a" /* CACHE */].TOKEN_DATA, {
    token: '',
    tokenType: index_api["f" /* TOKEN */].GUEST
  });
};

var checkout_updateTokens = function updateTokens(cache) {
  var token = checkout_getTokenData(cache);
  var context = _this;

  if (context.removeConfig) {
    context.removeConfig();
  }
  context.removeConfig = cache.getData(constants["a" /* CACHE */].API).middleware.add(function (o) {
    var options = o;
    if (!Object(common["q" /* getKey */])(options.data, 'head')) {
      throw new Error('current options are mandatory');
    }

    options.data.head = checkout__extends({}, options.data.head, token);
    return options;
  });
};

var nonMethods = {
  setData: function setData(cache, checkoutElementPayMode, merchantConfig, paymentInstrumentsResponse) {
    var paymentInstruments = paymentInstrumentsResponse.body;
    var config = merchantConfig.configuration;
    cache.setData(cache.setDataCACHE.RAW_INSTRUMENTS, JSON.parse(JSON.stringify(paymentInstruments)));
    Object(common["N" /* parseData */])(paymentInstruments, cache, checkoutElementPayMode);
    cache.setData(constants["a" /* CACHE */].PAYMENT_OPTIONS, paymentInstruments);
    if (!config || !config.data) {
      config.data = {};
    }
    config.data.token = paymentInstruments.guestToken;
    config.merchant.mid = _mid;
    config.data.tokenType = index_api["f" /* TOKEN */].GUEST;
    cache.setData(constants["a" /* CACHE */].GUEST_TOKEN, config.data.token);
    cache.setData(constants["a" /* CACHE */].MERCHANT_CONFIG, Object(merchant_config["b" /* set */])(config));
    if (Object(common["q" /* getKey */])(paymentInstruments, 'guestToken')) {
      cache.setData(constants["a" /* CACHE */].TOKEN_DATA, {
        token: paymentInstruments.guestToken,
        tokenType: index_api["f" /* TOKEN */].GUEST
      });
      checkout_updateTokens.call(this, cache);
    }
  }
};

var getInstrumentForTxnToken = function _getInstrumentForTxnToken() {
  var _initData = {
    inProgressPromise: null,
    data: null,
    orderId: null,
    token: null
  };

  function _getGlobalStoreFpoResponse() {
    var fpoResponse = (common_cache["b" /* globaleStore */].getState() || {})[constants["c" /* GLOBAL_STORE */].FPO_UPDATED_RESPONSE];
    if (fpoResponse) {
      return {
        head: fpoResponse.head,
        body: fpoResponse.cashierData
      };
    }

    return null;
  }

  return function (api, data, useCached) {
    if (data.token) {
      var _globaleStore$setStat;

      if (useCached && _initData.orderId === data.orderId && _initData.token === data.token && (_initData.inProgressPromise || _initData.data)) {
        return _initData.inProgressPromise || Promise.resolve(_getGlobalStoreFpoResponse() || _initData.data);
      }

      var resolveInProgress = void 0;
      var rejectInProgress = void 0;
      _initData.inProgressPromise = new Promise(function (localResolve, localReject) {
        resolveInProgress = localResolve;
        rejectInProgress = localReject;
      });

      _initData.data = null;
      _initData.orderId = data.orderId;
      _initData.token = data.token;

      data.applyPaymentOffer = 'true';
      data.fetchAllPaymentOffers = 'true';
      data.mid = _mid;
      common_cache["b" /* globaleStore */].setState((_globaleStore$setStat = {}, _globaleStore$setStat[constants["c" /* GLOBAL_STORE */].FPO_UPDATED_RESPONSE] = null, _globaleStore$setStat));
      return api.tokenPaymodes(data).then(function (response) {
        _initData.data = response;
        resolveInProgress(response);
        _initData.inProgressPromise = null;
        return response;
      }).catch(function (error) {
        rejectInProgress(error);
        _initData.inProgressPromise = null;
        throw error;
      });
    }
    throw new Error('provide token to get the paymodes for the Txn token');
  };
}();

var _init = function initialize(mConfig, self) {
  var config = Object(merchant_config["b" /* set */])(mConfig, true);
  var cache = self.cache;
  cache.setData(constants["a" /* CACHE */].MERCHANT_CONFIG, config);
  cache.setData(constants["g" /* default */].TXN_AMOUNT, Object(common["L" /* money */])(config.data.amount));
  cache.setData(constants["g" /* default */].UNMODIFIED_TXN_AMOUNT, Object(common["L" /* money */])(config.data.amount));

  if (config.data.tokenType !== index_api["f" /* TOKEN */].GUEST) {
    cache.setData(constants["a" /* CACHE */].TOKEN_DATA, {
      token: config.data.token,
      tokenType: config.data.tokenType
    });
    var payoptions = checkout__extends({}, cache.getData(constants["a" /* CACHE */].PAYMENT_OPTIONS));

    var isMGV = Object(common["q" /* getKey */])(cache.getData(constants["g" /* default */].CURRENT_PAYMODE), 'paymodeUsed') && Object(common["q" /* getKey */])(cache.getData(constants["g" /* default */].CURRENT_PAYMODE), 'paymodeUsed').indexOf('GIFT_VOUCHER') > -1;

    /*
     in case of access token since the amount is not priorly known the payment flow is sent which is
     set on merchant so adding a check that if payment flow is received as add and pay then check on
     UI whether txn amount is greater than wallet or not and if txn amount is less than wallet then
     paydata as merchant pay options instead of merchantaddmoney pay options.
     So adding a check just for access token flow as of now so as not to break the existing txn token
     flow for this condition
     */

    if (cache.getData(constants["g" /* default */].IS_EMISUBVENTION_ACCESS_TOKEN_FLOW) && Object(common["q" /* getKey */])(payoptions, 'wallet.isEnabled') && !Object(common["B" /* isInsufficientBalance */])(payoptions, cache) && Object(common["A" /* isHybridOrAddNPayWithSufficientWalletBalance */])(payoptions, cache)) {
      payoptions.payData = payoptions.merchantPayOption;
      cache.setData(constants["a" /* CACHE */].PAYMENT_OPTIONS, payoptions);
    }
    if (Object(common["q" /* getKey */])(payoptions, 'mgv.isEnabled') && Object(common["D" /* isMgvSufficient */])(payoptions.mgv, cache) && Object(common["B" /* isInsufficientBalance */])(payoptions, cache) && isMGV) {
      payoptions.wallet && (payoptions.wallet.isUsed = false);
      if (Object(common["w" /* isAddNPay */])(payoptions, cache)) {
        payoptions.payData = payoptions.addMoneyPayOption;
      } else {
        payoptions.payData = payoptions.merchantPayOption;
      }
      cache.setData(constants["a" /* CACHE */].PAYMENT_OPTIONS, payoptions);
    }

    if (Object(common["q" /* getKey */])(payoptions, 'wallet.isEnabled') && Object(common["B" /* isInsufficientBalance */])(payoptions, cache) && !Object(common["z" /* isHybridOrAddNPay */])(payoptions, cache) && !Object(common["q" /* getKey */])(payoptions, 'subscriptionDetail.isEnabled', false) && !cache.getData(constants["g" /* default */].IS_LOCAL_STORAGE_ALLOWED)) {
      payoptions.wallet.isUsed = false;
      payoptions.wallet.isEnabled = false;
      var usedPaymode = cache.getData(constants["g" /* default */].CURRENT_PAYMODE);
      if (usedPaymode && !usedPaymode.isWalletCheck) {
        payoptions.wallet.isEnabled = true;
      }
      cache.setData(constants["a" /* CACHE */].PAYMENT_OPTIONS, payoptions);
    }
    if (Object(common["q" /* getKey */])(payoptions, 'mgv.isEnabled') && Object(common["D" /* isMgvSufficient */])(payoptions.mgv, cache) && Object(common["B" /* isInsufficientBalance */])(payoptions, cache) && isMGV) {
      payoptions.wallet && (payoptions.wallet.isUsed = false);
      if (Object(common["w" /* isAddNPay */])(payoptions, cache)) {
        payoptions.payData = payoptions.addMoneyPayOption;
      } else {
        payoptions.payData = payoptions.merchantPayOption;
      }
      cache.setData(constants["a" /* CACHE */].PAYMENT_OPTIONS, payoptions);
    }
  }
  if (config.data.tokenType === index_api["f" /* TOKEN */].GUEST) {
    var rawInstruments = JSON.parse(JSON.stringify(cache.getData(constants["a" /* CACHE */].RAW_INSTRUMENTS)));
    Object(common["N" /* parseData */])(rawInstruments);
    cache.setData(constants["a" /* CACHE */].PAYMENT_OPTIONS, rawInstruments);
  }
  Object(common["S" /* setUpiIntentMwebDisplay */])(cache);
  self.applyMiddleware(config);
  Object(common["a" /* applyMerchPref */])(cache.getData(constants["a" /* CACHE */].PAYMENT_OPTIONS, {}), config);
  var defaultSel = Object(common["i" /* defaultSelected */])(cache.getData(constants["a" /* CACHE */].PAYMENT_OPTIONS, {}), cache);
  self.createStoreData(cache.getData(constants["a" /* CACHE */].PAYMENT_OPTIONS, {}), config, defaultSel);
  Object(logger["log"])({ eventType: logger["EVENT"].INIT, config: config });
};

var checkout_fetchConfigAndPaymodes = function fetchConfigAndPaymodes(cache, mid, flow) {
  return new Promise(function (resolve) {
    cache.getData(constants["a" /* CACHE */].API).config(mid).then(function (mConfig) {
      var iframeEle = document.createElement('iframe');
      var config = mConfig.configuration;
      // if flow default is passed in case of saved config being deferred and flow default is added in initialise
      if (flow === index_api["d" /* FLOW */].DEFAULT) {
        config.flow = index_api["d" /* FLOW */].DEFAULT;
      }
      if (config.flow === index_api["d" /* FLOW */].DEFERRED) {
        if (!config.data) {
          config.data = {};
        }
        config.merchant.mid = mid;
      }
      cache.setData(constants["a" /* CACHE */].MERCHANT_CONFIG, Object(merchant_config["b" /* set */])(config));
      iframeEle.src = cache.getData(constants["a" /* CACHE */].API).iframePath();
      iframeEle.id = 'dummy-iframe';
      iframeEle.style.display = 'none';
      document.body.appendChild(iframeEle);
      iframeEle.onload = function () {
        resolve();
      };
    });
  });
};

var checkout_all = function all(promises) {
  return Promise.all(promises.map(function (promise) {
    return Promise.resolve(promise).then(function (data) {
      return { status: 'fulfilled', value: data };
    }).catch(function (error) {
      return { status: 'rejected', reason: error };
    });
  }));
};

/**
 * CheckoutJS constructor
 */

var checkout_Checkout = function () {
  function Checkout(checkoutElementPayMode) {
    var _this2 = this;

    _classCallCheck(this, Checkout);

    this.api = null;

    this.initLib = function (mid) {
      _this2.cache.setData(constants["a" /* CACHE */].MID, mid);
      _mid = mid;
      Object(logger["init"])({ meta: { mid: mid } });
      _this2.setAPI();
      return _this2.fetchConfigAndPaymodes(mid);
    };

    this.setAPI = function () {
      _this2.api = new index_api["a" /* API */](_mid);
      _this2.api.pay = token_customPay.bind(_this2, _this2.api.pay.bind(_this2.api), _this2.cache);
      _this2.api.getAsyncPayload = token_getAsyncPayload.bind(_this2, _this2.api.requestPayload.bind(_this2.api), _this2.cache);
      _this2.api.iframePath = common["v" /* iframePath */].bind(_this2);

      _this2.api.logger.subscribe('info', function (data) {
        Object(logger["log"])(data);
      });

      _this2.cache.setData(constants["a" /* CACHE */].API, _this2.api);
      checkout_updateTokens.call(_this2, _this2.cache);
    };

    this.close = function () {
      var config = _this2.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG, {});
      _this2.cache.setData(constants["g" /* default */].CURRENT_PAYMODE, null);
      var selector = config.root ? config.root : '#paytm-checkoutjs';
      var globalStoreUnsubscribe = _this2.cache.getData(constants["a" /* CACHE */].GLOBAL_STORE_UNSUBSCRIPTION);
      if (globalStoreUnsubscribe) {
        globalStoreUnsubscribe();
        _this2.cache.setData(constants["a" /* CACHE */].GLOBAL_STORE_UNSUBSCRIPTION, null);
      }
      selector = document.querySelector(selector);
      if (selector) {
        selector.parentElement.removeChild(selector);
        // TODO: Disbled cache deletion for the moment
        // this.cache.clearInstance(this.instanceKey);
      }
    };

    this.checkoutElementPayMode = checkoutElementPayMode;
    this.instanceKey = checkoutElementPayMode ? Object(common["n" /* generateUUID */])() : constants["g" /* default */].DEFAULT_INSTANCE_KEY;
    this.cache = common_cache["a" /* default */].create(this.instanceKey);
    this.setData = Object(common["d" /* callOnce */])(nonMethods.setData.bind(this, this.cache, this.checkoutElementPayMode), this);
    this.fetchConfigAndPaymodes = checkout_fetchConfigAndPaymodes.bind(null, this.cache);
    this.cache.setData(constants["a" /* CACHE */].CLOSE_HANDLER, this.close.bind(this));
    this.cache.setData(constants["a" /* CACHE */].CHECKOUT_ELEMENT_PAYMODE, checkoutElementPayMode);
    if (checkoutElementPayMode) {
      this.cache.setData(constants["a" /* CACHE */].MID, _mid);
      var getData = Object(common["q" /* getKey */])(common_cache["a" /* default */].getInstance(constants["g" /* default */].DEFAULT_INSTANCE_KEY), 'getData');
      getData && this.cache.setData(constants["a" /* CACHE */].MERCHANT_CONFIG, checkout__extends({}, getData(constants["a" /* CACHE */].MERCHANT_CONFIG)));
      this.setAPI();
    }
  }

  /**
   * CheckoutJS initialization method
   * @param {Object} merchantConfiguration - merchant config with which merchant initializes CheckoutJS
   */

  Checkout.prototype.init = function init(merchantConfiguration) {
    var _this3 = this;

    var self = this;
    var mConfig = merchantConfiguration;
    /* adding requestId every request */
    if (window.performance) {
      /* adding parseInt since in chrome timeOrigin was giving time with 3 decimal places
       and in firefox it was giving absolute integer */
      mConfig.data.requestId = parseInt(window.performance.timeOrigin, 10).toString();
    } else {
      mConfig.data.requestId = Date.now().toString();
    }

    return new Promise(function (resolve, reject) {
      try {
        if (!mConfig) {
          var error = Object(common["k" /* errorObject */])(error_codes["a" /* default */].ERROR_CODE['4001']);
          Object(logger["log"])({ eventType: logger["EVENT"].MERCHANT_CONFIG_ERROR, config: mConfig, error: error });
          return reject(error);
        }
        Object(logger["init"])({ meta: { mid: _mid, orderId: mConfig.data.orderId } });
        if (mConfig.retryData) {
          _this3.cache.setData(constants["a" /* CACHE */].RETRY_DATA, mConfig.retryData);
        }
        var tokenType = Object(common["q" /* getKey */])(mConfig, 'data.tokenType', '');
        var token = Object(common["q" /* getKey */])(mConfig, 'data.token', '');
        if (tokenType === index_api["f" /* TOKEN */].ACCESS) {
          Object(logger["log"])({
            eventType: constants["b" /* EVENTS */].ACCESS_TOKEN_FLOW_INITIALISED,
            mConfig: mConfig
          });
          _this3.cache.setData(constants["a" /* CACHE */].ACCESS_TOKEN, token);
        }
        if ((tokenType === index_api["f" /* TOKEN */].TXN || tokenType === index_api["f" /* TOKEN */].ACCESS) && mConfig && mConfig.flow !== index_api["d" /* FLOW */].DEFERRED) {
          var referenceId = Object(common["q" /* getKey */])(mConfig, 'emiSubvention.referenceId', '');
          var requestId = Object(common["q" /* getKey */])(mConfig, 'data.requestId', '');
          var instrumentForTxnTokenData = {
            token: Object(common["q" /* getKey */])(mConfig, 'data.token', ''),
            orderId: Object(common["q" /* getKey */])(mConfig, 'data.orderId', ''),
            tokenType: tokenType
          };

          if (referenceId) {
            instrumentForTxnTokenData.referenceId = referenceId;
          }
          if (requestId) {
            instrumentForTxnTokenData.requestId = requestId;
          }
          checkout_all([getInstrumentForTxnToken(_this3.cache.getData(constants["a" /* CACHE */].API), instrumentForTxnTokenData, Boolean(_this3.checkoutElementPayMode)), Object(localStorage["a" /* getDataFromLocalStorage */])(_this3.cache)]).then(function (_ref) {
            var instruments = _ref[0],
                storageObj = _ref[1];

            instruments = Object(common["f" /* cloneObject */])(instruments.value);
            if (Object(common["q" /* getKey */])(instruments, 'body.resultInfo.resultCode', '') === '1006') {
              var _notifyMerchant = Object(common["q" /* getKey */])(mConfig, 'handler.notifyMerchant', undefined);
              if (_notifyMerchant && _notifyMerchant.constructor === Function) {
                Object(logger["log"])({
                  eventType: constants["g" /* default */].NOTIFY_MERCHANT,
                  eventName: constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.SESSION_EXPIRED,
                  data: instruments
                });
                _notifyMerchant(constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.SESSION_EXPIRED, instruments);
              }
              reject(Object(common["k" /* errorObject */])(error_codes["a" /* default */].ERROR_CODE['4002']));
            }

            if (Object(common["q" /* getKey */])(mConfig, 'emiSubvention', null) && tokenType === index_api["f" /* TOKEN */].ACCESS) {
              var fallBackAmount = Object(common["q" /* getKey */])(mConfig, 'data.amount', null);
              _this3.cache.setData(constants["g" /* default */].FALLBACK_TXN_AMOUNT, fallBackAmount);
              _this3.cache.setData(constants["a" /* CACHE */].FALLBACK_TOKEN_DATA, {
                token: mConfig.data.token,
                tokenType: index_api["f" /* TOKEN */].ACCESS
              });
              var strategyFromConfig = Object(common["q" /* getKey */])(mConfig, 'emiSubvention.strategy', null);
              _this3.cache.setData(constants["g" /* default */].IS_EMISUBVENTION_ACCESS_TOKEN_FLOW, !!Object(common["q" /* getKey */])(mConfig, 'emiSubvention', null));

              _this3.cache.setData(constants["g" /* default */].EMISUBVENTION_STATEGY, strategyFromConfig);
              if (strategyFromConfig === index_api["c" /* EMI_SUBVENTION_STRATEGY */].ITEM_BASED) {
                var items = Object(common["q" /* getKey */])(mConfig, 'emiSubvention.items', []);
                var miniCart = Object(common["q" /* getKey */])(mConfig, 'emiSubvention.miniCart', null);
                items = items.map(function (item) {
                  return {
                    id: item.itemId,
                    productId: item.productId,
                    brandId: item.brandId,
                    categoryList: item.categoryList,
                    quantity: item.quantity,
                    price: item.amount,
                    verticalId: item.verticalId,
                    isEmiEnabled: item.isEmiEnabled,
                    model: item.model,
                    ean: item.ean
                  };
                });
                if (miniCart) {
                  miniCart = miniCart.map(function (item) {
                    return {
                      id: item.itemId,
                      name: item.name,
                      image: item.imageUrl,
                      price: item.amount,
                      quantity: item.quantity
                    };
                  });
                  _this3.cache.setData(constants["g" /* default */].SUBVENTION_MINI_CART_OBJ, miniCart);
                }

                _this3.cache.setData(constants["g" /* default */].SUBVENTION_OBJ, { items: items });
                /* adding a new initial obj since in case of bank offers the amount has to be updated
                based on discount percentage
                */
                _this3.cache.setData(constants["g" /* default */].SUBVENTION_OBJ_INITIAL, { items: items });
              }
              if (strategyFromConfig === index_api["c" /* EMI_SUBVENTION_STRATEGY */].AMOUNT_BASED) {
                var subventionAmount = Object(common["q" /* getKey */])(mConfig, 'emiSubvention.subventionAmount', null);
                var totalPrice = Object(common["q" /* getKey */])(mConfig, 'data.amount', null);
                var obj = {
                  price: totalPrice,
                  subventionAmount: subventionAmount
                };
                _this3.cache.setData(constants["g" /* default */].SUBVENTION_OBJ, obj);
                /* adding a new initial obj since in case of bank offers the amount has to be updated
                based on discount percentage
                */
                _this3.cache.setData(constants["g" /* default */].SUBVENTION_OBJ_INITIAL, obj);
              }
            }

            if (Object(common["q" /* getKey */])(instruments, 'body.resultInfo.resultStatus', '') === 'F') {
              reject(Object(common["k" /* errorObject */])(error_codes["a" /* default */].ERROR_CODE['4003']));
            }

            var paymodes = instruments.body;
            if (Object(common["q" /* getKey */])(paymodes, 'loginInfo.userLoggedIn', false)) {
              Object(logger["log"])({ eventType: logger["EVENT"].AUTO_LOGIN });
            }
            _this3.cache.setData(constants["g" /* default */].TXN_AMOUNT, Object(common["L" /* money */])(mConfig.data.amount));
            var isLocalStorageAccesible = Object(common["q" /* getKey */])(paymodes, 'isLocalStorageAllowedForLastPayMode');
            if (isLocalStorageAccesible && storageObj.status === 'fulfilled' && !_this3.checkoutElementPayMode) {
              _this3.cache.setData(constants["g" /* default */].SAVED_PAYMODES, storageObj.value);
              _this3.cache.setData(constants["g" /* default */].IS_LOGGED_IN, Object(common["q" /* getKey */])(paymodes, 'loginInfo.userLoggedIn'));
              _this3.cache.setData(constants["g" /* default */].IS_LOCAL_STORAGE_ALLOWED, true);
              if (_this3.cache.getData(constants["g" /* default */].IS_LOGGED_IN)) {
                _this3.cache.setData(constants["g" /* default */].MOBILE_NO, Object(common["q" /* getKey */])(paymodes.userDetails, 'mobile'));
                Object(localStorage["b" /* processLocalStorage */])(_this3.cache);
              }
            }
            _this3.cache.setData(constants["g" /* default */].ICON_BASE_URL, Object(common["q" /* getKey */])(paymodes, 'iconBaseUrl', ''));
            Object(common["N" /* parseData */])(paymodes, _this3.cache, _this3.checkoutElementPayMode);
            _this3.cache.setData(constants["a" /* CACHE */].PAYMENT_OPTIONS, paymodes);
            /* setting payment offers received in fpo so that after login/logout these can be used  */
            var paymentOffers = Object(common["q" /* getKey */])(paymodes, 'paymentOffers', []);
            _this3.cache.setData(constants["a" /* CACHE */].PAYMENT_OFFERS, paymentOffers);
            _init(mConfig, self);
            resolve();
          });
        } else if (mConfig.flow === index_api["d" /* FLOW */].DEFERRED) {
          Object(logger["log"])({
            eventType: constants["b" /* EVENTS */].DEFERRED_FLOW_INITIALIZED,
            mConfig: mConfig
          });
          _this3.cache.setData(constants["a" /* CACHE */].MERCHANT_CONFIG, Object(merchant_config["b" /* set */])(mConfig, true));
          mConfig.handler.deferred(constants["g" /* default */].DEFERRED_EVENTS.FETCH_PAYMODE).then(function (data) {
            // setting  txn amt received in payload
            var txnAmount = Object(common["q" /* getKey */])(data, 'paymentInfo.payableAmount.value', 0);
            _this3.cache.setData(constants["g" /* default */].TXN_AMOUNT, Object(common["L" /* money */])(txnAmount));
            _this3.cache.cache.setData(constants["g" /* default */].UNMODIFIED_TXN_AMOUNT, Object(common["L" /* money */])(txnAmount));
            var mid = Object(common["q" /* getKey */])(data, 'paymentInfo.mid', mConfig.merchant.mid);
            var merchantName = Object(common["q" /* getKey */])(data, 'payment_instruments.body.merchantDetails.merchantName', mConfig.merchant.name);
            mConfig.merchant.mid = mid;
            mConfig.merchant.name = merchantName;
            mConfig.data.amount = txnAmount;
            // setting login info true for deffered flow
            if (data.payment_instruments && data.payment_instruments.body) {
              data.payment_instruments.body.loginInfo = {
                userLoggedIn: true
              };
            }
            var paymentInstruments = data.payment_instruments.body;
            Object(common["N" /* parseData */])(paymentInstruments, _this3.cache, _this3.checkoutElementPayMode);
            _this3.cache.setData(constants["a" /* CACHE */].PAYMENT_OPTIONS, paymentInstruments);
            // setting fallback token data  because txn token has to be removed in retry and sso token has to be stored
            _this3.cache.setData(constants["a" /* CACHE */].FALLBACK_TOKEN_DATA, {
              token: mConfig.data.token,
              tokenType: index_api["f" /* TOKEN */].SSO
            });
            _init(mConfig, self);
            resolve();
          }).catch(function (error) {
            Object(logger["log"])({
              eventType: constants["g" /* default */].NOTIFY_MERCHANT,
              eventName: constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.FETCH_PAYMENT_OPTIONS_ERROR,
              data: error.message
            });
            common["M" /* notifyMerchant */].fetchPaymentError(error.message, _this3.cache);
            reject(error);
          });
        } else {
          _init(mConfig, self);
          resolve();
        }
      } catch (err) {
        reject(err);
      }
      return null;
    });
  };

  /**
   * A method to set merchant config incache and invokes middleware for _API interception
   *
   * @param {Object} config - config
   */
  Checkout.prototype.applyMiddleware = function applyMiddleware(config) {
    var _this4 = this;

    if (Object(common["y" /* isFunction */])(this.preMidleWare)) {
      this.preMidleWare();
    }

    if (Object(common["y" /* isFunction */])(this.postMidleWare)) {
      this.postMidleWare();
    }
    /* check for reference ID and if found add the same in request query for access token */
    var referenceId = Object(common["q" /* getKey */])(config, 'emiSubvention.referenceId', '');
    this.preMidleWare = this.cache.getData(constants["a" /* CACHE */].API).middleware.add(function () {
      var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var options = o;

      // subscription flow
      var paymentOptions = _this4.cache.getData(constants["a" /* CACHE */].PAYMENT_OPTIONS);
      var isSubscriptionFlow = false;
      if (Object(common["q" /* getKey */])(paymentOptions, 'subscriptionDetail.isEnabled')) {
        options.data.body.subscriptionId = paymentOptions.subscriptionDetail.subsId;
        isSubscriptionFlow = true;
      }
      Object(logger["log"])({ eventType: logger["EVENT"].SUBSCRIPTION_FLOW, value: isSubscriptionFlow });

      var tokenData = _this4.cache.getData(constants["a" /* CACHE */].TOKEN_DATA);
      options.data.head.token = tokenData.token;
      options.data.head.tokenType = tokenData.tokenType;
      var accessToken = _this4.cache.getData(constants["a" /* CACHE */].ACCESS_TOKEN);
      if (accessToken) {
        options.data.body.accessToken = accessToken;
      }
      if (options.data.body) {
        if (config.merchant && config.merchant.mid) {
          options.data.body.mid = config.merchant.mid;
        }
        if (config.data.orderId) {
          options.data.body.orderId = config.data.orderId;
          options.query.orderId = config.data.orderId;
        }
        if (config.data.requestId) {
          options.data.head.requestId = config.data.requestId;
        }
        if (referenceId) {
          options.query.referenceId = referenceId;
        }
        if (options.url.search('/v1/transactionStatus') > -1 && _this4.cache.getData(constants["g" /* default */].IS_IN_POLLING_STATUS)) {
          options.data.head.version = 'v2';
        }
        if (options.url.search('/api/v1/processTransaction') > -1) {
          var mConfig = _this4.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
          if (Object(utils_common["h" /* isWebViewFlow */])(mConfig)) {
            mConfig.merchantServerEndpoint = Object(utils_common["i" /* merchantServerEndpoint */])();
            mConfig.staticPath = Object(common["r" /* getStaticPath */])();
            mConfig.environment = "prod";
            options.data.body.checkoutJsConfig = encodeURI(JSON.stringify(mConfig).replace(/'/g, '')); // this is to remove character from json string in order to avoid json parse error
          }
        }
        options.data.body.paymentFlow = Object(common["O" /* paymentFlow */])(_this4.cache.getData(constants["a" /* CACHE */].PAYMENT_OPTIONS, constant["l" /* PAYMENT_FLOW */].NONE), _this4.cache);
      }
      if (!config.data.tokenType) delete options.data.head.type;else options.data.head.type = config.data.tokenType;
      return options;
    });

    this.postMidleWare = this.cache.getData(constants["a" /* CACHE */].API).postFetch.add(function (option) {
      var request = option.request,
          response = option.response;

      if (Object(common["q" /* getKey */])(response, 'body.txnInfo.RESPCODE', undefined) === '1006' || Object(common["q" /* getKey */])(response, 'body.resultInfo.resultCode', undefined) === '1006') {
        // handle the session expired for the user...
        if (Object(common["q" /* getKey */])(request, 'data.head.tokenType', '') === index_api["f" /* TOKEN */].GUEST) {
          // call the fetch paymodes api to update the guest token in cache for the GUEST token flow
          _this4.cache.getData(constants["a" /* CACHE */].API).payModes().then(function (res) {
            if (Object(common["q" /* getKey */])(res, 'body.resultInfo.resultStatus', undefined) === 'S') {
              _this4.cache.setData(constants["a" /* CACHE */].TOKEN_DATA, {
                tokenType: index_api["f" /* TOKEN */].GUEST,
                token: Object(common["q" /* getKey */])(res, 'body.guestToken', '')
              });
            }
          });
        } else if (Object(common["q" /* getKey */])(request, 'data.head.tokenType', '') === index_api["f" /* TOKEN */].TXN) {
          // call the merchant handler on the expiration of txn token
          var mConfig = _this4.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
          _this4.cache.getData(constants["a" /* CACHE */].STORE).setState({ sessionExpired: true });
          var _notifyMerchant2 = Object(common["q" /* getKey */])(mConfig, 'handler.notifyMerchant', undefined);
          if (_notifyMerchant2 && _notifyMerchant2.constructor === Function) {
            Object(logger["log"])({
              eventType: constants["g" /* default */].NOTIFY_MERCHANT,
              eventName: constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.SESSION_EXPIRED,
              data: response
            });
            _notifyMerchant2(constants["g" /* default */].NOTIFY_MERCHANT_EVENTS.SESSION_EXPIRED, response);
          }
        }
        if (request && request.url.search('/api/v1/processTransaction') !== -1) {
          Object(formPost["f" /* postInWindow */])(response, _this4.cache); // in case of session expire then close the popup window
        }
        _this4.cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: '' });
      } else if (request && request.url && request.url.search('/api/v1/processTransaction') !== -1 && Object(common["q" /* getKey */])(response, 'body.resultInfo.resultStatus', undefined) === 'F') {
        Object(formPost["f" /* postInWindow */])(response, _this4.cache);
        if (Object(common["q" /* getKey */])(response, 'body.resultInfo.retry', undefined) === false) {
          // retry exhausted
          _this4.cache.getData(constants["a" /* CACHE */].STORE).setState({ overlayValue: '' });
          response.body.content = response.body.txnInfo || Object(common["q" /* getKey */])(response, 'body.bankForm.redirectForm.content', undefined) || {};
          response.body.callbackUrl = response.body.callBackUrl || response.body.callbackUrl || Object(common["q" /* getKey */])(response, 'body.bankForm.redirectForm.actionUrl', undefined) || '';
          Object(formPost["b" /* handlePostData */])(response, _this4.cache);
        } else if (Object(common["q" /* getKey */])(response, 'body.resultInfo.retry') === true) {
          Object(logger["log"])({ eventType: logger["EVENT"].PAYMENT_RETRY_AVAILABLE });
          // still retry available
          _this4.cache.getData(constants["a" /* CACHE */].STORE).setState({
            retryMessage: response.body.resultInfo.resultMsg,
            overlayValue: constants["g" /* default */].RETRY
          });
          // get fallback token from cache and set current token as sso and remove txn token
          var tokenData = _this4.cache.getData(constants["a" /* CACHE */].FALLBACK_TOKEN_DATA, {
            token: config.data.token,
            tokenType: index_api["f" /* TOKEN */].SSO
          });
          _this4.cache.setData(constants["a" /* CACHE */].TOKEN_DATA, {
            token: tokenData.token,
            tokenType: tokenData.tokenType
          });
        } else if (request && request.url.search('/api/v1/processTransaction') !== -1 && Object(common["q" /* getKey */])(response, 'body.resultInfo.resultStatus', undefined) === 'S') {
          var _mConfig = _this4.cache.getData(constants["a" /* CACHE */].MERCHANT_CONFIG);
          if (Object(utils_common["h" /* isWebViewFlow */])(_mConfig)) {
            var _getKey = Object(common["q" /* getKey */])(response, 'body.bankForm.redirectForm', {}),
                actionUrl = _getKey.actionUrl,
                content = _getKey.content;

            response.body.content = content;
            response.body.callbackUrl = actionUrl;
            var form = Object(formPost["a" /* _getFormHtmlNode */])(response.body);
            document.body.appendChild(form);
            form.submit();
          }
        }
      } else if (request && request.url.search('/v1/transactionStatus') !== -1 && Object(common["q" /* getKey */])(response, 'body.resultInfo.resultStatus', undefined) === 'S' || request && request.url.search('/api/v1/processTransaction') !== -1 && Object(common["q" /* getKey */])(response, 'body.resultInfo.resultStatus', undefined) === 'S' && (Object(common["q" /* getKey */])(request, 'data.body.paymentMode', undefined) === constants["g" /* default */].POSTPAID || Object(common["q" /* getKey */])(request, 'data.body.paymentMode', undefined) === constants["g" /* default */].GIFT_VOUCHER)) {
        Object(localStorage["c" /* savingUsedPaymodeInLocalStorage */])(_this4.cache);
      }
      if (request && request.url.search('/api/v1/processTransaction') !== -1 && Object(common["q" /* getKey */])(response, 'body.resultInfo.resultStatus', undefined) === 'S') {
        var retryCounts = _this4.cache.getData(constants["g" /* default */].ALLOWED_MERCHANT_RETRY_COUNTS);
        if (!Object(common["F" /* isNullOrUndefined */])(retryCounts) && retryCounts > 0) {
          _this4.cache.setData(constants["g" /* default */].ALLOWED_MERCHANT_RETRY_COUNTS, retryCounts - 1);
        } else {
          _this4.cache.setData(constants["g" /* default */].ALLOWED_MERCHANT_RETRY_COUNTS, 0);
        }
      }
    });
  };

  Checkout.prototype.createStoreData = function createStoreData(paymentOptions, mConfig) {
    var defaultSelectedValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var store = Object(unistore_es["a" /* default */])({
      payData: paymentOptions.payData,
      mgv: paymentOptions.mgv,
      wallet: paymentOptions.wallet,
      AppStyle: mConfig.style,
      payEnabled: true,
      labels: mConfig.labels,
      selected: defaultSelectedValue,
      loginInfo: paymentOptions.loginInfo,
      btnText: '',
      stopScroll: false,
      sessionExpired: false,
      notificationMsg: '',
      cache: this.cache,
      instanceKey: this.instanceKey,
      checkoutElementPayMode: this.checkoutElementPayMode,
      subscription: paymentOptions.subscriptionDetail
    });
    this.cache.setData(constants["a" /* CACHE */].STORE, store);
  };

  return Checkout;
}();

var checkout = new checkout_Checkout();

var checkout_init = checkout.init.bind(checkout);
var checkout_close = checkout.close.bind(checkout);
var initLib = checkout.initLib.bind(checkout);
var PAYMODE = index_api["e" /* PAYMODE */];
var ELEMENT_PAYMODE = index_api["b" /* ELEMENT_PAYMODE */];
var TOKEN = index_api["f" /* TOKEN */];
var FLOW = index_api["d" /* FLOW */];
var BASE_INSTANCE_KEY = checkout.instanceKey;
var DEFERRED_EVENTS = constants["g" /* default */].DEFERRED_EVENTS,
    NOTIFY_MERCHANT_EVENTS = constants["g" /* default */].NOTIFY_MERCHANT_EVENTS;


var helpers = {
  fetchPaymentOptions: function fetchPaymentOptions() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return getInstrumentForTxnToken.apply(undefined, [checkout.api].concat(args));
  },
  isObject: common["G" /* isObject */],
  setMerchantConfig: merchant_config["b" /* set */],
  getKey: common["q" /* getKey */],
  getMid: function getMid() {
    return _mid;
  }
};

var createInstance = function createInstance(checkoutElementPayMode) {
  var checkoutInstance = new checkout_Checkout(checkoutElementPayMode);

  return {
    init: checkoutInstance.init.bind(checkoutInstance),
    close: checkoutInstance.close.bind(checkoutInstance),
    instanceKey: checkoutInstance.instanceKey
  };
};

/***/ }),

/***/ "LeMX":
/***/ (function(module, exports, __webpack_require__) {

var t = __webpack_require__("0gEq");function n(t, n) {
  for (var r in n) {
    t[r] = n[r];
  }return t;
}function r(t) {
  this.getChildContext = function () {
    return { store: t.store };
  };
}r.prototype.render = function (t) {
  return t.children && t.children[0] || t.children;
}, exports.connect = function (r, e) {
  var o;return "function" != typeof r && ("string" == typeof (o = r || {}) && (o = o.split(/\s*,\s*/)), r = function r(t) {
    for (var n = {}, r = 0; r < o.length; r++) {
      n[o[r]] = t[o[r]];
    }return n;
  }), function (o) {
    function i(i, u) {
      var c = this,
          f = u.store,
          s = r(f ? f.getState() : {}, i),
          a = e ? function (t, n) {
        "function" == typeof t && (t = t(n));var r = {};for (var e in t) {
          r[e] = n.action(t[e]);
        }return r;
      }(e, f) : { store: f },
          p = function p() {
        var t = r(f ? f.getState() : {}, i);for (var n in t) {
          if (t[n] !== s[n]) return s = t, c.setState({});
        }for (var e in s) {
          if (!(e in t)) return s = t, c.setState({});
        }
      };this.componentWillReceiveProps = function (t) {
        i = t, p();
      }, this.componentDidMount = function () {
        f.subscribe(p);
      }, this.componentWillUnmount = function () {
        f.unsubscribe(p);
      }, this.render = function (r) {
        return t.h(o, n(n(n({}, a), r), s));
      };
    }return (i.prototype = new t.Component()).constructor = i;
  };
}, exports.Provider = r;
//# sourceMappingURL=preact.js.map

/***/ }),

/***/ "LnyB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return locale; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_en__ = __webpack_require__("RH0W");


var _i18n = {};

var locale = function locale(key) {
  if (!key) {
    return '';
  }
  var msg = key.split(/\.(.+)/);
  var a = _i18n[msg[0]];
  return a && a[msg[1]] || !1;
};

var load = function load(data) {
  _i18n = data;
};

load(__WEBPACK_IMPORTED_MODULE_0__locale_en__["a" /* default */]);

/***/ }),

/***/ "NOly":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/constant.js
var constant = __webpack_require__("TwIz");

// EXTERNAL MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/utils/http.js
var http = __webpack_require__("1Lr7");

// EXTERNAL MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/utils/common.js
var common = __webpack_require__("y11t");

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/api/nb.js




/**
 *  Net banking channels available based on merchant or add money
 *
 * @param {Boolean} isAddMoney - if true than add money nb channels shown otherwise merchant nb channels
 * @returns {Promise<Object>} - Promise object
 */
function nbChannels(isAddMoney) {
  return http["c" /* post */].call(this, Object(common["a" /* apiEndpoint */])(constant["a" /* API */].NB_CHANNELS), Object(common["l" /* requestPayload */])({ type: isAddMoney ? 'ADD_MONEY' : 'MERCHANT' }));
}
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/api/request.js


var request__url = function _url(url) {
  if (url) {
    return Object(common["a" /* apiEndpoint */])(url);
  }
  return '';
};

function request_payload(url) {
  var options = {};
  options.data = Object(common["l" /* requestPayload */])({});
  options.method = 'POST';
  options.url = request__url(url);
  if (Object(common["f" /* isFunction */])(Object(common["b" /* getKey */])(this, 'runMiddleware'))) {
    options = this.runMiddleware(options);
  }
  return options;
}
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/utils/validations.js
var radix = 10;
var mobileRegex = /^\d{10}$/;
var binRegex = /^\d{6,22}$/;
var upperCase = /^[A-Z_]+$/;

/**
 * @private
 * card validation based on luhn algorithm
 * @param {Number | String} cn - card number
 * @return {Object} [output] - output object contains result of luhn algorithm
 * @return {Boolean} output.hasError - property set to true if enter card number has error
 * @return {Boolean} output.isCardNumberValid - property set to true if enter card number has error
 *
 * */
var _luhn = function _luhn(cn) {
  var output = {
    hasError: false, // no error occur
    isCardNumberValid: true // card number  has no error
  };
  var nDigits = cn.length;
  var nSum = 0;
  var isSecond = false;
  var isValid = false;

  for (var i = nDigits - 1; i >= 0; i -= 1) {
    var d = parseInt(cn[i], radix);
    if (isSecond === true) d *= 2;

    nSum += parseInt(d / 10, radix);
    nSum += d % 10;
    isSecond = !isSecond;
  }
  isValid = nSum % 10 === 0; // is valid
  if (!isValid) {
    output.hasError = true;
    output.isCardNumberValid = false; // card has failed luhn algo
  }
  return output;
};

/**
 * Validation on month and year of card
 * @param {Number | String} _month - month of card ( 1 ,2 etc )
 * @param {Number | String } _year - year of card  ( 2019 etc )
 * @return {Object} [output] - output contain result of running validations rules
 * @return {Boolean} output.hasError - field is set to true if contains error
 * @return {Boolean} output.isMonthValid - field is set to true if entered month is not valid
 * @return {Boolean} output.isYearValid - field is set to true if entered year is not valid
 * */
var _expiryValidation = function _expiryValidation(_month, _year) {
  var date = new Date();
  var month = _month;
  var year = _year;
  var output = {
    hasError: false, // no error occur
    isMonthValid: true, // month has no error
    isYearValid: true // year has no error
  };
  year = parseInt(year, radix);
  month = parseInt(month, radix);

  if (year < date.getFullYear()) {
    // year is less then current year
    output.hasError = true;
    output.isYearValid = false;
    return output;
  }

  if (month < 1 || month > 12 /* month is out of range 1 - 12 */ || year === date.getFullYear() && month < date.getMonth() + 1 /* year is same as current year and month is less then current month */
  ) {
      output.hasError = true;
      output.isMonthValid = false;
      return output;
    }
  return output;
};

/**
 * Card validation
 * @param {Object} card - card object
 * @param {Number | String} card.month - month of card ( 1 ,2 etc )
 * @param {Number | String } card.year - year of card  ( 2019 etc )
 * @return {Object} [output] - output contain result of running validations rules
 * @return {Boolean} output.hasError - field is set to true if contains error
 * @return {Boolean} output.isMonthValid - field is set to true if entered month is not valid
 * @return {Boolean} output.isYearValid - field is set to true if entered year is not valid
 * */
function isCardValid(card) {
  var output = {
    hasError: false, // no error occur
    isCardNumberValid: true, // card number has no error
    isMonthValid: true, // month has no error
    isYearValid: true // year has no error
  };

  var result = _luhn(card.number);
  if (result.hasError) {
    output.hasError = result.hasError;
    output.isCardNumberValid = result.isCardNumberValid;
    return output;
  }
  result = _expiryValidation(card.month, card.year);
  if (result.hasError) {
    output.hasError = result.hasError;
    output.isMonthValid = result.isMonthValid;
    output.isYearValid = result.isYearValid;
  }
  return output;
}

/**
 * Validate mobile number
 *
 * @param {number|string} mobileNumber - mobile number
 * @returns {boolean} - result of validation on mobile number
 */
var validateMobile = function validateMobile(mobileNumber) {
  return mobileRegex.test(mobileNumber);
};

/**
 * Validate card number
 *
 * @param {string} bin - card number
 * @returns {boolean} - result of validation on card number
 */
var validateBin = function validateBin(bin) {
  return binRegex.test(bin);
};

/**
 * Validate uppercase input value
 *
 * @param {string} code - input value pass as uppercase.
 * @returns {boolean} - result of validation on input value.
 */
var validateUpperCase = function validateUpperCase(code) {
  return upperCase.test(code);
};
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/api/login.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable no-undef */






/**
 * Login using mobile number
 *
 * @param {number|string} mobileNumber - mobile number
 * @returns {Promise<Object>} - Promise object
 */
function sentOtp(mobileNumber) {
  if (!mobileNumber) {
    return Promise.reject(new Error(constant["f" /* ERRORS */].MOBILE));
  }

  if (!validateMobile(mobileNumber)) {
    return Promise.reject(new Error(constant["f" /* ERRORS */].INVALID_MOBILE));
  }

  mobileNumber = mobileNumber.toString();
  return http["c" /* post */].call(this, Object(common["a" /* apiEndpoint */])(constant["a" /* API */].SEND_OTP), Object(common["l" /* requestPayload */])({ mobileNumber: mobileNumber }));
}

/**
 * OTP verification for login using mobile number
 *
 * @param {number|string} otp - otp as numeric or string
 * @param {Boolean} rememberMe - remember user or not
 * @returns {Promise<Object>} - Promise object
 */
function validateOtp(otp, rememberMe) {
  var _this = this;

  if (!otp) {
    return Promise.reject(new Error(constant["f" /* ERRORS */].OTP));
  }

  if (Object(common["g" /* isNull */])(rememberMe)) {
    rememberMe = false;
  }

  otp = otp.toString();

  return new Promise(function (resolve, reject) {
    var payload = request_payload.call(_this, constant["a" /* API */].VAL_OTP);
    payload.data.body = _extends({}, payload.data.body, { otp: otp, rememberMe: rememberMe, fetchCashierData: true });
    Object(common["e" /* iFrameApiCall */])(payload).then(function (data) {
      resolve(data);
    }).catch(function (err) {
      reject(err);
    });
  });

  // return post(
  //   apiEndpoint(API.VAL_OTP),
  //   requestPayload({ otp, rememberMe, fetchCashierData: true })
  // );
}

function logout() {
  var _this2 = this;

  return new Promise(function (resolve, reject) {
    Object(common["e" /* iFrameApiCall */])(request_payload.call(_this2, constant["a" /* API */].LOG_OUT)).then(function (data) {
      return resolve(data);
    }).catch(function (err) {
      reject(err);
    });
  });
  // return post(apiEndpoint(API.LOG_OUT), requestPayload({}));
}
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/api/card.js





/**
 * Card details based on card number.
 *
 * @param {string} bin - Card number
 * @param {boolean} isEmi - true if emi related data required
 * @returns {Promise<any>} - promise object contains response from server api
 */
function cardDetails(bin, isEmi) {
  if (!validateBin(bin)) {
    return Promise.reject(new Error(constant["f" /* ERRORS */].BIN));
  }

  isEmi = !Object(common["g" /* isNull */])(isEmi) ? isEmi : false;
  bin = bin.toString();
  return http["c" /* post */].call(this, Object(common["a" /* apiEndpoint */])(constant["a" /* API */].BIN), Object(common["l" /* requestPayload */])({ bin: bin, isEMIDetail: isEmi }));
}

/**
 * Card details based on card number.
 *
 * @param {string} url - request url
 * @param {object} payload - request payload
 * @returns {Promise<any>} - promise object contains response from server api
 */
function directApi(url, payload) {
  var _this = this;

  var skipMiddleware = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  return new Promise(function (resolve, reject) {
    http["c" /* post */].call(_this, url, payload, skipMiddleware).then(function (data) {
      if (data && data.body && data.body.resultInfo && data.body.resultInfo.resultStatus === 'S') {
        resolve(data);
      } else {
        reject(data);
      }
    }).catch(function (err) {
      reject(err);
    });
  });
}
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/api/emi.js
var emi__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






/**
 * Emi details based on channel code
 *
 * @param {string} channelCode - Bank channel code
 * @param {string | number} amount - amount for which emi details required
 * @returns {Promise<any>} - promise object contains response from server api
 */
function emiDetails(channelCode, amount, emiType) {
  if (!validateUpperCase(channelCode)) {
    return Promise.reject(new Error(constant["f" /* ERRORS */].EMI));
  }

  var payload = { channelCode: channelCode, emiType: emiType };
  if (amount !== undefined && amount !== null) {
    payload.amount = amount;
  }
  return http["c" /* post */].call(this, Object(common["a" /* apiEndpoint */])(constant["a" /* API */].EMI), Object(common["l" /* requestPayload */])(payload));
}

/**
 * Bank List for EMI Subvention
 *
 * @param {Object} obj - EMI Subvention Payload
 * @returns {Promise<any>} - promise object contains response from server api
 */
function emiSubventionBanks(obj) {
  return http["c" /* post */].call(this, Object(common["a" /* apiEndpoint */])(constant["a" /* API */].EMI_BANKS), Object(common["l" /* requestPayload */])(obj));
}

/**
 * Emi details based on channel code for EMI Subvention
 *
 * @param {string} bankCode - Bank channel code
 * @param {string} cardType - Card Type
 * @param {Object} obj - EMI Subvention Payload
 * @returns {Promise<any>} - promise object contains response from server api
 */
function emiSubventionPlans(bankCode, cardType, obj) {
  var payload = emi__extends({}, obj);
  payload.filters = {
    bankCode: bankCode,
    cardType: cardType
  };
  return http["c" /* post */].call(this, Object(common["a" /* apiEndpoint */])(constant["a" /* API */].EMI_TENURE), Object(common["l" /* requestPayload */])(payload));
}

/**
 * Emi details based on channel code for EMI Subvention
 *
 * @param {Object} payload - Request Payload
 * @param {Object} obj - subvention object containing  items or price based on strategy
 * @returns {Promise<any>} - promise object contains response from server api
 */
function emiSubventionValidatePlan(payload, obj) {
  var paymentDetails = payload.paymentDetails,
      generateTokenForIntent = payload.generateTokenForIntent,
      planId = payload.planId,
      customerId = payload.customerId,
      cacheCardToken = payload.cacheCardToken;

  obj.planId = planId;
  obj.paymentDetails = paymentDetails;
  obj.generateTokenForIntent = generateTokenForIntent;
  obj.customerId = customerId;
  obj.cacheCardToken = cacheCardToken;

  return http["c" /* post */].call(this, Object(common["a" /* apiEndpoint */])(constant["a" /* API */].EMI_VALIDATE), Object(common["l" /* requestPayload */])(obj));
}
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/api/upi.js




/**
 * UPI address of user
 *
 * @returns {Promise<Object>} - Promise object
 */
function vpaDetails() {
  return http["c" /* post */].call(this, Object(common["a" /* apiEndpoint */])(constant["a" /* API */].VPA), Object(common["l" /* requestPayload */])({})).then(function (data) {
    var _data = {};
    _data.resultInfo = data.resultInfo;
    _data.userProfile = data.sarvatraUserProfile;
    _data.vpa = data.sarvatraVpa;
    return _data;
  }, function (error) {
    return error;
  });
}

/**
 * Verify upi vpa handler
 * @param {String} vpa - upi vpa handler
 * @return {Promise<Object>} - upi api response object
 * */
function validateVPA(vpa) {
  if (Object(common["g" /* isNull */])(vpa)) {
    return Promise.reject(new Error(constant["f" /* ERRORS */].VPA));
  }

  return http["c" /* post */].call(this, Object(common["a" /* apiEndpoint */])(constant["a" /* API */].VALIDATE_VPA), Object(common["l" /* requestPayload */])({ vpa: vpa }));
}
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/api/promo.js




/**
 *  Promo offers available on card,wallet and net banking
 *
 * @param {string} cn - Card number or Saved card id
 * @param {string} cardType - DEBIT_CARD,CREDIT_CARD,NET_BANKING,BALANCE
 * @param {boolean} isSC - true if saved card id is provided otherwise set to null
 * @param {string} bankCode - Bank code if cardType is NET_BANKING otherwise set to null
 * @returns {Promise<Object>} - Promise object
 */
function promoDetails(cn, cardType, isSC, bankCode) {
  var payload = { txnType: cardType };
  var cardNumber = cn;
  if (cardNumber || bankCode) {
    if (isSC) {
      cardNumber += '|';
    }
    if (bankCode) {
      // NB
      payload.bankCode = bankCode;
    } else {
      // Card
      payload.cardNumber = cardNumber;
    }
  }
  return http["c" /* post */].call(this, Object(common["a" /* apiEndpoint */])(constant["a" /* API */].PROMO), Object(common["l" /* requestPayload */])(payload));
}
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/api/merchant.js




/**
 * Fetch merchant configuration based on mid
 *
 * @param {string} mid - merchant id
 * @returns {Promise<Object>} - Promise object
 */

function config(mid) {
  var _this = this;

  if (Object(common["g" /* isNull */])(mid)) {
    return Promise.reject(new Error(constant["f" /* ERRORS */].MID));
  }

  return new Promise(function (resolve, reject) {
    http["b" /* get */].call(_this, Object(common["i" /* merchantServerEndpoint */])(constant["a" /* API */].MERCHANT_CONFIG) + '/' + mid).then(function (data) {
      var _ref = data && data.body || {},
          merchantPreferenceInfos = _ref.merchantPreferenceInfos,
          resultInfo = _ref.resultInfo;

      if (resultInfo && resultInfo.resultStatus === 'S' && merchantPreferenceInfos) {
        var response = {};
        var checkout = merchantPreferenceInfos.CHECKOUT;
        checkout.payMode.order = checkout.payMode.order.map(function (mode) {
          return mode.type.toUpperCase();
        });
        /* isGradientEffectEnable key added to configuration for further use */
        checkout.isGradientEffectEnable = merchantPreferenceInfos.isGradientEffectEnable || false;
        response.configuration = checkout;
        resolve(response);
      } else {
        reject(data);
      }
    }).catch(function (error) {
      reject(error);
    });
  });
}

function configPayload(mid) {
  return {
    targetURL: Object(common["i" /* merchantServerEndpoint */])(constant["a" /* API */].MERCHANT_CONFIG) + '/' + mid,
    method: 'GET'
  };
}
// EXTERNAL MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/utils/logger.js
var logger = __webpack_require__("2HRo");

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/api/paytm.js
var paytm__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable no-undef */







/**
 * Format card value as per native api
 *
 * @param {object} card - card info object
 * @returns {string} - formatted card value
 * @private
 */
var paytm__formatCard = function _formatCard(card) {
  var output = '';
  if (!card) {
    return '|||'; // default value
  }
  if (Object(common["d" /* has */])(card, 'id')) {
    output += card.id;
  }
  output += '|';
  if (Object(common["d" /* has */])(card, 'number')) {
    output += card.number;
  }
  output += '|';
  if (Object(common["d" /* has */])(card, 'cvv')) {
    output += card.cvv;
  }
  output += '|';
  if (Object(common["d" /* has */])(card, 'expiry')) {
    output += card.expiry;
  }
  return output;
};
/**
 * Format card object on credit and debit card
 *
 * @param {Object} _payObj - Pay object
 * @returns {Object} - formatted pay object
 * @private
 */
var paytm__formatObj = function _formatObj(_payObj) {
  var payObj = _payObj;
  if (payObj.paymentMode === 'DEBIT_CARD' || payObj.paymentMode === 'CREDIT_CARD') {
    if (!Object(common["d" /* has */])(payObj, 'cardInfo')) {
      throw new Error('Debit or Credit card must contain cardInfo object');
    }
    if (typeof payObj.cardInfo === 'object') {
      var cardInfo = paytm__formatCard(payObj.cardInfo);
      if (Object(common["d" /* has */])(payObj.cardInfo, 'isSave')) {
        payObj.storeInstrument = payObj.cardInfo.isSave ? '1' : '0';
      } else {
        payObj.storeInstrument = '0';
      }
      payObj.cardInfo = cardInfo;
    }
  }
  return payObj;
};

/**
 * Redirect pay request to paytm page.
 *
 * @param {object} payObj - Payment object
 * @returns {Promise<Object>} - Promise object
 */
function pay(payObj) {
  if (!payObj) {
    return Promise.reject(new Error(constant["f" /* ERRORS */].PAY));
  }
  var payload = paytm__extends({}, payObj);
  payload.requestType = 'NATIVE';

  return http["c" /* post */].call(this, Object(common["a" /* apiEndpoint */])(constant["a" /* API */].PT), Object(common["l" /* requestPayload */])(paytm__formatObj(payObj)));

  // openWindowPopup(this.cache);
  // return new Promise((resolve, reject) => {
  //   getValidTokenForFlow(this.cache)
  //     .then(_ => {
  //       _pay.call(this, payload).then(
  //         res => {
  //           resolve(res);
  //         },
  //         err => {
  //           reject(err);
  //         }
  //       );
  //     })
  //     .catch(err => {
  //       reject(err);
  //     });
  // });

  // return _pay(payObj);
}

// function _pay(payObj) {
//   return post.call(this, apiEndpoint(API.PT), requestPayload(_formatObj(payObj)));
// };

/**
 * Fetch balance of paytm payments instrument ( Wallet , Payment Bank , Postpaid )
 *
 * @param {string} payMode - Paymode for which balance fetch. Allow values ( BALANCE | PPBL | PAYTM_DIGITAL_CREDIT )
 * @returns {Promise<Object>} - Promise object
 */
function balance(payMode) {
  var _this = this;

  if (!validateUpperCase(payMode)) {
    return Promise.reject(new Error(constant["f" /* ERRORS */].BAL));
  }

  return new Promise(function (resolve, reject) {
    var payload = request_payload.call(_this, constant["a" /* API */].BAL);
    payload.data.body = paytm__extends({}, payload.data.body, { paymentMode: payMode });
    Object(common["e" /* iFrameApiCall */])(payload).then(function (data) {
      resolve(data);
    }).catch(function (err) {
      reject(err);
    });
  });
  // return post(apiEndpoint(API.BAL), requestPayload({ paymentMode: payMode }));
}

/**
 * Fetch all payments options available on merchant
 *
 * @returns {Promise<Object>} - Promise object
 */
function payModes() {
  return http["c" /* post */].call(this, Object(common["a" /* apiEndpoint */])(constant["a" /* API */].OPTIONS), Object(common["l" /* requestPayload */])({}));
}

/**
 * Transaction status of order
 * @param {String} mid - merchant id
 * @param {String} orderId - order id
 * @returns {Promise<Object>} - Promise object
 */
function paytm_status(mid, orderId) {
  if (Object(common["g" /* isNull */])(mid)) {
    return Promise.reject(new Error(constant["f" /* ERRORS */].MID));
  }

  if (Object(common["g" /* isNull */])(orderId)) {
    return Promise.reject(new Error(constant["f" /* ERRORS */].ORDERID));
  }

  return http["c" /* post */].call(this, Object(common["a" /* apiEndpoint */])(constant["a" /* API */].TRANS_STATUS), Object(common["l" /* requestPayload */])({ mid: mid, orderId: orderId, isCallbackUrlRequired: true }));
}

// filter vpas from paymode
var _filterPaymodes = function _filterPaymodes(paymodes) {
  paymodes.bankAccounts.map(function (paymode) {
    paymode.bankMetaData = {};
    paymode.credsAllowed = [];
    paymode.accRefNumber = '';
    paymode.name = '';
    paymode.account = '';
    paymode.accRefId = '';
    paymode.ifsc = '';
    paymode.mpinSet = '';
    return paymode;
  });

  paymodes.vpaDetails.map(function (paymode) {
    paymode.name = '';
    if (paymode.defaultDebit) {
      paymode.defaultDebit.account = '';
      paymode.defaultDebit.accRefNumber = '';
      paymode.defaultDebit.accRefId = '';
      paymode.defaultDebit.ifsc = '';
      paymode.defaultDebit.credsAllowed = [];
    }
    if (paymode.defaultCredit) {
      paymode.defaultCredit.account = '';
      paymode.defaultCredit.accRefNumber = '';
      paymode.defaultCredit.accRefId = '';
      paymode.defaultCredit.ifsc = '';
      paymode.defaultCredit.credsAllowed = [];
    }

    return paymode;
  });
  return paymodes;
};

// mapping app data for ui logger to remove user info
var _mapAppDataLog = function _mapAppDataLog(appData) {
  var _data = {};
  var localAppData = JSON.parse(JSON.stringify(appData.body));
  if (appData) {
    _data = localAppData;
    _data.userDetails = localAppData.userDetails && paytm__extends({}, localAppData.userDetails, {
      username: '',
      mobile: '',
      email: ''
    });
    _data.upiMetaData = localAppData.upiMetaData && paytm__extends({}, localAppData.upiMetaData, {
      upiLinkedMobileNumber: ''
    });
    _data.merchantDetails = localAppData.merchantDetails && paytm__extends({}, localAppData.merchantDetails, {
      merchantVpa: ''
    });
    _data.addMoneyMerchantDetails = localAppData.addMoneyMerchantDetails && paytm__extends({}, localAppData.addMoneyMerchantDetails, {
      merchantVpa: ''
    });

    if (_data.merchantPayOption && _data.merchantPayOption.userProfileSarvatra) {
      _data.merchantPayOption.userProfileSarvatra.response = localAppData.merchantPayOption.userProfileSarvatra ? _filterPaymodes(localAppData.merchantPayOption.userProfileSarvatra.response) : '';
    }

    if (_data.addMoneyPayOption && _data.addMoneyPayOption.userProfileSarvatra) {
      _data.addMoneyPayOption.userProfileSarvatra.response = localAppData.addMoneyPayOption.userProfileSarvatra ? _filterPaymodes(localAppData.addMoneyPayOption.userProfileSarvatra.response) : '';
    }

    delete _data.retryData;
  }
  return _data;
};

function tokenPaymodes(payload) {
  var _this2 = this;

  var token = payload.token,
      mid = payload.mid,
      orderId = payload.orderId,
      applyPaymentOffer = payload.applyPaymentOffer,
      fetchAllPaymentOffers = payload.fetchAllPaymentOffers,
      referenceId = payload.referenceId,
      requestId = payload.requestId,
      tokenType = payload.tokenType;

  return new Promise(function (resolve, reject) {
    var payload = request_payload.call(_this2, constant["a" /* API */].OPTIONS);
    payload.data.head = paytm__extends({}, payload.data.head, { token: token, tokenType: tokenType, type: tokenType });
    payload.data.body = paytm__extends({}, payload.data.body, {
      mid: mid,
      orderId: orderId,
      applyPaymentOffer: applyPaymentOffer,
      fetchAllPaymentOffers: fetchAllPaymentOffers
    });
    /* If request Id found add it to body params */
    if (requestId) {
      payload.data.body.requestId = requestId;
    }
    payload.query = paytm__extends({}, payload.query, { orderId: orderId });
    /* If reference Id found add it to query params */
    if (referenceId) {
      payload.query = paytm__extends({}, payload.query, { referenceId: referenceId });
    }

    logger["a" /* pubsubLogger */].info({ eventType: constant["g" /* EVENT */].API_INIT, url: payload.url, iframeCall: true });
    Object(common["e" /* iFrameApiCall */])(payload).then(function (data) {
      try {
        var parseData = _mapAppDataLog(JSON.parse(JSON.stringify(data)));

        logger["a" /* pubsubLogger */].info({
          eventType: constant["g" /* EVENT */].API_STATUS,
          url: payload.url,
          data: parseData,
          statusCode: 200,
          iframe: true
        });
      } catch (e) {}
      resolve(data);
    }).catch(function (err) {
      logger["a" /* pubsubLogger */].info({
        eventType: constant["g" /* EVENT */].API_STATUS,
        url: payload.url,
        data: err,
        statusCode: 500,
        iframe: true
      });
      reject(err);
    });
  });
}
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/api/pcf.js




/* passing txn amount since in case of access token flow amount has to be passed in fetch pcf details */
function fetchPcfDetails(payMethods, txnAmount) {
  var payload = { payMethods: payMethods };
  if (txnAmount) {
    payload.txnAmount = txnAmount;
  }
  return http["c" /* post */].call(this, Object(common["a" /* apiEndpoint */])(constant["a" /* API */].FETCH_PCF_DETAILS), Object(common["l" /* requestPayload */])(payload));
}
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/api/offers.js




function applyPromo(details) {
  return http["c" /* post */].call(this, Object(common["a" /* apiEndpoint */])(constant["a" /* API */].APPLY_PROMO), Object(common["l" /* requestPayload */])(details));
}
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/api/bank-mandate.js




function validateIfsc(ifscData) {
  var skipMiddleware = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  return http["c" /* post */].call(this, Object(common["m" /* walletApiEndPoint */])(constant["a" /* API */].VALIDATE_IFSC), Object(common["k" /* requestIFSCPayload */])(ifscData), skipMiddleware);
}

function getIfsc(ifscData) {
  var skipMiddleware = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  return http["c" /* post */].call(this, Object(common["m" /* walletApiEndPoint */])(constant["a" /* API */].GET_IFSC), Object(common["k" /* requestIFSCPayload */])(ifscData), skipMiddleware);
}
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/api/prn.js




function validatePRN(payload) {
  return http["c" /* post */].call(this, Object(common["a" /* apiEndpoint */])(constant["a" /* API */].VALIDATE_PRN), Object(common["l" /* requestPayload */])(payload));
}
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/api/sc.js




/**
 * Card Token based on Saved Card Id.
 *
 * @param {Object} payload - Object to send in body
 * @param {Object} queryParams - Object to send in query  params
 * @returns {Promise<any>} - promise object contains response from server api
 */
function getCacheCardToken(payload, queryParams) {
  var url = Object(common["a" /* apiEndpoint */])(constant["a" /* API */].CACHE_CARD_TOKEN) + '?' + Object(http["d" /* queryStr */])(queryParams);
  return http["c" /* post */].call(this, url, payload, {
    skipMiddleware: true,
    'Content-type': constant["b" /* CONTENT_TYPE */].FORM_URLENCODED
  });
}
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/api.js


















/*
 * A private method for binding mid,orderid, token and token type
 *
 * @param {string} mid - merchant id
 * @param {string} orderId - order id
 * @param {string} token - token
 * @param {string} [type] - token type
 *
 * @return {Function} - callback function to register on interceptors with http request as parameter
 * */
var _bindOptions = function _bindOptions(mid, orderId, token, type) {
  return function (request) {
    request.query.mid = mid;
    request.query.orderId = orderId;

    if (request.data) {
      if (request.data.head) {
        request.data.head.token = token || '';
        request.data.head.type = type || '';
      }
      if (request.data.body) {
        request.data.body.mid = mid;
      }
    }
    return request;
  };
};

/**
 * A module wrapper over paytm native api that can be access via javascript functions.
 *
 * @example var paytmApi = new Paytm.API(mid: String, orderId: String, txnToken: String, options: Object)
 * @param {string} mid - merchant id
 * @param {string} orderId - order id
 * @param {string} token - transaction token
 * @param {Object} [options] - optional js object that contains meta data
 * @param {string} options.type - token type - SSO , TXN_TOKEN
 */
function API(mid, orderId, token, options) {
  if (!mid) {
    throw new Error(constant["f" /* ERRORS */].CHECKOUT);
  }

  this.middleware = new http["a" /* Interceptor */]();
  this.postFetch = new http["a" /* Interceptor */]();
  this.middleware.add(_bindOptions(mid, orderId, token, options && options.type || ''));
}

API.prototype.runMiddleware = http["e" /* runMiddleware */];
API.prototype.sendOtp = sentOtp;
API.prototype.verifyOtp = validateOtp;
API.prototype.logout = logout;
API.prototype.balance = balance;
API.prototype.nbChannels = nbChannels;
API.prototype.cardDetails = cardDetails;
API.prototype.tokenPaymodes = tokenPaymodes;
API.prototype.emiDetails = emiDetails;
API.prototype.pay = pay;
API.prototype.payModes = payModes;
API.prototype.upiVpa = vpaDetails;
API.prototype.verifyVPA = validateVPA;
API.prototype.promoDetails = promoDetails;
API.prototype.configPayload = configPayload;
API.prototype.config = config;
API.prototype.fetchPcfDetails = fetchPcfDetails;
API.prototype.status = paytm_status;
API.prototype.requestPayload = request_payload;
API.prototype.logger = logger["a" /* pubsubLogger */];
API.prototype.applyPromo = applyPromo;
API.prototype.directApi = directApi;
API.prototype.validatePRN = validatePRN;

API.prototype.emiSubventionBanks = emiSubventionBanks;
API.prototype.emiSubventionPlans = emiSubventionPlans;
API.prototype.emiSubventionValidatePlan = emiSubventionValidatePlan;
API.prototype.getCacheCardToken = getCacheCardToken;
API.prototype.validateIfsc = validateIfsc;
API.prototype.getIfsc = getIfsc;
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/index.api.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return index_api_API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PAYMODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FLOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ELEMENT_PAYMODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EMI_SUBVENTION_STRATEGY; });



/**
 * Promise polyfill if browser not supported
 * */

if (!window.Promise) {
  if (true) {
    var s = document.createElement('script');
    s.type = 'application/javascript';
    s.async = true;
    s.src = "https://staticpg.paytm.in" + '/common/lib/promise/promise-polyfill.min.js';
    document.body.appendChild(s);
  }
}

var index_api_API = API;
var TOKEN = constant["n" /* TOKEN */];
var PAYMODE = constant["m" /* PAYMODE */];
var FLOW = constant["h" /* FLOW */];
var ELEMENT_PAYMODE = constant["c" /* ELEMENT_PAYMODE */];
var EMI_SUBVENTION_STRATEGY = constant["e" /* EMI_SUBVENTION_STRATEGY */];

/***/ }),

/***/ "RH0W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _en = {};

_en.static = {
  'paymode.select.option': 'Select an option to pay',
  'paymode.select.other': 'Select from other options',
  'sc.select': 'SELECT A SAVED CARD',
  'got.it': 'Ok, Got It!',
  'select.option.to.pay.subscription': 'SELECT AN OPTION TO SUBSCRIBE'
};

_en.header = {
  'otp.send': 'OTP requested successfully',
  'order.id': 'Order ID',
  'select.option.pay': 'Select an option to pay',
  'select.option.to.pay.subscription': 'SELECT AN OPTION TO SUBSCRIBE',
  switch: 'Switch',
  account: 'Account'
};

_en.footer = {
  message: '100% Secure Payments Powered by Paytm'
};

_en.offers = {
  message: 'Exclusive Offers for You',
  termsAndCondition: 'Offer T&C',
  bankOffers: 'Bank Offers',
  validatePromoError: 'This transaction requires a valid promocode to proceed.',
  invalidTermsAndConditionUrl: 'Invalid terms and conditions URL.',
  instantDiscount: 'Instant discount of ₹amount applicable.',
  cashback: 'Cashback worth ₹amount applicable.',
  pwpPreLogin: "Bank offers won't be applicable after logging into Paytm."
};

_en.retry = {
  message: 'Retry',
  'payment.failed': 'Payment Failed',
  info: 'Please do not close this window or press back while we confirm your payment status'
};

_en.processing = {
  heading: 'Processing Your Payment',
  info: 'Please do not close this window or press back while we confirm your payment status'
};

_en.card = {
  number: 'Card Number',
  expiry: 'Expiry / Validity',
  cvv: 'CVV',
  'save.card': 'Save this card for future payments',
  'invalid.card.number': 'Please enter valid card number',
  'invalid.expiry': 'Invalid Expiry Date',
  'invalid.cvv': 'Please enter valid CVV'
};

_en.ppbl = {
  'check.balance': 'Check Balance',
  'available.balance': 'Available Balance ₹ ',
  'insufficient.balance': 'You do not have enough balance for this payment',
  'invalid.passcode': 'Enter valid passcode',
  enterPasscode: 'Enter passcode'
};

_en.qr = {
  pay: 'Scan QR to Pay',
  'scan.qrcode': 'Scan QR code using your Paytm app',
  'scan.qrcode.upi': 'Scan QR code using Paytm or your preferred UPI app',
  'scan.upi.qrcode': 'Scan QR code using Paytm or your preferred UPI app to complete payment',
  'scan.upi.payment': 'Payment will be completed on that app',
  'scan.paytm': 'You will be able to pay using any of your saved payment options',
  'scan.upi': 'Scan with your Paytm app to pay using UPI or any of your saved payment options',
  'all.apps': 'All other apps will only have UPI as payment option',
  'click.enlarge': 'Click to enlarge',
  'prn.incorrect': 'Enter the correct Payment Reference No.',
  'prn.description': 'It is an 8 digit no. displayed on payment confirmation screen in your APP',
  prn: 'Enter Paytm reference number',
  'process.payment': 'Processing Payment',
  'process.redirect': 'You will be redirected once the payment is successful on your {{UPI_APP}} App',
  'process.press.btn': 'Please do not press back button until payment is completed',
  reload: 'Click to Reload QR',
  'scan.pending': 'It seems your transaction has moved into pending state.You can retry or wait for the transaction to complete. In case of retry, you will be charged only for one transaction even if the first transaction successfully completes after sometime'
};

_en.pdc = {
  'check.balance': 'Check Balance',
  'available.balance': 'Available Balance ₹ ',
  'insufficient.balance': 'You do not have enough balance for this payment'
};

_en.savedCard = {
  'label.viewMore': 'View All Saved Cards',
  'label.viewLess': 'View Less',
  'label.invalidCvv': 'Invalid CVV'
};

_en.upi = {
  'select.upi': 'Select Your UPI App',
  'handler.suggestion': 'OR Enter Your UPI ID',
  'id.required': 'Please enter a UPI ID',
  'invalid.id': 'Please enter a valid UPI ID',
  title: 'Pay using your UPI ID',
  'title.desc': 'Enter your UPI ID and approve the payment request on the app linked to it.',
  'polling.default.goto': 'UPI linked Bank/ UPI mobile application',
  'polling.approve': 'Check pending requests and approve payment by entering UPI PIN',
  'polling.click': 'If the UPI address belongs to your friend/ family, they will need to approve the payment request on thier UPI linked bank application',
  'polling.noback': 'Please do not press back button until payment is completed',
  'subscription.error': 'The UPI ID entered does not support subscription payments. Please try with another UPI ID.'
};

_en.nb = {
  'secure.redirection.message': 'You will be redirected to bank\'s website for secure payment processing',
  'no.result.found': 'No Result Found'
};

_en.login = {
  message: 'Pay using your saved payment instruments',
  'otp.sent.number': 'Enter OTP sent to mobile number',
  'invalid.otp.length': 'Please Enter Valid Otp',
  'invalid.mobile.input': 'Please Enter a valid mobile number',
  'otp.not.received': "Didn't receive OTP?",
  'request.otp': 'Request Another OTP',
  rememberMe: 'Remember Me',
  'btn.sendOtp.text': 'Proceed',
  'btn.verifyOtp.text': 'Verify',
  'subscription.msg': 'Use your wallet balance, saved payment options & keep track of your subscription',
  'mobile.number': 'Mobile no.',
  'change.number': 'Change'
};

_en.wallet = {
  'insufficient.balance': 'You do not have enough balance for this payment'
};

_en.mgv = {
  'insufficient.balance': 'You do not have enough balance for this payment'
};

_en.payButton = {
  text: 'PAY ₹',
  addNPayText: 'Add ₹amount & Pay',
  effectivePrice: '(Effective price: ₹effectPrice with ₹amount cashback)'
};

_en.emiErrors = {
  emiBankListErrorHeading: 'EMI option is not available on this bank',
  emiBankListErrorSubtext: 'Select other banks to avail EMI',
  emiPlanError: 'Unable to apply Plan',
  emiPlanSubtext: 'Select other plan to avail EMI',
  errorBtn: 'OK , Got it',
  emiPlanSelectError: 'Select EMI Plan',
  emiNotAvailable: 'EMI not available on this card. Please choose another card'
};
_en.emi = {
  interest: 'Interest as per the plan will be applicable on each product',
  emiConvert: 'Your bank will convert your payment into EMI in 3-4 working days',
  cashback: 'Cashback, if any, will be credited to you in 45 days post order delivery',
  kycText: 'Kindly get your KYC done to receive cashback in your Paytm wallet. Please ignore if already done',
  emiHybridDisabledText: 'Paytm Balance and EMI cannot be used together for this payment',
  emiHybridDisabledCardText: 'Paytm Balance and EMI cannot be used together for this payment. Please select your Emi Again'
};

_en.subscription = {
  savedCard: 'This card will be saved for future payments',
  details: 'Subscription Details',
  viewDetails: 'View Subscription Details',
  upto: 'upto',
  'merchant.shared': 'As shared by',
  'may.be.deducted': 'may be charged by your bank for verification'
};

_en.pcf = {
  inclusive: 'Inclusive of ',
  'convenience.gst': 'Convenience Charge + GST',
  'apx.amount': 'Approximate amount',
  applicable: 'as applicable',
  'convenience.charge': 'Convenience Charges',
  convenience: 'Convenience',
  'error.heading': 'Unable to fetch convenience charges',
  'error.desc': 'We could not fetch convenience charges for payment using <placeholder>. Please use another option to complete payment',
  'error.web.desc': 'Please use another option to complete payment',
  'error.web.heading': 'We could not fetch convenience charges for payment using <placeholder>.',
  'error.web.heading1': 'We could not fetch convenience fee.  Please try again.',
  'amount.vary': 'Amount may vary from bank to bank',
  nb: 'Amount may vary from bank to bank',
  cc: 'Amount may vary based on card scheme'
};

/** bank mandate */
_en.bm = {
  'enter.number': 'Enter Bank Account Number',
  'invalid.number': 'Please enter a valid bank account number',
  'blank.number': 'Please enter your bank account number',
  'enter.name': 'Enter your name (As per Bank Records)',
  'invalid.name': 'Please enter a valid name',
  'blank.name': 'Please enter your name',
  'enter.ifsc': 'Enter IFSC',
  'invalid.ifsc': 'Please enter a valid IFSC',
  'blank.ifsc': 'Please enter your bank IFSC',
  'find.ifsc': 'Find IFSC',
  'blank.auth': 'Please choose authenticate mode',
  'authenticate.using': 'Authenticate Using',
  'account.saving': 'Savings Account',
  'confirm.NET_BANKING': 'You will be asked to login to your netbanking account by your bank to confirm the mandate request',
  'confirm.DEBIT_CARD': 'You will be asked to enter your debit card details by your bank to confirm the mandate request',
  'change.bank': 'Change Bank',
  'auth.using': 'Authenticate Using',
  proceed: 'Proceed',
  confirm: 'Confirm',
  'select.other.bank': 'Select from all other banks',
  'search.state': 'Search State',
  'search.city': 'Search City',
  'search.bank': 'Search Bank',
  'select.state': 'Select State',
  'select.city': 'Select City',
  'select.bank': 'Select your Bank',
  'subscription.details': 'Subscription Details',
  'customer.name': 'Customer Name',
  frequency: 'Frequency',
  'max.amount': 'Maximum Amount',
  'start.date': 'Start Date',
  'exp.date': 'Expiry Date',
  purpose: 'Purpose',
  'bank.acc.details': 'Bank Account Details',
  'ifsc.code': 'IFSC Code',
  'savings.acc': 'Savings Account',
  'mandate.powered': 'E-mandate Powered by',
  'ac.no': 'A/C No.',
  'until.cancelled': 'Until Cancelled',
  'subs.on.demand': 'As and When Presented',
  'amt.deduct': 'Will be deducted within 2-4 days'
};

/** UPI Intent */
_en.upi_intent = {
  'help.step1': 'Click on Pay button to open the list of UPI apps installed on your mobile',
  // "help.step1": `Select the option "UPI Apps" on Paytm Payments Page. On proceeding, you will see a list of active UPI Apps on your device`,
  'help.step2': 'On selecting your preferred UPI App, you will be taken to the app to complete the payment',
  'help.step3': 'After completing your payment, you will be redirected back to the payment confirmation screen',
  'help.title': 'How to Pay Using UPI Apps',
  label: 'Pay using a UPI App',
  'paymode.label': 'Pay Using UPI Apps',
  help: 'Know More',
  desc: 'Click the Pay button to select from the list of apps available on your mobile',
  'psp.not.found': 'Unable to process your payment. Please retry using any other paymode',
  'loader.heading': 'Fetching UPI Apps',
  'loader.desc': 'Please wait while we fetch the list of UPI Apps installed on your mobile',
  'loader.retry.heading': 'Awaiting Response',
  'loader.retry.desc': 'The response from your UPI app is taking longer than ususal. Please wait or click on try again',
  'loader.retry.validation.heading': 'Validating',
  'loader.retry.validation.desc': 'Please wait while we fetch the final payment status before you try again'
};

/* DirectBank */
_en.dBank = {
  paymentDetails: 'Payment Details',
  completePayment: 'Complete Payment',
  otp: 'An OTP has been sent to your registered mobile number',
  enterOtp: 'Enter OTP',
  requestAnotherOtp: 'Request Another OTP',
  cancel: 'Cancel',
  notReceivedOtp: 'Still did not receive OTP?',
  otpMissing: 'OTP Missing',
  otpIncomplete: 'OTP Incomplete',
  resendOtp: 'Resend OTP',
  cancelPayment: 'Cancel Payment',
  questionCancel: 'Why do you want to cancel this payment?',
  wantBank: 'Want to complete this payment on Bank website',
  goBank: 'Go to Bank Website',
  notBuy: 'Do not want to buy this product/service anymore',
  notRegistered: 'Do not have access to registered mobile number',
  submit: 'Submit',
  issueOtp: 'Facing issue with OTP page',
  other: 'Other',
  paytm: 'Paytm'
};

/* harmony default export */ __webpack_exports__["a"] = (_en);

/***/ }),

/***/ "TwIz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return PAYMODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ELEMENT_PAYMODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return PAYMENT_FLOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FLOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LOGGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EMI_SUBVENTION_STRATEGY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CONTENT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EMI_SUBVENTION_ITEM_KEYS; });
var API = {
  NB_CHANNELS: '/api/v1/fetchNBPaymentChannels',
  OPTIONS: '/api/v2/fetchPaymentOptions',
  BIN: '/api/v1/fetchBinDetail',
  SEND_OTP: '/api/v1/login/sendOtp',
  VAL_OTP: '/api/v2/login/validateOtp',
  PT: '/api/v1/processTransaction',
  BAL: '/api/v1/fetchBalanceInfo',
  EMI: '/api/v1/fetchEMIDetail',
  VPA: '/api/v1/fetchVpaDetails',
  PROMO: '/api/v1/fetchPromoCodeDetail',
  TRANS_STATUS: '/v1/transactionStatus',
  MERCHANT_CONFIG: '/theme',
  VALIDATE_VPA: '/api/v1/vpa/validate',
  LOG_OUT: '/api/v2/logout/user',
  CART: '/api/v1/cart',
  CARD_DETAILS: '/api/v1/fetchCardDetails',
  FETCH_EMI_BANK_DETAILS: '/api/',
  FETCH_PCF_DETAILS: '/api/v1/fetchPcfDetails',
  APPLY_PROMO: '/api/v1/applyPromo',
  FETCH_ALL_PAYMENT_OFFERS: '/api/v1/fetchAllPaymentOffers',
  VALIDATE_IFSC: '/service/getBank',
  GET_IFSC: '/service/getList',
  EMI_BANKS: '/api/v1/emiSubvention/banks',
  EMI_TENURE: '/api/v1/emiSubvention/tenures',
  EMI_VALIDATE: '/api/v1/emiSubvention/validateEmi',
  CACHE_CARD_TOKEN: '/PAYTM_EXPRESS/getCardToken/emi',
  VALIDATE_PRN: '/api/v1/validatePRN'
};

var ERRORS = {
  CHECKOUT: 'API constructor mandatory fields => mid,orderId and token',
  UI: 'UI constructor mandatory fields => mid,orderId and txnToken',
  MOBILE: 'Mobile number cannot be null or empty',
  INVALID_MOBILE: 'Mobile number should be valid and of 10 digits',
  OTP: 'OTP cannot be null or empty',
  BIN: 'Card number cannot be blank or less than 6 digit',
  EMI: 'Channel code cannot be empty or number',
  BAL: 'Paymode should be non-empty and of string type',
  PAY: 'Pay object cannot be empty',
  MID: 'Merchant id should not be null',
  ORDERID: 'Order id should not be null',
  VPA: 'Enter a valid vpa',
  PCF: 'Pay methods should not be null'
};

var PAYMODE = {
  WALLET: 'BALANCE',
  PAYMENT_BANK: 'PPBL',
  GIFT_VOUCHER: 'MGV',
  POSTPAID: 'PDC',
  CARD: 'CARD',
  EMI: 'EMI',
  NB: 'NB',
  UPI: 'UPI',
  COD: 'COD',
  LOGIN: 'LOGIN'
};

var ELEMENT_PAYMODE = {
  PAY_WITH_PAYTM: 'PAY WITH PAYTM',
  CARD: 'CARD',
  EMI: 'EMI',
  NB: 'NB',
  UPI: 'UPI',
  SCAN_AND_PAY: 'SCAN AND PAY'
};

var TOKEN = {
  SSO: 'SSO',
  TXN: 'TXN_TOKEN',
  ACCESS: 'ACCESS'
};

var PAYMENT_FLOW = {
  ADDANDPAY: 'ADDANDPAY',
  NONE: 'NONE',
  HYBRID: 'HYBRID'
};

var FLOW = {
  DEFAULT: 'DEFAULT',
  DEFERRED: 'DEFERRED'
};

var EVENT = {
  API_INIT: 'API_INIT',
  API_STATUS: 'API_STATUS'
};

var METHOD = {
  GET: 'GET',
  POST: 'POST'
};

var MESSAGE = {
  GENERIC_ERROR: 'Something went wrong'
};

var LOGGER = {
  DEBUG: 'DEBUG',
  INFO: 'INFO'
};
var EMI_SUBVENTION_STRATEGY = {
  ITEM_BASED: 'ITEM_BASED',
  AMOUNT_BASED: 'AMOUNT_BASED'
};
var CONTENT_TYPE = {
  JSON: 'application/json',
  FORM_URLENCODED: 'application/x-www-form-urlencoded'
};

var EMI_SUBVENTION_ITEM_KEYS = {
  BRAND_ID: 'brandId',
  CATEGORY_LIST: 'categoryList',
  MODEL: 'model',
  EAN: 'ean'
};

/***/ }),

/***/ "WsRd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return globaleStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_unistore__ = __webpack_require__("2FAC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_constants__ = __webpack_require__("hafV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_common__ = __webpack_require__("ocZ9");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var cache = function _cache() {
  var cacheInstances = {};

  var Cache = function Cache() {
    var _this = this;

    _classCallCheck(this, Cache);

    this.caches = {};

    this.getData = function (key, defaultVal) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils_common__["q" /* getKey */])(_this.caches, key, defaultVal);
    };

    this.setData = function (key, value) {
      if (!key) {
        return;
      }

      _this.caches[key] = value;
    };

    this.clear = function () {
      _this.caches = {};
    };
  };

  function create(instanceKey) {
    instanceKey = instanceKey || __WEBPACK_IMPORTED_MODULE_1__utils_constants__["g" /* default */].DEFAULT_INSTANCE_KEY;
    return cacheInstances[instanceKey] = new Cache();
  }

  function getInstance(instanceKey) {
    instanceKey = instanceKey || __WEBPACK_IMPORTED_MODULE_1__utils_constants__["g" /* default */].DEFAULT_INSTANCE_KEY;
    return cacheInstances[instanceKey];
  }

  function clearInstance(instanceKey) {
    instanceKey = instanceKey || __WEBPACK_IMPORTED_MODULE_1__utils_constants__["g" /* default */].DEFAULT_INSTANCE_KEY;
    delete cacheInstances[instanceKey];
  }

  function clear() {
    cacheInstances = {};
  }

  return {
    create: create,
    getInstance: getInstance,
    clearInstance: clearInstance,
    clear: clear
  };
}();

/* harmony default export */ __webpack_exports__["a"] = (cache);

var globaleStore = Object(__WEBPACK_IMPORTED_MODULE_0_unistore__["a" /* default */])({});

/***/ }),

/***/ "gKfx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _constant = {};
_constant.ERROR_MESSAGE = {};

_constant.ERROR_CODE = {
  4001: '4001',
  4002: '4002',
  4003: '4003'
};

_constant.ERROR_MESSAGE[_constant.ERROR_CODE['4001']] = 'merchant configuration should not be empty or blank';
_constant.ERROR_MESSAGE[_constant.ERROR_CODE['4002']] = 'token session expired';
_constant.ERROR_MESSAGE[_constant.ERROR_CODE['4003']] = 'error occur while fetching paymodes';

/* harmony default export */ __webpack_exports__["a"] = (_constant);

/***/ }),

/***/ "hafV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CACHE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RESPONSE_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RESPONSE_STATUS_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UPI_INTENT_MWEB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GLOBAL_STORE; });
var _constant = {};

/* ---------------- Native Api  ----------------*/

_constant.PPBL = 'PPBL';
_constant.POSTPAID = 'PAYTM_DIGITAL_CREDIT';
_constant.CC = 'CREDIT_CARD';
_constant.DC = 'DEBIT_CARD';
_constant.NB = 'NET_BANKING';
_constant.EMI = 'EMI';
_constant.UPI = 'UPI';
_constant.AOA = 'WALLET';
_constant.UPI_INTENT = 'UPI_INTENT';
_constant.UPI_PUSH = 'UPI_PUSH';
_constant.WALLET = 'BALANCE';
_constant.GIFT_VOUCHER = 'GIFT_VOUCHER';
_constant.COD = 'COD';
_constant.NATIVE = 'NATIVE';
_constant['3D'] = '3D';
_constant.NONE = 'NONE';
_constant.PIN = 'pin';
_constant.OTP = 'otp';
_constant.ATM = 'atm';
_constant.USRPWD = 'USRPWD';
_constant.WAP = 'WAP';
_constant.WEB = 'WEB';
_constant.ADA = 'ADVANCE_DEPOSIT_ACCOUNT';
_constant.UPIPUSH = 'UPIPUSH';
_constant.UPIPUSHEXPRESS = 'UPIPUSHEXPRESS';
_constant.QR_PRN = 'QR_PRN';
_constant.SUBMIT = 'SUBMIT';
_constant.UPDATE_PAYLOAD = 'UPDATE_PAYLOAD';
_constant.GET_TXN_TOKEN_PAYLOAD = 'GET_TXN_TOKEN_PAYLOAD';
_constant.SUBMIT_WITH_TOKEN = 'SUBMIT_WITH_TOKEN';
_constant.PAY_SUCCESS = 'paysuccess';
_constant.PAY_FAIL = 'payfail';
_constant.SESSION_EXPIRED = 'sessionExpired';
_constant.TXN_TOKEN_EXPIRED = 'txnTokenExpired';
_constant.GENERIC_ERROR = 'Something went wrong';
_constant.PROCESSING = 'Processing';
_constant.CUSTOM_PROCESSING = 'CUSTOM_PROCESSING';
_constant.RETRY = 'Retry';
_constant.TXN_AMOUNT = 'TXN_AMOUNT';
_constant.FALLBACK_TXN_AMOUNT = 'FALLBACK_TXN_AMOUNT';
_constant.WITHOUT_PCF_TXN_AMOUNT = 'WITHOUT_PCF_TXN_AMOUNT';
_constant.UNMODIFIED_TXN_AMOUNT = 'UNMODIFIED_TXN_AMOUNT';
_constant.SHOW_PROCESSING = 'showProcessing';
_constant.HEADER = 'header';
_constant.FOOTER = 'footer';
_constant.OFFERS = 'offers';
_constant.STATIC = 'static';
_constant.LOGIN = 'LOGIN';
_constant.OPEN_POPUP_WINDOW = 'OPEN_POPUP_WINDOW';
_constant.POPUP_WINDOW = 'POPUP_WINDOW';
_constant.IS_DIRECT_BANK = 'IS_DIRECT_BANK';
_constant.IS_SELF_CLOSE = 'IS_SELF_CLOSE';
_constant.HIDE_PROCESSING = 'hideProcessing';
_constant.CLIENT_VALIDATION = 'clientValidation';
_constant.INITIALIZED = 'initialized';
_constant.HIDECN = 'hideCN';
_constant.HIDECVVEXPIRY = 'hideCVVExpiry';
_constant.SHOW_EMI_PLAN_LIST = 'showEmiPlan';
_constant.HIDE_EMI_PLAN_LIST = 'hideEmiPlan';
_constant.SHOW_SAVED_CARD_AND_PLAN = 'showSavedCardAndPlan';
_constant.HIDE_SAVED_CARD_AND_PLAN = 'hideSavedCardAndPlan';
_constant.CARD_NOT_SUPPORTED = 'cardNotSupported';
_constant.HIDE_RING_LODER = 'HIDE_RING_LODER';
_constant.LOG_CARD_DETAILS = 'LOG_CARD_DETAILS';
_constant.REMOVE_CARD_NUMBER = 'REMOVE_CARD_NUMBER';
_constant.CARD_DETAILS_RESOLVED = 'cardDetailsResolved';
_constant.MID = 'MID';
_constant.ORDER_ID = 'ORDER_ID';
_constant.CARD_DETAILS = 'cardDetails';
_constant.SUBSCRIPTION = 'Subscription';
_constant.UPDATE_HEIGHT = 'UPDATE_HEIGHT';
_constant.HANDLE_PROMO_RESPONSE = 'handlePromoResponse';
_constant.SC = 'SC';
_constant.CARD_AND_DEBIT = 'Debit / Credit Cards';
_constant.DEFAULT_INSTANCE_KEY = 'DEFAULT';
_constant.IS_LINK_TXN = 'IS_LINK_TXN';
_constant.IS_UPI_TXN = 'IS_UPI_TXN';
_constant.TIMEOUT_ID = 'TIMEOUT_ID';
_constant.INTERVAL_ID = 'INTERVAL_ID';
_constant.IS_BANKPAGE_REQUIRED_BLOCKED = 'IS_BANKPAGE_REQUIRED_BLOCKED';
_constant.MGV = 'MGV';
_constant.NOTIFY_MERCHANT = 'NOTIFY_MERCHANT';
_constant.IS_EMISUBVENTION_ACCESS_TOKEN_FLOW = 'IS_EMISUBVENTION_ACCESS_TOKEN_FLOW';
_constant.EMISUBVENTION_STATEGY = 'EMISUBVENTION_STATEGY';
_constant.SUBVENTION_OBJ = 'SUBVENTION_OBJ';
_constant.SUBVENTION_OBJ_INITIAL = 'SUBVENTION_OBJ_INITIAL';
_constant.SUBVENTION_MINI_CART_OBJ = 'SUBVENTION_MINI_CART_OBJ';
_constant.CACHE_CARD_TOKEN = 'cacheCardToken';
_constant.WEB_VIEW_FLOW = 'WEB_VIEW_FLOW';
_constant.SUBS_PAYMODE_MIN_AMOUNT = '1';
_constant.BM = 'BANK_MANDATE';
_constant.SBM = 'SAVED_BANK_MANDATE';
_constant.EMISUBVENTION_TOKEN = 'EMISUBVENTION_TOKEN';
_constant.PAYMODE_BASED_OFFER = 'PAYMODE_BASED_OFFER';
_constant.SET_VALIDATION_STATUS = 'SET_VALIDATION_STATUS';
_constant.IS_IN_POLLING_STATUS = 'IS_IN_POLLING_STATUS';
_constant.ALLOWED_MERCHANT_RETRY_COUNTS = 'ALLOWED_MERCHANT_RETRY_COUNTS';
_constant.CVV_EXPIRY_FOCUS = 'CVV_EXPIRY_FOCUS';
_constant.SAVED_PAYMODES = 'SAVED_PAYMODES';
_constant.IS_LOGGED_IN = 'IS_LOGGED_IN';
_constant.IS_LOCAL_STORAGE_ALLOWED = 'IS_LOCAL_STORAGE_ALLOWED';
_constant.CURRENT_PAYMODE = 'CURRENT_PAYMODE';
_constant.MOBILE_NO = 'MOBILE_NO';
_constant.CARD_TYPE = 'CARD_TYPE';
_constant.STORAGE_USED = 'STORAGE_USED';
_constant.FOUND_LAST_USED_PAYMODE = 'FOUND_LAST_USED_PAYMODE';
_constant.CARD_NUMBER_RESET = 'CARD_NUMBER_RESET';
_constant.BANK_OFFER_TXN_AMOUNT = 'BANK_OFFER_TXN_AMOUNT';
_constant.ICON_BASE_URL = 'ICON_BASE_URL';
_constant.IS_UPI_APPS_PAYMODE_ENABLED = 'IS_UPI_APPS_PAYMODE_ENABLED';
_constant.IS_PAYMENT_REQUEST_CONFIRMATION_PROGRESS = 'IS_PAYMENT_REQUEST_CONFIRMATION_PROGRESS';

_constant.DEFERRED_EVENTS = {
  FETCH_PAYMODE: 'FETCH_PAYMODE',
  FETCH_EMI_PLANS: 'FETCH_EMI_PLANS',
  FETCH_EMI_BANK_DETAILS: 'FETCH_EMI_BANK_DETAILS',
  FETCH_CARD_DETAILS: 'FETCH_CARD_DETAILS',
  APPLY_EMI: 'APPLY_EMI',
  INITIATE_TXN: 'INITIATE_TXN',
  POST_CART: 'POST_CART'
};
_constant.HELPER_TYPE = {
  CVV_HELPER: 'CVV_HELPER',
  SUBS_DETAILS_HELPER: 'SUBS_DETAILS_HELPER'
};

// QR
_constant.QR = {
  WS: '/websocket/',
  QR_HOST: "wss://securegw.paytm.in:443"
};

// emi type constants
_constant.EMI_STANDARD = 'STANDARD';
_constant.EMI_SUBVENTION = 'SUBVENTION';

_constant.NOTIFY_MERCHANT_EVENTS = {
  SESSION_EXPIRED: 'SESSION_EXPIRED',
  FETCH_PAYMENT_OPTIONS_ERROR: 'FETCH_PAYMENT_OPTIONS_ERROR',
  HANDLER_ERROR: 'HANDLER_ERROR',
  FETCH_EMI_BANK_LIST_ERROR: 'FETCH_EMI_BANK_LIST_ERROR',
  PAYMENT_ERROR: 'PAYMENT_ERROR',
  APP_CLOSED: 'APP_CLOSED'
};
_constant.SUBS_TYPE = {
  VARIABLE: 'VARIABLE'
};

_constant.BANK_MANDATE_PAY_TYPE = 'bm';
_constant.SAVED_BANK_MANDATE_PAY_TYPE = 'sbm';

/** ********** Bank account constraints ********* */
_constant.ACCOUNT_NAME_MAX_LENGTH = 50;
_constant.ACCOUNT_NUMBER_MAX_LENGTH = 19;
_constant.ACCOUNT_IFSC_LENGTH = 11;
_constant.ACCOUNT_NAME_MIN_LENGTH = 3;
_constant.ACCOUNT_NUMBER_MIN_LENGTH = 9;

/** ********** Bank Mandate Authenticate Modes ************ */
_constant.MANDATE_AUTH_MODES = { NET_BANKING: 'Net Banking', DEBIT_CARD: 'Debit Card' };
_constant.NB_AUTH_MODE = 'NET_BANKING';

var CACHE = {
  MERCHANT_CONFIG: 'merchantConfig',
  API: 'api',
  STORE: 'store',
  PAYMENT_OPTIONS: 'paymentOptions',
  EMI_BANK_LIST: 'emiBankList',
  TOKEN_DATA: 'tokenData',
  GUEST_TOKEN: 'guestToken',
  FALLBACK_TOKEN_DATA: 'fallbackTokenData',
  PLAN_DETAILS: 'planDetails',
  PAYMENT_INTENT: 'paymentIntent',
  EMI_PLANS: 'emiPlans',
  SELECTEDBANK: 'selectedBank',
  CARD_DETAILS: 'cardDetails',
  ORDER_ID: 'orderId',
  RAW_INSTRUMENTS: 'rawPayData',
  DEFERRED_POPUP_DATA: 'deferredPopupData',
  CONVENIENCE_CHARGES: 'convenienceCharges',
  CLOSE_HANDLER: 'closeHandler',
  BANK_OFFERS: 'bankOffers',
  ALL_BANK_OFFERS: 'allBankOffers',
  MID: 'mid',
  ACCESS_TOKEN: 'accessToken',
  RETRY_DATA: 'RETRY_DATA',
  PAYMENT_OFFERS: 'PAYMENT_OFFERS',
  GLOBAL_STORE_UNSUBSCRIPTION: 'GLOBAL_STORE_UNSUBSCRIPTION',
  CHECKOUT_ELEMENT_PAYMODE: 'CHECKOUT_ELEMENT_PAYMODE'
};

var EVENTS = {
  DEFERRED_FLOW_INITIALIZED: 'DEFERRED_FLOW_INITIALIZED',
  SC_EMI_FETCH_PLANS: 'SC_EMI_FETCH_PLANS',
  SC_EMI_FETCH_PLANS_ERROR: 'SC_EMI_FETCH_PLANS_ERROR',
  EMI_FETCH_BANK: 'EMI_FETCH_BANK',
  EMI_FETCH_BANK_ERROR: 'EMI_FETCH_BANK_ERROR',
  EMI_FETCH_PLANS: 'EMI_FETCH_PLANS',
  EMI_FETCH_PLANS_ERROR: 'EMI_FETCH_PLANS_ERROR',
  EMI_APPLY_PLAN: 'EMI_APPLY_PLAN',
  EMI_APPLY_PLAN_ERROR: 'EMI_APPLY_PLAN_ERROR',
  SC_EMI_APPLY_PLAN: 'SC_EMI_APPLY_PLAN',
  SC_EMI_APPLY_PLAN_ERROR: 'SC_EMI_APPLY_PLAN_ERROR',
  DEFERRED_INITIATE_TXN: 'DEFERRED_INITIATE_TXN',
  DEFERRED_INITIATE_TXN_ERROR: 'DEFERRED_INITIATE_TXN_ERROR',
  ACCESS_TOKEN_FLOW_INITIALISED: 'ACCESS_TOKEN_FLOW_INITIALISED',
  ACCESS_TOKEN_INITIATE_TXN: 'ACCESS_TOKEN_INITIATE_TXN'
};

var RESPONSE_STATUS = {
  SUCCESS: 'SUCCESS',
  PROCESSING: 'PROCESSING',
  TXN_SUCCESS: 'TXN_SUCCESS',
  FAIL: 'FAIL',
  REDIRECT: 'REDIRECT',
  F: 'F',
  S: 'S'
};

var RESPONSE_STATUS_CODE = {
  SUCCESS: 200
};

var UPI_INTENT_MWEB = {
  UPI_INTENT: 'UPI_INTENT',
  UPI_INTENT_MWEB: 'UPI_INTENT_MWEB',
  VISIBILITY_HIDDEN_VALUE: 'VISIBILITY_HIDDEN_VALUE',
  IS_UPI_INTENT_MWEB_ENABLED: 'IS_UPI_INTENT_MWEB_ENABLED'
};

var GLOBAL_STORE = {
  FPO_UPDATED_RESPONSE: 'FPO_UPDATED_RESPONSE'
};

/* harmony default export */ __webpack_exports__["g"] = (_constant);

/***/ }),

/***/ "lRnM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return set; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_src_constant__ = __webpack_require__("TwIz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_src_utils_common__ = __webpack_require__("y11t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_i18n__ = __webpack_require__("LnyB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_constants__ = __webpack_require__("hafV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logger__ = __webpack_require__("lq6S");






/**
 * Recursive merger helper function
 * @param {Object} current - existing object
 * @param {Object} newObject - new object
 */

var recursiveMerge = function recursiveMerge(current, newObject) {
  if (Object.keys(current).length === 0) {
    return newObject;
  }
  for (var prop in current) {
    if (Object.prototype.hasOwnProperty.call(current, prop)) {
      // key exists in source object
      if (Object.prototype.hasOwnProperty.call(newObject, prop)) {
        // key exists in target object
        if (current[prop] && current[prop].constructor === Object) {
          newObject[prop] = recursiveMerge(current[prop], newObject[prop]);
        }
      } else {
        // key not exists in target object
        // eslint-disable-next-line no-lonely-if
        if (current[prop] && current[prop].constructor === Object) {
          newObject[prop] = {};
          newObject[prop] = recursiveMerge(current[prop], newObject[prop]);
        } else {
          newObject[prop] = current[prop];
        }
      }
    }
  }
  return newObject;
};

/**
 * A private method to merge new Object with existing
 *
 * @param {Object} current - existing Object
 * @param {Object} newObject - new new Object
 * @returns {Object} - final merged object
 */
var mergeObject = function mergeObject() {
  var current = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var newObject = arguments[1];
  return recursiveMerge(current, newObject);
};

var errorMessages = {
  merchant: {
    obj: 'merchant object is mandatory field in configuration',
    mid: 'merchant id is mandatory field in merchant object of configuration',
    webviewConsent: 'multipleWindowWebview key should be of boolean type',
    type: 'merchant id should be of string type',
    notifyMerchantCallbackMandatory: 'notifyMerchant function handler is mandatory in handler object',
    notifyMerchantCallbackFunction: 'notifyMerchant should be of function type',
    transactionStatus: 'transactionStatus needs to be implemented if redirect flag set to false in merchant object'
  },
  data: {
    obj: 'data object is mandatory field in configuration',
    token: 'if token is present then tokenType key should be there',
    tokenType: 'token type should be one of the following only , ',
    amount: 'amount should be present on data object',
    orderId: 'order id should be present on data object',
    mandatoryToken: 'Token is mandatory'
  },
  flow: {
    deferredHandler: 'For ' + __WEBPACK_IMPORTED_MODULE_0__common_src_constant__["h" /* FLOW */].DEFERRED + ' flow deferred function is mandatory in handler object',
    tokenType: 'For ' + __WEBPACK_IMPORTED_MODULE_0__common_src_constant__["h" /* FLOW */].DEFERRED + ' flow tokenType should be ' + __WEBPACK_IMPORTED_MODULE_0__common_src_constant__["n" /* TOKEN */].SSO + ' only',
    txnTokenType: 'For ' + __WEBPACK_IMPORTED_MODULE_0__common_src_constant__["h" /* FLOW */].DEFAULT + ' flow tokenType should be ' + __WEBPACK_IMPORTED_MODULE_0__common_src_constant__["n" /* TOKEN */].TXN + ' only'
  },
  token: {
    tokenHandler: 'For ' + __WEBPACK_IMPORTED_MODULE_0__common_src_constant__["n" /* TOKEN */].ACCESS + '  Initiate transaction function is mandatory in handler object',
    emiSubventionObject: 'For ' + __WEBPACK_IMPORTED_MODULE_0__common_src_constant__["n" /* TOKEN */].ACCESS + '  emiSubvention key is mandatory in merchant config',
    strategyRequired: 'For emiSubvention object strategy key is required',
    strategyType: 'For emiSubvention strategy should be ' + __WEBPACK_IMPORTED_MODULE_0__common_src_constant__["e" /* EMI_SUBVENTION_STRATEGY */].ITEM_BASED + ' or ' + __WEBPACK_IMPORTED_MODULE_0__common_src_constant__["e" /* EMI_SUBVENTION_STRATEGY */].AMOUNT_BASED + ' only',
    referenceId: 'For Access Token Reference Id is mandatory',
    noAmount: 'For Amount based strategy, subventionAmount key is required',
    noItems: 'For Item based strategy, items object is required',
    itemsKey: 'For Item based strategy, items object  requires either of BrandID, CategoryList, Model or Ean'
  },
  handler: {
    initiateTransaction: 'initiateTransaction method should be implemented if tokenType is ' + __WEBPACK_IMPORTED_MODULE_0__common_src_constant__["n" /* TOKEN */].GUEST
  }
};

var merchantMapClientMessage = function merchantMapClientMessage() {
  var mapping = {}; /* mapping of display text and client side validation error messages */
  mapping[__WEBPACK_IMPORTED_MODULE_3__utils_constants__["g" /* default */].STATIC.toLowerCase()] = {
    label: {
      paymodeSelection: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('static.paymode.select.option'),
      subscriptionSelection: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('static.select.option.to.pay.subscription'),
      paymodeOtherSelection: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('static.paymode.select.other'),
      saveCardSelection: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('static.sc.select')
    },
    error: {}
  };
  mapping[__WEBPACK_IMPORTED_MODULE_3__utils_constants__["g" /* default */].HEADER.toLowerCase()] = {
    label: {
      otpSend: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('header.otp.send'),
      orderID: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('header.order.id'),
      account: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('header.account'),
      switch: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('header.switch'),
      selectOption: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('header.select.option.pay'),
      subscriptionOption: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('header.select.option.to.pay.subscription'),
      viewSubsDetail: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('subscription.viewDetails')
    },
    error: {}
  };

  mapping[__WEBPACK_IMPORTED_MODULE_3__utils_constants__["g" /* default */].FOOTER.toLowerCase()] = {
    label: {
      message: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('footer.message')
    },
    error: {}
  };

  mapping[__WEBPACK_IMPORTED_MODULE_3__utils_constants__["g" /* default */].OFFERS.toLowerCase()] = {
    label: {
      message: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('offers.message')
    },
    error: {}
  };

  mapping[__WEBPACK_IMPORTED_MODULE_3__utils_constants__["g" /* default */].PROCESSING.toLowerCase()] = {
    label: {
      heading: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('processing.heading'),
      info: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('processing.info')
    },
    error: {}
  };

  mapping[__WEBPACK_IMPORTED_MODULE_3__utils_constants__["g" /* default */].RETRY.toLowerCase()] = {
    label: {
      paymentFailed: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('retry.payment.failed'),
      info: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('retry.info')
    },
    error: {}
  };

  mapping[__WEBPACK_IMPORTED_MODULE_0__common_src_constant__["m" /* PAYMODE */].CARD.toLowerCase()] = {
    label: {
      cardNumber: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('card.number'),
      expiry: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('card.expiry'),
      cvv: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('card.cvv'),
      savedCard: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('card.save.card')
    },
    error: {
      invalidCardNumber: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('card.invalid.card.number'),
      invalidExpiry: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('card.invalid.expiry'),
      invalidCvv: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('card.invalid.cvv')
    }
  };

  mapping[__WEBPACK_IMPORTED_MODULE_0__common_src_constant__["m" /* PAYMODE */].PAYMENT_BANK.toLowerCase()] = {
    label: {
      checkBalance: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('ppbl.check.balance'),
      availableBalance: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('ppbl.available.balance'),
      insufficientBalance: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('ppbl.insufficient.balance'),
      enterPasscode: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('ppbl.enterPasscode')
    },
    error: {
      invalidPasscode: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('ppbl.invalid.passcode')
    }
  };

  mapping[__WEBPACK_IMPORTED_MODULE_0__common_src_constant__["m" /* PAYMODE */].POSTPAID.toLowerCase()] = {
    label: {
      checkBalance: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('pdc.check.balance'),
      availableBalance: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('pdc.available.balance'),
      insufficientBalance: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('pdc.insufficient.balance')
    }
  };

  mapping[__WEBPACK_IMPORTED_MODULE_0__common_src_constant__["m" /* PAYMODE */].UPI.toLowerCase()] = {
    label: {
      selectUpi: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('upi.select.upi'),
      upiEnterSuggest: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('upi.handler.suggestion')
    },
    error: {
      required: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('upi.id.required'),
      inValidId: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('upi.invalid.id'),
      subscriptionError: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('upi.subscription.error')
    }
  };

  mapping[__WEBPACK_IMPORTED_MODULE_0__common_src_constant__["m" /* PAYMODE */].COD.toLowerCase()] = {
    label: {}
  };

  mapping[__WEBPACK_IMPORTED_MODULE_0__common_src_constant__["m" /* PAYMODE */].NB.toLowerCase()] = {
    label: {
      secureRedirectionMessage: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('nb.secure.redirection.message')
    }
  };

  mapping[__WEBPACK_IMPORTED_MODULE_0__common_src_constant__["m" /* PAYMODE */].WALLET.toLowerCase()] = {
    label: {
      insufficientBalance: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('wallet.insufficient.balance')
    }
  };

  mapping[__WEBPACK_IMPORTED_MODULE_0__common_src_constant__["m" /* PAYMODE */].GIFT_VOUCHER.toLowerCase()] = {
    label: {
      insufficientBalance: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('mgv.insufficient.balance')
    }
  };

  mapping[__WEBPACK_IMPORTED_MODULE_3__utils_constants__["g" /* default */].LOGIN.toLowerCase()] = {
    label: {
      labelMessage: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('login.message'),
      otpSentNumberMessage: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('login.otp.sent.number'),
      requestOtp: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('login.request.otp'),
      otpNotreceived: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('login.otp.not.received'),
      rememberMe: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('login.rememberMe'),
      btnSendOtpText: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('login.btn.sendOtp.text'),
      btnVerifyOtpText: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('login.btn.verifyOtp.text'),
      subscriptionMsg: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('login.subscription.msg'),
      mobileNumber: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('login.mobile.number'),
      changeNumber: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('login.change.number')
    },
    error: {
      invalidOtpLength: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('login.invalid.otp.length'),
      invalidMobileInput: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('login.invalid.mobile.input')
    }
  };
  mapping[__WEBPACK_IMPORTED_MODULE_3__utils_constants__["g" /* default */].EMI.toLowerCase()] = {
    label: {
      interest: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('emi.interest'),
      emiConvert: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('emi.emiConvert'),
      cashback: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('emi.cashback'),
      kycText: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('emi.kycText'),
      emiHybridDisabledText: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('emi.emiHybridDisabledText'),
      emiHybridDisabledCardText: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('emi.emiHybridDisabledCardText')
    },
    error: {
      errorBtn: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('emiErrors.errorBtn'),
      emiBankListErrorHeading: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('emiErrors.emiBankListErrorHeading'),
      emiBankListErrorSubtext: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('emiErrors.emiBankListErrorSubtext'),
      emiPlanError: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('emiErrors.emiPlanError'),
      emiPlanSubtext: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('emiErrors.emiPlanSubtext'),
      emiPlanSelectError: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('emiErrors.emiPlanSelectError'),
      emiNotAvailable: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('emiErrors.emiNotAvailable')
    }
  };
  mapping[__WEBPACK_IMPORTED_MODULE_3__utils_constants__["g" /* default */].SUBSCRIPTION.toLowerCase()] = {
    label: {
      savedCard: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('subscription.savedCard'),
      details: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('subscription.details'),
      upto: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('subscription.upto'),
      maybe: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('subscription.may.be.deducted'),
      sharedBy: Object(__WEBPACK_IMPORTED_MODULE_2__utils_i18n__["a" /* locale */])('subscription.merchant.shared'),
      renewMessage: ''
    },
    error: {}
  };
  return mapping;
};

var mapStyle = function mapStyle() {
  return (
    // merchant customization of style
    {
      borderColor: '' /* border and input border and box color */
      , bodyBackgroundColor: '' /* background body color */
      , bodyColor: '' /* body color */
      , themeBackgroundColor: '' /* background color to be applied on pay button, checkbox, radio */
      , themeColor: '' /* text color to be applied across checkout payment page */
      , headerBackgroundColor: '' /* header background color */
      , headerColor: '' /* header text color */
      , errorColor: '' /* client side validation error message color */
      , successColor: '' /* client side validation success message color */
      , infoColor: '' /* client side validation info message color */
      , infoBackgroundColor: '' /* client side validation info message background color */
      , gradient: '' /* gradient object */
    }
  );
};

var mapPayMode = function mapPayMode() {
  var mapping = {
    labels: {},
    filter: {
      include: [], // paymode to include in final render on user browser
      exclude: [__WEBPACK_IMPORTED_MODULE_0__common_src_constant__["m" /* PAYMODE */].EMI, __WEBPACK_IMPORTED_MODULE_0__common_src_constant__["m" /* PAYMODE */].PAYMENT_BANK] // paymode to remove from final render on user browser
    },
    order: [__WEBPACK_IMPORTED_MODULE_0__common_src_constant__["m" /* PAYMODE */].NB, __WEBPACK_IMPORTED_MODULE_0__common_src_constant__["m" /* PAYMODE */].CARD] // Ordering of paymodes as per merchant preference
  };

  // map paymode name as per merchant preferences
  mapping.labels[__WEBPACK_IMPORTED_MODULE_0__common_src_constant__["m" /* PAYMODE */].NB] = 'Net Banking';
  mapping.labels[__WEBPACK_IMPORTED_MODULE_0__common_src_constant__["m" /* PAYMODE */].CARD] = 'Some new Card';
  return mapping;
};

var mapLabels = function mapLabels() {
  return (
    /* Textual changes for component text - button text , */
    {
      pay: ''
    }
  );
};
var mapMerchantProperties = function mapMerchantProperties() {
  return {
    /* merchant name and logo configuration */
    mid: '' /* merchant id */
    , name: '',
    logo: '',
    redirect: true /* when set user will redirect to callback url pass by merchant */
    , callbackUrl: '' /* callback url for */
    , hidePaytmBranding: false /* hide paytm branding - footer and header related to paytm */
    , multipleWindowWebview: false /* consent for multiple windows/tabs opening in web view */
  };
};

var mapHandler = function mapHandler() {
  return {};
};

var _config = {
  root: '' /* querySelector to fetch using id or class name | DOM HTML node instance */
  , style: mapStyle(),
  flow: __WEBPACK_IMPORTED_MODULE_0__common_src_constant__["h" /* FLOW */].DEFAULT /* Type of flow to invoke checkout - DEFAULT,DEFERRED */
  , data: {
    /* mandatory field provided by the merchant if these changes not provide then error thrown to merchant */
    orderId: '' /* order id */
    , token: '' /* token for using API */
    , tokenType: __WEBPACK_IMPORTED_MODULE_0__common_src_constant__["n" /* TOKEN */].GUEST /* token type */
    , amount: '' /* transaction amount as string or number */
    , userDetail: {
      mobileNumber: '',
      name: ''
    }
  },
  merchant: mapMerchantProperties(),
  mapClientMessage: merchantMapClientMessage(),
  labels: mapLabels(),
  expireDuration: 3600000 /* window popup close after time duration expired */
  , payMode: mapPayMode(),
  handler: mapHandler(),
  hidePaymodeLabel: true,
  isGradientEffectEnable: false
};

var validations = {
  handler: function handlerValidations(config) {
    // handler callback related validations
    var output = {
      hasError: false,
      message: ''
    };

    // notifyMerchant is mandatory callback needs to implemented. It's used when payment page session expire occur
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__common_src_utils_common__["d" /* has */])(config.handler, 'notifyMerchant')) {
      output.hasError = true;
      output.message = errorMessages.merchant.notifyMerchantCallbackMandatory;
      return output;
    }

    // notifyMerchant should be of function type
    if (config.handler.notifyMerchant.constructor !== Function) {
      output.hasError = true;
      output.message = errorMessages.merchant.notifyMerchantCallbackFunction;
      return output;
    }

    var notifyMerchantFn = config.handler.notifyMerchant;
    config.handler.notifyMerchant = function (eventName, data) {
      Object(__WEBPACK_IMPORTED_MODULE_4__logger__["log"])({ eventType: __WEBPACK_IMPORTED_MODULE_3__utils_constants__["g" /* default */].NOTIFY_MERCHANT, eventName: eventName, data: data });
      notifyMerchantFn(eventName, data);
    };
    return output;
  },
  merchant: function merchantValidations(config) {
    // merchant related validations
    var output = {
      hasError: false,
      message: ''
    };

    // merchant object is not present
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__common_src_utils_common__["d" /* has */])(config, 'merchant')) {
      output.hasError = true;
      output.message = errorMessages.merchant.obj;
      return output;
    }

    // mid is not present
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__common_src_utils_common__["d" /* has */])(config.merchant, 'mid')) {
      output.hasError = true;
      output.message = errorMessages.merchant.mid;
      return output;
    }

    // multipleWindowWebview key should be of boolean type
    if (typeof config.merchant.multipleWindowWebview !== 'boolean') {
      output.hasError = true;
      output.message = errorMessages.merchant.webviewConsent;
      return output;
    }

    // mid should be of string type
    if (Object(__WEBPACK_IMPORTED_MODULE_1__common_src_utils_common__["g" /* isNull */])(config.merchant.mid) || typeof config.merchant.mid !== 'string') {
      output.hasError = true;
      output.message = errorMessages.merchant.type;
      return output;
    }

    // transactionStatus needs to be implemented if redirect flag set to false in merchant object
    if (config.merchant.redirect === false && !Object(__WEBPACK_IMPORTED_MODULE_1__common_src_utils_common__["d" /* has */])(config.handler, 'transactionStatus')) {
      output.hasError = true;
      output.message = errorMessages.merchant.transactionStatus;
      return output;
    }

    return output;
  },
  data: function dataValidations(config) {
    // transaction data related validations
    var output = {
      hasError: false,
      message: ''
    };

    // data object is not present
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__common_src_utils_common__["d" /* has */])(config, 'data')) {
      output.hasError = true;
      output.message = errorMessages.data.obj;
      return output;
    }

    //  token is mandatory
    if (Object(__WEBPACK_IMPORTED_MODULE_1__common_src_utils_common__["d" /* has */])(config.data, 'token') && !config.data.token) {
      output.hasError = true;
      output.message = errorMessages.data.mandatoryToken;
      return output;
    }

    // if token is present then tokenType should be present
    if (Object(__WEBPACK_IMPORTED_MODULE_1__common_src_utils_common__["d" /* has */])(config.data, 'token') && !Object(__WEBPACK_IMPORTED_MODULE_1__common_src_utils_common__["d" /* has */])(config.data, 'tokenType')) {
      output.hasError = true;
      output.message = errorMessages.data.token;
      return output;
    }

    // transaction amount is mandatory field in default flow , in deferred flow amount is used from cart api response
    if (config.flow === __WEBPACK_IMPORTED_MODULE_0__common_src_constant__["h" /* FLOW */].DEFAULT && !config.data.amount) {
      output.hasError = true;
      output.message = errorMessages.data.amount;
      return output;
    }

    // order id is mandatory field
    if (!config.data.orderId && config.data.tokenType && config.data.tokenType === __WEBPACK_IMPORTED_MODULE_0__common_src_constant__["n" /* TOKEN */].TXN) {
      output.hasError = true;
      output.message = errorMessages.data.orderId;
      return output;
    }

    return output;
  },
  flow: function flowValidations(config) {
    // flow related validations
    var output = {
      hasError: false,
      message: ''
    };

    // if flow is DEFERRED then deferred callback is mandatory in handler
    if (config.flow === __WEBPACK_IMPORTED_MODULE_0__common_src_constant__["h" /* FLOW */].DEFERRED && !Object(__WEBPACK_IMPORTED_MODULE_1__common_src_utils_common__["d" /* has */])(config.handler, 'deferred')) {
      output.hasError = true;
      output.message = errorMessages.flow.deferredHandler;
      return output;
    }

    // if flow is DEFAULT then tokenType should of TXN_TOKEN
    if (config.flow === __WEBPACK_IMPORTED_MODULE_0__common_src_constant__["h" /* FLOW */].DEFAULT && (!Object(__WEBPACK_IMPORTED_MODULE_1__common_src_utils_common__["d" /* has */])(config.data, 'tokenType') || !Object(__WEBPACK_IMPORTED_MODULE_1__common_src_utils_common__["d" /* has */])(config.data, 'token') || config.data.tokenType !== __WEBPACK_IMPORTED_MODULE_0__common_src_constant__["n" /* TOKEN */].TXN && config.data.tokenType !== __WEBPACK_IMPORTED_MODULE_0__common_src_constant__["n" /* TOKEN */].ACCESS)) {
      output.hasError = true;
      output.message = errorMessages.flow.txnTokenType;
      return output;
    }

    // if flow is DEFERRED then tokenType should of SSO and token is always present
    if (config.flow === __WEBPACK_IMPORTED_MODULE_0__common_src_constant__["h" /* FLOW */].DEFERRED && (!Object(__WEBPACK_IMPORTED_MODULE_1__common_src_utils_common__["d" /* has */])(config.data, 'tokenType') || !Object(__WEBPACK_IMPORTED_MODULE_1__common_src_utils_common__["d" /* has */])(config.data, 'token') || config.data.tokenType !== __WEBPACK_IMPORTED_MODULE_0__common_src_constant__["n" /* TOKEN */].SSO)) {
      output.hasError = true;
      output.message = errorMessages.flow.tokenType;
      return output;
    }
    return output;
  },
  token: function tokenValidation(config) {
    // token related validations
    var output = {
      hasError: false,
      message: ''
    };
    var accessTokenExists = Object(__WEBPACK_IMPORTED_MODULE_1__common_src_utils_common__["d" /* has */])(config.data, 'tokenType') && config.data.tokenType === __WEBPACK_IMPORTED_MODULE_0__common_src_constant__["n" /* TOKEN */].ACCESS;

    // if token type is access token ,initiate transaction handler is required
    if (accessTokenExists && !Object(__WEBPACK_IMPORTED_MODULE_1__common_src_utils_common__["d" /* has */])(config.handler, 'initiateTransaction')) {
      output.hasError = true;
      output.message = errorMessages.token.tokenHandler;
      return output;
    }

    // if token type is access token but no emiSubvention object is present throw error
    if (accessTokenExists && !Object(__WEBPACK_IMPORTED_MODULE_1__common_src_utils_common__["d" /* has */])(config, 'emiSubvention')) {
      output.hasError = true;
      output.message = errorMessages.token.emiSubventionObject;
      return output;
    }

    // if referenceId key is not present in emiSubvention Object return error
    if (accessTokenExists && !Object(__WEBPACK_IMPORTED_MODULE_1__common_src_utils_common__["d" /* has */])(config.emiSubvention, 'referenceId')) {
      output.hasError = true;
      output.message = errorMessages.token.referenceId;
      return output;
    }

    // if strategy key is not present in emiSubvention Object return error
    if (accessTokenExists && !Object(__WEBPACK_IMPORTED_MODULE_1__common_src_utils_common__["d" /* has */])(config.emiSubvention, 'strategy')) {
      output.hasError = true;
      output.message = errorMessages.token.strategyRequired;
      return output;
    }
    var strategy = config && config.emiSubvention && config.emiSubvention.strategy;
    // if strategy is not item or amount based return error
    if (accessTokenExists && strategy !== __WEBPACK_IMPORTED_MODULE_0__common_src_constant__["e" /* EMI_SUBVENTION_STRATEGY */].AMOUNT_BASED && strategy !== __WEBPACK_IMPORTED_MODULE_0__common_src_constant__["e" /* EMI_SUBVENTION_STRATEGY */].ITEM_BASED) {
      output.hasError = true;
      output.message = errorMessages.token.strategyType;
      return output;
    }

    var amountKeyExists = config && config.emiSubvention && Object(__WEBPACK_IMPORTED_MODULE_1__common_src_utils_common__["d" /* has */])(config.emiSubvention, 'subventionAmount') || false;
    if (accessTokenExists && strategy === __WEBPACK_IMPORTED_MODULE_0__common_src_constant__["e" /* EMI_SUBVENTION_STRATEGY */].AMOUNT_BASED && !amountKeyExists) {
      output.hasError = true;
      output.message = errorMessages.token.noAmount;
      return output;
    }

    var items = config && config.emiSubvention && config.emiSubvention.items || [];
    if (accessTokenExists && strategy === __WEBPACK_IMPORTED_MODULE_0__common_src_constant__["e" /* EMI_SUBVENTION_STRATEGY */].ITEM_BASED && !items.length) {
      output.hasError = true;
      output.message = errorMessages.token.noItems;
      return output;
    }
    if (accessTokenExists && strategy === __WEBPACK_IMPORTED_MODULE_0__common_src_constant__["e" /* EMI_SUBVENTION_STRATEGY */].ITEM_BASED && items.length) {
      /* object values is not supported on old browsers so changing that to object.keys */
      Object.keys(items).forEach(function (key) {
        var item = items[key];
        if (!(item[__WEBPACK_IMPORTED_MODULE_0__common_src_constant__["d" /* EMI_SUBVENTION_ITEM_KEYS */].BRAND_ID] || item[__WEBPACK_IMPORTED_MODULE_0__common_src_constant__["d" /* EMI_SUBVENTION_ITEM_KEYS */].CATEGORY_LIST] || item[__WEBPACK_IMPORTED_MODULE_0__common_src_constant__["d" /* EMI_SUBVENTION_ITEM_KEYS */].MODEL] || item[__WEBPACK_IMPORTED_MODULE_0__common_src_constant__["d" /* EMI_SUBVENTION_ITEM_KEYS */].EAN])) {
          output.hasError = true;
          output.message = errorMessages.token.itemsKey;
        }
      });

      return output;
    }

    return output;
  }
};

var isValid = function isValid(config) {
  var output = validations.merchant(config);

  if (output.hasError) {
    return output;
  }

  output = validations.handler(config);

  if (output.hasError) {
    return output;
  }

  output = validations.data(config);
  if (output.hasError) {
    return output;
  }
  output = validations.flow(config);
  if (output.hasError) {
    return output;
  }
  output = validations.token(config);
  if (output.hasError) {
    return output;
  }

  return output; // merchant configuration is valid
};

var resetConfig = function resetConfig(c) {
  var config = c;
  config.labels = {};
  config.payMode = {
    labels: {},
    filter: [],
    order: []
  };
  return config;
};
var init = function init() {
  _config = resetConfig(_config); // reset configuration to empty
};

init();
var get = function get() {
  return _config;
};

var set = function set(config) {
  var validate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var c = mergeObject(_config, config);
  if (validate) {
    var valid = isValid(c);
    if (valid.hasError) {
      Object(__WEBPACK_IMPORTED_MODULE_4__logger__["log"])({ eventType: __WEBPACK_IMPORTED_MODULE_4__logger__["EVENT"].MERCHANT_CONFIG_ERROR, config: c, error: valid });
      throw new Error(valid.message);
    }
  }
  _config = c;
  return _config;
};

/***/ }),

/***/ "lq6S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT", function() { return EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return init; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "log", function() { return log; });
var _data = [];
var configuration = null;
var isConfigurationSet = false;

var EVENT = {
  BOC_IFRAME_SUBMIT: 'BOC_IFRAME_SUBMIT',
  BOC_SUBMIT: 'BOC_SUBMIT',
  BOC_EVENT_PAY_SUCCESS: 'BOC_EVENT_PAY_SUCCESS',
  BOC_EVENT_PAY_FAIL: 'BOC_EVENT_PAY_FAIL',
  BOC_EVENT_PAY_ERROR: 'BOC_EVENT_PAY_ERROR',
  BOC_EVENT_CLIENT_VALIDATION: 'BOC_EVENT_CLIENT_VALIDATION',
  BOC_EVENT_SHOW_PROCESSING: 'BOC_EVENT_SHOW_PROCESSING',
  CARD_IFRAME_SUBMIT: 'CARD_IFRAME_SUBMIT',
  CARD_EVENT_PAY_SUCCESS: 'CARD_EVENT_PAY_SUCCESS',
  CARD_EVENT_PAY_FAIL: 'CARD_EVENT_PAY_FAIL',
  CARD_EVENT_CLIENT_VALIDATION: 'CARD_EVENT_CLIENT_VALIDATION',
  CARD_EVENT_SHOW_PROCESSING: 'CARD_EVENT_SHOW_PROCESSING',
  CARD_EVENT_HIDE_PROCESSING: 'CARD_EVENT_HIDE_PROCESSING',
  CARD_EVENT_SESSION_EXPIRED: 'CARD_EVENT_SESSION_EXPIRED',
  CARD_EVENT_CVV_HELPER: 'CARD_EVENT_CVV_HELPER',
  CARD_EVENT_CARD_NOT_SUPPORTED: 'CARD_EVENT_CARD_NOT_SUPPORTED',
  CARD_EVENT_TXN_TOKEN_EXPIRED: 'CARD_EVENT_TXN_TOKEN_EXPIRED',
  CARD_EVENT_CARD_DETAILS: 'CARD_EVENT_CARD_DETAILS',
  CARD_ERROR: 'CARD_ERROR',
  APP_CLOSE: 'APP_CLOSE',
  APP_AUTO_CLOSE: 'APP_AUTO_CLOSE',
  AUTO_LOGIN: 'AUTO_LOGIN',
  BUTTON_CLICK: 'BUTTON_CLICK',
  SELECTED_PAYMODE: 'SELECTED_PAYMODE',
  CLIENT_VALIDATION_INVALID_OTP: 'CLIENT_VALIDATION_INVALID_OTP',
  SC_CVV: 'SC_CVV',
  MERCHANT_CONFIG_ERROR: 'MERCHANT_CONFIG_ERROR',
  INIT: 'INIT',
  INVOKE: 'INVOKE',
  API_INIT: 'API_INIT',
  API_STATUS: 'API_STATUS',
  WALLET_BALANCE_INSUFFICIENT: 'WALLET_BALANCE_INSUFFICIENT',
  MGV_BALANCE_INSUFFICIENT: 'MGV_BALANCE_INSUFFICIENT',
  BALANCE_CHECKED: 'BALANCE_CHECKED',
  COLLECT_FLOW_USED: 'COLLECT_FLOW_USED',
  DISPLAY_UPI_HANDLER_SUGGESTION: 'DISPLAY_UPI_HANDLER_SUGGESTION',
  UPI_HANDLER_SELECTED: 'UPI_HANDLER_SELECTED',
  NB_BANK_SELECTED: 'NB_BANK_SELECTED',
  NB_SEARCH_BAR_USED: 'NB_SEARCH_BAR_USED',
  SC_SUBMIT_DETAILS: 'SC_SUBMIT_DETAILS',
  TXN_STATUS_HANDLED: 'TXN_STATUS_HANDLED',
  PAYMENT_RETRY_AVAILABLE: 'PAYMENT_RETRY_AVAILABLE',
  PAYMODE_SELECTED: 'PAYMODE_SELECTED',
  MANUAL_LOGIN: 'MANUAL_LOGIN',
  LOGIN_SUCCESSFUL: 'LOGIN_SUCCESSFUL',
  IS_INTENT_SUPPORTED: 'IS_INTENT_SUPPORTED',
  CALL_UPI_POLL_INTENT: 'CALL_UPI_POLL_INTENT',
  POLLING_STATUS_CALL: 'POLLING_STATUS_CALL',
  INTENT_SET_TIMEOUT: 'INTENT_SET_TIMEOUT',
  APP_SWITCH: 'APP_SWITCH',
  UPI_INTENT_ACTIVE: 'UPI_INTENT_ACTIVE',
  INTENT_PAY_SUBMIT: 'INTENT_PAY_SUBMIT',
  INTENT_DEEPLINK_INVOKED: 'INTENT_DEEPLINK_INVOKED',
  POLLING_ERROR: 'POLLING_ERROR',
  LOGIN_FPO_RESPONSE: 'LOGIN_FPO_RESPONSE',
  LOGIN_FPO_RESPONSE_ERROR: 'LOGIN_FPO_RESPONSE_ERROR',
  BOC_GET_TXN_TOKEN_PAYLOAD: 'BOC_GET_TXN_TOKEN_PAYLOAD',
  POPUP_WINDOW: 'POPUP_WINDOW',
  DBANK_FEEDBAK_REDIRECT: 'DBANK_FEEDBAK_REDIRECT',
  DBANK_PAGE_EXPIRE: 'DBANK_PAGE_EXPIRE',
  DBANK_PAYON_BANK: 'DBANK_PAYON_BANK',
  DBANK_SUBMIT_PRESSED: 'DBANK_SUBMIT_PRESSED',
  DBANK_CANCEL: 'DBANK_CANCEL',
  DBANK_REDIRECT_INACTIVE: 'DBANK_REDIRECT_INACTIVE',
  DBANK_REDIRECT_OTP_EXPIRED: 'DBANK_REDIRECT_OTP_EXPIRED',
  DBANK_SUBMIT_FAILED: 'DBANK_SUBMIT_FAILED',
  DBANK_SUBMIT_FAILED_BANKRETRY: 'DBANK_SUBMIT_FAILED_BANKRETRY',
  DBANK_SUBMIT_FAILED_REDIRECT: 'DBANK_SUBMIT_FAILED_REDIRECT',
  DBANK_SUBMIT_SUCESS: 'DBANK_SUBMIT_SUCESS',
  DBANK_RESEND_FAILED: 'DBANK_RESEND_FAILED',
  DBANK_RESEND_SUCESS: 'DBANK_RESEND_SUCESS',
  DBANK_RESEND_EXHAUSTED: 'DBANK_RESEND_EXHAUSTED',
  DBANK_CANCEL_NOBUY: 'DBANK_CANCEL_NOBUY',
  DBANK_CANCEL_OTPISSUE: 'DBANK_CANCEL_OTPISSUE',
  DBANK_CANCEL_NOMOBILEACCESS: 'DBANK_CANCEL_NOMOBILEACCESS',
  DBANK_SHOW_PAGE_EXPIRY: 'DBANK_SHOW_PAGE_EXPIRY',
  DBANK_FEEDBACK_OVERLAY: 'DBANK_FEEDBACK_OVERLAY',
  DBANK_FEEDBACK_CLOSE: 'DBANK_FEEDBACK_CLOSE',
  DBANK_UNLOAD: 'DBANK_UNLOAD',
  DBANK_FORM_POST: 'DBANK_FORM_POST',
  RESEND_OTP_CLICK: 'RESEND_OTP_CLICK',
  JOIN_ROOM: 'JOIN_ROOM',
  QR_STATUS: 'QR_STATUS',
  QR_PROCESSING: 'QR_PROCESSING',
  QR_SUCCESS: 'QR_SUCCESS',
  QR_FAIL: 'QR_FAIL',
  PRN_FLOW: 'PRN_FLOW',
  QR_ERROR: 'QR_ERROR',
  QR_SESSION_TIMEOUT: 'QR_SESSION_TIMEOUT',
  WS_CREATE: 'WS_CREATE',
  WS_DISCONNECT: 'WS_DISCONNECT',
  WS_INIT_ERROR: 'WS_INIT_ERROR',
  PRN_VALIDATE_API: 'PRN_VALIDATE_API',
  SUBSCRIPTION_FLOW: 'SUBSCRIPTION_FLOW',
  PRE_PTC_API_CALL_LOG: 'PRE_PTC_API_CALL_LOG',
  REQUEST_ANOTHER_OTP: 'REQUEST_ANOTHER_OTP',
  CHANGE_MOBILE_NUMBER: 'CHANGE_MOBILE_NUMBER',
  REMEMBER_ME: 'REMEMBER_ME',
  UPI_INTENT_HELPER: 'UPI_INTENT_HELPER',
  MOBILE_NUMBER_FOCUS: 'MOBILE_NUMBER_FOCUS',
  MOBILE_NUMBER_FOCUS_ERROR: 'MOBILE_NUMBER_FOCUS_ERROR',
  OTP_FOCUS: 'OTP_FOCUS',
  OTP_FOCUS_ERROR: 'OTP_FOCUS_ERROR',
  UPI_FOCUS: 'OTP_FOCUS',
  UPI_FOCUS_ERROR: 'OTP_FOCUS_ERROR',
  BM_BANK_SELECT: 'BM_BANK_SELECT',
  BM_SELECT_OTHER_BANKS_CLICK: 'BM_SELECT_OTHER_BANKS_CLICK',
  BM_CHANGE_BANK_CLICK: 'BM_CHANGE_BANK_CLICK',
  BM_FIND_IFSC_CLICK: 'BM_FIND_IFSC_CLICK',
  INPUT_ELE_CLICKED: 'INPUT_ELE_CLICKED',
  API_FAILED: 'API_FAILED',
  UPI_INTENT_RETRY: 'UPI_INTENT_RETRY',
  EXCEPTION: 'EXCEPTION',
  LAST_USED_PAYMODE: 'LAST_USED_PAYMODE',
  PERSISTED_ARRAY: 'PERSISTED_ARRAY',
  SAVING_CURRENT_PAYMODE: 'SAVING_CURRENT_PAYMODE',
  INVALID_VPA_ERROR: 'INVALID_VPA_ERROR'
};

var init = function init(options) {
  if (window.Logger && window.Logger.init) {
    isConfigurationSet = true;
    window.Logger.init(options);
  } else {
    configuration = options;
  }
};

var log = function log(data) {
  if (window.Logger && window.Logger.log) {
    if (!isConfigurationSet && configuration) {
      isConfigurationSet = true;
      window.Logger.init && window.Logger.init(configuration);
    }
    if (_data.length > 0) {
      _data.forEach(function (record) {
        try {
          window.Logger.log(record);
        } catch (e) {}
      });
      _data = [];
    }
    window.Logger.log(data);
  } else {
    _data.push(data);
  }
};

/***/ }),

/***/ "ocZ9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compareObjects */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return isInsufficientBalance; });
/* unused harmony export applyMerchantPref */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return isAddNPay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return isHybridOrAddNPay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return isHybridOrAddNPayWithSufficientWalletBalance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return isMgvSufficient; });
/* harmony export (immutable) */ __webpack_exports__["j"] = equalsIgnoreCase;
/* harmony export (immutable) */ __webpack_exports__["G"] = isObject;
/* harmony export (immutable) */ __webpack_exports__["x"] = isArray;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return money; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return setUpiIntentMwebDisplay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return isMobileDevice; });
/* unused harmony export parseCheckoutElementPayMode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return parseData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return commas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return isNullOrUndefined; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return callOnce; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getEncodedQs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return staticPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return paymentFlow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return defaultSelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return clientMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyMerchPref; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return loggedInChanged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return calculateAmountPayable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return updateSlideIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return touchStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return touchEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return handleSwipeCtrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return errorObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return handleSaveCardOnSubscription; });
/* harmony export (immutable) */ __webpack_exports__["P"] = pick;
/* harmony export (immutable) */ __webpack_exports__["H"] = isString;
/* harmony export (immutable) */ __webpack_exports__["y"] = isFunction;
/* harmony export (immutable) */ __webpack_exports__["l"] = find;
/* unused harmony export objectValues */
/* harmony export (immutable) */ __webpack_exports__["b"] = areObjectValuesShallowNotEqual;
/* harmony export (immutable) */ __webpack_exports__["p"] = getIframeRequestPayload;
/* harmony export (immutable) */ __webpack_exports__["T"] = showPaymentPageUrl;
/* harmony export (immutable) */ __webpack_exports__["J"] = isValidUrl;
/* harmony export (immutable) */ __webpack_exports__["h"] = convertRupeeCharToUnicode;
/* harmony export (immutable) */ __webpack_exports__["Q"] = removeDataForLogging;
/* harmony export (immutable) */ __webpack_exports__["m"] = findIndex;
/* harmony export (immutable) */ __webpack_exports__["n"] = generateUUID;
/* harmony export (immutable) */ __webpack_exports__["f"] = cloneObject;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return notifyMerchant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getStaticPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return iframePath; });
/* harmony export (immutable) */ __webpack_exports__["Y"] = updatePayloadForTenureEMI;
/* harmony export (immutable) */ __webpack_exports__["Z"] = updatePayloadForValidateEMI;
/* harmony export (immutable) */ __webpack_exports__["X"] = updatePayloadBasedOnStrategy;
/* unused harmony export shallowEqual */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return isIphoneDevice; });
/* harmony export (immutable) */ __webpack_exports__["R"] = scrollInContentWrap;
/* unused harmony export deviceHeightLessThan640 */
/* unused harmony export scrollWithTimeout */
/* unused harmony export savedCardWithCVV */
/* unused harmony export scrollToSelectedOption */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getZeroSubscriptionText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return isUrlAbsolute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_src_utils_common__ = __webpack_require__("y11t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_src_constant__ = __webpack_require__("TwIz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("hafV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__error_codes__ = __webpack_require__("gKfx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_merchant_config__ = __webpack_require__("lRnM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_logger__ = __webpack_require__("lq6S");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var _isNullOrUndefined = function _isNullOrUndefined(val) {
  return val === undefined || val === null;
};
var _isInt = function _isInt(n) {
  return n % 1 === 0;
};

var typeMap = {
  DEBIT_CARD: 'card',
  CREDIT_CARD: 'card',
  NET_BANKING: 'nb',
  PPBL: 'ppbl',
  EMI: 'emi',
  UPI: 'upi',
  COD: 'cod',
  PAYTM_DIGITAL_CREDIT: 'pdc',
  SAVED_CARDS: 'savedCards',
  SAVED_VPAS: 'savedVPAs',
  ADVANCE_DEPOSIT_ACCOUNT: 'ada'
};

/**
 * Compares two inputs for equality
 *
 * @param {*} x - original object to be compared
 * @param {*} y - new object to compare with
 * @returns {Boolean} - returns true if both inputs are same else return false
 */
var compareObjects = function compareObjects(x, y) {
  if (x === y) return true;
  if (!(x instanceof Object) || !(y instanceof Object)) return false;
  if (typeof x === 'function' && typeof y === 'function' || x instanceof Date && y instanceof Date || x instanceof RegExp && y instanceof RegExp || x instanceof String && y instanceof String || x instanceof Number && y instanceof Number) {
    return x.toString() === y.toString();
  }
  for (var p in x) {
    /* eslint no-continue: "off" */
    if (!Object.prototype.hasOwnProperty.call(x, p)) continue;
    if (!Object.prototype.hasOwnProperty.call(y, p)) return false;
    if (x[p] === y[p]) continue;
    if (typeof x[p] !== 'object') return false;
    if (!Object.equals(x[p], y[p])) return false;
  }
  for (var _p in y) {
    if (Object.prototype.hasOwnProperty.call(y, _p) && !Object.prototype.hasOwnProperty.call(x, _p)) return false;
  }
  return true;
};

var indexOfObject = function indexOfObject(myArray, key, value) {
  for (var i = 0; i < myArray.length; i += 1) {
    if (myArray[i][key] === value) {
      return { obj: myArray[i], ind: i };
    }
  }
  return -1;
};

/**
 * Get property value from nested object
 *
 * @param {Object} obj - object to perform property lookup
 * @param {String} path - the path at which lookup is performed
 * @param {*} defaultValue (optional) -  default value to be reurned if property not found
 * @returns {*} - returns the property value if found else returns dafaultValue
 */
var getKey = function getKey(obj, path, defaultValue) {
  var result = String.prototype.split.call(path, /[,[\].]+?/).filter(Boolean).reduce(function (res, key) {
    return !Object(__WEBPACK_IMPORTED_MODULE_0__common_src_utils_common__["g" /* isNull */])(res) ? res[key] : res;
  }, obj);
  return Object(__WEBPACK_IMPORTED_MODULE_0__common_src_utils_common__["g" /* isNull */])(result) || result === obj ? defaultValue : result;
};

var isInsufficientBalance = function isInsufficientBalance(paymentOptions, cache) {
  if (paymentOptions) {
    var txnAmount = cache.getData(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].TXN_AMOUNT);

    if (getKey(paymentOptions, 'subscriptionDetail.isEnabled', false) && txnAmount === '0') {
      txnAmount = __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].SUBS_PAYMODE_MIN_AMOUNT;
    }
    if (paymentOptions.wallet) {
      if (parseFloat(paymentOptions.wallet.walletBalance) >= parseFloat(txnAmount)) {
        return false;
      }
    }
  }
  return true;
};

var applyMerchantPref = function applyMerchantPref(paymodes, mConfig) {
  var order = getKey(mConfig, 'payMode.order');
  var checkExclude = getKey(mConfig, 'payMode.filter.exclude', []);
  var finalPaymodes = [];
  var labels = getKey(mConfig, 'payMode.labels');
  finalPaymodes = paymodes.filter(function (item) {
    if (labels && labels[item.type.toUpperCase()]) {
      item.displayName = labels[item.type.toUpperCase()];
    }
    return !(checkExclude.length > 0 && checkExclude.indexOf(item.type.toUpperCase()) > -1);
  });
  var mappedArray = finalPaymodes;
  if (order) {
    mappedArray = order.map(function (item) {
      var indObj = indexOfObject(finalPaymodes, 'type', item.toLowerCase());
      if (indObj !== -1) {
        var removed = finalPaymodes.splice(indObj.ind, 1);
        return removed.length ? removed[0] : -1;
      }
      return -1;
    }).filter(function (item) {
      return item !== -1;
    });
    mappedArray = mappedArray.concat(finalPaymodes);
  }
  return mappedArray;
};

var isAddNPay = function isAddNPay(payoptions, cache) {
  if (payoptions && payoptions.wallet && payoptions.wallet.isUsed && isInsufficientBalance(payoptions, cache) && payoptions.paymentFlow === __WEBPACK_IMPORTED_MODULE_1__common_src_constant__["l" /* PAYMENT_FLOW */].ADDANDPAY) {
    return true;
  }
  return false;
};

var isHybridOrAddNPay = function isHybridOrAddNPay(paymentOptions, cache) {
  if (paymentOptions && Object.prototype.hasOwnProperty.call(paymentOptions, 'paymentFlow') && paymentOptions.paymentFlow !== __WEBPACK_IMPORTED_MODULE_1__common_src_constant__["l" /* PAYMENT_FLOW */].NONE && getKey(paymentOptions, 'wallet.isUsed', false) && isInsufficientBalance(paymentOptions, cache)) {
    // Add n Pay and Hybrid Flow
    return true;
  }
  // pg only
  return false;
};
var isHybridOrAddNPayWithSufficientWalletBalance = function isHybridOrAddNPayWithSufficientWalletBalance(paymentOptions, cache) {
  if (paymentOptions && Object.prototype.hasOwnProperty.call(paymentOptions, 'paymentFlow') && paymentOptions.paymentFlow !== __WEBPACK_IMPORTED_MODULE_1__common_src_constant__["l" /* PAYMENT_FLOW */].NONE && getKey(paymentOptions, 'wallet.isUsed', false) && !isInsufficientBalance(paymentOptions, cache)) {
    // Add n Pay and Hybrid Flow
    return true;
  }
  // pg only
  return false;
};

var isMgvSufficient = function isMgvSufficient(payoption, cache) {
  if (payoption) {
    var taxAmount = cache.getData(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].TXN_AMOUNT);
    if (parseFloat(payoption.availableBalance) >= parseFloat(taxAmount)) {
      return true;
    }
  }
  return false;
};

/**
 * Compare two strings case insensitively
 *
 * @export
 * @param {string} first
 * @param {string} second
 * @returns {boolean} are string equal?
 */
function equalsIgnoreCase(first, second) {
  return (first || '').toLowerCase() === (second || '').toLowerCase();
}

/**
 * Validate whether an input is an Object or not.
 *
 * @export
 * @param {*} input
 * @returns {boolean} is input is an Object?
 */
function isObject(input) {
  return Object.prototype.toString.call(input) === '[object Object]';
}

/**
 * Validate whether an input is an Array or not.
 *
 * @export
 * @param {*} input
 * @returns {boolean} is input is an Array?
 */
function isArray(input) {
  return Array.isArray(input);
}

var money = function money(amount) {
  if (!Number.isNaN(amount)) {
    return parseFloat(Math.round(amount * 100) / 100).toFixed(2).replace('.00', '');
  }
  return amount;
};

var processWallet = function processWallet(balanceObj) {
  if (!balanceObj) return {};
  var wallet = {};
  if (balanceObj.payChannelOptions && balanceObj.payChannelOptions.length) {
    var paymode = balanceObj.payChannelOptions[0];
    if (paymode.balanceInfo && paymode.balanceInfo.accountBalance && paymode.balanceInfo.accountBalance.value) {
      wallet.walletBalance = money(balanceObj.payChannelOptions[0].balanceInfo.accountBalance.value);
    }
    if (paymode.balanceInfo && paymode.balanceInfo.subWalletDetails) {
      wallet.subWalletDetails = paymode.balanceInfo.subWalletDetails;
    }
    wallet.isUsed = true;
    wallet.isEnabled = true;
    wallet.isDisplay = true;
    /* adding paymentmode check in wallet object so as to identify wallet object easily */
    wallet.paymentMode = balanceObj.paymentMode;
    if (paymode.isDisabled) {
      wallet.isDisplay = paymode.isDisabled.status !== 'true';
      wallet.disableMsg = paymode.isDisabled.msg;
      wallet.isEnabled = paymode.isDisabled.status === 'false' && paymode.isDisabled.merchantAccept === 'true';
    }
    wallet.displayName = balanceObj.displayName;

    if (!wallet.walletBalance || money(wallet.walletBalance) <= 0) {
      wallet.isUsed = false;
    }
    wallet.feeAmount = balanceObj.feeAmount ? balanceObj.feeAmount : 0;
    wallet.taxAmount = balanceObj.taxAmount ? balanceObj.taxAmount : 0;
  }
  return wallet;
};

var processMgv = function processMgv(mgvObj) {
  if (!mgvObj) return null;
  var mgv = {};
  if (mgvObj.payChannelOptions && mgvObj.payChannelOptions.length) {
    var paymode = mgvObj.payChannelOptions[0];
    if (paymode.balanceInfo && paymode.balanceInfo.accountBalance && paymode.balanceInfo.accountBalance.value) {
      mgv.availableBalance = money(mgvObj.payChannelOptions[0].balanceInfo.accountBalance.value);
    }
    paymode.templateId && (mgv.templateId = paymode.templateId);
    mgv.isEnabled = true;
    mgv.isHybridDisabled = paymode.isHybridDisabled;
    mgv.id = mgvObj.id;
    mgv.paymentMode = mgvObj.paymentMode;
    mgv.type = mgvObj.type;
    if (paymode.isDisabled) {
      mgv.disableMsg = paymode.isDisabled.msg;
      mgv.isEnabled = paymode.isDisabled.status === 'false' && paymode.isDisabled.merchantAccept === 'true';
    }
    mgv.displayName = mgvObj.displayName;

    if (!mgv.availableBalance || money(mgv.availableBalance) <= 0) {
      mgv.isEnabled = false;
    }
  }
  return mgv;
};

var fetchSavedVpa = function fetchSavedVpa(profileDetails) {
  var VPA_AUTH_MODE = 'USRPWD';
  var savedVpaList = [];
  var vpaDetails = profileDetails.vpaDetails,
      bankAccounts = profileDetails.bankAccounts;

  var primaryVpaDetails = void 0;
  vpaDetails.forEach(function (vpa) {
    /* pick the vpa detail which is set primary */
    if (vpa.primary) {
      primaryVpaDetails = vpa;
    }
  });
  if (bankAccounts && bankAccounts.length) {
    bankAccounts.forEach(function (bankAccount) {
      var sVPAInstrument = {};
      /* in fpo v2 vpa detail comes seperately and hence have to pick name from vpa Details */
      sVPAInstrument.vpaId = getKey(primaryVpaDetails, 'name', getKey(bankAccount, 'accRefId'));
      sVPAInstrument.bankName = bankAccount.bank;
      /* slice -4 is being used to show the last 4 digits of the account number
       */
      sVPAInstrument.bankAccountNo = bankAccount.maskedAccountNumber.toString().slice(-4);
      /* todo this needs to be checked for what payeedata has to be sent for upipush txn
       *  currently setting bankaccount as whole vpaDetail was set in fpo v1 */
      sVPAInstrument.payeeData = bankAccount;
      sVPAInstrument.authMode = VPA_AUTH_MODE;
      sVPAInstrument.displayName = sVPAInstrument.bankName + ' - UPI';
      savedVpaList.push(sVPAInstrument);
    });
  }
  return savedVpaList;
};

var addPaymodeProperties = function addPaymodeProperties(list, subscription) {
  if (!list) return [];
  var cardCount = 0;
  var idx = void 0;
  return list.filter(function (item, index) {
    item.paymentMode && (item.type = typeMap[item.paymentMode]);
    if (item.type === 'card') {
      cardCount += 1;
      item.displayName = __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].CARD_AND_DEBIT;
    }
    // handling of display name if only one from credit , debit card is coming as paymode
    if (cardCount === 1 && item.type === 'card' && getKey(subscription, 'isEnabled', false)) {
      item.showDisplayName = true;
      idx = index;
    }
    if (cardCount >= 2 && item.type === 'card' && getKey(subscription, 'isEnabled', false)) {
      list[idx].showDisplayName = false;
    }
    item.isEnabled = !(item.isDisabled && item.isDisabled.status === 'true');
    return !(item.type === 'card' && cardCount >= 2);
  });
};

var isAndroidMweb = function isAndroidMweb() {
  var userAgent = window.navigator.userAgent || '';
  var isAndroid = /android/i.test(userAgent);
  var isAndroidWebViewKitKat = /android/i.test(userAgent) && /version\/[0-9].[0-9]/i.test(userAgent) && /Chrome\/\d*.\d*.\d*.\d*/i.test(userAgent);
  var isAndroidWebViewLollipop = /android/i.test(userAgent) && /wv/i.test(userAgent);
  var isUcBrowser = /ucbrowser|ucweb/i.test(userAgent);
  if (isAndroid && !isAndroidWebViewKitKat && !isAndroidWebViewLollipop && !isUcBrowser) {
    return true;
  }
  return false;
};

// const enableMidForUpiIntentMweb = (mid, orderId) => {
//   const enabledMidsUpiIntent = {
//     wHNUTH68224456779429: true,
//     AliSem26864341878851: true,
//     qNLEbz38834473442956: true,
//     slSpEG68327288525417: true,
//     ankpgp42986102247938: true,
//     iteite32049126720624: true,
//     zMXEFR83237974807152: true,
//     uCqBst06907425123687: true,
//     thStpg34491519591324: true,
//     nJuReA16339161897045: true,
//     ewOkIj89660348606926: true,
//     uSjDDx33134705348761: true,
//     phWccH34827864229470: true,
//     Jltyhs197678951592363: true,
//     BzsmkK78937952374483: true,
//     CppIkS77240431629035: true,
//     DuhxxC28068076146265: true,
//     EmEdCS60185669890238: true,
//     NIRBHA60344112284894: true,
//     TnvdaD49942329337141: true,
//     YLikIO89313606956833: true
//   };
//   // enabledMidsUpiIntent.hasOwnProperty(mid) && enabledMidsUpiIntent[mid] && orderId.indexOf('khata') >= 0
//   return !!(enabledMidsUpiIntent.hasOwnProperty(mid) && enabledMidsUpiIntent[mid]);
// };

var getHidenVisibalityProperties = function getHidenVisibalityProperties() {
  var hidden = void 0;
  var visibilityChange = void 0;
  if (typeof document.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    hidden = 'hidden';
    visibilityChange = 'visibilitychange';
  } else if (typeof document.mozHidden !== 'undefined') {
    hidden = 'mozHidden';
    visibilityChange = 'mozvisibilitychange';
  } else if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden';
    visibilityChange = 'msvisibilitychange';
  } else if (typeof document.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden';
    visibilityChange = 'webkitvisibilitychange';
  }
  return { hidden: hidden, visibilityChange: visibilityChange };
};

var setUpiIntentMwebDisplay = function setUpiIntentMwebDisplay(cache) {
  var option = cache.getData(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* CACHE */].PAYMENT_OPTIONS);
  if (isAndroidMweb() && getKey(option, 'upiAppsPayModeEnabled', false) === true) {
    var hiddenVisibilityObj = getHidenVisibalityProperties();
    if (hiddenVisibilityObj && hiddenVisibilityObj.hidden && hiddenVisibilityObj.visibilityChange) {
      cache.setData(__WEBPACK_IMPORTED_MODULE_2__constants__["f" /* UPI_INTENT_MWEB */].IS_UPI_INTENT_MWEB_ENABLED, true);
      cache.setData(__WEBPACK_IMPORTED_MODULE_2__constants__["f" /* UPI_INTENT_MWEB */].VISIBILITY_HIDDEN_VALUE, hiddenVisibilityObj);
      Object(__WEBPACK_IMPORTED_MODULE_5__common_logger__["log"])({ eventType: __WEBPACK_IMPORTED_MODULE_5__common_logger__["EVENT"].IS_INTENT_SUPPORTED, value: true });
    }
  } else {
    cache.setData(__WEBPACK_IMPORTED_MODULE_2__constants__["f" /* UPI_INTENT_MWEB */].IS_UPI_INTENT_MWEB_ENABLED, false);
    Object(__WEBPACK_IMPORTED_MODULE_5__common_logger__["log"])({ eventType: __WEBPACK_IMPORTED_MODULE_5__common_logger__["EVENT"].IS_INTENT_SUPPORTED, value: false });
  }
};

var checkForRetryPayMode = function checkForRetryPayMode(cache, currentPaymode) {
  var retryData = cache.getData(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* CACHE */].RETRY_DATA);
  try {
    if (retryData && parseInt(retryData.selectedPaymentModeId, 10) === currentPaymode.id) {
      return true;
    }
    return false;
  } catch (e) {
    return false;
  }
};

var isValidUpiPayChannel = function isValidUpiPayChannel(channel, cache) {
  var channelCode = getKey(channel, 'channelCode');
  return equalsIgnoreCase(channelCode, __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].UPI) || equalsIgnoreCase(channelCode, __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].UPIPUSH) && isAndroidMweb() && getHidenVisibalityProperties() && cache.getData(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].IS_UPI_APPS_PAYMODE_ENABLED);
};

var processPaymodes = function processPaymodes(paymodes, cache) {
  var subscription = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var id = 0;
  // setting wallet id as -1 initially since index 0 being passed  was giving issues on render of wallet
  var walletId = -1;
  var defaultRetryPaymodeSelection = null; // this var will be used in showing default paymode selected to user in case of retry
  var localStorageSavedPaymode = getKey(cache.getData(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].CURRENT_PAYMODE), 'paymodeUsed');
  var uniqCardNo = getKey(cache.getData(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].CURRENT_PAYMODE), 'uniqueCardData');
  paymodes.paymentModes = addPaymodeProperties(paymodes.paymentModes, subscription);

  if (paymodes.paymentModes) {
    paymodes.paymentModes.forEach(function (paymode, index) {
      if ((paymode.displayName && paymode.displayName === localStorageSavedPaymode || paymode.type && paymode.type === 'card' && paymode.type === localStorageSavedPaymode) && paymode.paymentMode !== __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].GIFT_VOUCHER) {
        cache.setData(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].FOUND_LAST_USED_PAYMODE, true);
        paymodes.lastUsedPaymode = paymode;
      }
      if (paymode.paymentMode === 'BALANCE') {
        walletId = index;
      }
      if (paymode.paymentMode === __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].GIFT_VOUCHER) {
        id += 1;
        paymode.type = 'mgv';
        paymode.id = id;
        var mgvObject = processMgv(JSON.parse(JSON.stringify(paymode)));
        if (paymode.displayName && paymode.displayName === localStorageSavedPaymode && isMgvSufficient(mgvObject, cache)) {
          cache.setData(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].FOUND_LAST_USED_PAYMODE, true);
          paymodes.lastUsedPaymode = paymode;
        }
      }
      if (paymode.paymentMode === __WEBPACK_IMPORTED_MODULE_1__common_src_constant__["m" /* PAYMODE */].LOGIN) {
        id += 1;
        paymode.type = __WEBPACK_IMPORTED_MODULE_1__common_src_constant__["m" /* PAYMODE */].LOGIN.toLowerCase();
        paymode.id = id;
      }
      if (paymode.paymentMode === __WEBPACK_IMPORTED_MODULE_1__common_src_constant__["m" /* PAYMODE */].UPI) {
        cache.setData(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].IS_UPI_TXN, true);
        paymode.isEnabled = false;
        if (paymode.payChannelOptions) {
          paymode.payChannelOptions.map(function (channel) {
            // Enable the UPI for Upi Intent also, iff, userAgent is android mweb and hiddenVisibily supported
            if (isValidUpiPayChannel(channel, cache)) {
              paymode.isEnabled = true;
            }
            return channel;
          });
        }
      }

      if (paymode.paymentMode === 'NET_BANKING' || paymode.paymentMode === 'EMI') {
        paymode.data = {};
        if (getKey(paymode, 'payChannelOptions')) {
          paymode.data.banks = [].concat(paymode.payChannelOptions);
        }
        delete paymode.payChannelOptions;
      }
      !paymode.name && (paymode.name = paymode.displayName);
      id += 1;
      paymode.id = id;
      !paymode.type && (paymode.type = paymode.paymentMode);
      if (checkForRetryPayMode(cache, paymode)) {
        defaultRetryPaymodeSelection = paymode;
      }
    });
  }

  if (paymodes.savedInstruments) {
    paymodes.savedInstruments.forEach(function (instrument) {
      id += 1;
      instrument.id = id;
      instrument.type = 'sc';
      instrument.firstSix = instrument.cardDetails.firstSixDigit;
      instrument.lastFour = instrument.cardDetails.lastFourDigit;
      if (checkForRetryPayMode(cache, instrument)) {
        defaultRetryPaymodeSelection = instrument;
      }
      if (instrument.displayName && instrument.displayName === localStorageSavedPaymode && instrument.lastFour === uniqCardNo) {
        cache.setData(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].FOUND_LAST_USED_PAYMODE, true);
        paymodes.lastUsedPaymode = instrument;
      }
    });
  }
  if (getKey(paymodes, 'upiProfile.respDetails.profileDetail', null)) {
    var profileDetail = getKey(paymodes, 'upiProfile.respDetails.profileDetail', null);
    paymodes.savedVPas = fetchSavedVpa(profileDetail);
    delete paymodes.upiProfile;
  }

  if (paymodes.savedMandateBanks && paymodes.savedMandateBanks.length) {
    paymodes.savedMandateBanks.forEach(function (bankMandate) {
      id += 1;
      bankMandate.id = id;
      bankMandate.type = __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].SAVED_BANK_MANDATE_PAY_TYPE;
      bankMandate.paymentMode = __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].SBM;
      bankMandate.lastFour = bankMandate.maskedAccountNumber.slice(-4);
    });
  }

  if (paymodes.savedVPas) {
    paymodes.savedVPas.forEach(function (vpa) {
      id += 1;
      vpa.id = id;
      vpa.paymentMode = __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].UPI;
      vpa.type = 'upipush';
      if (checkForRetryPayMode(cache, vpa)) {
        defaultRetryPaymodeSelection = vpa;
      }
      if (vpa.displayName && vpa.displayName === localStorageSavedPaymode) {
        cache.setData(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].FOUND_LAST_USED_PAYMODE, true);
        paymodes.lastUsedPaymode = vpa;
      }
    });
  }
  if (defaultRetryPaymodeSelection) {
    paymodes.defaultRetryPaymodeSelection = defaultRetryPaymodeSelection;
  }
  //  paymodes.paymentModes = addPaymodeProperties(paymodes.paymentModes);
  return walletId;
};

var _IS_MOBILE_REGEX = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|OperaMini/i;

var isMobileDevice = function isMobileDevice() {
  return _IS_MOBILE_REGEX.test(window.navigator.userAgent);
};

var parseCheckoutElementPayMode = function parseCheckoutElementPayMode(paymentOptions, checkoutElementPayMode, loginChangeFlow, cache) {
  var paymentModes = getKey(paymentOptions, 'merchantPayOption.paymentModes');
  var isPayModeNotFound = false;
  var isPayWithPaytm = equalsIgnoreCase(__WEBPACK_IMPORTED_MODULE_1__common_src_constant__["c" /* ELEMENT_PAYMODE */].PAY_WITH_PAYTM, checkoutElementPayMode);

  if (!isPayWithPaytm || isPayWithPaytm && !equalsIgnoreCase(paymentOptions.paymentFlow, __WEBPACK_IMPORTED_MODULE_1__common_src_constant__["l" /* PAYMENT_FLOW */].ADDANDPAY)) {
    paymentOptions.paymentFlow = __WEBPACK_IMPORTED_MODULE_1__common_src_constant__["l" /* PAYMENT_FLOW */].NONE;
  }

  if (paymentModes && checkoutElementPayMode) {
    var _requestedPaymodes;

    var requestedPaymodes = (_requestedPaymodes = {}, _requestedPaymodes[checkoutElementPayMode.toUpperCase()] = true, _requestedPaymodes);

    if (isPayWithPaytm) {
      var _requestedPaymodes2;

      requestedPaymodes = (_requestedPaymodes2 = {}, _requestedPaymodes2[__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].POSTPAID] = true, _requestedPaymodes2[__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].PPBL] = true, _requestedPaymodes2[__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].WALLET] = true, _requestedPaymodes2[__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].LOGIN] = true, _requestedPaymodes2[__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].GIFT_VOUCHER] = true, _requestedPaymodes2);
    }
    paymentModes = paymentModes.filter(function (mode) {
      return (requestedPaymodes[(mode.paymentMode || mode.type || '').toUpperCase()] || requestedPaymodes[(typeMap[mode.paymentMode] || '').toUpperCase()]) && (equalsIgnoreCase(getKey(mode, 'paymentMode'), __WEBPACK_IMPORTED_MODULE_1__common_src_constant__["m" /* PAYMODE */].WALLET) || getKey(mode, 'isDisabled.status') !== 'true');
    });

    // UPI paymode handling
    if (equalsIgnoreCase(checkoutElementPayMode, __WEBPACK_IMPORTED_MODULE_1__common_src_constant__["c" /* ELEMENT_PAYMODE */].UPI) && paymentModes.length === 1) {
      var isUPIAllowed = getKey(paymentModes[0], 'payChannelOptions', []).some(function (channel) {
        return isValidUpiPayChannel(channel, cache);
      });
      if (!isUPIAllowed) {
        paymentModes = [];
      }
    }
    paymentOptions.merchantPayOption.paymentModes = paymentModes;
    isPayModeNotFound = paymentModes.length === 0;
  }

  if (
  // !isPayWithPaytm &&
  getKey(paymentOptions, 'qrDetail')) {
    var isScanAndPay = !isMobileDevice() && equalsIgnoreCase(checkoutElementPayMode, __WEBPACK_IMPORTED_MODULE_1__common_src_constant__["c" /* ELEMENT_PAYMODE */].SCAN_AND_PAY);
    if (isPayWithPaytm && getKey(paymentOptions, 'qrDetail.upiQR') || !isPayWithPaytm && !isScanAndPay) {
      delete paymentOptions.qrDetail;
    }

    if (isScanAndPay) {
      isPayModeNotFound = false;
    }
  }

  var savedInstruments = getKey(paymentOptions, 'merchantPayOption.savedInstruments');
  if (savedInstruments) {
    if (equalsIgnoreCase(__WEBPACK_IMPORTED_MODULE_1__common_src_constant__["m" /* PAYMODE */].EMI, checkoutElementPayMode)) {
      paymentOptions.merchantPayOption.savedInstruments = savedInstruments.filter(function (si) {
        return si.isEmiAvailable;
      });
    } else if (!(equalsIgnoreCase(__WEBPACK_IMPORTED_MODULE_1__common_src_constant__["m" /* PAYMODE */].CARD, checkoutElementPayMode) || equalsIgnoreCase(__WEBPACK_IMPORTED_MODULE_1__common_src_constant__["c" /* ELEMENT_PAYMODE */].PAY_WITH_PAYTM, checkoutElementPayMode) && getKey(paymentOptions, 'loginInfo.userLoggedIn'))) {
      delete paymentOptions.merchantPayOption.savedInstruments;
    }
  }

  if (!equalsIgnoreCase(__WEBPACK_IMPORTED_MODULE_1__common_src_constant__["c" /* ELEMENT_PAYMODE */].PAY_WITH_PAYTM, checkoutElementPayMode)) {
    if (getKey(paymentOptions, 'merchantPayOption.upiProfile.respDetails.profileDetail')) {
      delete paymentOptions.merchantPayOption.upiProfile.respDetails.profileDetail;
    }

    // if (getKey(paymentOptions, 'merchantPayOption.userProfileSarvatra.response.vpaDetails')) {
    //   delete paymentOptions.merchantPayOption.userProfileSarvatra.response.vpaDetails;
    // }

    // if (getKey(paymentOptions, 'merchantPayOption.userProfileSarvatra.response.bankAccounts')) {
    //   delete paymentOptions.merchantPayOption.userProfileSarvatra.response.bankAccounts;
    // }
  }

  if (isPayModeNotFound && !loginChangeFlow) {
    throw new Error('Paymode not available!');
  }

  return getKey(paymentOptions, 'merchantPayOption');
};

var parseData = function parseData(input, cache, checkoutElementPayMode) {
  var loginChangeFlow = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (!input || !isObject(input)) {
    return [];
  }
  cache.setData(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].IS_UPI_APPS_PAYMODE_ENABLED, getKey(input, 'upiAppsPayModeEnabled', false));
  var paymodes = checkoutElementPayMode ? parseCheckoutElementPayMode(input, checkoutElementPayMode, loginChangeFlow, cache) : input.merchantPayOption;

  if (isObject(input.loginInfo) && (!checkoutElementPayMode || equalsIgnoreCase(__WEBPACK_IMPORTED_MODULE_1__common_src_constant__["c" /* ELEMENT_PAYMODE */].PAY_WITH_PAYTM, checkoutElementPayMode))) {
    input.loginInfo.id = 'loginInfo';
    if (!getKey(input, 'loginInfo.userLoggedIn')) {
      var loginObj = {
        paymentMode: __WEBPACK_IMPORTED_MODULE_1__common_src_constant__["m" /* PAYMODE */].LOGIN
      };
      paymodes.paymentModes.unshift(loginObj);
    }
  }

  if (getKey(input, 'allowedRetryCountsForMerchant', 0) > 0) {
    cache.setData(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].ALLOWED_MERCHANT_RETRY_COUNTS, 0
    // getKey(input, 'allowedRetryCountsForMerchant', 0) + 1
    );
  } else {
    cache.setData(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].ALLOWED_MERCHANT_RETRY_COUNTS, 0);
  }

  if (Object.prototype.hasOwnProperty.call(input, 'link') && input.link && input.link.linkType) {
    cache.setData(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].IS_LINK_TXN, true);
  } else {
    cache.setData(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].IS_LINK_TXN, false);
  }
  var merchantPayOption = input.merchantPayOption,
      addMoneyPayOption = input.addMoneyPayOption,
      subscriptionDetail = input.subscriptionDetail;

  if (merchantPayOption) {
    var walletId = processPaymodes(merchantPayOption, cache, subscriptionDetail);

    if (walletId !== -1) {
      input.wallet = processWallet(merchantPayOption.paymentModes.splice(walletId, 1)[0]);
      input.wallet && (input.wallet.isWalletOnly = input.walletOnly);
      if (input.paymentFlow === __WEBPACK_IMPORTED_MODULE_1__common_src_constant__["l" /* PAYMENT_FLOW */].ADDANDPAY) {
        input.wallet.isUsed = true;
      }
      if (getKey(subscriptionDetail, 'isEnabled', false) && merchantPayOption.paymentModes.length) {
        input.wallet.isUsed = false;
      }
      merchantPayOption.paymentModes = merchantPayOption.paymentModes.filter(function (paymode) {
        if (paymode.paymentMode === __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].GIFT_VOUCHER) {
          input.mgv = processMgv(paymode);
          return false;
        }
        return true;
      });
      if (cache.getData(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].TXN_AMOUNT)) {
        if (getKey(input, 'wallet.isEnabled') && isInsufficientBalance(input, cache) && !isHybridOrAddNPay(input, cache) && !getKey(input, 'subscriptionDetail.isEnabled', false)) {
          input.wallet.isUsed = false;
          input.wallet.isEnabled = false;
        }
        if (getKey(input, 'mgv.isEnabled') && isMgvSufficient(input.mgv, cache) && isInsufficientBalance(input, cache) && getKey(cache.getData(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].CURRENT_PAYMODE), 'paymodeUsed') && getKey(cache.getData(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].CURRENT_PAYMODE), 'paymodeUsed').indexOf('GIFT_VOUCHER') > -1) {
          input.wallet && (input.wallet.isUsed = false);
        }
      }
    }

    var usedPaymode = cache.getData(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].CURRENT_PAYMODE);
    if (usedPaymode && isInsufficientBalance(input, cache) && cache.getData(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].FOUND_LAST_USED_PAYMODE)) {
      if (!usedPaymode.isWalletCheck && isHybridOrAddNPay(input, cache)) {
        paymodes = input.merchantPayOption;
        input.wallet.isUsed = false;
      }
    }
  }
  if (addMoneyPayOption) {
    if (getKey(addMoneyPayOption, 'upiProfile.respDetails.profileDetail')) {
      delete addMoneyPayOption.upiProfile.respDetails.profileDetail;
    }
    processPaymodes(addMoneyPayOption, cache);
  }
  // Set add n pay paymodes if ADDANDPAY flag present
  if (isAddNPay(input, cache)) {
    paymodes = input.addMoneyPayOption;
  } else if (merchantPayOption) {
    paymodes = input.merchantPayOption;
  } else {
    paymodes = [];
  }
  input.payData = paymodes;
  return paymodes;
};

var _numberWithCommas = function _numberWithCommas(x) {
  /* setting x to toString because length throws error when number was being passed */
  x = x.toString();

  if (_isNullOrUndefined(x)) {
    return '';
  }

  if (x.length === 0) {
    return '';
  }

  if (x.indexOf(',') !== -1) {
    x = x.toString().replace(/,/g, '');
  }
  if (x && !_isInt(x)) {
    x = parseFloat(x).toFixed(2); // Set to 2 decimal value
  }
  // if(x){
  //     x = parseFloat(x).toFixed(2); // Set to 2 decimal value
  // }

  var numbers = x.toString().split('.');
  var output = '';
  // number with commas
  if (numbers.length >= 1) {
    if (window.Number && window.Number.prototype.toLocaleString) {
      output = parseFloat(numbers[0]).toLocaleString('en-in');
    } else {
      output = numbers[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }
  // If number has floating part
  if (numbers.length === 2) {
    if (!(numbers[1] === '00' || numbers[1] === '0')) {
      output += '.' + numbers[1];
    }
  }
  return output;
};

var commas = _numberWithCommas;
var isNullOrUndefined = _isNullOrUndefined;

/**
 * Make a method restricted to be called only once and return the cached value
 * @param {Function} cb - the method that needs to be made call only once
 * @param {Object} ctx (optional) - the context to the the provided method needs to be bound to
 * @returns {*} - returns a method that invokes tha passed method
 */

var callOnce = function callOnce(cb, ctx) {
  if (!(cb instanceof Function)) return function () {};
  var called = false;
  var returned = void 0;
  return function callOnceFunc() {
    if (!called) {
      called = true;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      returned = ctx ? cb.call.apply(cb, [ctx].concat(args)) : cb.apply(undefined, args);
    }
    return returned;
  };
};

var getEncodedQs = function getEncodedQs(obj) {
  var arr = [];
  if (!obj) {
    return '';
  }
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      arr.push(key + '=' + window.encodeURIComponent(obj[key]));
    }
  }
  return arr.join('&');
};

var staticPath = function staticPath() {
  var _url = "https://staticpg.paytm.in";

  try {
    if (typeof window !== 'undefined') {
      if (true) {
        _url += '/' + "checkoutjs" + '/' + "442";
      }
    }
  } catch (e) {}
  return _url;
};

var paymentFlow = function paymentFlow(paymentOption, cache) {
  var flow = __WEBPACK_IMPORTED_MODULE_1__common_src_constant__["l" /* PAYMENT_FLOW */].NONE;
  if (paymentOption && isHybridOrAddNPay(paymentOption, cache)) {
    flow = paymentOption.paymentFlow;
  }
  return flow;
};

var defaultSelected = function defaultSelected(paymentOptions, cache) {
  var selectedPaymode = null;
  var elementPaymode = cache.getData(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* CACHE */].CHECKOUT_ELEMENT_PAYMODE);
  var isEmiElementPaymode = equalsIgnoreCase(elementPaymode, __WEBPACK_IMPORTED_MODULE_1__common_src_constant__["c" /* ELEMENT_PAYMODE */].EMI);
  var _paymentOptions$payDa = paymentOptions.payData,
      paymentModes = _paymentOptions$payDa.paymentModes,
      savedVPas = _paymentOptions$payDa.savedVPas,
      savedInstruments = _paymentOptions$payDa.savedInstruments,
      savedMandateBanks = _paymentOptions$payDa.savedMandateBanks,
      defaultRetryPaymodeSelection = _paymentOptions$payDa.defaultRetryPaymodeSelection,
      lastUsedPaymode = _paymentOptions$payDa.lastUsedPaymode;

  var isMGV = getKey(cache.getData(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].CURRENT_PAYMODE), 'isMGV', undefined);
  // Check to not set local storage paymode when walletBalance is sufficient
  if (lastUsedPaymode && isInsufficientBalance(paymentOptions, cache)) {
    // MGV shouldn't be selected in case it's balance is not sufficient
    if (isMGV && isMgvSufficient(paymentOptions.mgv, cache) || !isMGV) {
      cache.setData(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].STORAGE_USED, true);
      return lastUsedPaymode;
    }
  }

  if (defaultRetryPaymodeSelection) {
    selectedPaymode = defaultRetryPaymodeSelection;
    delete paymentOptions.payData.defaultRetryPaymodeSelection;
  } else if (savedVPas && savedVPas.length > 0) {
    selectedPaymode = savedVPas[0];
  } else if (!isEmiElementPaymode && savedInstruments && savedInstruments.length > 0) {
    selectedPaymode = savedInstruments[0];
  } else if (!isEmiElementPaymode && savedMandateBanks && savedMandateBanks.length) {
    selectedPaymode = savedMandateBanks[0];
  } else if (paymentModes && paymentModes.length > 0) {
    selectedPaymode = paymentModes[0];
  }
  if (isInsufficientBalance(paymentOptions, cache) && !isMgvSufficient(paymentOptions.mgv, cache) || !lastUsedPaymode && isInsufficientBalance(paymentOptions, cache)) {
    return selectedPaymode;
  }

  if (getKey(paymentOptions, 'subscriptionDetail.isEnabled', false) && !getKey(paymentOptions, 'wallet.isUsed', true)) {
    return selectedPaymode;
  }
  return null;
};

var clientMessage = function clientMessage(key, cache) {
  var config = cache.getData(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* CACHE */].MERCHANT_CONFIG);
  if (config && config.mapClientMessage) {
    return config.mapClientMessage[key] || {};
  }
  return {};
};
var applyMerchPref = function applyMerchPref(_paymentOptions, mConfig) {
  var paymentOptions = _paymentOptions;
  if (getKey(paymentOptions, 'addMoneyPayOption.paymentModes')) {
    paymentOptions.addMoneyPayOption.paymentModes = applyMerchantPref(paymentOptions.addMoneyPayOption.paymentModes, mConfig);
  }
  if (getKey(paymentOptions, 'merchantPayOption.paymentModes')) {
    paymentOptions.merchantPayOption.paymentModes = applyMerchantPref(paymentOptions.merchantPayOption.paymentModes, mConfig);
  }
};

var loggedInChanged = function loggedInChanged(payOptions, cache, checkoutElementPayMode) {
  parseData(payOptions.cashierData, cache, checkoutElementPayMode, true);
  cache.setData(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* CACHE */].PAYMENT_OPTIONS, payOptions.cashierData);
  applyMerchPref(payOptions.cashierData, Object(__WEBPACK_IMPORTED_MODULE_4__common_merchant_config__["a" /* get */])());
  return payOptions;
};

var calculateAmountPayable = function calculateAmountPayable(txnAmount, walletObj) {
  var commaSeparatedAmount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var subscription = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var walletBalance = 0;
  var amountPayable = txnAmount;
  /**
   * for zero amount subscription setting txn value to 1
   */
  if (getKey(subscription, 'isEnabled', false) && txnAmount === '0') {
    amountPayable = __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].SUBS_PAYMODE_MIN_AMOUNT;
  }

  if (getKey(walletObj, 'isUsed', false)) {
    walletBalance = walletObj.walletBalance;
    if (parseFloat(walletBalance) < parseFloat(amountPayable)) {
      amountPayable = parseFloat(amountPayable) - parseFloat(walletBalance);
    }
  }
  return commaSeparatedAmount ? _numberWithCommas(amountPayable.toString()) : amountPayable;
};

var updateSlideIndex = function updateSlideIndex(activeInd, helpTextLen) {
  return activeInd === helpTextLen - 1;
};

var touchStart = function touchStart(e) {
  var touchObj = e.changedTouches[0];
  e.preventDefault();
  return {
    startX: touchObj.pageX,
    startY: touchObj.pageY
  };
};

var touchEnd = function touchEnd(e, startX, threshold) {
  var touchObj = e.changedTouches[0];
  var swipeDist = touchObj.pageX - startX;
  return swipeDist >= threshold;
};

var handleSwipeCtrl = function handleSwipeCtrl(isrightswipe, index, helpText) {
  var actvInd = isrightswipe ? index - 1 === -1 ? 0 : index - 1 : index + 1 === helpText.length ? helpText.length - 1 : index + 1;
  var okBtnVal = actvInd === helpText.length - 1;
  return { actvInd: actvInd, okBtnVal: okBtnVal };
};

var errorObject = function errorObject(errorCode) {
  return {
    hasError: true,
    code: errorCode,
    message: __WEBPACK_IMPORTED_MODULE_3__error_codes__["a" /* default */].ERROR_MESSAGE[errorCode] || ''
  };
};

/**
 * Handle save card save maessage based on subscription
 *
 * @export
 * @param {Object} subscription  subscription object
 * @param {Object} paymentOptions payment option object
 * @returns {Object} saveCard configrations
 */
var handleSaveCardOnSubscription = function handleSaveCardOnSubscription(subscription, paymentOptions, cache) {
  var output = {
    disabled: false,
    displayName: clientMessage(__WEBPACK_IMPORTED_MODULE_1__common_src_constant__["m" /* PAYMODE */].CARD.toLowerCase(), cache).label.savedCard,
    subscriptionEnabled: false
  };
  if (subscription && subscription.isEnabled) {
    var wallet = paymentOptions.wallet,
        _paymentFlow = paymentOptions.paymentFlow;

    output.displayName = clientMessage(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].SUBSCRIPTION.toLowerCase(), cache).label.savedCard;
    if (!(getKey(wallet, 'isUsed') && subscription.nonSpecificPayMode) || _paymentFlow !== __WEBPACK_IMPORTED_MODULE_1__common_src_constant__["l" /* PAYMENT_FLOW */].ADDANDPAY || subscription.saveCardMandatoryAddNPay && getKey(wallet, 'isUsed') && _paymentFlow === __WEBPACK_IMPORTED_MODULE_1__common_src_constant__["l" /* PAYMENT_FLOW */].ADDANDPAY) {
      output.disabled = true;
    }
    output.subscriptionEnabled = true;
  }
  return output;
};
/**
 * Picks first level key-value from an object for request keys
 *
 * @export
 * @param {Object} obj
 * @param {Array} keysToPluck keys for which value needs to be extracted.
 * @returns {Object} filtered object
 */
function pick(obj, keysToPluck) {
  if (isObject(obj) && isArray(keysToPluck)) {
    return keysToPluck.reduce(function (acc, key) {
      acc[key] = obj[key] || null;
      return acc;
    }, {});
  }

  return {};
}

/**
 * Validate whether an input is string or not.
 *
 * @export
 * @param {*} input
 * @returns {boolean} is input is string?
 */
function isString(input) {
  return typeof input === 'string';
}

/**
 * Validate whether an input is function or not.
 *
 * @export
 * @param {*} input
 * @returns {boolean} is input is function?
 */
function isFunction(input) {
  return typeof input === 'function';
}

/**
 * Find a array element which satisfies the callback function condition
 *
 * @export
 * @param {Array<*>} inputArray
 * @param {Function} callback
 * @returns {*} array element or undefined
 */
function find(inputArray, callback) {
  if (isArray(inputArray) && isFunction(callback)) {
    for (var index = 0; index < inputArray.length; index += 1) {
      var currentItem = inputArray[index];

      if (callback(currentItem, index, inputArray)) {
        return currentItem;
      }
    }
  }

  return undefined;
}

function objectValues(obj) {
  if (isObject(obj)) {
    return Object.keys(obj).map(function (key) {
      return obj[key];
    });
  }

  return [];
}

function areObjectValuesShallowNotEqual(firstObj, secondObj, keys) {
  if (!isObject(firstObj) || !isObject(secondObj) || !isArray(keys)) {
    return false;
  }

  return keys.some(function (key) {
    return firstObj[key] !== secondObj[key];
  });
}

function getIframeRequestPayload(cache, apiUrl) {
  var _cache$getData$reques = _extends({}, cache.getData(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* CACHE */].API).requestPayload(apiUrl)),
      url = _cache$getData$reques.url,
      query = _cache$getData$reques.query,
      method = _cache$getData$reques.method,
      data = _cache$getData$reques.data;

  data.body = _extends({}, data.body, query);

  return {
    targetURL: url + '?' + getEncodedQs(query),
    queryParams: query,
    requestData: data,
    method: method
  };
}

/**
 * @returns {url} for redirection flow(enhanced native)
 */
function showPaymentPageUrl() {
  return "https://securegw.paytm.in/theia" + '/api/v1/showPaymentPage';
}

var validLinkUrlRegExp = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@\-/]))?/;

function isValidUrl(url) {
  return validLinkUrlRegExp.test(url);
}

function convertRupeeCharToUnicode(text) {
  var rupeeUnicode = String.fromCodePoint(0x20b9);
  return (text || '').replace(/₹/g, rupeeUnicode);
}

var removeVpaDetails = function removeVpaDetails(_data) {
  var data = _data;
  var vpaDetails = getKey(data, 'response.vpaDetails', []);
  var bankAccounts = getKey(data, 'response.bankAccounts', []);
  /* remove all the relevant data related to account number, vpa id */
  vpaDetails = vpaDetails.map(function (_detail) {
    var detail = _detail;
    detail.defaultCredit = {};
    detail.defaultDebit.accRefNumber = '';
    detail.defaultDebit.account = '';
    detail.defaultDebit.credsAllowed = [];
    detail.defaultDebit.ifsc = '';
    detail.defaultDebit.name = '';
    detail.defaultDebit.accRefId = '';
    detail.name = '';
    return detail;
  });
  bankAccounts = bankAccounts.map(function (_account) {
    var account = _account;
    account.accRefNumber = '';
    account.account = '';
    account.credsAllowed = [];
    account.ifsc = '';
    account.name = '';
    return account;
  });
  data.response.vpaDetails = vpaDetails;
  data.response.bankAccounts = bankAccounts;
  return data;
};

function removeDataForLogging(data) {
  data.userDetails = data.userDetails && _extends({}, data.userDetails, {
    email: '',
    username: '',
    mobile: '',
    paytmCCEnabled: '',
    kyc: ''
  });
  data.merchantDetails = data.merchantDetails && _extends({}, data.merchantDetails, {
    merchantVpa: ''
  });
  var userProfileSarvatraMerchantPayOption = getKey(data, 'merchantPayOption.userProfileSarvatra', null);
  var userProfileSarvatraAddMoneyPayOption = getKey(data, 'addMoneyPayOption.userProfileSarvatra', null);
  if (userProfileSarvatraMerchantPayOption) {
    data.merchantPayOption.userProfileSarvatra = removeVpaDetails(userProfileSarvatraMerchantPayOption);
  }
  if (userProfileSarvatraAddMoneyPayOption) {
    data.addMoneyPayOption.userProfileSarvatra = removeVpaDetails(userProfileSarvatraAddMoneyPayOption);
  }
  return data;
}

function findIndex(array, callbackFn) {
  if (isArray(array) && array.length && isFunction(callbackFn)) {
    for (var index = 0; index < array.length; index += 1) {
      // Explicit check for true
      if (callbackFn(array[index], index) === true) {
        return index;
      }
    }
  }

  return -1;
}

/**
 * Generates UUID
 *
 * @export
 * @returns {string} UUID
 */
function generateUUID() {
  // Timestamp
  var unixEpochTimestamp = new Date().getTime();
  // Time in microseconds since page-load or 0 if unsupported
  var domHighResTimeStamp = performance && performance.now() * 1000 || 0;

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (char) {
    var random = Math.random() * 16; // random number between 0 and 16
    if (unixEpochTimestamp > 0) {
      // Use timestamp until depleted
      // eslint-disable-next-line no-bitwise
      random = (unixEpochTimestamp + random) % 16 | 0;
      unixEpochTimestamp = Math.floor(unixEpochTimestamp / 16);
    } else {
      // Use microseconds since page-load if supported
      // eslint-disable-next-line no-bitwise
      random = (domHighResTimeStamp + random) % 16 | 0;
      domHighResTimeStamp = Math.floor(domHighResTimeStamp / 16);
    }
    // eslint-disable-next-line no-bitwise
    return (char === 'x' ? random : random & 0x3 | 0x8).toString(16);
  });
}

/**
 * Createa cloned object
 *
 * @export
 * @param {Object} input
 * @returns {Object} cloned object
 */
function cloneObject(input) {
  try {
    return JSON.parse(JSON.stringify(input));
  } catch (ex) {
    return input;
  }
}

/**
 * Notify merchant object which returna event based notify methods.
 */
var notifyMerchant = function _notifyMerchant() {
  function _invokeNotifyMerchantHandler(event, data, cache) {
    var notifyMerchantHandler = getKey(cache.getData(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* CACHE */].MERCHANT_CONFIG), 'handler.notifyMerchant');

    if (isFunction(notifyMerchantHandler)) {
      notifyMerchantHandler(event, data);
    }
  }

  var _EVENTS = __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].NOTIFY_MERCHANT_EVENTS;

  return {
    fetchPaymentError: _invokeNotifyMerchantHandler.bind(null, _EVENTS.FETCH_PAYMENT_OPTIONS_ERROR),
    handleError: _invokeNotifyMerchantHandler.bind(null, _EVENTS.HANDLER_ERROR),
    fetchEmiBankListError: _invokeNotifyMerchantHandler.bind(null, _EVENTS.FETCH_EMI_BANK_LIST_ERROR),
    paymentError: _invokeNotifyMerchantHandler.bind(null, _EVENTS.PAYMENT_ERROR),
    appClosed: _invokeNotifyMerchantHandler.bind(null, _EVENTS.APP_CLOSED)
  };
}();

var getStaticPath = function getStaticPath() {
  // eslint-disable-next-line no-undef
  var _url = "https://staticpg.paytm.in";

  try {
    if (typeof window !== 'undefined') {
      // eslint-disable-next-line no-undef
      if (true) {
        _url += '/' + "checkoutjs" + '/' + "442";
      }
    }
  } catch (e) {}
  return _url;
};

var iframePath = function iframePath() {
  return getStaticPath() + '/assets/iframes/dummy-frame.html';
};
function updatePayloadForTenureEMI(cache, payload) {
  var subventionObject = cache.getData(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].SUBVENTION_OBJ);
  if (subventionObject) {
    payload.subventionObject = subventionObject;
  }
  return payload;
}

function updatePayloadForValidateEMI(cache, plan, requestPayload, cacheCardToken) {
  var isEmiSubventionFlow = cache.getData(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].IS_EMISUBVENTION_ACCESS_TOKEN_FLOW);
  var subventionObject = cache.getData(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].SUBVENTION_OBJ);
  if (isEmiSubventionFlow && subventionObject) {
    var mConfig = cache.getData(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* CACHE */].MERCHANT_CONFIG);
    var emiStrategy = cache.getData(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].EMISUBVENTION_STATEGY);
    var itemsFromConfig = getKey(subventionObject, 'items', []);
    var itemBreakUp = plan.itemBreakUp;

    if (emiStrategy === __WEBPACK_IMPORTED_MODULE_1__common_src_constant__["e" /* EMI_SUBVENTION_STRATEGY */].ITEM_BASED) {
      itemBreakUp.forEach(function (item) {
        itemsFromConfig = itemsFromConfig.map(function (i) {
          if (i.id === item.id) {
            i.offerDetails = { offerId: item.offerId };
          }
          return i;
        });
      });
      requestPayload.items = subventionObject.items;
    } else {
      itemBreakUp.forEach(function (item) {
        if (item.id === __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].EMI_SUBVENTION) {
          /* For amount based subvention since the items is not available hence if item id
           * is subvention pass that offer id to validate requestpayload  */
          requestPayload.offerDetails = { offerId: item.offerId };
        }
      });
      requestPayload.price = subventionObject.price;
      requestPayload.subventionAmount = subventionObject.subventionAmount;
    }
    requestPayload.customerId = getKey(mConfig, 'emiSubvention.customerId', null);
    var paymentAmount = cache.getData(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].BANK_OFFER_TXN_AMOUNT);
    requestPayload.paymentDetails = {
      /* using the initial txn amount being passed from configuration  */
      totalTransactionAmount: paymentAmount || cache.getData(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].FALLBACK_TXN_AMOUNT)
    };
    requestPayload.generateTokenForIntent = true;

    if (cacheCardToken) {
      requestPayload.cacheCardToken = cacheCardToken;
    }
  }
  return requestPayload;
}

function updatePayloadBasedOnStrategy(cache, payload, obj) {
  var items = obj.items,
      price = obj.price,
      subventionAmount = obj.subventionAmount;

  var emiStrategy = cache.getData(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].EMISUBVENTION_STATEGY);
  if (emiStrategy === __WEBPACK_IMPORTED_MODULE_1__common_src_constant__["e" /* EMI_SUBVENTION_STRATEGY */].ITEM_BASED) {
    payload.items = items;
  } else {
    payload.price = price;
    payload.subventionAmount = subventionAmount;
    payload.offerDetails = obj.offerDetails;
  }
  return payload;
}

var shallowEqual = function shallowEqual(a, b) {
  for (var key in a) {
    if (a[key] !== b[key]) return false;
  }for (var _key2 in b) {
    if (!(_key2 in a)) return false;
  }return true;
};

var isIphoneDevice = function isIphoneDevice() {
  var userAgent = window.navigator && window.navigator.userAgent;

  return !!(userAgent.match(/iPad/i) || userAgent.match(/iPhone/i));
};

function scrollInContentWrap(value) {
  var deltaHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  /* if the value is coming as less than 200 means the header wont be in fix state so hence remove
   * height of big header that is approx 140px, if value is greater than 200px then remove the fixed
   * header height od 60px */
  var element = document.querySelector('#paytm-app .payment-content-wrap');
  var headerHeight = value > 202 ? 60 : 142;
  isMobileDevice() && !isIphoneDevice() && element.scrollTo({
    top: value - headerHeight - deltaHeight, // subtracting 60px for header from offset value
    left: 0,
    behavior: 'smooth'
  });
}

var deviceHeightLessThan640 = function deviceHeightLessThan640() {
  return window.innerHeight <= 640;
};

var scrollWithTimeout = function scrollWithTimeout(value, deltaHeight) {
  var timeoutValue = deviceHeightLessThan640() ? 500 : 300;
  setTimeout(function () {
    scrollInContentWrap(value, deltaHeight);
  }, timeoutValue);
};
/* a function to return whether cvv is required for given saved card */
var savedCardWithCVV = function savedCardWithCVV(option) {
  /* setting cvvRequired as true if not coming in saved Card object */
  return getKey(option, 'cardDetails.cvvRequired', true);
};

var scrollToSelectedOption = function scrollToSelectedOption(option) {
  var defaultSelectedPaymodeOffSetTop = getKey(option, 'reference._component.componentRef.offsetTop', 0);
  /* adding 20px to scroll whem mgv since it is on top and scrolling to mgv the header hides the
  selected paymode */

  if (option.type === 'mgv') {
    defaultSelectedPaymodeOffSetTop += 20;
  }
  /* if pamode type is sc, card or ppbl dont scroll down yet because of iframe load issues */
  var optionType = [__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].SC, __WEBPACK_IMPORTED_MODULE_1__common_src_constant__["m" /* PAYMODE */].CARD, __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].PPBL];
  defaultSelectedPaymodeOffSetTop && !optionType.some(function (type) {
    return equalsIgnoreCase(getKey(option, 'type'), type);
  }) && isMobileDevice() && !isIphoneDevice() && scrollInContentWrap(defaultSelectedPaymodeOffSetTop);

  /* if the option is a saved card and has cvv required then only open keyboard,
   * saved card like maestro dont have cvv required but keyboard was opening on the same */
  if (!isIphoneDevice() && savedCardWithCVV(option) && optionType.some(function (type) {
    return equalsIgnoreCase(getKey(option, 'type'), type);
  })) {
    setTimeout(function () {
      var hiddenInput = document.getElementById('ptm-hidden-input');
      hiddenInput && hiddenInput.focus();
    }, 50);
  }
};

var getZeroSubscriptionText = function getZeroSubscriptionText(cache) {
  var infotext = '';
  var txnAmount = cache.getData(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].TXN_AMOUNT);
  if (txnAmount === '0') {
    infotext = clientMessage(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].SUBSCRIPTION.toLowerCase(), cache).label.upto + ' ' + String.fromCodePoint(0x20b9) + commas(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].SUBS_PAYMODE_MIN_AMOUNT) + ' ' + clientMessage(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* default */].SUBSCRIPTION.toLowerCase(), cache).label.maybe;
  }
  return infotext;
};

var isUrlAbsolute = function isUrlAbsolute(url) {
  return url.indexOf('http://') === 0 || url.indexOf('https://') === 0;
};

/***/ }),

/***/ "y11t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isNull; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return requestPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return requestIFSCPayload; });
/* unused harmony export appendQueryInUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apiEndpoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return walletApiEndPoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return merchantServerEndpoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getStaticPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return has; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return iFrameApiCall; });
/* unused harmony export isObject */
/* harmony export (immutable) */ __webpack_exports__["j"] = objectValues;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getKey; });
/* harmony export (immutable) */ __webpack_exports__["f"] = isFunction;
/* unused harmony export isWebViewDetected */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isWebViewFlow; });
var _id = 0;

/**
 * Null or undefined check on value
 * @param {any} value - can be of any type
 * @return {Boolean} - result of value is null or undefined
 * */
var isNull = function isNull(value) {
  return value === null || value === undefined;
};

/**
 * Http request payload structure for native apis.
 *
 * @param {object} data - input data to be pass on the body of ajax call.
 * @returns {object} - json object as par structure of native apis.
 */
var requestPayload = function requestPayload(data) {
  return {
    head: {
      version: 'v1',
      requestTimestamp: Date.now(),
      channelId: 'WEB',
      token: '',
      tokenType: '',
      workFlow: 'checkout'
    },
    body: data
  };
};

var requestIFSCPayload = function requestIFSCPayload(data) {
  return {
    operationType: 'P2B_TRANSFER',
    channel: 'MP-ANDROID',
    ipAddress: '127.0.0.1',
    request: data,
    version: '8.8.0',
    platformName: 'PayTM'
  };
};

var appendQueryInUrl = function appendQueryInUrl(url, query) {
  var output = url + '?';
  Object.keys(query).forEach(function (key) {
    if (Object.prototype.hasOwnProperty.call(query, key)) {
      output += key + '=' + query[key] + '&';
    }
  });
  return output;
};

/**
 * Generate an Theia API endpoint based on configuration environment
 *
 * @param {string} path - _API service url apart from host server.
 * @returns {string} - API endpoint including host server
 */

var apiEndpoint = function apiEndpoint(path) {
  var url = '';
  if (true) {
    url = "https://securegw.paytm.in/theia";
  }
  if (path) {
    url += path;
  }
  return url;
};

var walletApiEndPoint = function walletApiEndPoint(path) {
  var url = '';
  if (true) {
    url = "https://trust.paytm.in";
  }
  if (path) {
    url += path;
  }
  return url;
};

/**
 * Generate an Merchant API endpoint based on configuration environment
 *
 * @param {string} path - _API service url apart from host server.
 * @returns {string} - API endpoint including host server
 */

var merchantServerEndpoint = function merchantServerEndpoint(path) {
  var url = '';
  if (true) {
    url = "https://securegw.paytm.in/merchantpgpui";
  }
  if (path) {
    url += path;
  }
  return url;
};

var getStaticPath = function getStaticPath() {
  var _url = "https://staticpg.paytm.in";

  try {
    if (typeof window !== 'undefined') {
      if (true) {
        _url += '/' + "checkoutjs" + '/' + "442";
      }
    }
  } catch (e) {}
  return _url;
};

/**
 * Check if key exists in object or not
 * @param {Object} obj - object
 * @param {String} key - field name to be check in object
 * @return {Boolean} - return true if key exists in object otherwise false
 * */
var has = function has(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
};

var iFrameApiCall = function iFrameApiCall(payload) {
  return new Promise(function (resolve, reject) {
    if (false) {
      // resolve();
      // payload.skipMiddleware = true;
      // _ajax(payload)
      //   .then(data => {
      //     resolve(data);
      //   })
      //   .catch(err => {
      //     reject(err);
      //   });
    } else {
      var dummyFrame = document.getElementById('dummy-iframe');
      if (dummyFrame) {
        var handler = function handler(id, event) {
          switch (event.data.id === id && event.data.type) {
            case 'successApiCallResponse':
              resolve(event.data.responses[0]);
              window.removeEventListener('message', handler);
              break;
            case 'errorApiCallResponse':
              reject(event.data.response);
              window.removeEventListener('message', handler);
              break;
            default:
              break;
          }
        };
        window.addEventListener('message', handler.bind(null, _id));
        dummyFrame.contentWindow.postMessage({ type: 'MAKECALL', requests: [payload], id: _id }, '*');
        _id += 1;
      }
    }
  });
};

/**
 * Validate whether an input is an Object or not.
 *
 * @export
 * @param {*} input
 * @returns {boolean} is input is an Object?
 */
function isObject(input) {
  return Object.prototype.toString.call(input) === '[object Object]';
}

/**
 * Gets object values
 *
 * @export
 * @param {Object} input
 * @returns {Array<*>} Array pf object values
 */
function objectValues(input) {
  if (isObject(input)) {
    return Object.keys(input).reduce(function (acc, key) {
      acc.push(input[key]);
      return acc;
    }, []);
  }

  return [];
}

/**
 * Get property value from nested object
 *
 * @param {Object} obj - object to perform property lookup
 * @param {String} path - the path at which lookup is performed
 * @param {*} defaultValue (optional) -  default value to be reurned if property not found
 * @returns {*} - returns the property value if found else returns dafaultValue
 */
var getKey = function getKey(obj, path, defaultValue) {
  var result = String.prototype.split.call(path, /[,[\].]+?/).filter(Boolean).reduce(function (res, key) {
    return !isNull(res) ? res[key] : res;
  }, obj);
  return isNull(result) || result === obj ? defaultValue : result;
};

/**
 * Validate whether an input is function or not.
 *
 * @export
 * @param {*} input
 * @returns {boolean} is input is function?
 */
function isFunction(input) {
  return typeof input === 'function';
}

var isWebViewDetected = function isWebViewDetected() {
  var userAgent = window.navigator && window.navigator.userAgent;
  /* Check for Safari Web View */
  var isSafariWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(userAgent);
  if (isSafariWebView || /wv/i.test(userAgent) || !/UCBrowser/g.test(userAgent) && /version\/[0-9].[0-9]/i.test(userAgent) && /Chrome\/\d*.\d*.\d*.\d*/i.test(userAgent)) {
    return true;
  }
  return false;
};

var isWebViewFlow = function isWebViewFlow(mConfig) {
  return isWebViewDetected() && !(mConfig && mConfig.merchant && mConfig.merchant.multipleWindowWebview);
};

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.js